(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}
parcelRequire.register("agnkb", function(module, exports) {

$parcel$export(module.exports, "withRegion", function () { return $b7e06600096fce03$export$2f9294bfc17c771e; });
$parcel$export(module.exports, "createNode", function () { return $b7e06600096fce03$export$270e7ba5936d3c48; });
$parcel$export(module.exports, "launch", function () { return $b7e06600096fce03$export$9a7f3579b2beee84; });
$parcel$export(module.exports, "setStoreName", function () { return $b7e06600096fce03$export$71fac2a1f979e2c1; });
$parcel$export(module.exports, "createEvent", function () { return $b7e06600096fce03$export$c30017717ce2168e; });
$parcel$export(module.exports, "createStore", function () { return $b7e06600096fce03$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "combine", function () { return $b7e06600096fce03$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "createStoreObject", function () { return $b7e06600096fce03$export$e9d45223cdf1e997; });
$parcel$export(module.exports, "createEffect", function () { return $b7e06600096fce03$export$7ea7134f704deda4; });
$parcel$export(module.exports, "attach", function () { return $b7e06600096fce03$export$5ddf9e484e541d6f; });
$parcel$export(module.exports, "createApi", function () { return $b7e06600096fce03$export$9cdc2b9a8d94c842; });
$parcel$export(module.exports, "createDomain", function () { return $b7e06600096fce03$export$d4fc37724c119bb4; });
$parcel$export(module.exports, "fromObservable", function () { return $b7e06600096fce03$export$4b2432e2d8723823; });
$parcel$export(module.exports, "merge", function () { return $b7e06600096fce03$export$4950aa0f605343fb; });
$parcel$export(module.exports, "sample", function () { return $b7e06600096fce03$export$4812e460280c6ef2; });
$parcel$export(module.exports, "guard", function () { return $b7e06600096fce03$export$864d727b48066337; });
$parcel$export(module.exports, "restore", function () { return $b7e06600096fce03$export$db239ef39aadc7fe; });
$parcel$export(module.exports, "split", function () { return $b7e06600096fce03$export$65980d18b75784e2; });
$parcel$export(module.exports, "allSettled", function () { return $b7e06600096fce03$export$bcf8c46c380b2b4c; });
$parcel$export(module.exports, "fork", function () { return $b7e06600096fce03$export$7a5058c6b79333e0; });
$parcel$export(module.exports, "hydrate", function () { return $b7e06600096fce03$export$fa8d919ba61d84db; });
$parcel$export(module.exports, "scopeBind", function () { return $b7e06600096fce03$export$18f6b3f66cc08bf; });
$parcel$export(module.exports, "serialize", function () { return $b7e06600096fce03$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "createWatch", function () { return $b7e06600096fce03$export$940333bc61f71f83; });
$parcel$export(module.exports, "step", function () { return $b7e06600096fce03$export$35d34bc0ed591a92; });
$parcel$export(module.exports, "clearNode", function () { return $b7e06600096fce03$export$51cfe97d637c237c; });
$parcel$export(module.exports, "is", function () { return $b7e06600096fce03$export$226b3eccf92c9ed9; });
$parcel$export(module.exports, "setGraphInspector", function () { return $b7e06600096fce03$export$7980e214724429d7; });
$parcel$export(module.exports, "withFactory", function () { return $b7e06600096fce03$export$84070f57da009beb; });
$parcel$export(module.exports, "setInspector", function () { return $b7e06600096fce03$export$aa4047e72657c4f7; });
$parcel$export(module.exports, "forward", function () { return $b7e06600096fce03$export$174bb771924e7eb1; });
$parcel$export(module.exports, "version", function () { return $b7e06600096fce03$export$83d89fbfd8236492; });
function $b7e06600096fce03$var$e(e, t) {
    for(let r in e)t(e[r], r);
}
function $b7e06600096fce03$var$t(e, t) {
    e.forEach(t);
}
function $b7e06600096fce03$var$r(e, t) {
    if (!e) throw Error(t);
}
function $b7e06600096fce03$export$2f9294bfc17c771e(e, t) {
    let r = $b7e06600096fce03$var$L(e).meta || {};
    $b7e06600096fce03$var$he = {
        id: $b7e06600096fce03$var$L(e).id,
        parent: $b7e06600096fce03$var$he,
        value: e,
        template: r.template || $b7e06600096fce03$var$be(),
        sidRoot: r.sidRoot || $b7e06600096fce03$var$he && $b7e06600096fce03$var$he.sidRoot,
        meta: r
    };
    try {
        return t();
    } finally{
        $b7e06600096fce03$var$ye("region"), $b7e06600096fce03$var$he = $b7e06600096fce03$var$V($b7e06600096fce03$var$he);
    }
}
function $b7e06600096fce03$export$270e7ba5936d3c48({ node: e = [], from: r, source: a, parent: n = r || a, to: i, target: o, child: l = i || o, scope: s = {}, meta: f = {}, family: d = {
    type: "regular"
}, regional: u } = {}) {
    let c = $b7e06600096fce03$var$Se(n), p = $b7e06600096fce03$var$Se(d.links), m = $b7e06600096fce03$var$Se(d.owners), g = [];
    $b7e06600096fce03$var$t(e, (e)=>e && $b7e06600096fce03$var$le(g, e));
    let h = {
        id: $b7e06600096fce03$var$pe(),
        seq: g,
        next: $b7e06600096fce03$var$Se(l),
        meta: f,
        scope: s,
        family: {
            type: d.type || "crosslink",
            links: p,
            owners: m
        }
    };
    return $b7e06600096fce03$var$t(p, (e)=>$b7e06600096fce03$var$le($b7e06600096fce03$var$T(e), h)), $b7e06600096fce03$var$t(m, (e)=>$b7e06600096fce03$var$le($b7e06600096fce03$var$B(e), h)), $b7e06600096fce03$var$t(c, (e)=>$b7e06600096fce03$var$le(e.next, h)), u && $b7e06600096fce03$var$he && $b7e06600096fce03$var$we($b7e06600096fce03$var$H($b7e06600096fce03$var$he), [
        h
    ]), h;
}
function $b7e06600096fce03$export$9a7f3579b2beee84(e, r, a) {
    let n, i = $b7e06600096fce03$var$nt, o = null, l = $b7e06600096fce03$var$et;
    if (e.target && (r = e.params, a = e.defer, n = e.meta, i = "page" in e ? e.page : i, e.stack && (o = e.stack), l = $b7e06600096fce03$var$G(e) || l, e = e.target), l && $b7e06600096fce03$var$et && l !== $b7e06600096fce03$var$et && ($b7e06600096fce03$var$et = null), Array.isArray(e)) for(let t = 0; t < e.length; t++)$b7e06600096fce03$var$Qe("pure", i, $b7e06600096fce03$var$L(e[t]), o, r[t], l, n);
    else $b7e06600096fce03$var$Qe("pure", i, $b7e06600096fce03$var$L(e), o, r, l, n);
    if (a && !$b7e06600096fce03$var$tt) return;
    let s, f, d, u, c, p, m = {
        isRoot: $b7e06600096fce03$var$tt,
        currentPage: $b7e06600096fce03$var$nt,
        scope: $b7e06600096fce03$var$et,
        isWatch: $b7e06600096fce03$var$rt,
        isPure: $b7e06600096fce03$var$at
    };
    $b7e06600096fce03$var$tt = 0;
    e: for(; u = $b7e06600096fce03$var$Ke();){
        let { idx: e, stack: r, type: a } = u;
        d = r.node, $b7e06600096fce03$var$nt = c = r.page, $b7e06600096fce03$var$et = $b7e06600096fce03$var$G(r), c ? p = c.reg : $b7e06600096fce03$var$et && (p = $b7e06600096fce03$var$et.reg);
        let n = !!c, i = !!$b7e06600096fce03$var$et, o = {
            fail: 0,
            scope: d.scope
        };
        s = f = 0;
        for(let t = e; t < d.seq.length && !s; t++){
            let l = d.seq[t];
            if (l.order) {
                let { priority: n, barrierID: i } = l.order, o = i ? c ? `${c.fullID}_${i}` : i : 0;
                if (t !== e || a !== n) {
                    i ? $b7e06600096fce03$var$Ze.has(o) || ($b7e06600096fce03$var$Ze.add(o), $b7e06600096fce03$var$Xe(t, r, n, i)) : $b7e06600096fce03$var$Xe(t, r, n);
                    continue e;
                }
                i && $b7e06600096fce03$var$Ze.delete(o);
            }
            switch(l.type){
                case "mov":
                    {
                        let e, t = l.data;
                        switch(t.from){
                            case $b7e06600096fce03$var$P:
                                e = $b7e06600096fce03$var$H(r);
                                break;
                            case "a":
                            case "b":
                                e = r[t.from];
                                break;
                            case "value":
                                e = t.store;
                                break;
                            case "store":
                                if (p && !p[t.store.id]) {
                                    if (n) {
                                        let e = $b7e06600096fce03$var$st(c, t.store.id);
                                        r.page = c = e, e ? p = e.reg : i ? ($b7e06600096fce03$var$pt($b7e06600096fce03$var$et, t.store, 0, 1, t.softRead), p = $b7e06600096fce03$var$et.reg) : p = void 0;
                                    } else i && $b7e06600096fce03$var$pt($b7e06600096fce03$var$et, t.store, 0, 1, t.softRead);
                                }
                                e = $b7e06600096fce03$var$We(p && p[t.store.id] || t.store);
                        }
                        switch(t.to){
                            case $b7e06600096fce03$var$P:
                                r.value = e;
                                break;
                            case "a":
                            case "b":
                                r[t.to] = e;
                                break;
                            case "store":
                                $b7e06600096fce03$var$dt(c, $b7e06600096fce03$var$et, d, t.target).current = e;
                        }
                        break;
                    }
                case "compute":
                    let e1 = l.data;
                    if (e1.fn) {
                        $b7e06600096fce03$var$rt = "watch" === $b7e06600096fce03$var$J(d, "op"), $b7e06600096fce03$var$at = e1.pure;
                        let t = e1.safe ? (0, e1.fn)($b7e06600096fce03$var$H(r), o.scope, r) : $b7e06600096fce03$var$mt(o, e1.fn, r);
                        e1.filter ? f = !t : r.value = t, $b7e06600096fce03$var$rt = m.isWatch, $b7e06600096fce03$var$at = m.isPure;
                    }
            }
            s = o.fail || f;
        }
        if ($b7e06600096fce03$var$ft && $b7e06600096fce03$var$ft(r, o), !s) {
            let e = $b7e06600096fce03$var$H(r), a = $b7e06600096fce03$var$G(r);
            if ($b7e06600096fce03$var$t(d.next, (t)=>{
                $b7e06600096fce03$var$Qe("child", c, t, r, e, a);
            }), a) {
                $b7e06600096fce03$var$J(d, "needFxCounter") && $b7e06600096fce03$var$Qe("child", c, a.fxCount, r, e, a), $b7e06600096fce03$var$J(d, "storeChange") && $b7e06600096fce03$var$Qe("child", c, a.storeChange, r, e, a), $b7e06600096fce03$var$J(d, "warnSerialize") && $b7e06600096fce03$var$Qe("child", c, a.warnSerializeNode, r, e, a);
                let n = a.additionalLinks[d.id];
                n && $b7e06600096fce03$var$t(n, (t)=>{
                    $b7e06600096fce03$var$Qe("child", c, t, r, e, a);
                });
            }
        }
    }
    $b7e06600096fce03$var$tt = m.isRoot, $b7e06600096fce03$var$nt = m.currentPage, $b7e06600096fce03$var$et = $b7e06600096fce03$var$G(m);
}
function $b7e06600096fce03$var$o(t, r = "combine") {
    let a = r + "(", n = "", i = 0;
    return $b7e06600096fce03$var$e(t, (e)=>{
        i < 25 && (null != e && (a += n, a += $b7e06600096fce03$var$X(e) ? $b7e06600096fce03$var$Q(e).fullName : e.toString()), i += 1, n = ", ");
    }), a + ")";
}
function $b7e06600096fce03$export$71fac2a1f979e2c1(e, t) {
    e.shortName = t, Object.assign($b7e06600096fce03$var$Q(e), $b7e06600096fce03$var$s(t, $b7e06600096fce03$var$V(e)));
}
function $b7e06600096fce03$var$s(e, t) {
    let r, a, n = e;
    if (t) {
        let n = $b7e06600096fce03$var$Q(t);
        0 === e.length ? (r = n.path, a = n.fullName) : (r = n.path.concat([
            e
        ]), a = 0 === n.fullName.length ? e : n.fullName + "/" + e);
    } else r = 0 === e.length ? [] : [
        e
    ], a = e;
    return {
        shortName: n,
        fullName: a,
        path: r
    };
}
function $b7e06600096fce03$var$f(e, t) {
    let r = t ? e : e[0];
    $b7e06600096fce03$var$ze(r);
    let a = r.or, n = r.and;
    if (n) {
        let r = t ? n : n[0];
        if ($b7e06600096fce03$var$Me(r) && "and" in r) {
            let r = $b7e06600096fce03$var$f(n, t);
            e = r[0], a = {
                ...a,
                ...r[1]
            };
        } else e = n;
    }
    return [
        e,
        a
    ];
}
function $b7e06600096fce03$var$d(e, ...t) {
    let r = $b7e06600096fce03$var$be();
    if (r) {
        let a = r.handlers[e];
        if (a) return a(r, ...t);
    }
}
function $b7e06600096fce03$export$c30017717ce2168e(e, t) {
    let r = $b7e06600096fce03$var$gt({
        or: t,
        and: "string" == typeof e ? {
            name: e
        } : e
    }), a = (e, ...t)=>($b7e06600096fce03$var$se(!$b7e06600096fce03$var$J(a, "derived"), "call of derived event", "createEvent"), $b7e06600096fce03$var$se(!$b7e06600096fce03$var$at, "unit call from pure function", "operators like sample"), $b7e06600096fce03$var$nt ? ((e, t, r, a)=>{
            let n = $b7e06600096fce03$var$nt, i = null;
            if (t) for(i = $b7e06600096fce03$var$nt; i && i.template !== t;)i = $b7e06600096fce03$var$V(i);
            $b7e06600096fce03$var$lt(i);
            let o = e.create(r, a);
            return $b7e06600096fce03$var$lt(n), o;
        })(a, o, e, t) : a.create(e, t)), o = $b7e06600096fce03$var$be(), l = Object.assign(a, {
        graphite: $b7e06600096fce03$export$270e7ba5936d3c48({
            meta: $b7e06600096fce03$var$$t(r.actualOp || "event", a, r),
            regional: 1
        }),
        create: (e)=>($b7e06600096fce03$export$9a7f3579b2beee84({
                target: a,
                params: e,
                scope: $b7e06600096fce03$var$et
            }), e),
        watch: (e)=>$b7e06600096fce03$var$Mt(a, e),
        map: (e)=>$b7e06600096fce03$var$zt(a, $b7e06600096fce03$var$_, e, [
                $b7e06600096fce03$var$Le()
            ]),
        filter: (e)=>$b7e06600096fce03$var$zt(a, "filter", e.fn ? e : e.fn, [
                $b7e06600096fce03$var$Le($b7e06600096fce03$var$qe, 1)
            ]),
        filterMap: (e)=>$b7e06600096fce03$var$zt(a, "filterMap", e, [
                $b7e06600096fce03$var$Le(),
                $b7e06600096fce03$var$_e((e)=>!$b7e06600096fce03$var$$e(e), 1)
            ]),
        prepend (e) {
            let t = $b7e06600096fce03$export$c30017717ce2168e("* → " + a.shortName, {
                parent: $b7e06600096fce03$var$V(a)
            });
            return $b7e06600096fce03$var$d("eventPrepend", $b7e06600096fce03$var$L(t)), $b7e06600096fce03$var$wt(t, a, [
                $b7e06600096fce03$var$Le()
            ], "prepend", e), $b7e06600096fce03$var$xt(a, t), t;
        }
    });
    return null != r && r.domain && r.domain.hooks.event(l), $b7e06600096fce03$var$K(l, "id", l.graphite.id), $b7e06600096fce03$var$ye(l.graphite), l;
}
function $b7e06600096fce03$var$c(e, a, n, i) {
    return $b7e06600096fce03$var$Ce(n, a, "first argument"), $b7e06600096fce03$var$r($b7e06600096fce03$var$xe(i), "second argument should be a function"), $b7e06600096fce03$var$se(!$b7e06600096fce03$var$J(e, "derived"), `${a} in derived store`, `${a} in store created via createStore`), $b7e06600096fce03$var$t(Array.isArray(n) ? n : [
        n
    ], (t)=>{
        e.off(t), $b7e06600096fce03$var$U(e).set(t, $b7e06600096fce03$var$kt($b7e06600096fce03$var$jt(t, e, "on", $b7e06600096fce03$var$Oe, i)));
    }), e;
}
function $b7e06600096fce03$export$f51a9068ac82ea43(e, a) {
    let o = $b7e06600096fce03$var$gt(a), l = $b7e06600096fce03$var$Be(e), s = $b7e06600096fce03$export$c30017717ce2168e({
        named: "updates",
        derived: 1
    });
    $b7e06600096fce03$var$d("storeBase", l);
    let f = l.id, m = {
        subscribers: new Map,
        updates: s,
        defaultState: e,
        stateRef: l,
        getState () {
            let e, t = l;
            if ($b7e06600096fce03$var$nt) {
                let t = $b7e06600096fce03$var$nt;
                for(; t && !t.reg[f];)t = $b7e06600096fce03$var$V(t);
                t && (e = t);
            }
            return !e && $b7e06600096fce03$var$et && ($b7e06600096fce03$var$pt($b7e06600096fce03$var$et, l, 1), e = $b7e06600096fce03$var$et), e && (t = e.reg[f]), $b7e06600096fce03$var$We(t);
        },
        setState: (e)=>$b7e06600096fce03$export$9a7f3579b2beee84({
                target: m,
                params: e,
                defer: 1,
                scope: $b7e06600096fce03$var$et
            }),
        reset: (...e)=>($b7e06600096fce03$var$t(e, (e)=>$b7e06600096fce03$var$c(m, ".reset", e, ()=>m.defaultState)), m),
        on: (e, t)=>$b7e06600096fce03$var$c(m, ".on", e, t),
        off (e) {
            let t = $b7e06600096fce03$var$U(m).get(e);
            return t && (t(), $b7e06600096fce03$var$U(m).delete(e)), m;
        },
        map (e, t) {
            let r, a;
            $b7e06600096fce03$var$Me(e) && (r = e, e = e.fn), $b7e06600096fce03$var$se($b7e06600096fce03$var$$e(t), "second argument of store.map", "updateFilter");
            let n = m.getState();
            $b7e06600096fce03$var$be() ? a = null : $b7e06600096fce03$var$$e(n) || (a = e(n, t));
            let i = $b7e06600096fce03$export$f51a9068ac82ea43(a, {
                name: `${m.shortName} \u2192 *`,
                derived: 1,
                and: r
            }), o = $b7e06600096fce03$var$jt(m, i, $b7e06600096fce03$var$_, $b7e06600096fce03$var$Ie, e);
            return $b7e06600096fce03$var$He($b7e06600096fce03$var$W(i), {
                type: $b7e06600096fce03$var$_,
                fn: e,
                from: l
            }), $b7e06600096fce03$var$W(i).noInit = 1, $b7e06600096fce03$var$d("storeMap", l, o), i;
        },
        watch (e, t) {
            if (!t || !$b7e06600096fce03$var$X(e)) {
                let t = $b7e06600096fce03$var$Mt(m, e);
                return $b7e06600096fce03$var$d("storeWatch", l, e) || e(m.getState()), t;
            }
            return $b7e06600096fce03$var$r($b7e06600096fce03$var$xe(t), "second argument should be a function"), e.watch((e)=>t(m.getState(), e));
        }
    }, g = $b7e06600096fce03$var$$t("store", m, o), h = m.defaultConfig.updateFilter;
    m.graphite = $b7e06600096fce03$export$270e7ba5936d3c48({
        scope: {
            state: l,
            fn: h
        },
        node: [
            $b7e06600096fce03$var$_e((e, t, r)=>(r.scope && !r.scope.reg[l.id] && (r.b = 1), e)),
            $b7e06600096fce03$var$Pe(l),
            $b7e06600096fce03$var$_e((e, t, { a: r, b: a })=>!$b7e06600096fce03$var$$e(e) && (e !== r || a), 1),
            h && $b7e06600096fce03$var$Le($b7e06600096fce03$var$Ie, 1),
            $b7e06600096fce03$var$Fe({
                from: $b7e06600096fce03$var$P,
                target: l
            })
        ],
        child: s,
        meta: {
            ...g,
            defaultState: e
        },
        regional: 1
    }), $b7e06600096fce03$var$K(m, "id", m.graphite.id), $b7e06600096fce03$var$K(m, "rootStateRefId", f);
    let y = $b7e06600096fce03$var$J(m, "serialize"), b = $b7e06600096fce03$var$J(m, "derived"), v = "ignore" === y, k = $b7e06600096fce03$var$J(m, "sid");
    return k && ($b7e06600096fce03$var$K(m, "storeChange", 1), l.sid = k), k || v || b || $b7e06600096fce03$var$K(m, "warnSerialize", 1), $b7e06600096fce03$var$r(b || !$b7e06600096fce03$var$$e(e), "current state can't be undefined, use null instead"), $b7e06600096fce03$var$we(m, [
        s
    ]), null != o && o.domain && o.domain.hooks.store(m), b || (m.reinit = $b7e06600096fce03$export$c30017717ce2168e({
        named: "reinit"
    }), m.reset(m.reinit)), l.meta = m.graphite.meta, $b7e06600096fce03$var$ye(m.graphite), m;
}
function $b7e06600096fce03$export$1be1fc439b849fdf(...e) {
    let t, a, n;
    [e, n] = $b7e06600096fce03$var$f(e);
    let i, o, l, s = e[e.length - 1];
    if ($b7e06600096fce03$var$xe(s) ? (a = e.slice(0, -1), t = s) : a = e, 1 === a.length) {
        let e = a[0];
        $b7e06600096fce03$var$Z(e) || (i = e, o = 1);
    }
    if (!o && (i = a, t)) {
        l = 1;
        let e = t;
        t = (t)=>e(...t);
    }
    return $b7e06600096fce03$var$r($b7e06600096fce03$var$Me(i), "shape should be an object"), $b7e06600096fce03$var$Ct(Array.isArray(i), !l, i, n, t);
}
function $b7e06600096fce03$export$e9d45223cdf1e997(...e) {
    return $b7e06600096fce03$var$se(0, "createStoreObject", "combine"), $b7e06600096fce03$export$1be1fc439b849fdf(...e);
}
function $b7e06600096fce03$var$h() {
    let e = {};
    return e.req = new Promise((t, r)=>{
        e.rs = t, e.rj = r;
    }), e.req.catch(()=>{}), e;
}
function $b7e06600096fce03$export$7ea7134f704deda4(e, t = {}) {
    let a = $b7e06600096fce03$var$gt($b7e06600096fce03$var$xe(e) ? {
        handler: e
    } : e, t), o = $b7e06600096fce03$export$c30017717ce2168e($b7e06600096fce03$var$xe(e) ? {
        handler: e
    } : e, {
        ...t,
        actualOp: "effect"
    }), l = $b7e06600096fce03$var$L(o);
    $b7e06600096fce03$var$K(l, "op", o.kind = "effect"), o.use = (e)=>($b7e06600096fce03$var$r($b7e06600096fce03$var$xe(e), ".use argument should be a function"), g.scope.handler = e, o), o.use.getCurrent = ()=>g.scope.handler;
    let s = o.finally = $b7e06600096fce03$export$c30017717ce2168e({
        named: "finally",
        derived: 1
    }), f = o.done = s.filterMap({
        named: "done",
        fn ({ status: e, params: t, result: r }) {
            if ("done" === e) return {
                params: t,
                result: r
            };
        }
    }), d = o.fail = s.filterMap({
        named: "fail",
        fn ({ status: e, params: t, error: r }) {
            if ("fail" === e) return {
                params: t,
                error: r
            };
        }
    }), c = o.doneData = f.map({
        named: "doneData",
        fn: ({ result: e })=>e
    }), m = o.failData = d.map({
        named: "failData",
        fn: ({ error: e })=>e
    }), g = $b7e06600096fce03$export$270e7ba5936d3c48({
        scope: {
            handler: o.defaultConfig.handler || (()=>$b7e06600096fce03$var$r(0, `no handler used in ${o.getType()}`))
        },
        node: [
            $b7e06600096fce03$var$_e((e, t, r)=>{
                let a = t.handler, n = $b7e06600096fce03$var$G(r);
                if (n) {
                    let e = n.handlers.unitMap.get(o) || n.handlers.sidMap[o.sid];
                    e && (a = e);
                }
                return e.handler = a, e;
            }, 0, 1),
            $b7e06600096fce03$var$_e(({ params: e, req: t, handler: r, args: a = [
                e
            ] }, n, i)=>{
                let o = $b7e06600096fce03$var$It(i), l = $b7e06600096fce03$var$Ot(e, t, 1, s, i, o), f = $b7e06600096fce03$var$Ot(e, t, 0, s, i, o), [d, u] = $b7e06600096fce03$var$At(r, f, a);
                d && ($b7e06600096fce03$var$Me(u) && $b7e06600096fce03$var$xe(u.then) ? u.then(l, f) : l(u));
            }, 0, 1)
        ],
        meta: {
            op: "fx",
            fx: "runner"
        }
    });
    l.scope.runner = g, $b7e06600096fce03$var$le(l.seq, $b7e06600096fce03$var$_e((e, { runner: t }, r)=>{
        let a = $b7e06600096fce03$var$V(r) ? {
            params: e,
            req: {
                rs (e) {},
                rj (e) {}
            }
        } : e;
        return r.meta || (r.meta = {
            fxID: $b7e06600096fce03$var$me()
        }), $b7e06600096fce03$export$9a7f3579b2beee84({
            target: t,
            params: a,
            defer: 1,
            scope: $b7e06600096fce03$var$G(r),
            meta: r.meta
        }), a.params;
    }, 0, 1)), o.create = (e)=>{
        let t = $b7e06600096fce03$var$h(), r = {
            params: e,
            req: t
        };
        if ($b7e06600096fce03$var$et && !$b7e06600096fce03$var$rt) {
            let e = $b7e06600096fce03$var$et;
            t.req.finally(()=>{
                $b7e06600096fce03$var$ot(e);
            }).catch(()=>{});
        }
        return $b7e06600096fce03$export$9a7f3579b2beee84({
            target: o,
            params: r,
            scope: $b7e06600096fce03$var$et
        }), t.req;
    };
    let y = o.inFlight = $b7e06600096fce03$export$f51a9068ac82ea43(0, {
        serialize: "ignore",
        named: ($b7e06600096fce03$var$J(o, "name") || o.graphite.id) + ".inFlight"
    }).on(o, (e)=>e + 1).on(s, (e)=>e - 1).map({
        fn: (e)=>e,
        named: "inFlight"
    });
    $b7e06600096fce03$var$K(s, "needFxCounter", "dec"), $b7e06600096fce03$var$K(o, "needFxCounter", 1);
    let b = o.pending = y.map({
        fn: (e)=>e > 0,
        named: "pending"
    });
    return $b7e06600096fce03$var$we(o, [
        s,
        f,
        d,
        c,
        m,
        b,
        y
    ]), null != a && a.domain && a.domain.hooks.effect(o), o;
}
function $b7e06600096fce03$export$5ddf9e484e541d6f(e) {
    let t;
    [e, t] = $b7e06600096fce03$var$f(e, 1);
    let { source: r, effect: a, mapParams: n } = e, o = $b7e06600096fce03$export$7ea7134f704deda4(e, t);
    $b7e06600096fce03$var$K(o, "attached", 1);
    let l, { runner: d } = $b7e06600096fce03$var$L(o).scope, u = $b7e06600096fce03$var$_e((e, t, a)=>{
        let l, { params: s, req: f, handler: d } = e, u = o.finally, c = $b7e06600096fce03$var$It(a), p = $b7e06600096fce03$var$Ot(s, f, 0, u, a, c), m = a.a, g = $b7e06600096fce03$var$te(d), h = 1;
        if (n ? [h, l] = $b7e06600096fce03$var$At(n, p, [
            s,
            m
        ]) : l = r && g ? m : s, h) {
            if (!g) return e.args = [
                m,
                l
            ], 1;
            $b7e06600096fce03$export$9a7f3579b2beee84({
                target: d,
                params: {
                    params: l,
                    req: {
                        rs: $b7e06600096fce03$var$Ot(s, f, 1, u, a, c),
                        rj: p
                    }
                },
                page: a.page,
                defer: 1,
                meta: a.meta
            });
        }
    }, 1, 1);
    if (r) {
        let e;
        $b7e06600096fce03$var$Z(r) ? (e = r, $b7e06600096fce03$var$we(e, [
            o
        ])) : (e = $b7e06600096fce03$export$1be1fc439b849fdf(r), $b7e06600096fce03$var$we(o, [
            e
        ])), l = [
            $b7e06600096fce03$var$Pe($b7e06600096fce03$var$W(e)),
            u
        ];
    } else l = [
        u
    ];
    d.seq.splice(1, 0, ...l), o.use(a);
    let c = $b7e06600096fce03$var$V(a);
    return c && (Object.assign($b7e06600096fce03$var$Q(o), $b7e06600096fce03$var$s(o.shortName, c)), o.defaultConfig.parent = c), $b7e06600096fce03$var$xt(a, o, "effect"), o;
}
function $b7e06600096fce03$export$9cdc2b9a8d94c842(...t) {
    let [[r, a], n] = $b7e06600096fce03$var$f(t), i = {};
    return $b7e06600096fce03$var$e(a, (e, t)=>{
        let a = i[t] = $b7e06600096fce03$export$c30017717ce2168e(t, {
            parent: $b7e06600096fce03$var$V(r),
            config: n
        });
        r.on(a, e), $b7e06600096fce03$var$xt(r, a);
    }), i;
}
function $b7e06600096fce03$export$d4fc37724c119bb4(r, a) {
    let o = $b7e06600096fce03$var$gt({
        or: a,
        and: "string" == typeof r ? {
            name: r
        } : r
    }), l = $b7e06600096fce03$export$270e7ba5936d3c48({
        family: {
            type: "domain"
        },
        regional: 1,
        parent: (null == o ? void 0 : o.domain) || (null == o ? void 0 : o.parent)
    }), s = {
        history: {},
        graphite: l,
        hooks: {}
    };
    l.meta = $b7e06600096fce03$var$$t("domain", s, {
        parent: (null == o ? void 0 : o.domain) || (null == o ? void 0 : o.parent),
        or: o
    }), $b7e06600096fce03$var$e({
        Event: $b7e06600096fce03$export$c30017717ce2168e,
        Effect: $b7e06600096fce03$export$7ea7134f704deda4,
        Store: $b7e06600096fce03$export$f51a9068ac82ea43,
        Domain: $b7e06600096fce03$export$d4fc37724c119bb4
    }, (e, r)=>{
        let a = r.toLowerCase(), n = $b7e06600096fce03$export$c30017717ce2168e({
            named: `on${r}`
        });
        s.hooks[a] = n;
        let o = new Set;
        s.history[`${a}s`] = o, n.create = (e)=>($b7e06600096fce03$export$9a7f3579b2beee84(n, e), e), $b7e06600096fce03$var$le($b7e06600096fce03$var$L(n).seq, $b7e06600096fce03$var$_e((e, t, r)=>(r.scope = null, e))), n.watch((e)=>{
            $b7e06600096fce03$var$we(s, [
                e
            ]), o.add(e), e.ownerSet || (e.ownerSet = o), $b7e06600096fce03$var$V(e) || (e.parent = s);
        }), $b7e06600096fce03$var$we(s, [
            n
        ]), s[`onCreate${r}`] = (e)=>($b7e06600096fce03$var$t(o, e), n.watch(e)), s[`create${r}`] = s[a] = (t, r)=>{
            let a = $b7e06600096fce03$var$gt({
                and: r,
                or: t
            });
            return null != a && a.domain ? e(t, r) : n(e(t, {
                parent: s,
                or: a
            }));
        };
    });
    let f = $b7e06600096fce03$var$V(s);
    return f && $b7e06600096fce03$var$e(s.hooks, (e, t)=>$b7e06600096fce03$var$wt(e, f.hooks[t])), null != o && o.domain && o.domain.hooks.domain(s), s;
}
function $b7e06600096fce03$export$4b2432e2d8723823(e) {
    $b7e06600096fce03$var$ze(e);
    let t = $b7e06600096fce03$var$E in e ? e[$b7e06600096fce03$var$E]() : e;
    $b7e06600096fce03$var$r(t.subscribe, "expect observable to have .subscribe");
    let a = $b7e06600096fce03$export$c30017717ce2168e(), n = $b7e06600096fce03$var$kt(a);
    return t.subscribe({
        next: a,
        error: n,
        complete: n
    }), a;
}
function $b7e06600096fce03$export$4950aa0f605343fb(e, t) {
    $b7e06600096fce03$var$Ce(e, "merge", "first argument");
    let r = $b7e06600096fce03$export$c30017717ce2168e({
        name: $b7e06600096fce03$var$o(e, "merge"),
        derived: 1,
        and: t
    });
    return $b7e06600096fce03$var$wt(e, r, [], "merge"), r;
}
function $b7e06600096fce03$var$M(e, a) {
    let n = 0;
    return $b7e06600096fce03$var$t($b7e06600096fce03$var$Nt, (t)=>{
        t in e && ($b7e06600096fce03$var$r(null != e[t], $b7e06600096fce03$var$Dt(a, t)), n = 1);
    }), n;
}
function $b7e06600096fce03$export$4812e460280c6ef2(...e) {
    let t, r, a, n, [[i, o, l], s] = $b7e06600096fce03$var$f(e), d = 1;
    return $b7e06600096fce03$var$$e(o) && $b7e06600096fce03$var$Me(i) && $b7e06600096fce03$var$M(i, "sample") && (o = i.clock, l = i.fn, d = !i.greedy, n = i.filter, t = i.target, r = i.name, a = i.sid, i = i.source), $b7e06600096fce03$var$Ft("sample", o, i, n, t, l, r, s, d, 1, 0, a);
}
function $b7e06600096fce03$export$864d727b48066337(...e) {
    let [[t, r], a] = $b7e06600096fce03$var$f(e);
    return r || (r = t, t = r.source), $b7e06600096fce03$var$M(r, "guard"), $b7e06600096fce03$var$Ft("guard", r.clock, t, r.filter, r.target, null, r.name, a, !r.greedy, 0, 1);
}
function $b7e06600096fce03$export$db239ef39aadc7fe(t, r, a) {
    if ($b7e06600096fce03$var$Z(t)) return $b7e06600096fce03$var$se(0, "restore($store)"), t;
    if ($b7e06600096fce03$var$ee(t) || $b7e06600096fce03$var$te(t)) {
        let e = $b7e06600096fce03$var$V(t), n = $b7e06600096fce03$export$f51a9068ac82ea43(r, {
            parent: e,
            name: t.shortName,
            and: a
        });
        return $b7e06600096fce03$var$wt($b7e06600096fce03$var$te(t) ? t.doneData : t, n), e && e.hooks.store(n), n;
    }
    let n = Array.isArray(t) ? [] : {};
    return $b7e06600096fce03$var$e(t, (e, t)=>n[t] = $b7e06600096fce03$var$Z(e) ? e : $b7e06600096fce03$export$f51a9068ac82ea43(e, {
            name: t
        })), n;
}
function $b7e06600096fce03$export$65980d18b75784e2(...t) {
    let a, i, o = "split", [[l, s], c] = $b7e06600096fce03$var$f(t), p = !s;
    p && (a = l.cases, s = l.match, i = l.clock, l = l.source);
    let m = $b7e06600096fce03$var$Z(s), g = !$b7e06600096fce03$var$X(s) && $b7e06600096fce03$var$xe(s), h = !m && !g && $b7e06600096fce03$var$Me(s);
    $b7e06600096fce03$var$r($b7e06600096fce03$var$X(l), "source must be a unit"), a || (a = {}), p ? $b7e06600096fce03$var$e(a, (e, t)=>$b7e06600096fce03$var$Ae(o, e, `cases.${t}`)) : ($b7e06600096fce03$var$r(h, "match should be an object"), $b7e06600096fce03$var$e(s, (e, t)=>a[t] = $b7e06600096fce03$export$c30017717ce2168e({
            derived: 1,
            named: `cases.${t}`,
            and: c
        })), a.__ = $b7e06600096fce03$export$c30017717ce2168e({
        derived: 1,
        named: "cases.__",
        and: c
    }));
    let y, b = new Set([].concat(l, i || [], Object.values(a))), v = Object.keys(m || g ? a : s);
    if (m || g) m && b.add(s), y = [
        m && $b7e06600096fce03$var$Pe($b7e06600096fce03$var$W(s), 0, 1),
        $b7e06600096fce03$var$Re({
            safe: m,
            filter: 1,
            pure: !m,
            fn (e, t, r) {
                let a = String(m ? r.a : s(e));
                $b7e06600096fce03$var$_t(t, $b7e06600096fce03$var$ie(v, a) ? a : "__", e, r);
            }
        })
    ];
    else if (h) {
        let t = $b7e06600096fce03$var$Be({});
        t.type = "shape";
        let r, a = [];
        $b7e06600096fce03$var$e(s, (e, n)=>{
            if ($b7e06600096fce03$var$X(e)) {
                r = 1, $b7e06600096fce03$var$le(a, n), b.add(e);
                let i = $b7e06600096fce03$var$wt(e, [], [
                    $b7e06600096fce03$var$Pe(t),
                    $b7e06600096fce03$var$_e((e, t, { a: r })=>r[n] = e)
                ]);
                if ($b7e06600096fce03$var$Z(e)) {
                    t.current[n] = e.getState();
                    let r = $b7e06600096fce03$var$W(e);
                    $b7e06600096fce03$var$He(t, {
                        from: r,
                        field: n,
                        type: "field"
                    }), $b7e06600096fce03$var$d("splitMatchStore", r, i);
                }
            }
        }), r && $b7e06600096fce03$var$d("splitBase", t), y = [
            r && $b7e06600096fce03$var$Pe(t, 0, 1),
            $b7e06600096fce03$var$Le((e, t, r)=>{
                for(let n = 0; n < v.length; n++){
                    let i = v[n];
                    if ($b7e06600096fce03$var$ie(a, i) ? r.a[i] : s[i](e)) return void $b7e06600096fce03$var$_t(t, i, e, r);
                }
                $b7e06600096fce03$var$_t(t, "__", e, r);
            }, 1)
        ];
    } else $b7e06600096fce03$var$r(0, "expect match to be unit, function or object");
    let k = $b7e06600096fce03$export$270e7ba5936d3c48({
        meta: {
            op: o
        },
        parent: i ? [] : l,
        scope: a,
        node: y,
        family: {
            owners: Array.from(b)
        },
        regional: 1
    });
    if (i && $b7e06600096fce03$var$Ft(o, i, l, null, k, null, o, c, 0, 0, 0), !p) return a;
}
function $b7e06600096fce03$export$bcf8c46c380b2b4c(e, { scope: t, params: r } = {}) {
    if (!$b7e06600096fce03$var$X(e)) return Promise.reject(new Error("first argument should be unit"));
    if (!($b7e06600096fce03$var$te(e) || $b7e06600096fce03$var$ee(e) || $b7e06600096fce03$var$Z(e) || $b7e06600096fce03$var$ae(e))) return Promise.reject(new Error("first argument accepts only effects, events, stores or scopes"));
    $b7e06600096fce03$var$ae(e) && (t = e);
    let a = $b7e06600096fce03$var$h();
    a.parentFork = $b7e06600096fce03$var$et;
    let { fxCount: n } = t;
    $b7e06600096fce03$var$le(n.scope.defers, a);
    let o = [], l = [];
    return $b7e06600096fce03$var$ae(e) || ($b7e06600096fce03$var$le(o, e), $b7e06600096fce03$var$le(l, $b7e06600096fce03$var$te(e) ? {
        params: r,
        req: {
            rs (e) {
                a.value = {
                    status: "done",
                    value: e
                };
            },
            rj (e) {
                a.value = {
                    status: "fail",
                    value: e
                };
            }
        }
    } : r)), $b7e06600096fce03$var$le(o, n), $b7e06600096fce03$var$le(l, null), $b7e06600096fce03$export$9a7f3579b2beee84({
        target: o,
        params: l,
        scope: t
    }), a.req;
}
function $b7e06600096fce03$var$A(e, r, a) {
    let n = [];
    (function e(i) {
        $b7e06600096fce03$var$ie(n, i) || ($b7e06600096fce03$var$le(n, i), "store" === $b7e06600096fce03$var$J(i, "op") && (a || $b7e06600096fce03$var$J(i, "sid")) && r(i, $b7e06600096fce03$var$J(i, "sid")), $b7e06600096fce03$var$t(i.next, e), $b7e06600096fce03$var$t($b7e06600096fce03$var$T(i), e), $b7e06600096fce03$var$t($b7e06600096fce03$var$B(i), e));
    })(e);
}
function $b7e06600096fce03$var$I(e, a) {
    let n = Array.isArray(e) ? new Map(e) : e, i = new Map, o = 0;
    if (n instanceof Map) {
        let e = {};
        return $b7e06600096fce03$var$t(n, (t, n)=>{
            $b7e06600096fce03$var$r($b7e06600096fce03$var$X(n), "Map key should be a unit"), a && a(n, t), n.sid && (n.sid in e && (o = 1), e[n.sid] = t), i.set(n, t);
        }), {
            sidMap: e,
            unitMap: i,
            hasSidDoubles: o
        };
    }
    return {
        sidMap: n,
        unitMap: i
    };
}
function $b7e06600096fce03$export$7a5058c6b79333e0(e, a) {
    let i, o = e;
    $b7e06600096fce03$var$re(e) && (i = e, o = a);
    let l = ((e)=>{
        let r = $b7e06600096fce03$export$270e7ba5936d3c48({
            scope: {
                defers: [],
                inFlight: 0,
                fxID: 0
            },
            node: [
                $b7e06600096fce03$var$_e((e, t, r)=>{
                    $b7e06600096fce03$var$V(r) ? "dec" === $b7e06600096fce03$var$J($b7e06600096fce03$var$V(r).node, "needFxCounter") ? t.inFlight -= 1 : (t.inFlight += 1, t.fxID += 1) : t.fxID += 1;
                }),
                $b7e06600096fce03$var$Re({
                    priority: "sampler",
                    batch: 1
                }),
                $b7e06600096fce03$var$_e((e, r)=>{
                    let { defers: a, fxID: n } = r;
                    r.inFlight > 0 || 0 === a.length || Promise.resolve().then(()=>{
                        r.fxID === n && $b7e06600096fce03$var$t(a.splice(0, a.length), (e)=>{
                            $b7e06600096fce03$var$ot(e.parentFork), e.rs(e.value);
                        });
                    });
                }, 0, 1)
            ]
        }), a = $b7e06600096fce03$export$270e7ba5936d3c48({
            node: [
                $b7e06600096fce03$var$_e((e, t, r)=>{
                    let a = $b7e06600096fce03$var$V(r);
                    if (a) {
                        let t = a.node;
                        if (!$b7e06600096fce03$var$J(t, "isCombine") || $b7e06600096fce03$var$V(a) && "combine" !== $b7e06600096fce03$var$J($b7e06600096fce03$var$V(a).node, "op")) {
                            let a = $b7e06600096fce03$var$G(r), n = t.scope.state.id, i = $b7e06600096fce03$var$J(t, "sid");
                            a.sidIdMap[i] = n, a.values.sidMap[i] = e;
                            let o = $b7e06600096fce03$var$J(t, "serialize");
                            o && a.sidSerializeSettings.set(i, "ignore" === o ? {
                                ignore: 1
                            } : {
                                ignore: 0,
                                write: o.write
                            });
                        }
                    }
                })
            ]
        }), i = $b7e06600096fce03$export$270e7ba5936d3c48({
            node: [
                $b7e06600096fce03$var$_e((e, t, r)=>{
                    let a = $b7e06600096fce03$var$G(r);
                    if (a) {
                        let e = $b7e06600096fce03$var$V(r);
                        e && (!$b7e06600096fce03$var$J(e.node, "isCombine") || $b7e06600096fce03$var$V(e) && "combine" !== $b7e06600096fce03$var$J($b7e06600096fce03$var$V(e).node, "op")) && (a.warnSerialize = 1);
                    }
                })
            ]
        }), o = {
            cloneOf: e,
            reg: {},
            values: {
                sidMap: {},
                idMap: {}
            },
            sidIdMap: {},
            sidSerializeSettings: new Map,
            getState (e) {
                if ("current" in e) return $b7e06600096fce03$var$dt($b7e06600096fce03$var$nt, o, null, e).current;
                let t = $b7e06600096fce03$var$L(e);
                return $b7e06600096fce03$var$dt($b7e06600096fce03$var$nt, o, t, t.scope.state, 1).current;
            },
            kind: "scope",
            graphite: $b7e06600096fce03$export$270e7ba5936d3c48({
                family: {
                    type: "domain",
                    links: [
                        r,
                        a,
                        i
                    ]
                },
                meta: {
                    unit: "fork"
                },
                scope: {
                    forkInFlightCounter: r
                }
            }),
            additionalLinks: {},
            handlers: {
                sidMap: {},
                unitMap: new Map
            },
            fxCount: r,
            storeChange: a,
            warnSerializeNode: i,
            activeEffects: []
        };
        return o;
    })(i);
    if (o) {
        let e = o.scope;
        if (e) {
            let r = e.activeEffects;
            e.activeEffects = [], l.activeEffects = r, $b7e06600096fce03$var$t(r, (e)=>e.ref = l);
        }
        if (o.values) {
            let { sidMap: e, unitMap: a, hasSidDoubles: n } = $b7e06600096fce03$var$I(o.values, (e)=>$b7e06600096fce03$var$r($b7e06600096fce03$var$Z(e), "Values map can contain only stores as keys"));
            Object.assign(l.values.sidMap, e), $b7e06600096fce03$var$t(a, (e, t)=>{
                l.values.idMap[t.stateRef.id] = e;
            }), l.fromSerialize = !(Array.isArray(o.values) || o.values instanceof Map), l.hasSidDoubles = n;
        }
        o.handlers && (l.handlers = $b7e06600096fce03$var$I(o.handlers, (e)=>$b7e06600096fce03$var$r($b7e06600096fce03$var$te(e), "Handlers map can contain only effects as keys")));
    }
    return l;
}
function $b7e06600096fce03$export$fa8d919ba61d84db(e, { values: a }) {
    $b7e06600096fce03$var$r($b7e06600096fce03$var$Me(a), "values property should be an object");
    let { sidMap: n, unitMap: o } = $b7e06600096fce03$var$I(a), l = Object.getOwnPropertyNames(n), s = {};
    $b7e06600096fce03$var$t(o, (e, t)=>{
        s[t.stateRef.id] = t;
    });
    let f, d, u, c = [], p = [];
    $b7e06600096fce03$var$ae(e) ? (f = e, u = 1, $b7e06600096fce03$var$r(f.cloneOf, "scope should be created from domain"), d = $b7e06600096fce03$var$L(f.cloneOf)) : $b7e06600096fce03$var$re(e) ? d = $b7e06600096fce03$var$L(e) : $b7e06600096fce03$var$r(0, "first argument of hydrate should be domain or scope"), $b7e06600096fce03$var$A(d, (e, t)=>{
        if (t && $b7e06600096fce03$var$ie(l, t)) {
            $b7e06600096fce03$var$le(c, e);
            let r = $b7e06600096fce03$var$J(e, "serialize");
            r && "ignore" !== r && (n[t] = r.read(n[t])), $b7e06600096fce03$var$le(p, n[t]);
        } else e.scope.state.id in s && ($b7e06600096fce03$var$le(c, e), $b7e06600096fce03$var$le(p, o.get(s[e.scope.state.id])));
    }, 1), $b7e06600096fce03$export$9a7f3579b2beee84({
        target: c,
        params: p,
        scope: f
    }), u && Object.assign(f.values.sidMap, n);
}
function $b7e06600096fce03$export$18f6b3f66cc08bf(e, { scope: t, safe: a } = {}) {
    $b7e06600096fce03$var$r(t || $b7e06600096fce03$var$et || a, "scopeBind cannot be called outside of forked .watch");
    let n = t || $b7e06600096fce03$var$et;
    return $b7e06600096fce03$var$te(e) ? (t)=>{
        let r = $b7e06600096fce03$var$h();
        return $b7e06600096fce03$export$9a7f3579b2beee84({
            target: e,
            params: {
                params: t,
                req: r
            },
            scope: n
        }), r.req;
    } : (t)=>($b7e06600096fce03$export$9a7f3579b2beee84({
            target: e,
            params: t,
            scope: n
        }), t);
}
function $b7e06600096fce03$export$dfdc1655ccc5b9cb(t, a = {}) {
    t.warnSerialize && console.error("There is a store without sid in this scope, its value is omitted"), $b7e06600096fce03$var$r(!t.hasSidDoubles, "duplicate sid found in this scope");
    let n = a.ignore ? a.ignore.map(({ sid: e })=>e) : [], i = {};
    return $b7e06600096fce03$var$e(t.values.sidMap, (e, r)=>{
        var a;
        if ($b7e06600096fce03$var$ie(n, r)) return;
        let o = t.sidIdMap[r], l = null !== (a = t.sidSerializeSettings.get(r)) && void 0 !== a ? a : {
            ignore: 0,
            write: $b7e06600096fce03$var$Lt
        };
        l.ignore || (i[r] = (0, l.write)(o && o in t.reg ? t.reg[o].current : e));
    }), "onlyChanges" in a && !a.onlyChanges && ($b7e06600096fce03$var$r(t.cloneOf, "scope should be created from domain"), $b7e06600096fce03$var$A($b7e06600096fce03$var$L(t.cloneOf), (e, r)=>{
        r in i || $b7e06600096fce03$var$ie(n, r) || $b7e06600096fce03$var$J(e, "isCombine") || "ignore" === $b7e06600096fce03$var$J(e, "serialize") || (i[r] = t.getState(e));
    })), i;
}
function $b7e06600096fce03$export$940333bc61f71f83({ unit: e, fn: t, scope: r }) {
    let a = [
        $b7e06600096fce03$export$35d34bc0ed591a92.run({
            fn: (e)=>t(e)
        })
    ];
    if (r) {
        let t = $b7e06600096fce03$export$270e7ba5936d3c48({
            node: a
        }), i = e.graphite.id, o = r.additionalLinks, l = o[i] || [];
        return o[i] = l, l.push(t), $b7e06600096fce03$var$R(()=>{
            let e = l.indexOf(t);
            -1 !== e && l.splice(e, 1), $b7e06600096fce03$export$51cfe97d637c237c(t);
        });
    }
    {
        let t = $b7e06600096fce03$export$270e7ba5936d3c48({
            node: a,
            parent: [
                e
            ],
            family: {
                owners: e
            }
        });
        return $b7e06600096fce03$var$R(()=>{
            $b7e06600096fce03$export$51cfe97d637c237c(t);
        });
    }
}
function $b7e06600096fce03$var$R(e) {
    let t = ()=>e();
    return t.unsubscribe = ()=>e(), t;
}
let $b7e06600096fce03$var$E = "undefined" != typeof Symbol && Symbol.observable || "@@observable", $b7e06600096fce03$var$_ = "map", $b7e06600096fce03$var$P = "stack", $b7e06600096fce03$var$L = (e)=>e.graphite || e, $b7e06600096fce03$var$T = (e)=>e.family.owners, $b7e06600096fce03$var$B = (e)=>e.family.links, $b7e06600096fce03$var$W = (e)=>e.stateRef, $b7e06600096fce03$var$H = (e)=>e.value, $b7e06600096fce03$var$U = (e)=>e.subscribers, $b7e06600096fce03$var$V = (e)=>e.parent, $b7e06600096fce03$var$G = (e)=>e.scope, $b7e06600096fce03$var$J = (e, t)=>$b7e06600096fce03$var$L(e).meta[t], $b7e06600096fce03$var$K = (e, t, r)=>$b7e06600096fce03$var$L(e).meta[t] = r, $b7e06600096fce03$var$Q = (e)=>e.compositeName, $b7e06600096fce03$var$X = (e)=>($b7e06600096fce03$var$xe(e) || $b7e06600096fce03$var$Me(e)) && "kind" in e;
const $b7e06600096fce03$var$Y = (e)=>(t)=>$b7e06600096fce03$var$X(t) && t.kind === e;
let $b7e06600096fce03$var$Z = $b7e06600096fce03$var$Y("store"), $b7e06600096fce03$var$ee = $b7e06600096fce03$var$Y("event"), $b7e06600096fce03$var$te = $b7e06600096fce03$var$Y("effect"), $b7e06600096fce03$var$re = $b7e06600096fce03$var$Y("domain"), $b7e06600096fce03$var$ae = $b7e06600096fce03$var$Y("scope");
var $b7e06600096fce03$export$226b3eccf92c9ed9 = {
    __proto__: null,
    unit: $b7e06600096fce03$var$X,
    store: $b7e06600096fce03$var$Z,
    event: $b7e06600096fce03$var$ee,
    effect: $b7e06600096fce03$var$te,
    domain: $b7e06600096fce03$var$re,
    scope: $b7e06600096fce03$var$ae,
    attached: (e)=>$b7e06600096fce03$var$te(e) && 1 == $b7e06600096fce03$var$J(e, "attached")
};
let $b7e06600096fce03$var$ie = (e, t)=>e.includes(t), $b7e06600096fce03$var$oe = (e, t)=>{
    let r = e.indexOf(t);
    -1 !== r && e.splice(r, 1);
}, $b7e06600096fce03$var$le = (e, t)=>e.push(t), $b7e06600096fce03$var$se = (e, t, r)=>!e && console.error(`${t} is deprecated${r ? `, use ${r} instead` : ""}`);
const $b7e06600096fce03$var$fe = ()=>{
    let e = 0;
    return ()=>"" + ++e;
};
let $b7e06600096fce03$var$de, $b7e06600096fce03$var$ue = $b7e06600096fce03$var$fe(), $b7e06600096fce03$var$ce = $b7e06600096fce03$var$fe(), $b7e06600096fce03$var$pe = $b7e06600096fce03$var$fe(), $b7e06600096fce03$var$me = $b7e06600096fce03$var$fe(), $b7e06600096fce03$export$7980e214724429d7 = (e)=>{
    $b7e06600096fce03$var$de = e;
}, $b7e06600096fce03$var$he = null, $b7e06600096fce03$var$ye = (e)=>{
    $b7e06600096fce03$var$de && $b7e06600096fce03$var$de(e, $b7e06600096fce03$var$he);
}, $b7e06600096fce03$var$be = ()=>$b7e06600096fce03$var$he && $b7e06600096fce03$var$he.template, $b7e06600096fce03$var$ve = (e)=>(e && $b7e06600096fce03$var$he && $b7e06600096fce03$var$he.sidRoot && (e = `${$b7e06600096fce03$var$he.sidRoot}|${e}`), e), $b7e06600096fce03$export$84070f57da009beb = ({ sid: e, name: t, loc: r, method: i, fn: o })=>$b7e06600096fce03$export$2f9294bfc17c771e($b7e06600096fce03$export$270e7ba5936d3c48({
        meta: {
            sidRoot: $b7e06600096fce03$var$ve(e),
            sid: e,
            name: t,
            loc: r,
            method: i,
            type: "factory"
        }
    }), o), $b7e06600096fce03$var$we = (e, r)=>{
    let a = $b7e06600096fce03$var$L(e);
    $b7e06600096fce03$var$t(r, (e)=>{
        let t = $b7e06600096fce03$var$L(e);
        "domain" !== a.family.type && (t.family.type = "crosslink"), $b7e06600096fce03$var$le($b7e06600096fce03$var$T(t), a), $b7e06600096fce03$var$le($b7e06600096fce03$var$B(a), t);
    });
}, $b7e06600096fce03$var$Se = (e = [])=>(Array.isArray(e) ? e : [
        e
    ]).flat().map($b7e06600096fce03$var$L), $b7e06600096fce03$var$Me = (e)=>"object" == typeof e && null !== e, $b7e06600096fce03$var$xe = (e)=>"function" == typeof e, $b7e06600096fce03$var$$e = (e)=>void 0 === e, $b7e06600096fce03$var$ze = (e)=>$b7e06600096fce03$var$r($b7e06600096fce03$var$Me(e) || $b7e06600096fce03$var$xe(e), "expect first argument be an object");
const $b7e06600096fce03$var$je = (e, t, a, n)=>$b7e06600096fce03$var$r(!(!$b7e06600096fce03$var$Me(e) && !$b7e06600096fce03$var$xe(e) || !("family" in e) && !("graphite" in e)), `${t}: expect ${a} to be a unit (store, event or effect)${n}`);
let $b7e06600096fce03$var$Ce = (e, r, a)=>{
    Array.isArray(e) ? $b7e06600096fce03$var$t(e, (e, t)=>$b7e06600096fce03$var$je(e, r, `${t} item of ${a}`, "")) : $b7e06600096fce03$var$je(e, r, a, " or array of units");
}, $b7e06600096fce03$var$Ae = (e, r, a = "target")=>$b7e06600096fce03$var$t($b7e06600096fce03$var$Se(r), (t)=>$b7e06600096fce03$var$se(!$b7e06600096fce03$var$J(t, "derived"), `${e}: derived unit in "${a}"`, "createEvent/createStore")), $b7e06600096fce03$var$Ie = (e, { fn: t }, { a: r })=>t(e, r), $b7e06600096fce03$var$Oe = (e, { fn: t }, { a: r })=>t(r, e), $b7e06600096fce03$var$qe = (e, { fn: t })=>t(e);
const $b7e06600096fce03$var$Ne = (e, t, r, a)=>{
    let n = {
        id: $b7e06600096fce03$var$ce(),
        type: e,
        data: t
    };
    return r && (n.order = {
        priority: r
    }, a && (n.order.barrierID = ++$b7e06600096fce03$var$De)), n;
};
let $b7e06600096fce03$var$De = 0, $b7e06600096fce03$var$Fe = ({ from: e = "store", store: t, target: r, to: a = r ? "store" : $b7e06600096fce03$var$P, batch: n, priority: i })=>$b7e06600096fce03$var$Ne("mov", {
        from: e,
        store: t,
        to: a,
        target: r
    }, i, n), $b7e06600096fce03$var$Re = ({ fn: e, batch: t, priority: r, safe: a = 0, filter: n = 0, pure: i = 0 })=>$b7e06600096fce03$var$Ne("compute", {
        fn: e,
        safe: a,
        filter: n,
        pure: i
    }, r, t), $b7e06600096fce03$var$Ee = ({ fn: e })=>$b7e06600096fce03$var$Re({
        fn: e,
        priority: "effect"
    }), $b7e06600096fce03$var$_e = (e, t, r)=>$b7e06600096fce03$var$Re({
        fn: e,
        safe: 1,
        filter: t,
        priority: r && "effect"
    }), $b7e06600096fce03$var$Pe = (e, t, r)=>$b7e06600096fce03$var$Fe({
        store: e,
        to: t ? $b7e06600096fce03$var$P : "a",
        priority: r && "sampler",
        batch: 1
    }), $b7e06600096fce03$var$Le = (e = $b7e06600096fce03$var$qe, t)=>$b7e06600096fce03$var$Re({
        fn: e,
        pure: 1,
        filter: t
    }), $b7e06600096fce03$export$35d34bc0ed591a92 = {
    mov: $b7e06600096fce03$var$Fe,
    compute: $b7e06600096fce03$var$Re,
    filter: ({ fn: e, pure: t })=>$b7e06600096fce03$var$Re({
            fn: e,
            filter: 1,
            pure: t
        }),
    run: $b7e06600096fce03$var$Ee
}, $b7e06600096fce03$var$Be = (e)=>({
        id: $b7e06600096fce03$var$ce(),
        current: e
    }), $b7e06600096fce03$var$We = ({ current: e })=>e, $b7e06600096fce03$var$He = (e, t)=>{
    e.before || (e.before = []), $b7e06600096fce03$var$le(e.before, t);
}, $b7e06600096fce03$var$Ue = null;
const $b7e06600096fce03$var$Ve = (e, t)=>{
    if (!e) return t;
    if (!t) return e;
    let r;
    return (e.v.type === t.v.type && e.v.id > t.v.id || $b7e06600096fce03$var$Ye(e.v.type) > $b7e06600096fce03$var$Ye(t.v.type)) && (r = e, e = t, t = r), r = $b7e06600096fce03$var$Ve(e.r, t), e.r = e.l, e.l = r, e;
}, $b7e06600096fce03$var$Ge = [];
let $b7e06600096fce03$var$Je = 0;
for(; $b7e06600096fce03$var$Je < 6;)$b7e06600096fce03$var$le($b7e06600096fce03$var$Ge, {
    first: null,
    last: null,
    size: 0
}), $b7e06600096fce03$var$Je += 1;
const $b7e06600096fce03$var$Ke = ()=>{
    for(let e = 0; e < 6; e++){
        let t = $b7e06600096fce03$var$Ge[e];
        if (t.size > 0) {
            if (3 === e || 4 === e) {
                t.size -= 1;
                let e = $b7e06600096fce03$var$Ue.v;
                return $b7e06600096fce03$var$Ue = $b7e06600096fce03$var$Ve($b7e06600096fce03$var$Ue.l, $b7e06600096fce03$var$Ue.r), e;
            }
            1 === t.size && (t.last = null);
            let r = t.first;
            return t.first = r.r, t.size -= 1, r.v;
        }
    }
}, $b7e06600096fce03$var$Qe = (e, t, r, a, n, i, o)=>$b7e06600096fce03$var$Xe(0, {
        a: null,
        b: null,
        node: r,
        parent: a,
        value: n,
        page: t,
        scope: i,
        meta: o
    }, e), $b7e06600096fce03$var$Xe = (e, t, r, a = 0)=>{
    let n = $b7e06600096fce03$var$Ye(r), i = $b7e06600096fce03$var$Ge[n], o = {
        v: {
            idx: e,
            stack: t,
            type: r,
            id: a
        },
        l: null,
        r: null
    };
    3 === n || 4 === n ? $b7e06600096fce03$var$Ue = $b7e06600096fce03$var$Ve($b7e06600096fce03$var$Ue, o) : (0 === i.size ? i.first = o : i.last.r = o, i.last = o), i.size += 1;
}, $b7e06600096fce03$var$Ye = (e)=>{
    switch(e){
        case "child":
            return 0;
        case "pure":
            return 1;
        case "read":
            return 2;
        case "barrier":
            return 3;
        case "sampler":
            return 4;
        case "effect":
            return 5;
        default:
            return -1;
    }
}, $b7e06600096fce03$var$Ze = new Set;
let $b7e06600096fce03$var$et, $b7e06600096fce03$var$tt = 1, $b7e06600096fce03$var$rt = 0, $b7e06600096fce03$var$at = 0, $b7e06600096fce03$var$nt = null, $b7e06600096fce03$var$ot = (e)=>{
    $b7e06600096fce03$var$et = e;
}, $b7e06600096fce03$var$lt = (e)=>{
    $b7e06600096fce03$var$nt = e;
};
const $b7e06600096fce03$var$st = (e, t)=>{
    if (e) {
        for(; e && !e.reg[t];)e = $b7e06600096fce03$var$V(e);
        if (e) return e;
    }
    return null;
};
let $b7e06600096fce03$var$ft, $b7e06600096fce03$var$dt = (e, t, r, a, n)=>{
    let i = $b7e06600096fce03$var$st(e, a.id);
    return i ? i.reg[a.id] : t ? ($b7e06600096fce03$var$pt(t, a, n), t.reg[a.id]) : a;
}, $b7e06600096fce03$export$aa4047e72657c4f7 = (e)=>{
    $b7e06600096fce03$var$ft = e;
};
const $b7e06600096fce03$var$ct = (e)=>e;
let $b7e06600096fce03$var$pt = (e, r, a, n, i)=>{
    var o;
    let l = e.reg, s = r.sid, f = null == r || null === (o = r.meta) || void 0 === o ? void 0 : o.serialize, d = e.fromSerialize && "ignore" !== f && (null == f ? void 0 : f.read) || $b7e06600096fce03$var$ct;
    if (l[r.id]) return;
    let u = {
        id: r.id,
        current: r.current,
        meta: r.meta
    };
    if (u.id in e.values.idMap) u.current = e.values.idMap[u.id];
    else if (s && s in e.values.sidMap && !(s in e.sidIdMap)) u.current = d(e.values.sidMap[s]);
    else if (r.before && !i) {
        let i = 0, o = a || !r.noInit || n;
        $b7e06600096fce03$var$t(r.before, (t)=>{
            switch(t.type){
                case $b7e06600096fce03$var$_:
                    {
                        let r = t.from;
                        if (r || t.fn) {
                            r && $b7e06600096fce03$var$pt(e, r, a, n);
                            let i = r && l[r.id].current;
                            o && (u.current = t.fn ? t.fn(i) : i);
                        }
                        break;
                    }
                case "field":
                    i || (i = 1, u.current = Array.isArray(u.current) ? [
                        ...u.current
                    ] : {
                        ...u.current
                    }), $b7e06600096fce03$var$pt(e, t.from, a, n), o && (u.current[t.field] = l[l[t.from.id].id].current);
            }
        });
    }
    s && (e.sidIdMap[s] = r.id), l[r.id] = u;
};
const $b7e06600096fce03$var$mt = (e, t, r)=>{
    try {
        return t($b7e06600096fce03$var$H(r), e.scope, r);
    } catch (t) {
        console.error(t), e.fail = 1, e.failReason = t;
    }
};
let $b7e06600096fce03$var$gt = (t, r = {})=>($b7e06600096fce03$var$Me(t) && ($b7e06600096fce03$var$gt(t.or, r), $b7e06600096fce03$var$e(t, (e, t)=>{
        $b7e06600096fce03$var$$e(e) || "or" === t || "and" === t || (r[t] = e);
    }), $b7e06600096fce03$var$gt(t.and, r)), r);
const $b7e06600096fce03$var$ht = (e, t)=>{
    $b7e06600096fce03$var$oe(e.next, t), $b7e06600096fce03$var$oe($b7e06600096fce03$var$T(e), t), $b7e06600096fce03$var$oe($b7e06600096fce03$var$B(e), t);
}, $b7e06600096fce03$var$yt = (e, t, r)=>{
    let a;
    e.next.length = 0, e.seq.length = 0, e.scope = null;
    let n = $b7e06600096fce03$var$B(e);
    for(; a = n.pop();)$b7e06600096fce03$var$ht(a, e), (t || r && "sample" !== $b7e06600096fce03$var$J(e, "op") || "crosslink" === a.family.type) && $b7e06600096fce03$var$yt(a, t, "on" !== $b7e06600096fce03$var$J(a, "op") && r);
    for(n = $b7e06600096fce03$var$T(e); a = n.pop();)$b7e06600096fce03$var$ht(a, e), r && "crosslink" === a.family.type && $b7e06600096fce03$var$yt(a, t, "on" !== $b7e06600096fce03$var$J(a, "op") && r);
}, $b7e06600096fce03$var$bt = (e)=>e.clear();
let $b7e06600096fce03$export$51cfe97d637c237c = (e, { deep: t } = {})=>{
    let r = 0;
    if (e.ownerSet && e.ownerSet.delete(e), $b7e06600096fce03$var$Z(e)) $b7e06600096fce03$var$bt($b7e06600096fce03$var$U(e));
    else if ($b7e06600096fce03$var$re(e)) {
        r = 1;
        let t = e.history;
        $b7e06600096fce03$var$bt(t.events), $b7e06600096fce03$var$bt(t.effects), $b7e06600096fce03$var$bt(t.stores), $b7e06600096fce03$var$bt(t.domains);
    }
    $b7e06600096fce03$var$yt($b7e06600096fce03$var$L(e), !!t, r);
}, $b7e06600096fce03$var$kt = (e)=>{
    let t = ()=>$b7e06600096fce03$export$51cfe97d637c237c(e);
    return t.unsubscribe = t, t;
}, $b7e06600096fce03$var$wt = (e, t, r, a, i)=>$b7e06600096fce03$export$270e7ba5936d3c48({
        node: r,
        parent: e,
        child: t,
        scope: {
            fn: i
        },
        meta: {
            op: a
        },
        family: {
            owners: [
                e,
                t
            ],
            links: t
        },
        regional: 1
    }), $b7e06600096fce03$export$174bb771924e7eb1 = (e)=>{
    let t = "forward", [{ from: r, to: a }, i] = $b7e06600096fce03$var$f(e, 1);
    return $b7e06600096fce03$var$Ce(r, t, '"from"'), $b7e06600096fce03$var$Ce(a, t, '"to"'), $b7e06600096fce03$var$Ae(t, a, "to"), $b7e06600096fce03$var$kt($b7e06600096fce03$export$270e7ba5936d3c48({
        parent: r,
        child: a,
        meta: {
            op: t,
            config: i
        },
        family: {},
        regional: 1
    }));
}, $b7e06600096fce03$var$Mt = (e, t)=>($b7e06600096fce03$var$r($b7e06600096fce03$var$xe(t), ".watch argument should be a function"), $b7e06600096fce03$var$kt($b7e06600096fce03$export$270e7ba5936d3c48({
        scope: {
            fn: t
        },
        node: [
            $b7e06600096fce03$var$Ee({
                fn: $b7e06600096fce03$var$qe
            })
        ],
        parent: e,
        meta: {
            op: "watch"
        },
        family: {
            owners: e
        },
        regional: 1
    }))), $b7e06600096fce03$var$xt = (e, t, r = "event")=>{
    $b7e06600096fce03$var$V(e) && $b7e06600096fce03$var$V(e).hooks[r](t);
}, $b7e06600096fce03$var$$t = (e, t, r)=>{
    let a = $b7e06600096fce03$var$gt(r), n = "domain" === e, i = $b7e06600096fce03$var$ue(), { sid: o = null, named: l = null, domain: f = null, parent: d = f } = a, u = l || a.name || (n ? "" : i), c = $b7e06600096fce03$var$s(u, d), p = {
        op: t.kind = e,
        name: t.shortName = u,
        sid: t.sid = $b7e06600096fce03$var$ve(o),
        named: l,
        unitId: t.id = i,
        serialize: a.serialize,
        derived: a.derived,
        config: a
    };
    if (t.parent = d, t.compositeName = c, t.defaultConfig = a, t.thru = (e)=>($b7e06600096fce03$var$se(0, "thru", "js pipe"), e(t)), t.getType = ()=>c.fullName, !n) {
        t.subscribe = (e)=>($b7e06600096fce03$var$ze(e), t.watch($b7e06600096fce03$var$xe(e) ? e : (t)=>e.next && e.next(t))), t[$b7e06600096fce03$var$E] = ()=>t;
        let e = $b7e06600096fce03$var$be();
        e && (p.nativeTemplate = e);
    }
    return p;
};
const $b7e06600096fce03$var$zt = (e, t, r, a)=>{
    let n;
    $b7e06600096fce03$var$Me(r) && (n = r, r = r.fn);
    let i = $b7e06600096fce03$export$c30017717ce2168e({
        name: `${e.shortName} \u2192 *`,
        derived: 1,
        and: n
    });
    return $b7e06600096fce03$var$wt(e, i, a, t, r), i;
}, $b7e06600096fce03$var$jt = (e, t, r, a, n)=>{
    let i = $b7e06600096fce03$var$W(t), o = $b7e06600096fce03$var$Fe({
        store: i,
        to: "a",
        priority: "read"
    });
    r === $b7e06600096fce03$var$_ && (o.data.softRead = 1);
    let l = [
        o,
        $b7e06600096fce03$var$Le(a)
    ];
    return $b7e06600096fce03$var$d("storeOnMap", i, l, $b7e06600096fce03$var$Z(e) && $b7e06600096fce03$var$W(e)), $b7e06600096fce03$var$wt(e, t, l, r, n);
}, $b7e06600096fce03$var$Ct = (t, a, n, i, l)=>{
    let s = t ? (e)=>[
            ...e
        ] : (e)=>({
            ...e
        }), f = t ? [] : {}, u = s(f), c = $b7e06600096fce03$var$Be(u), m = $b7e06600096fce03$var$Be(1);
    c.type = t ? "list" : "shape", c.noInit = 1, $b7e06600096fce03$var$d("combineBase", c, m);
    let g = $b7e06600096fce03$export$f51a9068ac82ea43(u, {
        name: $b7e06600096fce03$var$o(n),
        derived: 1,
        and: i
    }), h = $b7e06600096fce03$var$W(g);
    h.noInit = 1, $b7e06600096fce03$var$K(g, "isCombine", 1);
    let y = $b7e06600096fce03$var$Pe(c);
    y.order = {
        priority: "barrier"
    };
    let b = [
        $b7e06600096fce03$var$_e((e, t, r)=>(r.scope && !r.scope.reg[c.id] && (r.c = 1), e)),
        y,
        $b7e06600096fce03$var$Fe({
            store: m,
            to: "b"
        }),
        $b7e06600096fce03$var$_e((e, { key: t }, r)=>{
            if (r.c || e !== r.a[t]) return a && r.b && (r.a = s(r.a)), r.a[t] = e, 1;
        }, 1),
        $b7e06600096fce03$var$Fe({
            from: "a",
            target: c
        }),
        $b7e06600096fce03$var$Fe({
            from: "value",
            store: 0,
            target: m
        }),
        $b7e06600096fce03$var$Fe({
            from: "value",
            store: 1,
            target: m,
            priority: "barrier",
            batch: 1
        }),
        $b7e06600096fce03$var$Pe(c, 1),
        l && $b7e06600096fce03$var$Le()
    ];
    return $b7e06600096fce03$var$e(n, (e, t)=>{
        if (!$b7e06600096fce03$var$Z(e)) return $b7e06600096fce03$var$r(!$b7e06600096fce03$var$X(e) && !$b7e06600096fce03$var$$e(e), `combine expects a store in a field ${t}`), void (u[t] = f[t] = e);
        f[t] = e.defaultState, u[t] = e.getState();
        let a = $b7e06600096fce03$var$wt(e, g, b, "combine", l);
        a.scope.key = t;
        let n = $b7e06600096fce03$var$W(e);
        $b7e06600096fce03$var$He(c, {
            type: "field",
            field: t,
            from: n
        }), $b7e06600096fce03$var$d("combineField", n, a);
    }), g.defaultShape = n, $b7e06600096fce03$var$He(h, {
        type: $b7e06600096fce03$var$_,
        from: c,
        fn: l
    }), $b7e06600096fce03$var$be() || (g.defaultState = l ? h.current = l(u) : f), g;
};
let $b7e06600096fce03$var$At = (e, t, r)=>{
    try {
        return [
            1,
            e(...r)
        ];
    } catch (e) {
        return t(e), [
            0,
            null
        ];
    }
}, $b7e06600096fce03$var$It = (e)=>{
    let t = $b7e06600096fce03$var$G(e), r = {
        ref: t
    };
    return t && $b7e06600096fce03$var$le(t.activeEffects, r), r;
}, $b7e06600096fce03$var$Ot = (e, t, r, a, n, o)=>(l)=>{
        o.ref && $b7e06600096fce03$var$oe(o.ref.activeEffects, o), $b7e06600096fce03$export$9a7f3579b2beee84({
            target: [
                a,
                $b7e06600096fce03$var$qt
            ],
            params: [
                r ? {
                    status: "done",
                    params: e,
                    result: l
                } : {
                    status: "fail",
                    params: e,
                    error: l
                },
                {
                    value: l,
                    fn: r ? t.rs : t.rj
                }
            ],
            defer: 1,
            page: n.page,
            scope: o.ref,
            meta: n.meta
        });
    };
const $b7e06600096fce03$var$qt = $b7e06600096fce03$export$270e7ba5936d3c48({
    node: [
        $b7e06600096fce03$var$Ee({
            fn: ({ fn: e, value: t })=>e(t)
        })
    ],
    meta: {
        op: "fx",
        fx: "sidechain"
    }
}), $b7e06600096fce03$var$Nt = [
    "source",
    "clock",
    "target"
], $b7e06600096fce03$var$Dt = (e, t)=>e + `: ${t} should be defined`;
let $b7e06600096fce03$var$Ft = (e, t, a, n, i, o, l, s, f, c, g, h)=>{
    let y = !!i;
    $b7e06600096fce03$var$r(!$b7e06600096fce03$var$$e(a) || !$b7e06600096fce03$var$$e(t), $b7e06600096fce03$var$Dt(e, "either source or clock"));
    let b = 0;
    $b7e06600096fce03$var$$e(a) ? b = 1 : $b7e06600096fce03$var$X(a) || (a = $b7e06600096fce03$export$1be1fc439b849fdf(a)), $b7e06600096fce03$var$$e(t) ? t = a : ($b7e06600096fce03$var$Ce(t, e, "clock"), Array.isArray(t) && (t = $b7e06600096fce03$export$4950aa0f605343fb(t))), b && (a = t), s || l || (l = a.shortName);
    let v = "none";
    (g || n) && ($b7e06600096fce03$var$X(n) ? v = "unit" : ($b7e06600096fce03$var$r($b7e06600096fce03$var$xe(n), "`filter` should be function or unit"), v = "fn")), i ? ($b7e06600096fce03$var$Ce(i, e, "target"), $b7e06600096fce03$var$Ae(e, i)) : "none" === v && c && $b7e06600096fce03$var$Z(a) && $b7e06600096fce03$var$Z(t) ? i = $b7e06600096fce03$export$f51a9068ac82ea43(o ? o($b7e06600096fce03$var$We($b7e06600096fce03$var$W(a)), $b7e06600096fce03$var$We($b7e06600096fce03$var$W(t))) : $b7e06600096fce03$var$We($b7e06600096fce03$var$W(a)), {
        name: l,
        sid: h,
        or: s
    }) : (i = $b7e06600096fce03$export$c30017717ce2168e({
        name: l,
        derived: 1,
        or: s
    }), $b7e06600096fce03$var$d("sampleTarget", $b7e06600096fce03$var$L(i)));
    let k = $b7e06600096fce03$var$Be(), w = [];
    if ("unit" === v) {
        let [r, a] = $b7e06600096fce03$var$Et(n, i, t, k, e);
        w = [
            ...$b7e06600096fce03$var$Rt(a),
            ...$b7e06600096fce03$var$Rt(r)
        ];
    }
    let [M, x] = $b7e06600096fce03$var$Et(a, i, t, k, e), $ = $b7e06600096fce03$var$wt(t, i, [
        $b7e06600096fce03$var$d("sampleSourceLoader"),
        $b7e06600096fce03$var$Fe({
            from: $b7e06600096fce03$var$P,
            target: k
        }),
        ...$b7e06600096fce03$var$Rt(x),
        $b7e06600096fce03$var$Pe(M, 1, f),
        ...w,
        $b7e06600096fce03$var$Pe(k),
        "fn" === v && $b7e06600096fce03$var$Le((e, t, { a: r })=>n(e, r), 1),
        o && $b7e06600096fce03$var$Le($b7e06600096fce03$var$Ie),
        $b7e06600096fce03$var$d("sampleSourceUpward", y)
    ], e, o);
    return $b7e06600096fce03$var$we(a, [
        $
    ]), Object.assign($.meta, s, {
        joint: 1
    }), i;
};
const $b7e06600096fce03$var$Rt = (e)=>[
        $b7e06600096fce03$var$Pe(e),
        $b7e06600096fce03$var$_e((e, t, { a: r })=>r, 1)
    ], $b7e06600096fce03$var$Et = (e, t, r, a, i)=>{
    let o = $b7e06600096fce03$var$Z(e), l = o ? $b7e06600096fce03$var$W(e) : $b7e06600096fce03$var$Be(), s = $b7e06600096fce03$var$Be(o);
    return o || $b7e06600096fce03$export$270e7ba5936d3c48({
        parent: e,
        node: [
            $b7e06600096fce03$var$Fe({
                from: $b7e06600096fce03$var$P,
                target: l
            }),
            $b7e06600096fce03$var$Fe({
                from: "value",
                store: 1,
                target: s
            })
        ],
        family: {
            owners: [
                e,
                t,
                r
            ],
            links: t
        },
        meta: {
            op: i
        },
        regional: 1
    }), $b7e06600096fce03$var$d("sampleSource", s, l, a), [
        l,
        s
    ];
}, $b7e06600096fce03$var$_t = (e, t, r, a)=>{
    let n = e[t];
    n && $b7e06600096fce03$export$9a7f3579b2beee84({
        target: n,
        params: Array.isArray(n) ? n.map(()=>r) : r,
        defer: 1,
        stack: a
    });
}, $b7e06600096fce03$export$83d89fbfd8236492 = "22.8.6", $b7e06600096fce03$var$Lt = (e)=>e;

});

parcelRequire.register("dAUoi", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $9e5a613b88f55972$export$dca3b0875bd9a954; }, function (v) { return $9e5a613b88f55972$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $9e5a613b88f55972$export$16fa2f45be04daa8; }, function (v) { return $9e5a613b88f55972$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $9e5a613b88f55972$export$ffb0004e005737fa; }, function (v) { return $9e5a613b88f55972$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $9e5a613b88f55972$export$e2c29f18771995cb; }, function (v) { return $9e5a613b88f55972$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $9e5a613b88f55972$export$221d75b3f55bb0bd; }, function (v) { return $9e5a613b88f55972$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $9e5a613b88f55972$export$5f8d39834fd61797; }, function (v) { return $9e5a613b88f55972$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $9e5a613b88f55972$export$74bf444e3cd11ea5; }, function (v) { return $9e5a613b88f55972$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $9e5a613b88f55972$export$ae55be85d98224ed; }, function (v) { return $9e5a613b88f55972$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $9e5a613b88f55972$export$e530037191fcd5d7; }, function (v) { return $9e5a613b88f55972$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $9e5a613b88f55972$export$fd42f52fd3ae1109; }, function (v) { return $9e5a613b88f55972$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $9e5a613b88f55972$export$c8a8987d4410bf2d; }, function (v) { return $9e5a613b88f55972$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $9e5a613b88f55972$export$d38cd72104c1f0e9; }, function (v) { return $9e5a613b88f55972$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $9e5a613b88f55972$export$7d1e3a5e95ceca43; }, function (v) { return $9e5a613b88f55972$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $9e5a613b88f55972$export$257a8862b851cb5b; }, function (v) { return $9e5a613b88f55972$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $9e5a613b88f55972$export$a8257692ac88316c; }, function (v) { return $9e5a613b88f55972$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $9e5a613b88f55972$export$488013bae63b21da; }, function (v) { return $9e5a613b88f55972$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $9e5a613b88f55972$export$7c73462e0d25e514; }, function (v) { return $9e5a613b88f55972$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $9e5a613b88f55972$export$7568632d0d33d16d; }, function (v) { return $9e5a613b88f55972$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $9e5a613b88f55972$export$88948ce120ea2619; }, function (v) { return $9e5a613b88f55972$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $9e5a613b88f55972$export$35808ee640e87ca7; }, function (v) { return $9e5a613b88f55972$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $9e5a613b88f55972$export$fae74005e78b1a27; }, function (v) { return $9e5a613b88f55972$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $9e5a613b88f55972$export$dc8fbce3eb94dc1e; }, function (v) { return $9e5a613b88f55972$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $9e5a613b88f55972$export$6a7bc4e911dc01cf; }, function (v) { return $9e5a613b88f55972$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $9e5a613b88f55972$export$6d9c69b0de29b591; }, function (v) { return $9e5a613b88f55972$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $9e5a613b88f55972$export$f680877a34711e37; }, function (v) { return $9e5a613b88f55972$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $9e5a613b88f55972$export$d5a552a76deda3c2; }, function (v) { return $9e5a613b88f55972$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $9e5a613b88f55972$export$aaabe4eda9ed9969; }, function (v) { return $9e5a613b88f55972$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $9e5a613b88f55972$export$e5c5a5f917a5871c; }, function (v) { return $9e5a613b88f55972$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $9e5a613b88f55972$export$1538c33de8887b59; }, function (v) { return $9e5a613b88f55972$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $9e5a613b88f55972$export$13e3392192263954; }, function (v) { return $9e5a613b88f55972$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $9e5a613b88f55972$export$b8f5890fc79d6aca; }, function (v) { return $9e5a613b88f55972$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $9e5a613b88f55972$export$60241385465d0a34; }, function (v) { return $9e5a613b88f55972$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $9e5a613b88f55972$export$306c0aa65ff9ec16; }, function (v) { return $9e5a613b88f55972$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $9e5a613b88f55972$export$7b286972b8d8ccbf; }, function (v) { return $9e5a613b88f55972$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $9e5a613b88f55972$export$83d89fbfd8236492; }, function (v) { return $9e5a613b88f55972$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9e5a613b88f55972$export$dca3b0875bd9a954;
var $9e5a613b88f55972$export$16fa2f45be04daa8;
var $9e5a613b88f55972$export$ffb0004e005737fa;
var $9e5a613b88f55972$export$e2c29f18771995cb;
var $9e5a613b88f55972$export$221d75b3f55bb0bd;
var $9e5a613b88f55972$export$5f8d39834fd61797;
var $9e5a613b88f55972$export$74bf444e3cd11ea5;
var $9e5a613b88f55972$export$ae55be85d98224ed;
var $9e5a613b88f55972$export$e530037191fcd5d7;
var $9e5a613b88f55972$export$fd42f52fd3ae1109;
var $9e5a613b88f55972$export$c8a8987d4410bf2d;
var $9e5a613b88f55972$export$d38cd72104c1f0e9;
var $9e5a613b88f55972$export$7d1e3a5e95ceca43;
var $9e5a613b88f55972$export$257a8862b851cb5b;
var $9e5a613b88f55972$export$a8257692ac88316c;
var $9e5a613b88f55972$export$488013bae63b21da;
var $9e5a613b88f55972$export$7c73462e0d25e514;
var $9e5a613b88f55972$export$7568632d0d33d16d;
var $9e5a613b88f55972$export$88948ce120ea2619;
var $9e5a613b88f55972$export$35808ee640e87ca7;
var $9e5a613b88f55972$export$fae74005e78b1a27;
var $9e5a613b88f55972$export$dc8fbce3eb94dc1e;
var $9e5a613b88f55972$export$6a7bc4e911dc01cf;
var $9e5a613b88f55972$export$6d9c69b0de29b591;
var $9e5a613b88f55972$export$f680877a34711e37;
var $9e5a613b88f55972$export$d5a552a76deda3c2;
var $9e5a613b88f55972$export$aaabe4eda9ed9969;
var $9e5a613b88f55972$export$e5c5a5f917a5871c;
var $9e5a613b88f55972$export$1538c33de8887b59;
var $9e5a613b88f55972$export$13e3392192263954;
var $9e5a613b88f55972$export$b8f5890fc79d6aca;
var $9e5a613b88f55972$export$60241385465d0a34;
var $9e5a613b88f55972$export$306c0aa65ff9ec16;
var $9e5a613b88f55972$export$7b286972b8d8ccbf;
var $9e5a613b88f55972$export$83d89fbfd8236492;
"use strict";
var $9e5a613b88f55972$var$l = Symbol.for("react.element"), $9e5a613b88f55972$var$n = Symbol.for("react.portal"), $9e5a613b88f55972$var$p = Symbol.for("react.fragment"), $9e5a613b88f55972$var$q = Symbol.for("react.strict_mode"), $9e5a613b88f55972$var$r = Symbol.for("react.profiler"), $9e5a613b88f55972$var$t = Symbol.for("react.provider"), $9e5a613b88f55972$var$u = Symbol.for("react.context"), $9e5a613b88f55972$var$v = Symbol.for("react.forward_ref"), $9e5a613b88f55972$var$w = Symbol.for("react.suspense"), $9e5a613b88f55972$var$x = Symbol.for("react.memo"), $9e5a613b88f55972$var$y = Symbol.for("react.lazy"), $9e5a613b88f55972$var$z = Symbol.iterator;
function $9e5a613b88f55972$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $9e5a613b88f55972$var$z && a[$9e5a613b88f55972$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $9e5a613b88f55972$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $9e5a613b88f55972$var$C = Object.assign, $9e5a613b88f55972$var$D = {};
function $9e5a613b88f55972$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $9e5a613b88f55972$var$D;
    this.updater = e || $9e5a613b88f55972$var$B;
}
$9e5a613b88f55972$var$E.prototype.isReactComponent = {};
$9e5a613b88f55972$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$9e5a613b88f55972$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $9e5a613b88f55972$var$F() {}
$9e5a613b88f55972$var$F.prototype = $9e5a613b88f55972$var$E.prototype;
function $9e5a613b88f55972$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $9e5a613b88f55972$var$D;
    this.updater = e || $9e5a613b88f55972$var$B;
}
var $9e5a613b88f55972$var$H = $9e5a613b88f55972$var$G.prototype = new $9e5a613b88f55972$var$F;
$9e5a613b88f55972$var$H.constructor = $9e5a613b88f55972$var$G;
$9e5a613b88f55972$var$C($9e5a613b88f55972$var$H, $9e5a613b88f55972$var$E.prototype);
$9e5a613b88f55972$var$H.isPureReactComponent = !0;
var $9e5a613b88f55972$var$I = Array.isArray, $9e5a613b88f55972$var$J = Object.prototype.hasOwnProperty, $9e5a613b88f55972$var$K = {
    current: null
}, $9e5a613b88f55972$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $9e5a613b88f55972$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$9e5a613b88f55972$var$J.call(b, d) && !$9e5a613b88f55972$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $9e5a613b88f55972$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $9e5a613b88f55972$var$K.current
    };
}
function $9e5a613b88f55972$var$N(a, b) {
    return {
        $$typeof: $9e5a613b88f55972$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $9e5a613b88f55972$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $9e5a613b88f55972$var$l;
}
function $9e5a613b88f55972$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $9e5a613b88f55972$var$P = /\/+/g;
function $9e5a613b88f55972$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $9e5a613b88f55972$var$escape("" + a.key) : b.toString(36);
}
function $9e5a613b88f55972$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $9e5a613b88f55972$var$l:
                case $9e5a613b88f55972$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $9e5a613b88f55972$var$Q(h, 0) : d, $9e5a613b88f55972$var$I(c) ? (e = "", null != a && (e = a.replace($9e5a613b88f55972$var$P, "$&/") + "/"), $9e5a613b88f55972$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($9e5a613b88f55972$var$O(c) && (c = $9e5a613b88f55972$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($9e5a613b88f55972$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($9e5a613b88f55972$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $9e5a613b88f55972$var$Q(k, g);
        h += $9e5a613b88f55972$var$R(k, b, e, f, c);
    }
    else if (f = $9e5a613b88f55972$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $9e5a613b88f55972$var$Q(k, g++), h += $9e5a613b88f55972$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $9e5a613b88f55972$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $9e5a613b88f55972$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $9e5a613b88f55972$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $9e5a613b88f55972$var$U = {
    current: null
}, $9e5a613b88f55972$var$V = {
    transition: null
}, $9e5a613b88f55972$var$W = {
    ReactCurrentDispatcher: $9e5a613b88f55972$var$U,
    ReactCurrentBatchConfig: $9e5a613b88f55972$var$V,
    ReactCurrentOwner: $9e5a613b88f55972$var$K
};
$9e5a613b88f55972$export$dca3b0875bd9a954 = {
    map: $9e5a613b88f55972$var$S,
    forEach: function(a, b, e) {
        $9e5a613b88f55972$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $9e5a613b88f55972$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $9e5a613b88f55972$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$9e5a613b88f55972$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$9e5a613b88f55972$export$16fa2f45be04daa8 = $9e5a613b88f55972$var$E;
$9e5a613b88f55972$export$ffb0004e005737fa = $9e5a613b88f55972$var$p;
$9e5a613b88f55972$export$e2c29f18771995cb = $9e5a613b88f55972$var$r;
$9e5a613b88f55972$export$221d75b3f55bb0bd = $9e5a613b88f55972$var$G;
$9e5a613b88f55972$export$5f8d39834fd61797 = $9e5a613b88f55972$var$q;
$9e5a613b88f55972$export$74bf444e3cd11ea5 = $9e5a613b88f55972$var$w;
$9e5a613b88f55972$export$ae55be85d98224ed = $9e5a613b88f55972$var$W;
$9e5a613b88f55972$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $9e5a613b88f55972$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $9e5a613b88f55972$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$9e5a613b88f55972$var$J.call(b, f) && !$9e5a613b88f55972$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $9e5a613b88f55972$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$9e5a613b88f55972$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $9e5a613b88f55972$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $9e5a613b88f55972$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$9e5a613b88f55972$export$c8a8987d4410bf2d = $9e5a613b88f55972$var$M;
$9e5a613b88f55972$export$d38cd72104c1f0e9 = function(a) {
    var b = $9e5a613b88f55972$var$M.bind(null, a);
    b.type = a;
    return b;
};
$9e5a613b88f55972$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$9e5a613b88f55972$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $9e5a613b88f55972$var$v,
        render: a
    };
};
$9e5a613b88f55972$export$a8257692ac88316c = $9e5a613b88f55972$var$O;
$9e5a613b88f55972$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $9e5a613b88f55972$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $9e5a613b88f55972$var$T
    };
};
$9e5a613b88f55972$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $9e5a613b88f55972$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$9e5a613b88f55972$export$7568632d0d33d16d = function(a) {
    var b = $9e5a613b88f55972$var$V.transition;
    $9e5a613b88f55972$var$V.transition = {};
    try {
        a();
    } finally{
        $9e5a613b88f55972$var$V.transition = b;
    }
};
$9e5a613b88f55972$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$9e5a613b88f55972$export$35808ee640e87ca7 = function(a, b) {
    return $9e5a613b88f55972$var$U.current.useCallback(a, b);
};
$9e5a613b88f55972$export$fae74005e78b1a27 = function(a) {
    return $9e5a613b88f55972$var$U.current.useContext(a);
};
$9e5a613b88f55972$export$dc8fbce3eb94dc1e = function() {};
$9e5a613b88f55972$export$6a7bc4e911dc01cf = function(a) {
    return $9e5a613b88f55972$var$U.current.useDeferredValue(a);
};
$9e5a613b88f55972$export$6d9c69b0de29b591 = function(a, b) {
    return $9e5a613b88f55972$var$U.current.useEffect(a, b);
};
$9e5a613b88f55972$export$f680877a34711e37 = function() {
    return $9e5a613b88f55972$var$U.current.useId();
};
$9e5a613b88f55972$export$d5a552a76deda3c2 = function(a, b, e) {
    return $9e5a613b88f55972$var$U.current.useImperativeHandle(a, b, e);
};
$9e5a613b88f55972$export$aaabe4eda9ed9969 = function(a, b) {
    return $9e5a613b88f55972$var$U.current.useInsertionEffect(a, b);
};
$9e5a613b88f55972$export$e5c5a5f917a5871c = function(a, b) {
    return $9e5a613b88f55972$var$U.current.useLayoutEffect(a, b);
};
$9e5a613b88f55972$export$1538c33de8887b59 = function(a, b) {
    return $9e5a613b88f55972$var$U.current.useMemo(a, b);
};
$9e5a613b88f55972$export$13e3392192263954 = function(a, b, e) {
    return $9e5a613b88f55972$var$U.current.useReducer(a, b, e);
};
$9e5a613b88f55972$export$b8f5890fc79d6aca = function(a) {
    return $9e5a613b88f55972$var$U.current.useRef(a);
};
$9e5a613b88f55972$export$60241385465d0a34 = function(a) {
    return $9e5a613b88f55972$var$U.current.useState(a);
};
$9e5a613b88f55972$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $9e5a613b88f55972$var$U.current.useSyncExternalStore(a, b, e);
};
$9e5a613b88f55972$export$7b286972b8d8ccbf = function() {
    return $9e5a613b88f55972$var$U.current.useTransition();
};
$9e5a613b88f55972$export$83d89fbfd8236492 = "18.2.0";

});

parcelRequire.register("fxh8I", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $b4f73ba085a115d1$export$bf730a2d8bf68b42; }, function (v) { return $b4f73ba085a115d1$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b4f73ba085a115d1$export$bf730a2d8bf68b42;
"use strict";

var $bFIWD = parcelRequire("bFIWD");

var $kVQJL = parcelRequire("kVQJL");
function $b4f73ba085a115d1$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b4f73ba085a115d1$var$q = "function" === typeof Object.is ? Object.is : $b4f73ba085a115d1$var$p, $b4f73ba085a115d1$var$r = $kVQJL.useSyncExternalStore, $b4f73ba085a115d1$var$t = $bFIWD.useRef, $b4f73ba085a115d1$var$u = $bFIWD.useEffect, $b4f73ba085a115d1$var$v = $bFIWD.useMemo, $b4f73ba085a115d1$var$w = $bFIWD.useDebugValue;
$b4f73ba085a115d1$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $b4f73ba085a115d1$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $b4f73ba085a115d1$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($b4f73ba085a115d1$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $b4f73ba085a115d1$var$r(a, c[0], c[1]);
    $b4f73ba085a115d1$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $b4f73ba085a115d1$var$w(d);
    return d;
};

});
parcelRequire.register("bFIWD", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dAUoi"));

});

parcelRequire.register("kVQJL", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ggEgU"));

});
parcelRequire.register("ggEgU", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $bd7d611a7accb736$export$306c0aa65ff9ec16; }, function (v) { return $bd7d611a7accb736$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bd7d611a7accb736$export$306c0aa65ff9ec16;
"use strict";

var $bFIWD = parcelRequire("bFIWD");
function $bd7d611a7accb736$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $bd7d611a7accb736$var$k = "function" === typeof Object.is ? Object.is : $bd7d611a7accb736$var$h, $bd7d611a7accb736$var$l = $bFIWD.useState, $bd7d611a7accb736$var$m = $bFIWD.useEffect, $bd7d611a7accb736$var$n = $bFIWD.useLayoutEffect, $bd7d611a7accb736$var$p = $bFIWD.useDebugValue;
function $bd7d611a7accb736$var$q(a, b) {
    var d = b(), f = $bd7d611a7accb736$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $bd7d611a7accb736$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $bd7d611a7accb736$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $bd7d611a7accb736$var$m(function() {
        $bd7d611a7accb736$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $bd7d611a7accb736$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $bd7d611a7accb736$var$p(d);
    return d;
}
function $bd7d611a7accb736$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$bd7d611a7accb736$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $bd7d611a7accb736$var$t(a, b) {
    return b();
}
var $bd7d611a7accb736$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $bd7d611a7accb736$var$t : $bd7d611a7accb736$var$q;
$bd7d611a7accb736$export$306c0aa65ff9ec16 = void 0 !== $bFIWD.useSyncExternalStore ? $bFIWD.useSyncExternalStore : $bd7d611a7accb736$var$u;

});




var $agnkb = parcelRequire("agnkb");
var $aea1af87e475eaac$exports = {};
// shim for using process in browser
var $aea1af87e475eaac$var$process = $aea1af87e475eaac$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $aea1af87e475eaac$var$cachedSetTimeout;
var $aea1af87e475eaac$var$cachedClearTimeout;
function $aea1af87e475eaac$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $aea1af87e475eaac$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $aea1af87e475eaac$var$cachedSetTimeout = setTimeout;
        else $aea1af87e475eaac$var$cachedSetTimeout = $aea1af87e475eaac$var$defaultSetTimout;
    } catch (e) {
        $aea1af87e475eaac$var$cachedSetTimeout = $aea1af87e475eaac$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $aea1af87e475eaac$var$cachedClearTimeout = clearTimeout;
        else $aea1af87e475eaac$var$cachedClearTimeout = $aea1af87e475eaac$var$defaultClearTimeout;
    } catch (e) {
        $aea1af87e475eaac$var$cachedClearTimeout = $aea1af87e475eaac$var$defaultClearTimeout;
    }
})();
function $aea1af87e475eaac$var$runTimeout(fun) {
    if ($aea1af87e475eaac$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($aea1af87e475eaac$var$cachedSetTimeout === $aea1af87e475eaac$var$defaultSetTimout || !$aea1af87e475eaac$var$cachedSetTimeout) && setTimeout) {
        $aea1af87e475eaac$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $aea1af87e475eaac$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $aea1af87e475eaac$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $aea1af87e475eaac$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $aea1af87e475eaac$var$runClearTimeout(marker) {
    if ($aea1af87e475eaac$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($aea1af87e475eaac$var$cachedClearTimeout === $aea1af87e475eaac$var$defaultClearTimeout || !$aea1af87e475eaac$var$cachedClearTimeout) && clearTimeout) {
        $aea1af87e475eaac$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $aea1af87e475eaac$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $aea1af87e475eaac$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $aea1af87e475eaac$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $aea1af87e475eaac$var$queue = [];
var $aea1af87e475eaac$var$draining = false;
var $aea1af87e475eaac$var$currentQueue;
var $aea1af87e475eaac$var$queueIndex = -1;
function $aea1af87e475eaac$var$cleanUpNextTick() {
    if (!$aea1af87e475eaac$var$draining || !$aea1af87e475eaac$var$currentQueue) return;
    $aea1af87e475eaac$var$draining = false;
    if ($aea1af87e475eaac$var$currentQueue.length) $aea1af87e475eaac$var$queue = $aea1af87e475eaac$var$currentQueue.concat($aea1af87e475eaac$var$queue);
    else $aea1af87e475eaac$var$queueIndex = -1;
    if ($aea1af87e475eaac$var$queue.length) $aea1af87e475eaac$var$drainQueue();
}
function $aea1af87e475eaac$var$drainQueue() {
    if ($aea1af87e475eaac$var$draining) return;
    var timeout = $aea1af87e475eaac$var$runTimeout($aea1af87e475eaac$var$cleanUpNextTick);
    $aea1af87e475eaac$var$draining = true;
    var len = $aea1af87e475eaac$var$queue.length;
    while(len){
        $aea1af87e475eaac$var$currentQueue = $aea1af87e475eaac$var$queue;
        $aea1af87e475eaac$var$queue = [];
        while(++$aea1af87e475eaac$var$queueIndex < len)if ($aea1af87e475eaac$var$currentQueue) $aea1af87e475eaac$var$currentQueue[$aea1af87e475eaac$var$queueIndex].run();
        $aea1af87e475eaac$var$queueIndex = -1;
        len = $aea1af87e475eaac$var$queue.length;
    }
    $aea1af87e475eaac$var$currentQueue = null;
    $aea1af87e475eaac$var$draining = false;
    $aea1af87e475eaac$var$runClearTimeout(timeout);
}
$aea1af87e475eaac$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $aea1af87e475eaac$var$queue.push(new $aea1af87e475eaac$var$Item(fun, args));
    if ($aea1af87e475eaac$var$queue.length === 1 && !$aea1af87e475eaac$var$draining) $aea1af87e475eaac$var$runTimeout($aea1af87e475eaac$var$drainQueue);
};
// v8 likes predictible objects
function $aea1af87e475eaac$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$aea1af87e475eaac$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$aea1af87e475eaac$var$process.title = "browser";
$aea1af87e475eaac$var$process.browser = true;
$aea1af87e475eaac$var$process.env = {};
$aea1af87e475eaac$var$process.argv = [];
$aea1af87e475eaac$var$process.version = ""; // empty string to avoid regexp issues
$aea1af87e475eaac$var$process.versions = {};
function $aea1af87e475eaac$var$noop() {}
$aea1af87e475eaac$var$process.on = $aea1af87e475eaac$var$noop;
$aea1af87e475eaac$var$process.addListener = $aea1af87e475eaac$var$noop;
$aea1af87e475eaac$var$process.once = $aea1af87e475eaac$var$noop;
$aea1af87e475eaac$var$process.off = $aea1af87e475eaac$var$noop;
$aea1af87e475eaac$var$process.removeListener = $aea1af87e475eaac$var$noop;
$aea1af87e475eaac$var$process.removeAllListeners = $aea1af87e475eaac$var$noop;
$aea1af87e475eaac$var$process.emit = $aea1af87e475eaac$var$noop;
$aea1af87e475eaac$var$process.prependListener = $aea1af87e475eaac$var$noop;
$aea1af87e475eaac$var$process.prependOnceListener = $aea1af87e475eaac$var$noop;
$aea1af87e475eaac$var$process.listeners = function(name) {
    return [];
};
$aea1af87e475eaac$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$aea1af87e475eaac$var$process.cwd = function() {
    return "/";
};
$aea1af87e475eaac$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$aea1af87e475eaac$var$process.umask = function() {
    return 0;
};


function $133989e677847899$var$e(e, t) {
    e.cursor[t].prev && (e.cursor[t].prev.cursor[t].next = e.cursor[t].next), e.cursor[t].next && (e.cursor[t].next.cursor[t].prev = e.cursor[t].prev), e.queue[t].last === e && (e.queue[t].last = e.cursor[t].prev), e.queue[t].first === e && (e.queue[t].first = e.cursor[t].next), e.cursor[t].prev = null, e.cursor[t].next = null;
}
function $133989e677847899$var$t(e) {
    var t, l;
    e.status = "active", t = $133989e677847899$var$a(e), (l = e).cursor.prev && (l.cursor.prev.cursor.next = l.cursor.next), l.cursor.next && (l.cursor.next.cursor.prev = l.cursor.prev), t.last === l && (t.last = l.cursor.prev), t.first === l && (t.first = l.cursor.next), l.cursor.prev = null, l.cursor.next = null;
}
function $133989e677847899$var$a(e) {
    return e.group.activeChilds[e.priority];
}
function $133989e677847899$var$l(e, a) {
    a.value.active = a.value.pending = e, "active" !== a.status && $133989e677847899$var$t(a);
}
function $133989e677847899$var$n(l, n) {
    if (n.value.active === l) return n.value.pending = l, void ("pending" === n.status && ($133989e677847899$var$t(n), $133989e677847899$var$a(n).first || $133989e677847899$var$e(n.group, n.priority)));
    var r, o, i, s;
    "active" === n.status && (n.status = "pending", $133989e677847899$var$a(n).first || ((i = n.group).queue[s = n.priority].last ? (i.cursor[s].prev = i.queue[s].last, i.queue[s].last.cursor[s].next = i, i.queue[s].last = i) : i.queue[s].first = i.queue[s].last = i), o = n, (r = $133989e677847899$var$a(n)).last ? (o.cursor.prev = r.last, r.last.cursor.next = o, r.last = o) : r.first = r.last = o), n.value.pending = l, n.group.queue.rafID || (n.group.queue.rafID = $133989e677847899$var$Ae(n.group.queue.execQueue));
}
function $133989e677847899$var$r(a) {
    $133989e677847899$var$Te("execQueue");
    let l, n, r = $133989e677847899$var$we(), o = 0;
    e: for(; a.props.first || a.tree.first || a.data.first;){
        if ($133989e677847899$var$we() - r >= 1e3) {
            o = 1;
            break e;
        }
        let i = !!a.props.first;
        for(i && $133989e677847899$var$Te("props"); l = a.props.first;){
            for(; n = l.activeChilds.props.first;){
                if ($133989e677847899$var$we() - r >= 1e3) {
                    o = 1, $133989e677847899$var$qe("props");
                    break e;
                }
                n.runOp(n.value.pending), n.value.active = n.value.pending, $133989e677847899$var$t(n);
            }
            $133989e677847899$var$e(l, "props");
        }
        i && $133989e677847899$var$qe("props");
        let s = !!a.tree.first;
        for(s && $133989e677847899$var$Te("tree"); l = a.tree.first;){
            for(; n = l.activeChilds.tree.first;){
                if ($133989e677847899$var$we() - r >= 1e3) {
                    o = 1, $133989e677847899$var$qe("tree");
                    break e;
                }
                n.runOp(n.value.pending), n.value.active = n.value.pending, $133989e677847899$var$t(n);
            }
            $133989e677847899$var$e(l, "tree");
        }
        s && $133989e677847899$var$qe("tree");
        let c = !!a.data.first;
        for(c && $133989e677847899$var$Te("data"); l = a.data.first;){
            for(; n = l.activeChilds.data.first;){
                if ($133989e677847899$var$we() - r >= 1e3) {
                    o = 1, $133989e677847899$var$qe("data");
                    break e;
                }
                n.runOp(n.value.pending), n.value.active = n.value.pending, $133989e677847899$var$t(n);
            }
            $133989e677847899$var$e(l, "data");
        }
        c && $133989e677847899$var$qe("data");
    }
    if ($133989e677847899$var$qe("execQueue"), o) a.rafID = $133989e677847899$var$Ae(a.execQueue);
    else if (a.rafID = null, a.onDrain) {
        let e = a.onDrain;
        a.onDrain = null, e();
    }
}
function $133989e677847899$var$o({ value: e, runOp: t, group: a, priority: l }) {
    return {
        value: {
            active: e,
            pending: e
        },
        runOp: t,
        status: "active",
        priority: l,
        group: a,
        cursor: {
            prev: null,
            next: null
        }
    };
}
function $133989e677847899$var$i({ onComplete: e }) {
    let t = {
        props: {
            first: null,
            last: null
        },
        tree: {
            first: null,
            last: null
        },
        data: {
            first: null,
            last: null
        },
        rafID: null,
        execQueue () {},
        onDrain: e
    };
    return t.execQueue = $133989e677847899$var$r.bind(null, t), t;
}
function $133989e677847899$var$s(e) {
    return {
        ops: [],
        queue: e,
        activeChilds: {
            props: {
                first: null,
                last: null
            },
            tree: {
                first: null,
                last: null
            },
            data: {
                first: null,
                last: null
            }
        },
        cursor: {
            props: {
                prev: null,
                next: null
            },
            tree: {
                prev: null,
                next: null
            },
            data: {
                prev: null,
                next: null
            }
        }
    };
}
function $133989e677847899$var$c({ value: e, group: t, onInit: a, onChange: l }) {
    let r = $133989e677847899$var$o({
        value: e,
        group: t,
        runOp (e) {
            i.status = "A", l(e);
        },
        priority: "data"
    }), i = {
        status: "IA",
        value: r.value,
        ops: {
            init: $133989e677847899$var$o({
                value: 0,
                group: t,
                runOp (e) {
                    i.status = "A", a(i.value.active);
                },
                priority: "data"
            }),
            change: r,
            terminate: $133989e677847899$var$o({
                value: 0,
                group: t,
                runOp (e) {
                    i.status = "T";
                },
                priority: "data"
            })
        }
    };
    return $133989e677847899$var$n(1, i.ops.init), i;
}
function $133989e677847899$var$u(e) {
    switch(e.status){
        case "I":
        case "T":
        case "AT":
            return;
        case "A":
            e.status = "AT", $133989e677847899$var$n(1, e.ops.terminate);
            break;
        case "AA":
            e.status = "AT", $133989e677847899$var$n(1, e.ops.terminate), $133989e677847899$var$n(e.value.active, e.ops.change);
            break;
        case "IA":
            e.status = "T", $133989e677847899$var$n(0, e.ops.init);
    }
}
function $133989e677847899$var$p(e, t) {
    switch(t.status){
        case "I":
        case "T":
            return;
        case "A":
            t.value.active !== e && (t.status = "AA", $133989e677847899$var$n(e, t.ops.change));
            break;
        case "AA":
            t.value.active === e ? (t.status = "A", $133989e677847899$var$n(e, t.ops.change)) : t.value.pending !== e && (t.value.pending = e);
            break;
        case "IA":
            t.value.active = t.value.pending = e;
    }
}
function $133989e677847899$var$d(e) {
    switch(e = String(e)){
        case "__proto__":
        case "__defineGetter__":
        case "__defineSetter__":
        case "constructor":
        case "prototype":
        case "hasOwnProperty":
        case "toString":
        case "valueOf":
        case "setProperty":
        case "removeProperty":
            return "forbidden";
        default:
            return e.replace(/[^a-zA-Z0-9\-_]/g, "");
    }
}
function $133989e677847899$var$f(e, t) {
    for(let a = 0; a < t.length; a++){
        let { type: l, field: n, value: r } = t[a];
        $133989e677847899$var$Re[l](e, n, r);
    }
}
function $133989e677847899$var$m(e) {
    return "" !== e && 0 !== e && "0" !== e && (0 == e || null == e);
}
function $133989e677847899$var$v(e, t, a) {
    $133989e677847899$var$m(a) ? e.style.removeProperty(`--${t}`) : e.style.setProperty(`--${t}`, `${a}`);
}
function $133989e677847899$var$h(e, t, a) {
    $133989e677847899$var$m(a) ? delete e.style[t] : e.style[t] = `${a}`;
}
function $133989e677847899$var$g(e, t, a) {
    t && t.trim().length > 0 && (a ? e.classList.add(t) : (e.classList.remove(t), 0 === e.classList.length && e.removeAttribute("class")));
}
function $133989e677847899$var$b(e, t, a) {
    $133989e677847899$var$m(a) ? delete e.dataset[t] : e.dataset[t] = `${a}`;
}
function $133989e677847899$var$y(e, t, a) {
    if ($133989e677847899$var$m(a)) {
        switch(t){
            case "value":
                delete e.value;
                break;
            case "checked":
                e.checked = 0;
                break;
            case "spellcheck":
                if (0 == a) return void e.setAttribute("spellcheck", "false");
        }
        e.removeAttribute(t);
    } else {
        switch(t){
            case "value":
                e.value = `${a}`;
                break;
            case "checked":
                e.checked = `${a}`;
        }
        e.setAttribute(t, `${a}`);
    }
}
function $133989e677847899$var$k(e, t) {
    e.replaceData(0, (e.textContent || "").length, String(t));
}
function $133989e677847899$var$I({ fn: e, state: t = {}, defer: a = 0, name: l = "", draft: n, isSvgRoot: r, namespace: o, env: i, isBlock: s = 0 }) {
    let c = $133989e677847899$var$Ne, u = {
        id: ++$133989e677847899$var$Le,
        name: l,
        plain: [],
        watch: [],
        nameMap: {},
        pages: [],
        closure: [],
        childTemplates: [],
        handlers: $133989e677847899$var$Ee,
        upward: (0, $agnkb.step).filter({
            fn (e, t, a) {
                if (!a.page) {
                    if (!a.parent || !a.parent.page) return 1;
                    a.page = a.parent.page;
                }
                if (!a.page.root.activeSpawns.has(a.page.fullID)) return console.count("inactive page upward"), 0;
                let l = [
                    a.page.template
                ], n = [
                    a.page
                ];
                {
                    let e = a.page.parent;
                    for(; e;)n.push(e), l.push(e.template), e = e.parent;
                }
                return a.node.next.forEach((t)=>{
                    let r = t.meta.nativeTemplate;
                    if (r) {
                        if (l.includes(r)) {
                            let o = n[l.indexOf(r)];
                            (0, $agnkb.launch)({
                                target: t,
                                params: e,
                                defer: 1,
                                page: o,
                                stack: a,
                                scope: a.scope
                            });
                        } else console.error("context drift", {
                            stack: a,
                            node: t
                        });
                    } else (0, $agnkb.launch)({
                        target: t,
                        params: e,
                        defer: 1,
                        page: a.page,
                        stack: a,
                        scope: a.scope
                    });
                }), 0;
            }
        }),
        loader: (0, $agnkb.step).filter({
            fn (e, t, a) {
                if (a.parent) {
                    let t = a.scope ? a.scope.graphite.id : null;
                    if (a.page) {
                        if (!a.page.root.activeSpawns.has(a.page.fullID)) return console.count("inactive page loader"), 0;
                        if (a.page.template === u) return 1;
                        if (a.page.root.childSpawns[a.page.fullID][u.id]) a.page.root.childSpawns[a.page.fullID][u.id].forEach((l)=>{
                            (!t || l.root.scope && t === l.root.scope.graphite.id) && (0, $agnkb.launch)({
                                params: e,
                                target: a.node,
                                page: l,
                                defer: 1,
                                scope: a.scope
                            });
                        });
                        else {
                            let l = a.page.fullID, n = "rec" === a.page.template.name;
                            u.pages.forEach((r)=>{
                                if (!t || r.root.scope && t === r.root.scope.graphite.id) {
                                    if (r.fullID === l || r.fullID.startsWith(`${l}_`)) {
                                        let t = 1;
                                        if (n) {
                                            let e = a.page.template.id, l = r.parent;
                                            for(; l && l !== a.page;){
                                                if (l.template.id === e) {
                                                    t = 0;
                                                    break;
                                                }
                                                l = l.parent;
                                            }
                                        }
                                        t && (0, $agnkb.launch)({
                                            params: e,
                                            target: a.node,
                                            page: r,
                                            defer: 1,
                                            scope: a.scope
                                        });
                                    } else l.startsWith(`${r.fullID}_`) && (0, $agnkb.launch)({
                                        params: e,
                                        target: a.node,
                                        page: a.page,
                                        defer: 1,
                                        scope: a.scope
                                    });
                                }
                            });
                        }
                    } else u.pages.forEach((l)=>{
                        (!t || l.root.scope && t === l.root.scope.graphite.id) && (0, $agnkb.launch)({
                            params: e,
                            target: a.node,
                            page: l,
                            defer: 1,
                            scope: a.scope
                        });
                    });
                    return 0;
                }
                return 1;
            }
        }),
        parent: c,
        node: null,
        api: null,
        trigger: {
            mount: (0, $agnkb.createEvent)({
                named: "mount"
            })
        },
        draft: n,
        isSvgRoot: r,
        namespace: o,
        env: i,
        isBlock: s || !(!c || !c.isBlock)
    };
    c && c.childTemplates.push(u);
    let p = (0, $agnkb.createNode)({
        meta: {
            template: u
        }
    });
    return u.node = p, $133989e677847899$var$Ne = u, a ? u.deferredInit = ()=>{
        let a = $133989e677847899$var$Ne;
        $133989e677847899$var$Ne = u, u.deferredInit = null;
        try {
            (0, $agnkb.withRegion)(p, ()=>{
                let a = (0, $agnkb.restore)(t);
                u.api = e(a, u.trigger), u.nameMap = a;
            });
        } finally{
            $133989e677847899$var$Ne = a;
        }
    } : (0, $agnkb.withRegion)(p, ()=>{
        let a = (0, $agnkb.restore)(t);
        u.api = e(a, u.trigger), u.nameMap = a;
    }), $133989e677847899$var$Ne = c, u;
}
function $133989e677847899$var$x(e, t) {
    let a;
    switch(a = t ? t.getState(e) : e.current, e.type){
        case "list":
            return [
                ...a
            ];
        case "shape":
            return {
                ...a
            };
        default:
            return a;
    }
}
function $133989e677847899$var$w(e, t, a) {
    let l = t;
    for(; l && !$133989e677847899$var$Fe(l, e);)l = l.parent;
    return l ? $133989e677847899$var$Fe(l, e) : a ? (a.getState(e), a.reg[e.id]) : e;
}
function $133989e677847899$var$S(e, t) {
    $133989e677847899$var$Fe(t, e) || (t.reg[e.id] = $133989e677847899$var$w(e, t.parent, t.root.scope));
}
function $133989e677847899$var$D(e, t, a) {
    t in a || (a[t] = []), a[t].push(...e);
}
function $133989e677847899$var$C(e, { values: t = {}, parentLeaf: a, mountNode: l, svgRoot: n, leafData: r, opGroup: o, domSubtree: i, hydration: s, root: c }) {
    function u(e) {
        if (e.before) for(let t = 0; t < e.before.length; t++){
            let a = e.before[t];
            switch(a.type){
                case "map":
                    {
                        let t, l = a.from;
                        if (!a.fn && !l) break;
                        l && ($133989e677847899$var$S(l, f), t = d[l.id].current), d[e.id].current = a.fn ? a.fn(t) : t;
                        break;
                    }
                case "field":
                    {
                        let t = a.from;
                        $133989e677847899$var$S(t, f), d[e.id].current[a.field] = d[t.id].current;
                        break;
                    }
                case "closure":
                    $133989e677847899$var$S(a.of, f);
            }
        }
    }
    function p(e, t, a) {
        let l;
        t.stop = 1;
        try {
            for(; t.i < e.length;)l = e[t.i], t.i++, l.fn(a[l.of.id] ? a[l.of.id].current : $133989e677847899$var$w(l.of, f.parent, f.root.scope).current);
        } catch (e) {
            console.error(e), t.stop = 0;
        }
    }
    let d = {}, f = {
        draft: e.draft,
        svgRoot: n,
        data: r,
        parent: a,
        hydration: s,
        mountNode: l,
        root: c,
        id: ++$133989e677847899$var$Me,
        fullID: "",
        reg: d,
        template: e
    };
    e.pages.push(f);
    let m = $133989e677847899$var$Be;
    $133989e677847899$var$Be = f, a && $133989e677847899$var$D([
        f
    ], e.id, c.childSpawns[a.fullID]), f.fullID = a ? `${a.fullID}_${f.id}` : `${f.id}`, c.childSpawns[f.fullID] = {}, c.activeSpawns.add(f.fullID), c.leafOps[f.fullID] = {
        group: o,
        domSubtree: i
    };
    for(let t = 0; t < e.closure.length; t++){
        let a = e.closure[t], l = a, n = f.parent;
        e: for(; n;){
            if ($133989e677847899$var$Fe(n, a)) {
                l = $133989e677847899$var$Fe(n, a);
                break e;
            }
            n = n.parent;
        }
        !n && c.scope && (c.scope.getState(a), l = c.scope.reg[a.id]), d[a.id] = l;
    }
    for(let t = 0; t < e.plain.length; t++){
        let a = e.plain[t], l = {
            id: a.id,
            current: $133989e677847899$var$x(a, c.scope)
        };
        d[a.id] = l;
    }
    for(let a in t){
        let l = e.nameMap[a].stateRef.id;
        d[l] = {
            id: l,
            current: t[a]
        };
    }
    e.closure.forEach(u), e.plain.forEach(u);
    let v = {
        i: 0,
        stop: 0
    };
    for(; !v.stop;)p(e.watch, v, d);
    if (a) for(let e in c.childSpawns[f.fullID])$133989e677847899$var$D(c.childSpawns[f.fullID][e], e, c.childSpawns[a.fullID]);
    if ($133989e677847899$var$_e) $133989e677847899$var$_e.steps.push({
        target: e.trigger.mount,
        params: f,
        defer: 1,
        page: f,
        scope: c.scope
    });
    else {
        let t;
        $133989e677847899$var$_e = {
            parent: $133989e677847899$var$_e,
            steps: [
                {
                    target: e.trigger.mount,
                    params: f,
                    defer: 1,
                    page: f,
                    scope: c.scope
                }
            ]
        };
        do for(; t = $133989e677847899$var$_e.steps.shift();)$133989e677847899$var$_e = {
            parent: $133989e677847899$var$_e,
            steps: []
        }, (0, $agnkb.launch)(t);
        while ($133989e677847899$var$_e = $133989e677847899$var$_e.parent);
    }
    return $133989e677847899$var$Be = m, f;
}
function $133989e677847899$var$O(e) {
    let t = e.parent;
    for(; "element" !== t.type && "using" !== t.type;)t = t.parent;
    return t ? t.value : null;
}
function $133989e677847899$var$T(e) {
    if (!e.visible) return null;
    switch(e.type){
        case "text":
        case "element":
            return e;
        case "LF":
        case "route":
        case "rec":
        case "recItem":
        case "block":
        case "blockItem":
            for(let t = e.child.length - 1; t >= 0; t--){
                let a = $133989e677847899$var$T(e.child[t]);
                if (a) return a;
            }
            return null;
        case "list":
            {
                let t = e.lastChild;
                if (!t) return null;
                for(; t;){
                    let e = $133989e677847899$var$T(t);
                    if (e) return e;
                    t = t.left;
                }
                return null;
            }
        default:
            return null;
    }
}
function $133989e677847899$var$q(e) {
    switch(e.type){
        case "using":
            return null;
        case "LF":
            {
                let t = e.left;
                for(; t;){
                    let e = $133989e677847899$var$T(t);
                    if (e) return e;
                    t = t.left;
                }
                return $133989e677847899$var$q(e.parent);
            }
        case "element":
        case "text":
        case "route":
        case "rec":
        case "recItem":
        case "block":
        case "blockItem":
        case "list":
            {
                let t = e.parent;
                for(let a = e.index - 1; a >= 0; a--){
                    let e = t.child[a];
                    if (!e) continue;
                    let l = $133989e677847899$var$T(e);
                    if (l) return l;
                }
                switch(t.type){
                    case "element":
                    case "using":
                        return null;
                }
                return $133989e677847899$var$q(t);
            }
        default:
            return null;
    }
}
function $133989e677847899$var$A(e) {
    let t = $133989e677847899$var$q(e);
    return t ? t.value : null;
}
function $133989e677847899$var$R(e, t) {
    if (!e) throw Error(t);
}
function $133989e677847899$var$P(e, t) {
    if (!e) throw Error(`${t}() called outside from using() closure`);
}
function $133989e677847899$var$E(e) {
    if (!$133989e677847899$var$Ne) return;
    let { draft: t } = e;
    if ("listItem" !== t.type && "rec" !== t.type) switch($133989e677847899$var$Ne.draft.type){
        case "element":
        case "using":
        case "route":
        case "list":
        case "rec":
        case "recItem":
        case "block":
        case "blockItem":
            t.inParentIndex = $133989e677847899$var$Ne.draft.childCount, $133989e677847899$var$Ne.draft.childCount += 1, $133989e677847899$var$Ne.draft.childTemplates.push(e);
            break;
        default:
            console.warn(`unexpected currentTemplate type ${$133989e677847899$var$Ne.draft.type}`);
    }
}
function $133989e677847899$var$L(e, { parentBlockFragment: t, leaf: a, node: l, svgRoot: n, values: r }) {
    e.childTemplates.forEach((e)=>{
        $133989e677847899$var$M({
            parentBlockFragment: t,
            leaf: a,
            node: l,
            svgRoot: n,
            values: r,
            actor: e
        });
    });
}
function $133989e677847899$var$M({ parentBlockFragment: e, leaf: t, node: a = t.mountNode, actor: l, svgRoot: n, values: r }) {
    let i;
    $133989e677847899$var$R($133989e677847899$var$$e.includes(e.type), `incorrect parent ${e.type}`);
    let { draft: c } = l, { queue: u } = t.root.leafOps[t.fullID].group, p = $133989e677847899$var$s(u), d = t.root.leafOps[t.fullID].domSubtree, m = d;
    switch(c.type){
        case "route":
            {
                let t = {
                    type: "route",
                    parent: e,
                    child: [],
                    visible: 0,
                    index: c.inParentIndex
                };
                e.child[c.inParentIndex] = t, i = {
                    type: "route",
                    block: t,
                    ops: {},
                    initialized: 0,
                    pendingInit: null
                };
                break;
            }
        case "element":
            {
                let a;
                if (l.isBlock) {
                    let e, l, n = t;
                    for(; n && (!l || !e);){
                        n.template.env && (e = n.template.env);
                        let { draft: t } = n;
                        "element" === t.type && ("svg" === t.tag ? l = "svg" : "foreignObject" === t.tag && (l = "html")), n = n.parent;
                    }
                    l || (l = "html"), e && (a = "svg" === l ? e.document.createElementNS("http://www.w3.org/2000/svg", c.tag) : e.document.createElement(c.tag), $133989e677847899$var$f(a, c.staticSeq));
                } else a = c.stencil.cloneNode();
                let n = {
                    type: "element",
                    parent: e,
                    child: [],
                    value: a,
                    visible: 0,
                    index: c.inParentIndex
                };
                e.child[c.inParentIndex] = n, i = {
                    type: "element",
                    block: n,
                    ops: {
                        visible: $133989e677847899$var$o({
                            value: 0,
                            priority: "tree",
                            runOp (e) {
                                if (e) {
                                    $133989e677847899$var$N(n);
                                    let e = i;
                                    e.needToCallNode && (e.needToCallNode = 0, (0, $agnkb.launch)({
                                        target: $133989e677847899$var$Ve,
                                        params: {
                                            element: n.value,
                                            fns: c.node
                                        },
                                        page: v,
                                        scope: t.root.scope
                                    })), n.visible = 1;
                                } else n.value.remove(), n.visible = 0;
                            },
                            group: d
                        })
                    },
                    needToCallNode: c.node.length > 0
                }, m = $133989e677847899$var$s(u);
                break;
            }
        case "list":
            {
                let t = {
                    type: "list",
                    parent: e,
                    child: [],
                    lastChild: null,
                    visible: 1,
                    index: c.inParentIndex
                };
                e.child[c.inParentIndex] = t, i = {
                    type: "list",
                    draft: c,
                    block: t,
                    records: [],
                    pendingUpdate: null
                };
                break;
            }
        case "using":
        case "listItem":
            break;
        case "rec":
            {
                let t = {
                    type: "rec",
                    parent: e,
                    child: [],
                    visible: 1,
                    index: c.inParentIndex
                };
                e.child[c.inParentIndex] = t, i = {
                    type: "rec",
                    block: t
                };
                break;
            }
        case "recItem":
            {
                let t = {
                    type: "recItem",
                    parent: e,
                    child: [],
                    visible: 1,
                    index: c.inParentIndex
                };
                e.child[c.inParentIndex] = t, i = {
                    type: "rec item",
                    block: t
                };
                break;
            }
        case "block":
            {
                let t = {
                    type: "block",
                    parent: e,
                    child: [],
                    visible: 1,
                    index: c.inParentIndex
                };
                e.child[c.inParentIndex] = t, i = {
                    type: "block",
                    block: t
                };
                break;
            }
        case "blockItem":
            {
                let t = {
                    type: "blockItem",
                    parent: e,
                    child: [],
                    visible: 1,
                    index: c.inParentIndex
                };
                e.child[c.inParentIndex] = t, i = {
                    type: "block item",
                    block: t
                };
                break;
            }
        default:
            console.warn(`unexpected draft type ${c.type}`);
    }
    let v = $133989e677847899$var$C(l, {
        values: r,
        parentLeaf: t,
        mountNode: a,
        svgRoot: n || t.svgRoot,
        leafData: i,
        opGroup: p,
        domSubtree: m,
        hydration: t.hydration,
        root: t.root
    });
}
function $133989e677847899$var$N(e) {
    let t = $133989e677847899$var$A(e);
    t ? t.after(e.value) : $133989e677847899$var$O(e).prepend(e.value), e.visible = 1;
}
function $133989e677847899$var$B({ mount: e, state: t, onMount: a, onState: l }) {
    return {
        onMount: (0, $agnkb.sample)({
            source: t,
            clock: e,
            fn: a,
            greedy: 1
        }),
        onState: (0, $agnkb.sample)({
            source: e,
            clock: t,
            fn: l,
            greedy: 1
        })
    };
}
function $133989e677847899$var$F(e, t) {
    for(let a in e)t(e[a], a);
}
function $133989e677847899$export$c3c52e219617878(e, t) {
    if (!$133989e677847899$var$Ne) return;
    let a = $133989e677847899$var$Ne.draft;
    $133989e677847899$var$R("element" === a.type, `"handler" extension can be used only with element nodes, got "${a.type}"`), void 0 === t && (t = e, e = {});
    for(let e in t)$133989e677847899$var$R((0, $agnkb.is).unit(t[e]), `handler for "${e}" should be event`);
    let { passive: l = 0, capture: n = 0, prevent: r = 0, stop: o = 0 } = e;
    a.handler.push({
        options: {
            prevent: r,
            stop: o
        },
        domConfig: {
            passive: r ? 0 : l,
            capture: n
        },
        map: t
    });
}
function $133989e677847899$export$a40e83dd9f9a97c8(e) {
    $133989e677847899$var$P($133989e677847899$var$Ne, "spec");
    let t = $133989e677847899$var$Ne.draft;
    switch(t.type){
        case "list":
            return void (e.visible && (t.itemVisible = e.visible));
        case "listItem":
        case "using":
        case "route":
        case "rec":
        case "recItem":
        case "block":
        case "blockItem":
            return;
    }
    if (e.attr && t.attr.push(e.attr), e.data && t.data.push(e.data), "text" in e) {
        let a = e.text, l = t.childCount;
        Array.isArray(a) ? (t.text.push(...a.map((e, t)=>({
                index: t + l,
                value: e
            }))), t.childCount += a.length) : (t.text.push({
            index: l,
            value: a
        }), t.childCount += 1);
    }
    if (e.style) {
        let a = {};
        for(let t in e.style)a[$133989e677847899$var$d(t)] = e.style[t];
        t.style.push(a);
    }
    var a, l;
    if (e.classList && (a = e.classList, l = (e)=>t.classList.push(e), Array.isArray(a) ? a.forEach((e)=>{
        let t = "string" == typeof e ? $133989e677847899$var$V(e) : e.map((e)=>$133989e677847899$var$V(e || "")), a = "string" == typeof e ? 1 : e.map((e)=>null !== e);
        l({
            name: t,
            enabled: a
        });
    }) : $133989e677847899$var$F(a, (e, t)=>{
        let a = $133989e677847899$var$V(t);
        l({
            name: a,
            enabled: e
        });
    })), e.styleVar && t.styleVar.push(e.styleVar), e.visible && (t.visible = e.visible), e.handler) {
        let t = e.handler;
        "object" == typeof t.on ? $133989e677847899$export$c3c52e219617878(t.config || {}, t.on) : $133989e677847899$export$c3c52e219617878(t);
    }
    e.ɔ && $133989e677847899$export$a40e83dd9f9a97c8(e.ɔ);
}
function $133989e677847899$var$V(e) {
    return e.split(" ").map((e)=>e.trim()).filter((e)=>e.length > 0);
}
function $133989e677847899$var$U(e, { initCtx: t, runOp: a, hooks: { onMount: l, onState: r } }) {
    let i = e.opsAmount++;
    l.watch(({ value: e, leaf: l })=>{
        let n = t(e, l), r = $133989e677847899$var$o({
            value: e,
            priority: "props",
            runOp (e) {
                a(e, n);
            },
            group: l.root.leafOps[l.fullID].group
        });
        l.root.leafOps[l.fullID].group.ops[i] = r;
    }), r.watch(({ value: e, leaf: t })=>{
        $133989e677847899$var$n(e, t.root.leafOps[t.fullID].group.ops[i]);
    });
}
function $133989e677847899$var$j(e, t, a) {
    e[t].forEach((e)=>{
        $133989e677847899$var$F(e, (e, l)=>{
            switch(t){
                case "data":
                case "styleVar":
                    a[t][l] = e;
                    break;
                case "attr":
                    a.attr["xlink:href" === l ? "href" : l] = e;
                    break;
                case "style":
                    l.startsWith("--") ? a.styleVar[l.slice(2)] = e : a.style[l] = e;
            }
        });
    });
}
function $133989e677847899$var$z(e, t, a) {
    let l = e.data.block, n = {
        type: "text",
        parent: l,
        visible: 0,
        index: a,
        value: null
    };
    if (l.child[a] = n, e.hydration) {
        let a = $133989e677847899$var$q(n);
        if (a) switch(a.type){
            case "text":
                n.value = e.root.env.document.createTextNode(t), a.value.after(n.value);
                break;
            case "element":
                n.value = a.value.nextSibling, $133989e677847899$var$k(n.value, t);
        }
        else {
            let e = $133989e677847899$var$O(n);
            n.value = e.firstChild, $133989e677847899$var$k(n.value, t);
        }
        n.visible = 1;
    } else n.value = e.root.env.document.createTextNode(t), $133989e677847899$var$N(n);
    return n;
}
function $133989e677847899$var$G(e) {
    let t = e.stateRef, a = $133989e677847899$var$Ne;
    a.plain.includes(t) || a.closure.includes(t) || a.closure.push(t);
}
function $133989e677847899$export$dda1d9f60106f0e9(e, t) {
    let a, r = 0, o = 0;
    "function" == typeof t ? (r = 1, a = t) : t && (o = 1, t.fn && (r = 1, a = t.fn), t.ɔ && ("function" == typeof t.ɔ ? (r = 1, a = t.ɔ) : "function" == typeof t.ɔ.fn && (r = 1, a = t.ɔ.fn))), $133989e677847899$var$P($133989e677847899$var$Ne, "h");
    let i, s = $133989e677847899$var$Ne.env, c = $133989e677847899$var$Ne.namespace, u = c, p = "html";
    u = p = "svg" === c ? "svg" : "html", "svg" === e && (p = "svg", u = "svg"), $133989e677847899$var$Ne.isBlock || (i = "svg" === p ? s.document.createElementNS("http://www.w3.org/2000/svg", e) : s.document.createElement(e));
    let d = i, m = {
        type: "element",
        tag: e,
        attr: [],
        data: [],
        text: [],
        style: [],
        styleVar: [],
        classList: [],
        handler: [],
        stencil: d,
        seq: [],
        staticSeq: [],
        childTemplates: [],
        childCount: 0,
        inParentIndex: -1,
        opsAmount: 1,
        node: []
    };
    "foreignObject" === c ? (m.attr.push({
        xmlns: "http://www.w3.org/1999/xhtml"
    }), u = "html") : "svg" === e ? (m.attr.push({
        xmlns: "http://www.w3.org/2000/svg"
    }), u = "svg") : "foreignObject" === e && (u = "foreignObject");
    let v = $133989e677847899$var$I({
        name: "element",
        draft: m,
        isSvgRoot: "svg" === e,
        namespace: u,
        fn (e, { mount: i }) {
            let s = (0, $agnkb.createEvent)({
                named: "domElementCreated"
            });
            r && a(), o && $133989e677847899$export$a40e83dd9f9a97c8(t), (0, $agnkb.is).unit(m.visible) && (m.seq.push({
                type: "visible",
                value: m.visible
            }), $133989e677847899$var$G(m.visible));
            let c = {
                attr: {},
                data: {},
                style: {},
                styleVar: {}
            };
            $133989e677847899$var$j(m, "attr", c), $133989e677847899$var$j(m, "data", c), $133989e677847899$var$j(m, "style", c), $133989e677847899$var$j(m, "styleVar", c), $133989e677847899$var$F(c, (e, t)=>{
                $133989e677847899$var$F(e, (e, a)=>{
                    (0, $agnkb.is).unit(e) ? (m.seq.push({
                        type: t,
                        field: a,
                        value: e
                    }), $133989e677847899$var$G(e)) : m.staticSeq.push({
                        type: t,
                        field: a,
                        value: e
                    });
                });
            }), m.classList.forEach((e)=>{
                if ((0, $agnkb.is).unit(e.name) || (0, $agnkb.is).unit(e.enabled)) {
                    let t = (0, $agnkb.is).unit(e.name) ? e.name : (0, $agnkb.createStore)(e.name), a = (0, $agnkb.is).unit(e.enabled) ? e.enabled : (0, $agnkb.createStore)(e.enabled);
                    m.seq.push({
                        type: "classList",
                        field: t,
                        value: a
                    }), $133989e677847899$var$G(t), $133989e677847899$var$G(a);
                } else (0, $agnkb.is).unit(e.name) || e.name.map((t)=>m.staticSeq.push({
                        type: "classList",
                        field: t,
                        value: e.enabled
                    }));
            }), m.text.forEach((e)=>{
                null !== e.value && ((0, $agnkb.is).unit(e.value) ? (m.seq.push({
                    type: "dynamicText",
                    value: e.value,
                    childIndex: e.index
                }), $133989e677847899$var$G(e.value)) : m.seq.push({
                    type: "staticText",
                    value: String(e.value),
                    childIndex: e.index
                }));
            }), m.handler.forEach((e)=>{
                $133989e677847899$var$F(e.map, (t, a)=>{
                    m.seq.push({
                        type: "handler",
                        for: a,
                        handler: t,
                        options: e.options,
                        domConfig: e.domConfig
                    });
                });
            }), d && $133989e677847899$var$f(d, m.staticSeq), m.seq.forEach((e)=>{
                switch(e.type){
                    case "visible":
                        {
                            let { onMount: t, onState: a } = $133989e677847899$var$B({
                                mount: i,
                                state: e.value,
                                onMount: (e, t)=>({
                                        leaf: t,
                                        value: e,
                                        hydration: t.hydration
                                    }),
                                onState: (e, t)=>({
                                        leaf: e,
                                        value: t,
                                        hydration: 0
                                    })
                            });
                            t.watch(({ leaf: e, value: t, hydration: a })=>{
                                let n = e.data, r = n.block;
                                if (a && ($133989e677847899$var$l(t, n.ops.visible), t)) {
                                    let e, t = $133989e677847899$var$A(r);
                                    if (e = t ? t.nextSibling : $133989e677847899$var$O(r).firstChild, "#text" === e.nodeName) {
                                        let t = e;
                                        e = e.nextSibling, t.remove();
                                    }
                                    r.value = e, r.visible = 1;
                                }
                                $133989e677847899$var$L(m, {
                                    parentBlockFragment: r,
                                    leaf: e,
                                    node: r.value,
                                    svgRoot: v.isSvgRoot ? r.value : null
                                }), t && n.needToCallNode && (n.needToCallNode = 0, (0, $agnkb.launch)({
                                    target: $133989e677847899$var$Ve,
                                    params: {
                                        element: n.block.value,
                                        fns: m.node
                                    },
                                    page: e,
                                    defer: 1,
                                    scope: e.root.scope
                                })), (0, $agnkb.launch)({
                                    target: s,
                                    params: e,
                                    defer: 1,
                                    page: e,
                                    scope: e.root.scope
                                });
                            }), (0, $agnkb.merge)([
                                a,
                                t
                            ]).watch(({ leaf: e, value: t, hydration: a })=>{
                                a || $133989e677847899$var$n(t, e.data.ops.visible);
                            });
                            break;
                        }
                    case "attr":
                    case "data":
                    case "style":
                    case "styleVar":
                        {
                            let t = $133989e677847899$var$je[e.type], a = $133989e677847899$var$Ue.some(({ type: t, field: a })=>e.type === t && e.field === a), l = $133989e677847899$var$B({
                                mount: s,
                                state: e.value,
                                onMount: (e, t)=>({
                                        leaf: t,
                                        value: e
                                    }),
                                onState: (e, t)=>({
                                        leaf: e,
                                        value: t
                                    })
                            });
                            a ? (0, $agnkb.merge)([
                                l.onState,
                                l.onMount
                            ]).watch(({ leaf: a, value: l })=>{
                                t($133989e677847899$var$ze(a), e.field, l);
                            }) : $133989e677847899$var$U(m, {
                                initCtx (a, l) {
                                    let n = $133989e677847899$var$ze(l);
                                    return t(n, e.field, a), n;
                                },
                                runOp (a, l) {
                                    t(l, e.field, a);
                                },
                                hooks: l
                            });
                            break;
                        }
                    case "classList":
                        {
                            var t;
                            let a = $133989e677847899$var$je.classList, l = (0, $agnkb.createStore)({
                                prev: [],
                                curr: null !== (t = e.field.getState()) && void 0 !== t ? t : []
                            }).on(e.field, ({ curr: e }, t)=>({
                                    prev: e,
                                    curr: t
                                })), n = $133989e677847899$var$B({
                                mount: s,
                                state: (0, $agnkb.combine)({
                                    name: l,
                                    enabled: e.value
                                }),
                                onMount: (e, t)=>({
                                        leaf: t,
                                        value: e
                                    }),
                                onState: (e, t)=>({
                                        leaf: e,
                                        value: t
                                    })
                            });
                            $133989e677847899$var$U(m, {
                                initCtx (e, t) {
                                    let l = $133989e677847899$var$ze(t);
                                    return e.name.curr.forEach((t)=>{
                                        a(l, t, e.enabled);
                                    }), l;
                                },
                                runOp (e, t) {
                                    e.name.prev.filter((t)=>!e.name.curr.includes(t)).forEach((e)=>{
                                        a(t, e, 0);
                                    }), e.name.curr.forEach((l)=>{
                                        a(t, l, e.enabled);
                                    });
                                },
                                hooks: n
                            });
                            break;
                        }
                    case "dynamicText":
                        $133989e677847899$var$U(m, {
                            initCtx: (t, a)=>$133989e677847899$var$z(a, t, e.childIndex),
                            runOp (e, t) {
                                $133989e677847899$var$k(t.value, e);
                            },
                            hooks: $133989e677847899$var$B({
                                mount: s,
                                state: e.value,
                                onMount: (e, t)=>({
                                        leaf: t,
                                        value: String(e)
                                    }),
                                onState: (e, t)=>({
                                        leaf: e,
                                        value: String(t)
                                    })
                            })
                        });
                        break;
                    case "staticText":
                        s.watch((t)=>{
                            $133989e677847899$var$z(t, e.value, e.childIndex);
                        });
                        break;
                    case "handler":
                        {
                            let t = e.handler.graphite.meta.nativeTemplate || null;
                            s.watch((a)=>{
                                let l = null;
                                if (t) {
                                    let e = 0, n = a;
                                    for(; !e && n;)n.template === t ? (e = 1, l = n) : n = n.parent;
                                } else l = null;
                                $133989e677847899$var$ze(a).addEventListener(e.for, (t)=>{
                                    e.options.prevent && t.preventDefault(), e.options.stop && t.stopPropagation(), (0, $agnkb.launch)({
                                        target: e.handler,
                                        params: t,
                                        page: l,
                                        scope: a.root.scope
                                    });
                                }, e.domConfig);
                            });
                            break;
                        }
                }
            }), i.watch((e)=>{
                let t = e.data;
                if (!m.visible) {
                    let a = t.ops.visible, r = t.block;
                    if (e.hydration) {
                        $133989e677847899$var$l(1, a);
                        let e, t = $133989e677847899$var$A(r);
                        if (e = t ? t.nextSibling : $133989e677847899$var$O(r).firstChild, "#text" === e.nodeName) {
                            let t = e;
                            e = e.nextSibling, t.remove();
                        }
                        r.value = e, r.visible = 1;
                    }
                    $133989e677847899$var$L(m, {
                        parentBlockFragment: r,
                        leaf: e,
                        node: r.value,
                        svgRoot: v.isSvgRoot ? r.value : null
                    }), (0, $agnkb.launch)({
                        target: s,
                        params: e,
                        defer: 1,
                        page: e,
                        scope: e.root.scope
                    }), e.hydration ? t.needToCallNode && (t.needToCallNode = 0, (0, $agnkb.launch)({
                        target: $133989e677847899$var$Ve,
                        params: {
                            element: t.block.value,
                            fns: m.node
                        },
                        page: e,
                        defer: 1,
                        scope: e.root.scope
                    })) : $133989e677847899$var$n(1, a);
                }
            });
        },
        env: s
    });
    $133989e677847899$var$E(v);
}
function $133989e677847899$var$W() {
    if ("undefined" != typeof document) return {
        document: document
    };
    throw Error("your environment has no document");
}
function $133989e677847899$export$fb1889ddede82380(e, t) {
    let a, l, n, r, o, c;
    if ("function" == typeof t) a = t, n = $133989e677847899$var$W(), r = 0;
    else {
        if (!t) throw Error("using() second argument is missing");
        a = t.fn, n = t.env ? t.env : $133989e677847899$var$W(), r = t.hydrate, l = t.onComplete, o = t.onRoot, c = t.scope;
    }
    $133989e677847899$var$R(e, "using() first argument is missing");
    let u = {
        scope: c,
        env: n,
        activeSpawns: new Set,
        childSpawns: {},
        leafOps: {}
    }, p = e.namespaceURI, d = e.tagName.toLowerCase(), f = {
        type: "using",
        childTemplates: [],
        childCount: 0,
        inParentIndex: -1
    }, m = $133989e677847899$var$I({
        name: "using",
        draft: f,
        isSvgRoot: "svg" === d,
        namespace: "http://www.w3.org/2000/svg" === p ? "svg" : "foreignobject" === d ? "foreignObject" : "html",
        fn (e, { mount: t }) {
            a(), t.watch($133989e677847899$var$Ge.using);
        },
        env: n
    }), v = {
        type: "using",
        child: [],
        value: e
    }, h = $133989e677847899$var$i({
        onComplete: l
    }), g = $133989e677847899$var$C(m, {
        parentLeaf: $133989e677847899$var$Be || null,
        mountNode: e,
        svgRoot: m.isSvgRoot ? e : $133989e677847899$var$Be ? $133989e677847899$var$Be.svgRoot : null,
        leafData: {
            type: "using",
            draft: f,
            element: e,
            block: v
        },
        opGroup: $133989e677847899$var$s(h),
        domSubtree: $133989e677847899$var$s(h),
        hydration: r,
        root: u
    });
    if (o && o({
        template: m,
        leaf: g
    }), h.onDrain && !h.rafID) {
        let e = h.onDrain;
        h.onDrain = null, e();
    }
}
function $133989e677847899$var$H(e, t) {
    let a = e.root.childSpawns[e.fullID];
    for(let e in a){
        let l = a[e];
        for(let e = 0; e < l.length; e++)t(l[e]);
    }
}
function $133989e677847899$var$J(e, t) {
    let a = (t)=>{
        let l = t.data;
        if (e && "list" === l.type && l.pendingUpdate) {
            let e = l.pendingUpdate;
            l.pendingUpdate = null, (0, $agnkb.launch)({
                target: t.template.api.pendingUpdate,
                params: e,
                defer: 1,
                page: t,
                scope: t.root.scope
            });
        }
        if (e && "route" === l.type) {
            if (l.pendingInit) {
                let e = l.pendingInit.value;
                l.pendingInit = null, (0, $agnkb.launch)({
                    target: t.template.api.pendingInit,
                    params: e,
                    defer: 1,
                    page: t,
                    scope: t.root.scope
                });
            } else if (!l.block.visible) return;
        }
        switch(l.type){
            case "element":
                $133989e677847899$var$n(e, l.ops.visible);
                break;
            case "route":
            case "list":
            case "list item":
                $133989e677847899$var$H(t, a);
                break;
            default:
                console.log("unsupported type", l.type);
        }
    };
    $133989e677847899$var$H(t, a);
}
function $133989e677847899$var$K(e) {
    e.root.activeSpawns.delete(e.fullID), $133989e677847899$var$H(e, $133989e677847899$var$Y);
}
function $133989e677847899$var$X(e) {
    $133989e677847899$var$ee(e, e.root.childSpawns[e.parent.fullID][e.template.id]), $133989e677847899$var$ee(e, e.template.pages);
}
function $133989e677847899$var$Y(e) {
    let { data: t, root: a } = e;
    switch(t.type){
        case "element":
            $133989e677847899$var$ee(e, a.childSpawns[e.parent.fullID][e.template.id]), function e(t) {
                a.activeSpawns.delete(t.fullID);
                let l = a.childSpawns[t.fullID];
                delete a.childSpawns[t.fullID], delete a.leafOps[t.fullID], $133989e677847899$var$ee(t, t.template.pages);
                for(let t in l)l[t].forEach(e);
            }(e), $133989e677847899$var$n(0, t.ops.visible);
            break;
        case "list":
            {
                let a = t.records;
                for(let e = 0; e < a.length; e++){
                    let t = a[e];
                    t.instance && $133989e677847899$var$Y(t.instance), t.active = 0;
                }
                e.root.activeSpawns.delete(e.fullID), $133989e677847899$var$X(e);
                break;
            }
        case "list item":
            {
                let a = t.block;
                $133989e677847899$var$ee(a, a.parent.child);
                let l = a.left, n = a.right;
                l && (l.right = n, n || a.parent.lastChild !== a || (a.parent.lastChild = l)), n && (n.left = l), l || n || a.parent.lastChild !== a || (a.parent.lastChild = null), a.left = null, a.right = null, $133989e677847899$var$K(e), $133989e677847899$var$X(e);
                break;
            }
        case "route":
            $133989e677847899$var$K(e), $133989e677847899$var$X(e);
            break;
        case "block":
        case "block item":
        case "rec":
        case "rec item":
            $133989e677847899$var$K(e);
    }
    delete a.childSpawns[e.fullID], delete a.leafOps[e.fullID];
}
function $133989e677847899$var$ee(e, t) {
    if (!t) return;
    let a = t.indexOf(e);
    -1 !== a && t.splice(a, 1);
}
function $133989e677847899$export$aee1dbae5de2db9d(e, t) {
    if (Array.isArray(t)) return t.map((t)=>e.map((e)=>e[t]));
    if ("object" == typeof t && null !== t) {
        let a = {};
        for(let l in t){
            let n = t[l];
            a[l] = e.map("function" == typeof n ? (e)=>n(e) : (e)=>e[n]);
        }
        return a;
    }
    return e.map((e)=>e[t]);
}
function $133989e677847899$export$8837f4fc672e936d(e, t) {
    $133989e677847899$var$P($133989e677847899$var$Ne, "list"), "function" == typeof t && ((0, $agnkb.is).unit(e) ? e = {
        source: e,
        fn: t
    } : e.fn = t);
    let { fn: a, key: l, source: n, fields: r = [] } = e, o = void 0 !== l ? "function" == typeof l ? l : (e)=>e[l] : (e, t)=>t, i = {
        type: "list",
        key: (0, $agnkb.is).store(e) ? {
            type: "index"
        } : {
            type: "key",
            key: e.key
        },
        childTemplates: [],
        childCount: 0,
        inParentIndex: -1
    }, { env: d, namespace: f } = $133989e677847899$var$Ne;
    $133989e677847899$var$E($133989e677847899$var$I({
        name: "list",
        draft: i,
        isSvgRoot: 0,
        namespace: f,
        fn (e, { mount: t }) {
            let l = $133989e677847899$var$I({
                name: "list item",
                state: {
                    id: -1,
                    store: null
                },
                draft: i,
                isSvgRoot: 0,
                namespace: f,
                fn ({ id: e, store: t }, { mount: l }) {
                    a({
                        store: t,
                        key: e,
                        fields: $133989e677847899$export$aee1dbae5de2db9d(t, r)
                    });
                    let n = (0, $agnkb.createEvent)({
                        named: "itemUpdater"
                    });
                    if (t.on(n, (e, t)=>t), i.itemVisible) {
                        let { onMount: e, onState: t } = $133989e677847899$var$B({
                            mount: l,
                            state: i.itemVisible,
                            onMount: (e, t)=>({
                                    visible: e,
                                    leaf: t
                                }),
                            onState: (e, t)=>({
                                    visible: t,
                                    leaf: e
                                })
                        });
                        e.watch(({ visible: e, leaf: t })=>{
                            let a = t.data.block;
                            a.visible = e, a.childInitialized = e, e && $133989e677847899$var$L(i, {
                                parentBlockFragment: a,
                                leaf: t
                            });
                        }), t.watch(({ visible: e, leaf: t })=>{
                            let a = t.data.block;
                            a.visible = e, a.childInitialized ? $133989e677847899$var$J(e, t) : e && (a.childInitialized = 1, $133989e677847899$var$L(i, {
                                parentBlockFragment: a,
                                leaf: t
                            }));
                        });
                    } else l.watch($133989e677847899$var$Ge.listItem);
                    return {
                        itemUpdater: n
                    };
                },
                env: d
            }), m = (0, $agnkb.createStore)([]), v = n.map((e)=>e), h = (0, $agnkb.sample)({
                source: n,
                clock: t,
                fn: (e, t)=>({
                        updates: e,
                        leaf: t,
                        hydration: t.hydration
                    }),
                greedy: 1
            }), g = (0, $agnkb.createEvent)(), b = (0, $agnkb.sample)({
                source: h,
                clock: [
                    v,
                    g
                ],
                fn: ({ leaf: e }, t)=>({
                        updates: t,
                        leaf: e,
                        hydration: 0
                    }),
                greedy: 1
            });
            return (0, $agnkb.sample)({
                source: m,
                clock: [
                    h,
                    b
                ],
                greedy: 1,
                fn (e, { updates: t, leaf: a, hydration: r }) {
                    let d = a.data, f = a;
                    for(; f;){
                        if ("route" === f.data.type && !f.data.block.visible) return void (d.pendingUpdate = t);
                        f = f.parent;
                    }
                    let m = d.block;
                    $133989e677847899$var$Te("list update [" + n.shortName + "]");
                    let v = Array(t.length).fill(0), h = t.map(o), g = [];
                    for(let a = 0; a < e.length; a++){
                        let l = e[a], n = h.indexOf(l.key);
                        -1 !== n ? (g.push(l), v[n] = 1, $133989e677847899$var$p(t[n], l.asyncValue)) : (l.active = 0, l.instance && $133989e677847899$var$Y(l.instance), $133989e677847899$var$u(l.asyncValue));
                    }
                    for(let e = 0; e < t.length; e++){
                        if (v[e]) continue;
                        let n = t[e], o = h[e], u = $133989e677847899$var$s(a.root.leafOps[a.fullID].group.queue), p = {
                            type: "LF",
                            parent: m,
                            child: [],
                            childInitialized: 0,
                            visible: 0,
                            left: null,
                            right: null
                        }, d = {
                            type: "listItem",
                            key: o,
                            index: o,
                            active: 1,
                            leafData: {
                                type: "list item",
                                block: p,
                                listDraft: i
                            },
                            asyncValue: $133989e677847899$var$c({
                                value: n,
                                group: u,
                                onChange (e) {
                                    d.instance && (0, $agnkb.launch)({
                                        target: d.instance.template.api.itemUpdater,
                                        params: e,
                                        defer: 1,
                                        page: d.instance,
                                        scope: d.instance.root.scope
                                    });
                                },
                                onInit (e) {
                                    d.active && (r || (d.instance = $133989e677847899$var$C(l, {
                                        values: {
                                            id: o,
                                            store: e
                                        },
                                        parentLeaf: a,
                                        mountNode: a.mountNode,
                                        svgRoot: a.svgRoot,
                                        leafData: d.leafData,
                                        opGroup: u,
                                        domSubtree: a.root.leafOps[a.fullID].domSubtree,
                                        hydration: r,
                                        root: a.root
                                    })));
                                }
                            })
                        }, f = g.length;
                        g.push(d);
                        let b = f > 0 ? g[f - 1].leafData : null;
                        if (m.child.push(p), b) {
                            let e = b.block;
                            p.left = e;
                            let t = e.right;
                            t ? (t.left = p, p.right = t) : m.lastChild = p, e.right = p;
                        } else m.lastChild = p;
                        r && (d.instance = $133989e677847899$var$C(l, {
                            values: {
                                id: o,
                                store: n
                            },
                            parentLeaf: a,
                            mountNode: a.mountNode,
                            svgRoot: a.svgRoot,
                            leafData: d.leafData,
                            opGroup: u,
                            domSubtree: a.root.leafOps[a.fullID].domSubtree,
                            hydration: r,
                            root: a.root
                        }));
                    }
                    return $133989e677847899$var$qe("list update [" + n.shortName + "]"), 0 === g.length && (m.lastChild = null), d.records = g, g;
                },
                target: m
            }), {
                pendingUpdate: g
            };
        },
        env: d
    }));
}
function $133989e677847899$export$35059013cd4a06db(e) {
    $133989e677847899$var$P($133989e677847899$var$Ne, "node");
    let t = $133989e677847899$var$Ne.draft;
    switch(t.type){
        case "list":
        case "listItem":
        case "using":
        case "route":
        case "rec":
        case "recItem":
        case "block":
        case "blockItem":
            return void console.error("node() hook supported only in h() nodes");
    }
    t.node.push(e);
}
function $133989e677847899$export$4cb887bfde2d34ca({ source: e, visible: t, fn: a }) {
    $133989e677847899$var$P($133989e677847899$var$Ne, "route");
    let { env: l, namespace: n } = $133989e677847899$var$Ne, r = $133989e677847899$var$I({
        name: "route",
        isSvgRoot: 0,
        namespace: n,
        env: l,
        draft: {
            type: "route",
            childTemplates: [],
            childCount: 0,
            inParentIndex: -1
        },
        fn (r, { mount: o }) {
            let i;
            if ((0, $agnkb.is).store(t)) i = (0, $agnkb.combine)({
                value: e,
                visible: t
            });
            else {
                let a = t;
                i = e.map((e)=>({
                        value: e,
                        visible: a(e)
                    }));
            }
            let s = $133989e677847899$var$I({
                name: "route item",
                isSvgRoot: 0,
                namespace: n,
                env: l,
                draft: {
                    type: "route",
                    childTemplates: [],
                    childCount: 0,
                    inParentIndex: -1
                },
                state: {
                    store: null
                },
                fn ({ store: e }, { mount: t }) {
                    let l = (0, $agnkb.createEvent)({
                        named: "itemUpdater"
                    });
                    e.on(l, (e, t)=>t), a({
                        store: e
                    });
                    let n = (0, $agnkb.sample)({
                        source: t,
                        clock: i,
                        fn: (e, { visible: t, value: a })=>({
                                leaf: e,
                                visible: t,
                                value: a
                            }),
                        greedy: 1
                    });
                    t.watch($133989e677847899$var$Ge.routeItem), n.watch(({ leaf: e, visible: t, value: a })=>{
                        if (e.data.block.visible = t, t && (0, $agnkb.launch)({
                            target: l,
                            params: a,
                            defer: 1,
                            page: e,
                            scope: e.root.scope
                        }), t) {
                            let t = e.parent;
                            for(; t;){
                                if ("route" === t.data.type && !t.data.block.visible) return;
                                t = t.parent;
                            }
                        }
                        $133989e677847899$var$J(t, e);
                    });
                }
            });
            $133989e677847899$var$E(s);
            let { onMount: c, onState: u } = $133989e677847899$var$B({
                mount: o,
                state: i,
                onMount: ({ visible: e, value: t }, a)=>({
                        leaf: a,
                        visible: e,
                        value: t
                    }),
                onState: (e, { visible: t, value: a })=>({
                        leaf: e,
                        visible: t,
                        value: a
                    })
            }), p = (0, $agnkb.createEvent)(), d = (0, $agnkb.sample)({
                source: o,
                clock: p,
                greedy: 1,
                fn: (e, t)=>({
                        leaf: e,
                        value: t,
                        visible: 1
                    })
            });
            return (0, $agnkb.merge)([
                c,
                u,
                d
            ]).watch(({ leaf: e, visible: t, value: a })=>{
                let l = e.data;
                if (l.block.visible = t, t || l.initialized || !l.pendingInit) {
                    if (t && !l.initialized) {
                        let t = e.parent;
                        for(; t;){
                            if ("route" === t.data.type && !t.data.block.visible) return void (l.pendingInit = {
                                value: a
                            });
                            t = t.parent;
                        }
                    }
                    t && !l.initialized && ($133989e677847899$var$M({
                        parentBlockFragment: l.block,
                        leaf: e,
                        actor: s,
                        values: {
                            store: a
                        }
                    }), l.initialized = 1);
                } else l.pendingInit = null;
            }), {
                pendingInit: p
            };
        }
    });
    $133989e677847899$var$E(r);
}
function $133989e677847899$export$8fdf71db98f19724({ source: e, cases: t, key: a }) {
    let l;
    $133989e677847899$var$P($133989e677847899$var$Ne, "variant"), $133989e677847899$var$R((0, $agnkb.is).unit(e), "variant({source}) should be unit"), l = "function" == typeof a ? a : null == a ? (e)=>String(e) : (e)=>String(e[a]);
    let n = 0;
    for(let a in t)"__" !== a ? $133989e677847899$export$4cb887bfde2d34ca({
        source: e,
        visible: (e)=>l(e) === a,
        fn: t[a]
    }) : n = 1;
    if (n) {
        let a = Object.keys(t);
        $133989e677847899$export$4cb887bfde2d34ca({
            source: e,
            visible: (e)=>!a.includes(l(e)),
            fn: t.__
        });
    }
}
function $133989e677847899$export$eefdad1ee0ae29eb(e) {
    let t = "function" == typeof e ? e : e.fn, a = $133989e677847899$var$I({
        name: "rec",
        state: {
            store: null
        },
        isSvgRoot: 0,
        namespace: null,
        env: null,
        draft: {
            type: "rec",
            childTemplates: [],
            childCount: 0,
            inParentIndex: 0
        },
        defer: 1,
        isBlock: 1,
        fn ({ store: e }, { mount: a }) {
            t({
                store: e,
                state: e
            });
            let l = (0, $agnkb.createEvent)({
                named: "itemUpdater"
            });
            return e.on(l, (e, t)=>t), a.watch($133989e677847899$var$Ge.rec), {
                itemUpdater: l
            };
        }
    });
    return ({ store: e, state: t = e })=>{
        $133989e677847899$var$P($133989e677847899$var$Ne, "(rec instance)");
        let { env: l, namespace: n } = $133989e677847899$var$Ne;
        a.deferredInit && a.deferredInit(), $133989e677847899$var$E($133989e677847899$var$I({
            name: "rec item",
            isSvgRoot: 0,
            namespace: n,
            env: l,
            draft: {
                type: "recItem",
                childTemplates: [],
                childCount: 0,
                inParentIndex: -1
            },
            fn (e, { mount: l }) {
                let { onMount: n, onState: r } = $133989e677847899$var$B({
                    state: t,
                    mount: l,
                    onMount: (e, t)=>({
                            state: e,
                            leaf: t
                        }),
                    onState: (e, t)=>({
                            state: t,
                            leaf: e
                        })
                });
                r.watch(({ state: e, leaf: t })=>{
                    $133989e677847899$var$H(t, (a)=>{
                        (0, $agnkb.launch)({
                            target: a.template.api.itemUpdater,
                            params: e,
                            defer: 1,
                            page: t,
                            scope: t.root.scope
                        });
                    });
                }), n.watch(({ leaf: e, state: t })=>{
                    $133989e677847899$var$M({
                        parentBlockFragment: e.data.block,
                        leaf: e,
                        actor: a,
                        values: {
                            store: t
                        }
                    });
                });
            }
        }));
    };
}
function $133989e677847899$export$4767d4262788a6cc({ source: e, key: t, child: a, fn: l }) {
    let n = $133989e677847899$export$eefdad1ee0ae29eb(({ store: e })=>{
        $133989e677847899$export$8837f4fc672e936d({
            source: e,
            key: t,
            fn ({ store: e }) {
                let t = e.map((e)=>e[a] || []);
                l({
                    store: e,
                    child () {
                        n({
                            store: t
                        });
                    }
                });
            }
        });
    });
    n({
        store: e
    });
}
function $133989e677847899$export$837bd02682cd3db9({ fn: e, env: t, namespace: a = "html" }) {
    let l = $133989e677847899$var$I({
        name: "block",
        isSvgRoot: 0,
        namespace: a,
        env: t,
        draft: {
            type: "block",
            childTemplates: [],
            childCount: 0,
            inParentIndex: 0
        },
        isBlock: 1,
        fn ({}, { mount: t }) {
            e(), t.watch($133989e677847899$var$Ge.block);
        }
    });
    return ()=>{
        $133989e677847899$var$P($133989e677847899$var$Ne, "(block instance)");
        let e = {
            type: "blockItem",
            childTemplates: [],
            childCount: 0,
            inParentIndex: -1,
            itemOf: l
        }, { env: t, namespace: a } = $133989e677847899$var$Ne;
        $133989e677847899$var$E($133989e677847899$var$I({
            name: "block item",
            isSvgRoot: 0,
            namespace: a,
            env: t,
            draft: e,
            fn (e, { mount: t }) {
                t.watch($133989e677847899$var$Ge.blockItem);
            }
        }));
    };
}
function $133989e677847899$var$ce(e, t) {
    if (0 === t.length) return e;
    let a = [
        e[0]
    ];
    for(let l = 0; l < t.length; l++)a.push(t[l], e[l + 1]);
    return a;
}
function $133989e677847899$export$6f093cfa640b7166(e, ...t) {
    Array.isArray(e) ? $133989e677847899$export$a40e83dd9f9a97c8({
        text: $133989e677847899$var$ce(e, t)
    }) : $133989e677847899$export$a40e83dd9f9a97c8({
        text: e
    });
}
function $133989e677847899$export$b02c28252f48c6ac(e, ...t) {
    return t.every((e)=>!(0, $agnkb.is).store(e)) ? $133989e677847899$var$ce(e, t).join("") : (0, $agnkb.combine)(t, (t)=>$133989e677847899$var$ce(e, t).join(""));
}
let $133989e677847899$var$we;
$133989e677847899$var$we = "undefined" != typeof performance && performance.now ? ()=>performance.now() : "undefined" != typeof $aea1af87e475eaac$exports && $aea1af87e475eaac$exports.hrtime ? ()=>{
    let e = $aea1af87e475eaac$exports.hrtime();
    return (1e9 * e[0] + e[1]) / 1e6;
} : ()=>Date.now();
let $133989e677847899$var$Se = new Map;
const $133989e677847899$var$De = [], $133989e677847899$var$Ce = (e)=>{
    let t = $133989e677847899$var$Se.get(e);
    t || (t = {
        calls: 0,
        time: 0,
        label: e,
        childTime: 0
    }, $133989e677847899$var$Se.set(e, t)), t.calls += 1, $133989e677847899$var$De.push({
        bucket: t,
        pendingStart: $133989e677847899$var$we()
    });
}, $133989e677847899$var$Oe = (e)=>{
    let t = $133989e677847899$var$Se.get(e), a = $133989e677847899$var$De.pop().pendingStart, l = $133989e677847899$var$we() - a;
    t.time += l, $133989e677847899$var$De.length > 0 && ($133989e677847899$var$De[$133989e677847899$var$De.length - 1].bucket.childTime += l);
};
let $133989e677847899$var$Te, $133989e677847899$var$qe;
"undefined" != typeof performance && performance.mark ? ($133989e677847899$var$Te = (e)=>{
    performance.mark("☄️ " + e + " start"), $133989e677847899$var$Ce(e);
}, $133989e677847899$var$qe = (e)=>{
    $133989e677847899$var$Oe(e);
    try {
        performance.measure("☄️ " + e, "☄️ " + e + " start");
    } catch (e) {}
    performance.clearMarks("☄️ " + e + " start"), performance.clearMeasures("☄️ " + e);
}) : ($133989e677847899$var$Te = (e)=>{
    $133989e677847899$var$Ce(e);
}, $133989e677847899$var$qe = (e)=>{
    $133989e677847899$var$Oe(e);
});
let $133989e677847899$var$Ae = "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : (e)=>setTimeout(e, 0);
const $133989e677847899$var$Re = {
    attr: $133989e677847899$var$y,
    data: $133989e677847899$var$b,
    style: $133989e677847899$var$h,
    styleVar: $133989e677847899$var$v,
    classList: $133989e677847899$var$g
}, $133989e677847899$var$Pe = (e, t)=>e.includes(t);
let $133989e677847899$var$Ee = {
    storeBase (e, t) {
        e.plain.push(t);
    },
    storeOnMap (e, t, a, l) {
        var n, r;
        a.unshift(e.loader), a.push(e.upward), l && ($133989e677847899$var$Pe(e.plain, l) || ($133989e677847899$var$Pe(e.closure, l) || e.closure.push(l), r = {
            type: "closure",
            of: l
        }, (n = t).before || (n.before = []), n.before.push(r)));
    },
    storeMap (e, t, a) {
        $133989e677847899$var$Pe(e.plain, t) || $133989e677847899$var$Pe(a.seq, e.loader) || a.seq.unshift(e.loader);
    },
    storeWatch: (e, t, a)=>(e.watch.push({
            of: t,
            fn: a
        }), 1),
    eventPrepend (e, t) {
        t.seq.push(e.upward);
    },
    combineBase (e, t, a) {
        e.plain.push(t, a);
    },
    combineField (e, t, a) {
        $133989e677847899$var$Pe(e.plain, t) || a.seq.unshift(e.loader);
    },
    splitBase (e, t) {
        e.plain.push(t);
    },
    splitMatchStore (e, t, a) {
        $133989e677847899$var$Pe(e.plain, t) || a.seq.unshift(e.loader);
    },
    sampleSource (e, t, a, l) {
        t.current ? $133989e677847899$var$Pe(e.plain, a) || $133989e677847899$var$Pe(e.closure, a) || e.closure.push(a) : e.plain.push(a), e.plain.push(t), $133989e677847899$var$Pe(e.plain, l) || e.plain.push(l);
    },
    sampleTarget (e, t) {
        t.seq.push(e.loader);
    },
    sampleSourceLoader: (e)=>e.loader,
    sampleSourceUpward: (e, t)=>t && e.upward
}, $133989e677847899$var$Le = 0, $133989e677847899$var$Me = 0, $133989e677847899$var$Ne = null, $133989e677847899$var$Be = null;
const $133989e677847899$var$Fe = (e, t)=>e.reg[t.id];
let $133989e677847899$var$_e = null;
const $133989e677847899$var$$e = [
    "LF",
    "using",
    "element",
    "recItem",
    "rec",
    "block",
    "blockItem",
    "route"
];
let $133989e677847899$var$Ve = (0, $agnkb.createEvent)({
    named: "onMount"
});
$133989e677847899$var$Ve.watch(({ fns: e, element: t })=>{
    e.forEach((e)=>{
        e(t);
    });
});
const $133989e677847899$var$Ue = [
    {
        type: "attr",
        field: "value"
    },
    {
        type: "attr",
        field: "checked"
    },
    {
        type: "attr",
        field: "min"
    },
    {
        type: "attr",
        field: "max"
    }
], $133989e677847899$var$je = {
    attr: $133989e677847899$var$y,
    data: $133989e677847899$var$b,
    style: $133989e677847899$var$h,
    styleVar: $133989e677847899$var$v,
    classList: $133989e677847899$var$g
}, $133989e677847899$var$ze = (e)=>e.data.block.value;
let $133989e677847899$var$Ge = {
    using (e) {
        let t = e.data;
        $133989e677847899$var$L(t.draft, {
            parentBlockFragment: t.block,
            leaf: e
        });
    },
    routeItem (e) {
        let t = e.draft, a = e.data;
        a.block.visible = 1, $133989e677847899$var$L(t, {
            parentBlockFragment: a.block,
            leaf: e
        });
    },
    block (e) {
        $133989e677847899$var$L(e.draft, {
            parentBlockFragment: e.data.block,
            leaf: e
        });
    },
    blockItem (e) {
        $133989e677847899$var$M({
            parentBlockFragment: e.data.block,
            leaf: e,
            actor: e.draft.itemOf
        });
    },
    rec (e) {
        $133989e677847899$var$L(e.draft, {
            parentBlockFragment: e.data.block,
            leaf: e
        });
    },
    listItem (e) {
        let t = e.data, a = t.block;
        a.visible = 1, a.childInitialized = 1, $133989e677847899$var$L(t.listDraft, {
            parentBlockFragment: a,
            leaf: e
        });
    }
};



var $agnkb = parcelRequire("agnkb");
/**
 * Tokenize input string.
 */ function $70b1ced0e387e39e$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError('Pattern cannot start with "?" at '.concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $70b1ced0e387e39e$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $70b1ced0e387e39e$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a;
    var defaultPattern = "[^".concat($70b1ced0e387e39e$var$escapeString(options.delimiter || "/#?"), "]+?");
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || defaultPattern,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? defaultPattern : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $70b1ced0e387e39e$export$ef7acd7185315e22(str, options) {
    return $70b1ced0e387e39e$export$5b9bad9e403cf3d9($70b1ced0e387e39e$export$98e6a39c04603d36(str, options), options);
}
function $70b1ced0e387e39e$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $70b1ced0e387e39e$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError('Expected "'.concat(token.name, '" to not repeat, but got an array'));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError('Expected "'.concat(token.name, '" to not be empty'));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError('Expected all "'.concat(token.name, '" to match "').concat(token.pattern, '", but got "').concat(segment, '"'));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError('Expected "'.concat(token.name, '" to match "').concat(token.pattern, '", but got "').concat(segment, '"'));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError('Expected "'.concat(token.name, '" to be ').concat(typeOfMessage));
        }
        return path;
    };
}
function $70b1ced0e387e39e$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $70b1ced0e387e39e$export$71304158c7e35877(str, keys, options);
    return $70b1ced0e387e39e$export$968e97c88708237a(re, keys, options);
}
function $70b1ced0e387e39e$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $70b1ced0e387e39e$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $70b1ced0e387e39e$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $70b1ced0e387e39e$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $70b1ced0e387e39e$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $70b1ced0e387e39e$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), $70b1ced0e387e39e$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $70b1ced0e387e39e$var$stringToRegexp(path, keys, options) {
    return $70b1ced0e387e39e$export$9a9303716def6456($70b1ced0e387e39e$export$98e6a39c04603d36(path, options), keys, options);
}
function $70b1ced0e387e39e$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat($70b1ced0e387e39e$var$escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat($70b1ced0e387e39e$var$escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $70b1ced0e387e39e$var$escapeString(encode(token));
        else {
            var prefix = $70b1ced0e387e39e$var$escapeString(encode(token.prefix));
            var suffix = $70b1ced0e387e39e$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else if (token.modifier === "+" || token.modifier === "*") route += "((?:".concat(token.pattern, ")").concat(token.modifier, ")");
                else route += "(".concat(token.pattern, ")").concat(token.modifier);
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, $70b1ced0e387e39e$var$flags(options));
}
function $70b1ced0e387e39e$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $70b1ced0e387e39e$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $70b1ced0e387e39e$var$arrayToRegexp(path, keys, options);
    return $70b1ced0e387e39e$var$stringToRegexp(path, keys, options);
}


function $e13fe69fd88e859a$export$544c268deaca2597(e) {
    void 0 === e && (e = {});
    var r = (0, $agnkb.createEffect)((e)=>{
        var r = e.replace;
        return {
            params: e.params || {},
            query: e.query || {},
            replace: void 0 !== r && r
        };
    }, {
        name: "navigateFx",
        sid: "c2qlao"
    }), a = (0, $agnkb.attach)({
        and: {
            effect: r,
            mapParams: (e)=>({
                    params: e || {},
                    query: {}
                })
        },
        or: {
            name: "openFx",
            sid: "am04as"
        }
    }), n = (0, $agnkb.createStore)(!1, {
        name: "$isOpened",
        sid: "-8u29di"
    }), t = (0, $agnkb.createStore)({}, {
        name: "$params",
        sid: "6sxdf"
    }), o = (0, $agnkb.createStore)({}, {
        name: "$query",
        sid: "tylje5"
    }), i = (0, $agnkb.createEvent)({
        name: "opened",
        sid: "fafqk0"
    }), s = (0, $agnkb.createEvent)({
        name: "updated",
        sid: "66vs1s"
    }), d = (0, $agnkb.createEvent)({
        name: "closed",
        sid: "-wbq1n3"
    });
    return n.on(i, ()=>!0).on(d, ()=>!1), t.on(i, (e, r)=>r.params).on(s, (e, r)=>r.params), o.on(i, (e, r)=>r.query).on(s, (e, r)=>r.query), (0, $agnkb.split)({
        and: [
            {
                source: r.doneData,
                match: n.map((e)=>e ? "updated" : "opened"),
                cases: {
                    opened: i,
                    updated: s
                }
            }
        ],
        or: {
            sid: "3j56hf"
        }
    }), {
        $isOpened: n,
        $params: t,
        $query: o,
        opened: i,
        updated: s,
        closed: d,
        navigate: r,
        open: a,
        kind: $e13fe69fd88e859a$export$a84bdc57c5122798.ROUTE,
        settings: {
            derived: Boolean(e.filter)
        }
    };
}
function $e13fe69fd88e859a$var$r(e, r) {
    var a = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        r && (n = n.filter((r)=>Object.getOwnPropertyDescriptor(e, r).enumerable)), a.push.apply(a, n);
    }
    return a;
}
function $e13fe69fd88e859a$var$a(e) {
    for(var a = 1; a < arguments.length; a++){
        var t = null != arguments[a] ? arguments[a] : {};
        a % 2 ? $e13fe69fd88e859a$var$r(Object(t), !0).forEach((r)=>{
            $e13fe69fd88e859a$var$n(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e13fe69fd88e859a$var$r(Object(t)).forEach((r)=>{
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e13fe69fd88e859a$var$n(e, r, a) {
    return r in e ? Object.defineProperty(e, r, {
        value: a,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = a, e;
}
function $e13fe69fd88e859a$var$t(e, r) {
    (null == r || r > e.length) && (r = e.length);
    for(var a = 0, n = new Array(r); a < r; a++)n[a] = e[a];
    return n;
}
function $e13fe69fd88e859a$var$o(e, r) {
    var it = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (it) return (it = it.call(e)).next.bind(it);
    if (Array.isArray(e) || (it = ((e, r)=>{
        if (e) {
            if ("string" == typeof e) return $e13fe69fd88e859a$var$t(e, r);
            var a = ({}).toString.call(e).slice(8, -1);
            return "Object" === a && e.constructor && (a = e.constructor.name), "Map" === a || "Set" === a ? Array.from(e) : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? $e13fe69fd88e859a$var$t(e, r) : void 0;
        }
    })(e)) || r && e && "number" == typeof e.length) {
        it && (e = it);
        var a = 0;
        return ()=>a >= e.length ? {
                done: !0
            } : {
                done: !1,
                value: e[a++]
            };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e13fe69fd88e859a$var$i(e, r) {
    if (Object.keys(e).length !== Object.keys(r).length) return !1;
    for(var a in e)if ("" + e[a] != "" + r[a]) return !1;
    return !0;
}
function $e13fe69fd88e859a$export$5cc7f731b5937e99(e) {
    var r, a = e.params, n = e.query, t = e.serialize, o = (0, $70b1ced0e387e39e$export$ef7acd7185315e22)(e.pathCreator)(a), i = null !== (r = null == t ? void 0 : t.write(n)) && void 0 !== r ? r : new URLSearchParams(n);
    return o + (Object.keys(n).length ? "?" + i : "");
}
function $e13fe69fd88e859a$export$81336c211d5ff295(e) {
    var r = e.actualPath, a = (0, $70b1ced0e387e39e$export$4659b591c19bdf3d)(e.pathCreator.replace("://", "\\://"))(((e)=>{
        if (e.match(/^[a-z0-9]+\:\/\//i)) return e;
        var r = new URL("http://_" + e);
        return [
            r.pathname,
            r.hash
        ].join("");
    })(r));
    return a ? {
        matches: !0,
        params: a.params
    } : {
        matches: !1
    };
}
function $e13fe69fd88e859a$var$u(e) {
    if (!e) throw new Error("[Routing] No history provided");
}
function $e13fe69fd88e859a$var$c(e) {
    return e.map((e)=>!e);
}
function $e13fe69fd88e859a$export$dbd150cc4bdc656b(e) {
    var r = e.base, n = e.routes, t = e.notFoundRoute, u = e.hydrate, l = e.serialize, p = e.controls, m = void 0 === p ? (0, $agnkb.withFactory)({
        sid: "d2qzob",
        fn: ()=>$e13fe69fd88e859a$export$5f30bfe6ad37bbb0(),
        name: "controls",
        method: "createRouterControls"
    }) : p, f = ((e, r)=>{
        void 0 === r && (r = "");
        for(var n, t = [], i = ()=>{
            var e, r = n.value;
            Array.isArray(r.route) ? (e = t).push.apply(e, r.route.map((e)=>$e13fe69fd88e859a$var$a($e13fe69fd88e859a$var$a({}, r), {}, {
                    route: e
                }))) : t.push(r);
        }, s = $e13fe69fd88e859a$var$o(e); !(n = s()).done;)i();
        t = t.map((e)=>$e13fe69fd88e859a$var$a($e13fe69fd88e859a$var$a({}, e), {}, {
                path: "" + r + e.path
            }));
        for(var d, u = [], c = [], l = $e13fe69fd88e859a$var$o(t); !(d = l()).done;){
            var p = d.value;
            p.route.settings.derived ? u.push(p) : c.push(p);
        }
        if (u.length) for(var m, f = $e13fe69fd88e859a$var$o(u); !(m = f()).done;)console.error("createHistoryRouter: " + m.value.path + " uses derived route. This won't work");
        return c;
    })(n, r), h = (0, $agnkb.createEvent)({
        name: "setHistory",
        sid: "9zwyxu"
    }), v = (0, $agnkb.createEvent)({
        name: "navigateFromRouteTriggered",
        sid: "soge6d"
    }), O = (0, $agnkb.createEvent)({
        name: "historyUpdated",
        sid: "-x4474u"
    }), w = (0, $agnkb.createEvent)({
        name: "recalculateTriggered",
        sid: "-ykrhlj"
    }), $ = (0, $agnkb.createEvent)({
        name: "recalculated",
        sid: "aeh4sf"
    }), R = (0, $agnkb.createEvent)({
        name: "routesMatched",
        sid: "2rfqt6"
    }), x = (0, $agnkb.createEvent)({
        name: "routesMismatched",
        sid: "71hypl"
    }), P = (0, $agnkb.createEvent)({
        name: "routeNotFound",
        sid: "avqxzu"
    }), z = (0, $agnkb.createEvent)({
        name: "initialized",
        sid: "du6f0f"
    }), F = (0, $agnkb.createStore)("", {
        name: "$path",
        sid: "wz8cwv"
    }), C = (0, $agnkb.createStore)({}, {
        and: {
            name: "historyRouter.$query",
            updateFilter: (e, r)=>!$e13fe69fd88e859a$var$i(e, r)
        },
        name: "$query",
        sid: "tkdilp"
    }), H = (0, $agnkb.createStore)([], {
        and: {
            serialize: "ignore"
        },
        name: "$activeRoutes",
        sid: "9ljm7u"
    }), Q = (0, $agnkb.createStore)(null, {
        and: {
            serialize: "ignore"
        },
        name: "$history",
        sid: "g4i7nj"
    }), I = (0, $agnkb.createStore)(!1, {
        name: "$isFirstCheckPassed",
        sid: "9r108x"
    }), L = (0, $agnkb.createStore)(!1, {
        name: "$isRouteNavigateInProgress",
        sid: "a1vtrl"
    }), N = (0, $agnkb.attach)({
        and: {
            source: Q,
            effect: (e, r)=>$e13fe69fd88e859a$var$E($e13fe69fd88e859a$var$a({
                    history: e
                }, r))
        },
        or: {
            name: "pushFx",
            sid: "qm76ov"
        }
    }), B = (0, $agnkb.attach)({
        and: {
            source: Q,
            effect: (e)=>{
                var r = O;
                try {
                    r = (0, $agnkb.scopeBind)(O);
                } catch (e) {}
                return e.listen(()=>{
                    r();
                }), !0;
            }
        },
        or: {
            name: "subscribeHistoryFx",
            sid: "-b12mlt"
        }
    }), M = (0, $agnkb.sample)({
        and: [
            {
                clock: u ? [
                    O
                ] : [
                    O,
                    B.done
                ],
                source: Q,
                filter: Boolean,
                fn: (e)=>{
                    var r;
                    return {
                        path: e.location.pathname,
                        query: null !== (r = null == l ? void 0 : l.read(e.location.search)) && void 0 !== r ? r : Object.fromEntries(new URLSearchParams(e.location.search))
                    };
                }
            }
        ],
        or: {
            name: "historyUpdatedParsed",
            sid: "-rhkauu"
        }
    }), _ = (0, $agnkb.sample)({
        and: [
            {
                clock: M,
                source: {
                    path: F,
                    query: C
                },
                filter: (e, r)=>r.path !== e.path || !$e13fe69fd88e859a$var$i(r.query, e.query),
                fn: (e, r)=>r
            }
        ],
        or: {
            name: "historyUpdateTriggered",
            sid: "-pbyg2j"
        }
    });
    Q.on(h, (e, r)=>r), (0, $agnkb.sample)({
        and: [
            {
                clock: Q,
                target: B
            }
        ],
        or: {
            sid: "-pwl7u3"
        }
    }), (0, $agnkb.sample)({
        and: [
            {
                clock: _,
                source: Q,
                filter: Boolean,
                fn: (e)=>{
                    var r, a = null == e ? void 0 : e.location.hash;
                    return {
                        path: null == e ? void 0 : e.location.pathname,
                        query: null !== (r = null == l ? void 0 : l.read(null == e ? void 0 : e.location.search)) && void 0 !== r ? r : Object.fromEntries(new URLSearchParams(null == e ? void 0 : e.location.search)),
                        hash: a
                    };
                },
                target: w
            }
        ],
        or: {
            sid: "-ptu8va"
        }
    });
    for(var G, J = $e13fe69fd88e859a$var$o(f); !(G = J()).done;){
        var K = G.value, V = R.filterMap($e13fe69fd88e859a$var$T(K)), W = x.filterMap($e13fe69fd88e859a$var$T(K)), X = {
            opened: (0, $agnkb.sample)({
                and: [
                    {
                        clock: V,
                        filter: $e13fe69fd88e859a$var$c(K.route.$isOpened)
                    }
                ],
                or: {
                    name: "opened",
                    sid: "-vfmdab"
                }
            }),
            updated: (0, $agnkb.sample)({
                and: [
                    {
                        clock: V,
                        filter: K.route.$isOpened
                    }
                ],
                or: {
                    name: "updated",
                    sid: "-2uhvx2"
                }
            }),
            closed: (0, $agnkb.sample)({
                and: [
                    {
                        clock: W,
                        filter: K.route.$isOpened
                    }
                ],
                or: {
                    name: "closed",
                    sid: "jc9588"
                }
            })
        };
        (0, $agnkb.sample)({
            and: [
                {
                    clock: X.updated,
                    source: [
                        K.route.$params,
                        K.route.$query
                    ],
                    filter: (e, r)=>{
                        var a = e[1];
                        return !$e13fe69fd88e859a$var$i(e[0], r.params) || !$e13fe69fd88e859a$var$i(a, r.query);
                    },
                    fn: (e, r)=>r,
                    target: K.route.updated
                }
            ],
            or: {
                sid: "-ny7ju5"
            }
        }), (0, $agnkb.sample)({
            and: [
                {
                    clock: X.opened,
                    filter: $e13fe69fd88e859a$var$c(L),
                    target: K.route.opened
                }
            ],
            or: {
                sid: "-ngm4ul"
            }
        }), (0, $agnkb.sample)({
            and: [
                {
                    clock: X.closed,
                    target: K.route.closed
                }
            ],
            or: {
                sid: "-d2q1d1"
            }
        });
    }
    for(var Y, Z = ()=>{
        var e = Y.value;
        (0, $agnkb.sample)({
            and: [
                {
                    clock: e.route.navigate.doneData,
                    fn: (r)=>{
                        var a = r.replace;
                        return {
                            route: e,
                            params: r.params,
                            query: r.query,
                            replace: null != a && a
                        };
                    },
                    target: v
                }
            ],
            or: {
                sid: "-cm87k7"
            }
        });
    }, ee = $e13fe69fd88e859a$var$o(f); !(Y = ee()).done;)Z();
    L.on(v, ()=>!0), (0, $agnkb.sample)({
        and: [
            {
                clock: v,
                fn: (e)=>{
                    var r = e.params, a = e.query, n = e.replace;
                    return {
                        path: $e13fe69fd88e859a$export$5cc7f731b5937e99({
                            pathCreator: e.route.path,
                            params: r,
                            query: a,
                            serialize: l
                        }),
                        params: r,
                        query: a,
                        method: n ? "replace" : "push"
                    };
                },
                target: N
            }
        ],
        or: {
            sid: "-c2zeua"
        }
    }), L.reset([
        R,
        x
    ]), (0, $agnkb.sample)({
        and: [
            {
                clock: w,
                fn: (e)=>{
                    for(var r, a = e.path, n = e.query, t = e.hash, i = [], s = [], u = $e13fe69fd88e859a$var$o(f); !(r = u()).done;){
                        var c = r.value, l = c.path.includes("#") ? "" + a + t : "" + a, p = $e13fe69fd88e859a$export$81336c211d5ff295({
                            pathCreator: c.path,
                            actualPath: l
                        });
                        (p.matches ? i : s).push({
                            routeObj: c,
                            params: p.params,
                            query: n
                        });
                    }
                    return s.forEach((e, r)=>{
                        i.some((r)=>r.routeObj.route === e.routeObj.route) && s.splice(r, 1);
                    }), {
                        matching: i,
                        mismatching: s.filter(Boolean),
                        path: a,
                        query: n
                    };
                },
                target: $
            }
        ],
        or: {
            sid: "-ar5b7v"
        }
    }), F.on(_, (e, r)=>r.path), C.on(_, (e, r)=>r.query);
    var re = $.map((e)=>e.matching);
    return (0, $agnkb.sample)({
        and: [
            {
                clock: re,
                filter: (e)=>e.length > 0,
                target: R
            }
        ],
        or: {
            sid: "1l4g7x"
        }
    }), (0, $agnkb.sample)({
        and: [
            {
                clock: $.map((e)=>e.mismatching),
                filter: (e)=>e.length > 0,
                target: x
            }
        ],
        or: {
            sid: "1zyw8o"
        }
    }), H.on($, (e, r)=>r.matching.map((e)=>e.routeObj.route)), (0, $agnkb.sample)({
        and: [
            {
                clock: re,
                filter: (e)=>0 === e.length,
                target: P
            }
        ],
        or: {
            sid: "2hkb88"
        }
    }), (0, $agnkb.withFactory)({
        sid: "2kv2vu",
        fn: ()=>$e13fe69fd88e859a$export$76be974a4f0c1975(t),
        name: "none",
        method: "isRoute"
    }) && ((0, $agnkb.sample)({
        and: [
            {
                clock: P,
                source: C,
                filter: t.$isOpened,
                fn: (e)=>({
                        query: e,
                        params: {}
                    }),
                target: t.updated
            }
        ],
        or: {
            sid: "2levfh"
        }
    }), (0, $agnkb.sample)({
        and: [
            {
                clock: P,
                source: {
                    query: C,
                    isOpened: t.$isOpened
                },
                filter: (e)=>!e.isOpened,
                fn: (e)=>({
                        query: e.query,
                        params: {}
                    }),
                target: t.opened
            }
        ],
        or: {
            sid: "31cwmy"
        }
    }), (0, $agnkb.sample)({
        and: [
            {
                clock: re,
                source: t.$isOpened,
                filter: (e, r)=>e && r.length > 0,
                target: t.closed
            }
        ],
        or: {
            sid: "3haxuf"
        }
    })), (0, $agnkb.sample)({
        and: [
            {
                clock: m.back,
                source: Q,
                target: $e13fe69fd88e859a$var$A
            }
        ],
        or: {
            sid: "3xsrlj"
        }
    }), (0, $agnkb.sample)({
        and: [
            {
                clock: m.forward,
                source: Q,
                target: $e13fe69fd88e859a$var$D
            }
        ],
        or: {
            sid: "413j5p"
        }
    }), (0, $agnkb.sample)({
        and: [
            {
                clock: C,
                source: {
                    controlsQuery: m.$query,
                    localQuery: C
                },
                filter: (e)=>!$e13fe69fd88e859a$var$i(e.controlsQuery, e.localQuery),
                fn: (e)=>e.localQuery,
                target: m.$query
            }
        ],
        or: {
            sid: "4ghrrt"
        }
    }), (0, $agnkb.sample)({
        and: [
            {
                clock: m.$query,
                source: {
                    path: F,
                    localQuery: C,
                    isNavigateInProgress: L,
                    realHistory: Q
                },
                filter: (e, r)=>{
                    var a, n, t, o = e.localQuery, s = e.isNavigateInProgress, d = e.realHistory, u = null !== (a = null == l ? void 0 : l.read(null !== (n = null == d ? void 0 : d.location.search) && void 0 !== n ? n : "")) && void 0 !== a ? a : Object.fromEntries(new URLSearchParams(null !== (t = null == d ? void 0 : d.location.search) && void 0 !== t ? t : ""));
                    return s || !$e13fe69fd88e859a$var$i(r, u) || !$e13fe69fd88e859a$var$i(o, r);
                },
                fn: (e, r)=>{
                    var a, n = e.path, t = null !== (a = null == l ? void 0 : l.write(r)) && void 0 !== a ? a : new URLSearchParams(r);
                    return {
                        path: n + (t ? "?" + t : ""),
                        params: {},
                        query: r,
                        method: "push"
                    };
                },
                target: N
            }
        ],
        or: {
            sid: "4wzlkn"
        }
    }), (0, $agnkb.sample)({
        and: [
            {
                clock: $,
                source: {
                    activeRoutes: H,
                    path: F,
                    query: C
                },
                filter: I.map((e)=>!e),
                target: z
            }
        ],
        or: {
            sid: "gbpwte"
        }
    }), I.on(z, ()=>!0).reset(Q), {
        $path: F,
        $activeRoutes: H,
        $history: Q,
        setHistory: h,
        $query: C,
        back: m.back,
        forward: m.forward,
        push: N,
        routes: f,
        initialized: z,
        routeNotFound: P
    };
}
function $e13fe69fd88e859a$export$89e12c5b50f7529d(e) {
    var r = e.clock ? (0, $agnkb.sample)({
        and: [
            {
                clock: e.clock
            }
        ],
        or: {
            name: "clock",
            sid: "-ek44ri"
        }
    }) : (0, $agnkb.createEvent)({
        name: "clock",
        sid: "-ejkc65"
    }), a = $e13fe69fd88e859a$var$m(e.params || {}), n = $e13fe69fd88e859a$var$m(e.query || {}), t = $e13fe69fd88e859a$var$m(e.replace || !1);
    return (0, $agnkb.sample)({
        and: [
            {
                clock: r,
                source: {
                    params: a,
                    query: n,
                    replace: t
                },
                fn: (e, r)=>{
                    var a = e.params, n = e.query, t = e.replace;
                    return {
                        params: "function" == typeof a ? a(r) : a,
                        query: "function" == typeof n ? n(r) : n,
                        replace: "function" == typeof t ? t(r) : t
                    };
                },
                target: e.route.navigate
            }
        ],
        or: {
            sid: "ai8jf5"
        }
    }), r;
}
function $e13fe69fd88e859a$var$m(e) {
    return (0, $agnkb.is).store(e, {
        sid: "b1hcct"
    }) ? e : (0, $agnkb.createStore)(e, {
        sid: "-cvms36"
    });
}
function $e13fe69fd88e859a$export$cdba908a7d0612af(r) {
    var a = ((r)=>{
        var a = {};
        if ((0, $agnkb.withFactory)({
            sid: "-vuorye",
            fn: ()=>$e13fe69fd88e859a$export$76be974a4f0c1975(r),
            name: "none",
            method: "isRoute"
        })) return Object.assign(a, {
            route: r,
            chainedRoute: (0, $agnkb.withFactory)({
                sid: "-x3jlk0",
                fn: ()=>$e13fe69fd88e859a$export$544c268deaca2597(),
                name: "chainedRoute",
                method: "createRoute"
            }),
            beforeOpen: (0, $agnkb.createEvent)({
                name: "beforeOpen",
                sid: "2i9mdy"
            }),
            openOn: (0, $agnkb.merge)([
                r.opened,
                r.closed
            ], {
                name: "openOn",
                sid: "-n9uh0c"
            }),
            cancelOn: (0, $agnkb.merge)([
                (0, $agnkb.createEvent)({
                    name: "cancelOn",
                    sid: "r6ceph"
                })
            ], {
                name: "cancelOn",
                sid: "r6ce1d"
            })
        }), a;
        var n = r;
        if (Object.assign(a, {
            route: n.route,
            chainedRoute: n.chainedRoute || (0, $agnkb.withFactory)({
                sid: "-if59ok",
                fn: ()=>$e13fe69fd88e859a$export$544c268deaca2597(),
                name: "chainedRoute",
                method: "createRoute"
            }),
            beforeOpen: (0, $agnkb.is).unit(n.beforeOpen) ? n.beforeOpen : (0, $agnkb.attach)({
                and: n.beforeOpen,
                or: {
                    name: "beforeOpen",
                    sid: "-xdumjk"
                }
            })
        }), (0, $agnkb.is).effect(a.beforeOpen, {
            sid: "-qylloz"
        })) return Object.assign(a, {
            openOn: n.openOn || a.beforeOpen.doneData,
            cancelOn: n.cancelOn || a.beforeOpen.failData
        }), a;
        var t = r;
        return Object.assign(a, {
            openOn: (0, $agnkb.sample)({
                and: [
                    {
                        clock: t.openOn
                    }
                ],
                or: {
                    name: "openOn",
                    sid: "-92mmrn"
                }
            }),
            cancelOn: (0, $agnkb.sample)({
                and: [
                    {
                        clock: t.cancelOn || (0, $agnkb.createEvent)({
                            name: "clock",
                            sid: "-53qs2n"
                        })
                    }
                ],
                or: {
                    name: "cancelOn",
                    sid: "-m0jt12"
                }
            })
        }), a;
    })(r), n = a.route, t = a.chainedRoute, o = a.beforeOpen, i = a.openOn, s = a.cancelOn, d = (0, $agnkb.createStore)({}, {
        name: "$params",
        sid: "ahwukb"
    }), u = (0, $agnkb.createStore)({}, {
        name: "$query",
        sid: "-urele3"
    }), c = (0, $agnkb.combine)({
        and: [
            (0, $agnkb.combine)({
                and: [
                    [
                        n.$params,
                        n.$query
                    ]
                ],
                or: {
                    name: "and",
                    sid: "3v6jcf"
                }
            }),
            (0, $agnkb.combine)({
                and: [
                    [
                        d,
                        u
                    ]
                ],
                or: {
                    name: "and",
                    sid: "3vqbxs"
                }
            }),
            (e, r)=>e[0] === r[0] && e[1] === r[1]
        ],
        or: {
            name: "$hasSameParams",
            sid: "-xzy23v"
        }
    }), l = (0, $agnkb.sample)({
        and: [
            {
                clock: [
                    n.opened,
                    n.updated
                ]
            }
        ],
        or: {
            name: "routeOpened",
            sid: "-gtwxmc"
        }
    });
    (0, $agnkb.sample)({
        and: [
            {
                clock: l,
                target: o
            }
        ],
        or: {
            sid: "-noxmt5"
        }
    }), d.on(l, (e, r)=>r.params), u.on(l, (e, r)=>r.query);
    var p = (0, $agnkb.guard)({
        and: [
            {
                clock: i,
                source: {
                    params: d,
                    query: u
                },
                filter: c
            }
        ],
        or: {
            name: "chainedRouteResolved",
            sid: "-mwemeb"
        }
    });
    (0, $agnkb.sample)({
        and: [
            {
                clock: p,
                target: t.navigate
            }
        ],
        or: {
            sid: "-n6sf88"
        }
    });
    var m = (0, $agnkb.merge)([
        n.closed,
        s
    ], {
        name: "aborted",
        sid: "utn0jm"
    });
    return d.reset(m), u.reset(m), (0, $agnkb.sample)({
        and: [
            {
                clock: m,
                target: t.closed
            }
        ],
        or: {
            sid: "-mqalfe"
        }
    }), t;
}
function $e13fe69fd88e859a$export$664131e403871764(e) {
    var r, n, t, i = null !== (r = null === (n = e.route) || void 0 === n ? void 0 : n.$isOpened) && void 0 !== r ? r : (0, $agnkb.createStore)(!0, {
        name: "$isOpened",
        sid: "-ubx3p"
    }), s = (0, $agnkb.combine)({
        and: [
            e.source
        ],
        or: {
            name: "$source",
            sid: "-3rrhte"
        }
    }), d = null !== (t = e.clock) && void 0 !== t ? t : s, u = "cleanup" in e ? "boolean" == typeof e.cleanup ? $e13fe69fd88e859a$var$C[e.cleanup ? "all" : "none"] : $e13fe69fd88e859a$var$a($e13fe69fd88e859a$var$a({}, $e13fe69fd88e859a$var$C.default), e.cleanup) : $e13fe69fd88e859a$var$C.default, c = (0, $agnkb.sample)({
        and: [
            {
                clock: e.controls.$query,
                filter: i
            }
        ],
        or: {
            name: "queryUpdatedFromHistory",
            sid: "8lf3wv"
        }
    });
    (0, $agnkb.sample)({
        and: [
            {
                clock: d,
                source: (0, $agnkb.combine)({
                    and: [
                        [
                            s,
                            e.controls.$query
                        ]
                    ],
                    or: {
                        name: "source",
                        sid: "-3pgs50"
                    }
                }),
                filter: i,
                fn: (e)=>{
                    var r = e[0], n = e[1], t = {};
                    if (u.irrelevant) for(var i, s = $e13fe69fd88e859a$var$o(u.preserve); !(i = s()).done;){
                        var d = i.value;
                        d in n && (t[d] = n[d]);
                    }
                    else t = $e13fe69fd88e859a$var$a({}, n);
                    for(var c in r)t[c] = r[c];
                    if (u.empty) for(var l in r)u.preserve.includes(l) || t[l] || delete t[l];
                    return t;
                },
                target: e.controls.$query
            }
        ],
        or: {
            sid: "fuzb5g"
        }
    });
    var l = (r)=>{
        var a = e.source[r];
        a.on(c, (e, n)=>{
            var t;
            return null !== (t = n[r]) && void 0 !== t ? t : a.defaultState;
        });
    };
    for(var p in e.source)l(p);
}
var $e13fe69fd88e859a$export$a84bdc57c5122798 = {
    ROUTE: Symbol()
}, $e13fe69fd88e859a$export$5f30bfe6ad37bbb0 = ()=>({
        $query: (0, $agnkb.createStore)({}, {
            and: {
                updateFilter: (e, r)=>!$e13fe69fd88e859a$var$i(r, e)
            },
            name: "$query",
            sid: "z22f3o"
        }),
        back: (0, $agnkb.createEvent)({
            name: "back",
            sid: "lqciue"
        }),
        forward: (0, $agnkb.createEvent)({
            name: "forward",
            sid: "-5dfdts"
        })
    }), $e13fe69fd88e859a$export$76be974a4f0c1975 = (e)=>"object" == typeof e && null !== e && "kind" in e && e.kind === $e13fe69fd88e859a$export$a84bdc57c5122798.ROUTE, $e13fe69fd88e859a$var$E = (0, $agnkb.createEffect)((e)=>($e13fe69fd88e859a$var$u(e.history), e.history[e.method](e.path, {}), e), {
    name: "historyPushFx",
    sid: "-w0no5y"
}), $e13fe69fd88e859a$var$A = (0, $agnkb.createEffect)((e)=>($e13fe69fd88e859a$var$u(e), e.back(), e), {
    name: "historyBackFx",
    sid: "-ny8vwp"
}), $e13fe69fd88e859a$var$D = (0, $agnkb.createEffect)((e)=>($e13fe69fd88e859a$var$u(e), e.forward(), e), {
    name: "historyForwardFx",
    sid: "88oqi4"
}), $e13fe69fd88e859a$var$T = (e)=>(r)=>{
        var a = r.find((r)=>r.routeObj.route === e.route);
        if (a) return {
            params: a.params,
            query: a.query
        };
    }, $e13fe69fd88e859a$var$C = {
    all: {
        irrelevant: !0,
        empty: !0,
        preserve: []
    },
    default: {
        irrelevant: !1,
        empty: !0,
        preserve: []
    },
    none: {
        irrelevant: !1,
        empty: !1,
        preserve: []
    }
};



var $agnkb = parcelRequire("agnkb");

function $ad1d53f18b004f8e$export$5e89343b21832879(e) {
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>(0, $133989e677847899$export$35059013cd4a06db)(()=>e()));
}
function $ad1d53f18b004f8e$export$1261263aa227ed77(e) {
    (0, $133989e677847899$export$a40e83dd9f9a97c8)({
        visible: e.$isOpened
    });
}
function $ad1d53f18b004f8e$export$a92cb4e662b6b4b2({ clock: e, router: r, Link: n }) {
    (0, $agnkb.sample)({
        clock: e,
        fn: ()=>r.routes,
        target: n.$routes
    });
}
function $ad1d53f18b004f8e$export$cdda5b1be25f9499() {
    let e = (0, $agnkb.createStore)([]);
    function r(n, t = {}) {
        let c = (t.tag ?? "a") === "a", y = $ad1d53f18b004f8e$var$d(t.params ?? {}), p = $ad1d53f18b004f8e$var$d(t.query ?? {}), m = {
            ...t.attr
        };
        if (c) {
            let o = e.map((s)=>{
                var a;
                return ((a = s.find((i)=>i.route === n)) == null ? void 0 : a.path) ?? "";
            });
            m.href = (0, $agnkb.combine)(o, y, p, (s, a, i)=>(0, $e13fe69fd88e859a$export$5cc7f731b5937e99)({
                    pathCreator: s,
                    params: a,
                    query: i
                }));
        }
        let f = (0, $agnkb.createEvent)();
        (0, $agnkb.sample)({
            source: (0, $agnkb.combine)({
                query: p,
                params: y
            }),
            clock: f,
            target: n.navigate
        }), (0, $133989e677847899$export$dda1d9f60106f0e9)(t.tag ?? "a", {
            ...t,
            attr: m,
            fn () {
                var o;
                (o = t.fn) == null || o.call(t), (0, $133989e677847899$export$c3c52e219617878)({
                    prevent: c
                }, {
                    click: f
                });
            }
        });
    }
    return r.$routes = e, r;
}
function $ad1d53f18b004f8e$var$d(e) {
    return (0, $agnkb.is).store(e) ? e : (0, $agnkb.combine)(e);
}


// export * from "./ui";
var $b047cb928fb2fbfa$exports = {};

$parcel$export($b047cb928fb2fbfa$exports, "$searchQuery", function () { return $b047cb928fb2fbfa$export$ff606c0379270787; });
$parcel$export($b047cb928fb2fbfa$exports, "$formattedSearchFilter", function () { return $b047cb928fb2fbfa$export$f39a1cdbeb983f5c; });
$parcel$export($b047cb928fb2fbfa$exports, "$currentKind", function () { return $b047cb928fb2fbfa$export$315396cc69206b29; });
$parcel$export($b047cb928fb2fbfa$exports, "$currentLevel", function () { return $b047cb928fb2fbfa$export$e843a4bdf9f6b7a8; });
$parcel$export($b047cb928fb2fbfa$exports, "$currentFromTime", function () { return $b047cb928fb2fbfa$export$e04137b70cc2e046; });
$parcel$export($b047cb928fb2fbfa$exports, "$currentToTime", function () { return $b047cb928fb2fbfa$export$c30aa56130429a96; });
$parcel$export($b047cb928fb2fbfa$exports, "$currentPage", function () { return $b047cb928fb2fbfa$export$befb8e48537eb878; });
$parcel$export($b047cb928fb2fbfa$exports, "$logs", function () { return $b047cb928fb2fbfa$export$b16c828f71c53019; });
$parcel$export($b047cb928fb2fbfa$exports, "$pages", function () { return $b047cb928fb2fbfa$export$ebfeba3788e0f172; });
$parcel$export($b047cb928fb2fbfa$exports, "$groupedLogs", function () { return $b047cb928fb2fbfa$export$fc711c680434a993; });
$parcel$export($b047cb928fb2fbfa$exports, "$logsGroups", function () { return $b047cb928fb2fbfa$export$6a8055382887310a; });
$parcel$export($b047cb928fb2fbfa$exports, "effects", function () { return $b047cb928fb2fbfa$export$fb4689499fb20c56; });
$parcel$export($b047cb928fb2fbfa$exports, "events", function () { return $b047cb928fb2fbfa$export$4bf9923669ad6c63; });

var $agnkb = parcelRequire("agnkb");

var $agnkb = parcelRequire("agnkb");

const $282d3c07b97d7068$export$c20bb6a46350d592 = (0, $agnkb.createEvent)();
const $282d3c07b97d7068$export$a99804013664a287 = (0, $agnkb.createEvent)();
const $282d3c07b97d7068$export$3817193eb9502474 = (0, $agnkb.createStore)("");
const $282d3c07b97d7068$export$456a1449be803865 = $282d3c07b97d7068$export$3817193eb9502474.map(Boolean);
const $282d3c07b97d7068$export$d8ff71519acdd706 = (0, $agnkb.createEvent)();
const $282d3c07b97d7068$export$f6206badeeec0319 = (0, $agnkb.createEvent)();
const $282d3c07b97d7068$export$18d0aa8b957caef4 = (0, $agnkb.createEvent)();
$282d3c07b97d7068$export$3817193eb9502474.on($282d3c07b97d7068$export$c20bb6a46350d592, (_, token)=>token).reset($282d3c07b97d7068$export$a99804013664a287);
const $282d3c07b97d7068$export$b6537f11d186f6b6 = (0, $agnkb.createEffect)(()=>{
    return (0, $dde8f8cdf92b8dc1$export$12151e9ef3722552)();
});
const $282d3c07b97d7068$export$e42464f64b0bde8c = (0, $agnkb.createEvent)();
(0, $agnkb.sample)({
    source: $282d3c07b97d7068$export$b6537f11d186f6b6.pending,
    clock: $282d3c07b97d7068$export$e42464f64b0bde8c,
    filter: (pending)=>!pending,
    target: $282d3c07b97d7068$export$b6537f11d186f6b6
});
(0, $agnkb.sample)({
    source: $282d3c07b97d7068$export$456a1449be803865,
    clock: $282d3c07b97d7068$export$b6537f11d186f6b6.doneData,
    filter: (isAuthorized, sessionResponse)=>!isAuthorized && !!sessionResponse?.data?.token && sessionResponse.success,
    fn: (_, sessionResponse)=>sessionResponse.data.token,
    target: $282d3c07b97d7068$export$c20bb6a46350d592
});
const $282d3c07b97d7068$export$d2059582cfe4247c = (0, $agnkb.createEvent)();
(0, $agnkb.sample)({
    clock: $282d3c07b97d7068$export$b6537f11d186f6b6.doneData,
    filter: (sessionResponse)=>sessionResponse.success && sessionResponse.data.should_create_initial_admin,
    target: $282d3c07b97d7068$export$d2059582cfe4247c
});


const $b60cd828ae3cfea9$var$BASE_URL = "";
const $b60cd828ae3cfea9$export$aaece59a3c2b9dc3 = async ({ token: token, url: url, method: method, body: body, headers: headers })=>{
    try {
        const response = await fetch(`${$b60cd828ae3cfea9$var$BASE_URL}${url}`, {
            method: method,
            credentials: "include",
            referrerPolicy: "origin",
            body: body,
            headers: {
                ...headers,
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        });
        const responseText = await response.clone().text();
        switch(response.status){
            case 401:
                (0, $282d3c07b97d7068$export$d8ff71519acdd706)();
                break;
            case 403:
                (0, $282d3c07b97d7068$export$f6206badeeec0319)();
                break;
            case 404:
                (0, $282d3c07b97d7068$export$18d0aa8b957caef4)();
                break;
        }
        const jsonResponse = JSON.parse(responseText);
        return jsonResponse;
    } catch (error) {
        console.log(error);
    }
};
const $b60cd828ae3cfea9$export$3988ae62b71be9a3 = (0, $agnkb.attach)({
    source: (0, $282d3c07b97d7068$export$3817193eb9502474),
    mapParams: ({ url: url, headers: headers }, token)=>({
            token: token,
            url: url,
            headers: headers
        }),
    effect: (0, $agnkb.createEffect)(({ token: token, url: url, headers: headers })=>{
        return $b60cd828ae3cfea9$export$aaece59a3c2b9dc3({
            token: token,
            url: url,
            method: "GET",
            headers: headers
        });
    })
});
const $b60cd828ae3cfea9$export$299ba2dee77727e9 = (0, $agnkb.attach)({
    source: (0, $282d3c07b97d7068$export$3817193eb9502474),
    mapParams: ({ url: url, body: body, headers: headers }, token)=>({
            token: token,
            url: url,
            body: body,
            headers: headers
        }),
    effect: (0, $agnkb.createEffect)(({ token: token, url: url, body: body, headers: headers })=>{
        return $b60cd828ae3cfea9$export$aaece59a3c2b9dc3({
            token: token,
            url: url,
            method: "POST",
            body: body,
            headers: headers
        });
    })
});
const $b60cd828ae3cfea9$export$327f7b26ebf455db = (0, $agnkb.attach)({
    source: (0, $282d3c07b97d7068$export$3817193eb9502474),
    mapParams: ({ url: url, body: body, headers: headers }, token)=>({
            token: token,
            url: url,
            body: body,
            headers: headers
        }),
    effect: (0, $agnkb.createEffect)(({ token: token, url: url, body: body, headers: headers })=>{
        return $b60cd828ae3cfea9$export$aaece59a3c2b9dc3({
            token: token,
            url: url,
            method: "PUT",
            body: body,
            headers: headers
        });
    })
});
const $b60cd828ae3cfea9$export$1d2f21e549771e67 = (0, $agnkb.attach)({
    source: (0, $282d3c07b97d7068$export$3817193eb9502474),
    mapParams: ({ url: url, headers: headers }, token)=>({
            token: token,
            url: url,
            headers: headers
        }),
    effect: (0, $agnkb.createEffect)(({ token: token, url: url, headers: headers })=>{
        return $b60cd828ae3cfea9$export$aaece59a3c2b9dc3({
            token: token,
            url: url,
            method: "DELETE",
            headers: headers
        });
    })
});


const $e0105e1f51ddac9f$export$2ea2899b54bd4140 = ()=>{
    return (0, $b60cd828ae3cfea9$export$3988ae62b71be9a3)({
        url: "/api/schemas"
    });
};
const $e0105e1f51ddac9f$export$19a621270f26273c = (id)=>{
    return (0, $b60cd828ae3cfea9$export$3988ae62b71be9a3)({
        url: `/api/schemas/${id}`
    });
};
const $e0105e1f51ddac9f$export$1671f9161fc49fec = (query)=>{
    return (0, $b60cd828ae3cfea9$export$299ba2dee77727e9)({
        url: "/api/schemas/search",
        body: JSON.stringify(query)
    });
};
const $e0105e1f51ddac9f$export$5f4ce795563f4211 = (schema)=>{
    const retention_days = schema.retention_days === "" ? 0 : schema.retention_days;
    const modifiedSchema = {
        ...schema,
        retention_days: retention_days
    };
    return (0, $b60cd828ae3cfea9$export$299ba2dee77727e9)({
        url: "/api/schemas",
        body: JSON.stringify(modifiedSchema)
    });
};
const $e0105e1f51ddac9f$export$e1b290f9620da5ab = (schema)=>{
    const retention_days = schema.retention_days === "" ? 0 : schema.retention_days;
    const modifiedSchema = {
        ...schema,
        retention_days: retention_days
    };
    return (0, $b60cd828ae3cfea9$export$327f7b26ebf455db)({
        url: `/api/schemas/${schema.id}`,
        body: JSON.stringify(modifiedSchema)
    });
};
const $e0105e1f51ddac9f$export$afb15112eaa2ae8e = (id)=>{
    return (0, $b60cd828ae3cfea9$export$1d2f21e549771e67)({
        url: `/api/schemas/${id}`
    });
};



const $52b80dee660e935b$export$af63d7414243dad3 = ()=>{
    return (0, $b60cd828ae3cfea9$export$3988ae62b71be9a3)({
        url: "/api/tags"
    });
};
const $52b80dee660e935b$export$dad497fe1f6e27c0 = (id)=>{
    return (0, $b60cd828ae3cfea9$export$3988ae62b71be9a3)({
        url: `/api/tags/${id}`
    });
};
const $52b80dee660e935b$export$ee84a198a55b65e5 = (tag)=>{
    return (0, $b60cd828ae3cfea9$export$299ba2dee77727e9)({
        url: "/api/tags",
        body: JSON.stringify(tag)
    });
};
const $52b80dee660e935b$export$aaf61dfaebff7546 = (tag)=>{
    return (0, $b60cd828ae3cfea9$export$327f7b26ebf455db)({
        url: `/api/tags/${tag.id}`,
        body: JSON.stringify(tag)
    });
};
const $52b80dee660e935b$export$2895d72886bc0b68 = (id)=>{
    return (0, $b60cd828ae3cfea9$export$1d2f21e549771e67)({
        url: `/api/tags/${id}`
    });
};


const $d2a241c4f7a9141f$export$180605366c04f0cd = ()=>{
    if (navigator.languages && navigator.languages.length) return navigator.languages[0];
    return navigator.language;
};


const $5cd65399be29f718$export$65702e18b569a15d = {
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    year: "numeric",
    month: "numeric",
    day: "numeric"
};
const $5cd65399be29f718$export$6f5c75afcb5ad5cc = Intl.DateTimeFormat().resolvedOptions().timeZone;


const $ebb40c4f76ecbb36$export$354076178bdef094 = {
    required: ()=>({
            name: "required",
            validator: (value)=>({
                    isValid: Boolean(value),
                    errorText: "Required field"
                })
        }),
    email: ()=>({
            name: "email",
            validator: (value)=>({
                    isValid: /\S+@\S+\.\S+/.test(value),
                    errorText: "Invalid email"
                })
        }),
    password: ()=>({
            name: "password-equal",
            validator: (confirm, { password: password })=>({
                    isValid: password === confirm,
                    errorText: "Passwords must match"
                })
        })
};





var $agnkb = parcelRequire("agnkb");
const $69cfdfca25b18a98$export$e614dc9140f7ae71 = ({ source: source, target: target })=>{
    const result = (0, $agnkb.createEvent)();
    if ((0, $agnkb.is).unit(source)) (0, $agnkb.sample)({
        source: source,
        clock: result,
        target: target
    });
    else (0, $agnkb.sample)({
        source: result,
        target: target,
        fn: ()=>source
    });
    return result;
};


var $d461744a27a10557$exports = {};

$parcel$export($d461744a27a10557$exports, "$users", function () { return $d461744a27a10557$export$9b6f05aab99f3553; });
$parcel$export($d461744a27a10557$exports, "$currentUser", function () { return $d461744a27a10557$export$c4f903bd27e848b; });
$parcel$export($d461744a27a10557$exports, "$currentAccount", function () { return $d461744a27a10557$export$52003f91df03822; });
$parcel$export($d461744a27a10557$exports, "$currentTheme", function () { return $d461744a27a10557$export$6259d3105e9c14f3; });
$parcel$export($d461744a27a10557$exports, "themeChanged", function () { return $d461744a27a10557$export$1631a6e518ecce65; });
$parcel$export($d461744a27a10557$exports, "effects", function () { return $d461744a27a10557$export$fb4689499fb20c56; });
$parcel$export($d461744a27a10557$exports, "events", function () { return $d461744a27a10557$export$4bf9923669ad6c63; });


const $35791464ed1de21e$export$925a4945a6cd0f3e = ()=>{
    return (0, $b60cd828ae3cfea9$export$3988ae62b71be9a3)({
        url: "/api/users"
    });
};
const $35791464ed1de21e$export$7cbf767827cd68ba = (id)=>{
    return (0, $b60cd828ae3cfea9$export$3988ae62b71be9a3)({
        url: `/api/users/${id}`
    });
};
const $35791464ed1de21e$export$3493b8991d49f558 = (user)=>{
    return (0, $b60cd828ae3cfea9$export$299ba2dee77727e9)({
        url: "/api/users",
        body: JSON.stringify(user)
    });
};
const $35791464ed1de21e$export$2729cf999c745c98 = (user)=>{
    return (0, $b60cd828ae3cfea9$export$327f7b26ebf455db)({
        url: `/api/users/${user.id}`,
        body: JSON.stringify(user)
    });
};
const $35791464ed1de21e$export$7d0f10f273c0438a = (id)=>{
    return (0, $b60cd828ae3cfea9$export$1d2f21e549771e67)({
        url: `/api/users/${id}`
    });
};



var $agnkb = parcelRequire("agnkb");
const $d461744a27a10557$var$THEME_KEY = "theme";
const $d461744a27a10557$var$getUsersFx = (0, $agnkb.createEffect)(()=>{
    return (0, $35791464ed1de21e$export$925a4945a6cd0f3e)();
});
const $d461744a27a10557$var$getUserFx = (0, $agnkb.createEffect)((id)=>{
    return (0, $35791464ed1de21e$export$7cbf767827cd68ba)(id);
});
const $d461744a27a10557$export$9b6f05aab99f3553 = (0, $agnkb.createStore)([]).on($d461744a27a10557$var$getUsersFx.doneData, (_, usersResponse)=>usersResponse.data);
const $d461744a27a10557$export$c4f903bd27e848b = (0, $agnkb.createStore)({
    id: 0,
    name: "",
    email: "",
    role: "Member",
    tag_ids: [],
    token: "",
    is_revoked: false
}).on($d461744a27a10557$var$getUserFx.doneData, (_, userResponse)=>userResponse.data);
const $d461744a27a10557$export$52003f91df03822 = (0, $agnkb.createStore)({
    id: 0,
    name: "",
    email: "",
    role: "Member",
    tag_ids: [],
    token: "",
    is_revoked: false
});
const $d461744a27a10557$var$loadThemeFromStorageFx = (0, $agnkb.createEffect)(()=>{
    return localStorage.getItem($d461744a27a10557$var$THEME_KEY);
});
const $d461744a27a10557$var$setThemeToStorageFx = (0, $agnkb.createEffect)((theme)=>{
    return localStorage.setItem($d461744a27a10557$var$THEME_KEY, theme);
});
const $d461744a27a10557$export$6259d3105e9c14f3 = (0, $agnkb.createStore)("light");
const $d461744a27a10557$export$1631a6e518ecce65 = (0, $agnkb.createEvent)();
(0, $agnkb.sample)({
    source: $d461744a27a10557$export$1631a6e518ecce65,
    fn: (theme)=>theme.toLowerCase(),
    target: [
        $d461744a27a10557$var$setThemeToStorageFx,
        $d461744a27a10557$export$6259d3105e9c14f3
    ]
});
(0, $agnkb.sample)({
    source: $d461744a27a10557$var$loadThemeFromStorageFx.doneData,
    target: $d461744a27a10557$export$6259d3105e9c14f3
});
const $d461744a27a10557$export$fb4689499fb20c56 = {
    getUsersFx: $d461744a27a10557$var$getUsersFx,
    getUserFx: $d461744a27a10557$var$getUserFx,
    loadThemeFromStorageFx: $d461744a27a10557$var$loadThemeFromStorageFx
};
const $d461744a27a10557$export$4bf9923669ad6c63 = {};





var $agnkb = parcelRequire("agnkb");

const $13a4b22c312e9558$export$292f834bcb6eb1a1 = (role, fn)=>{
    const $access = (0, $agnkb.combine)((0, $agnkb.createStore)(role), (0, $d461744a27a10557$exports).$currentAccount, (requiredRole, { role: role })=>{
        return {
            state: requiredRole === role ? "allowed" : "restricted"
        };
    });
    (0, $133989e677847899$export$8fdf71db98f19724)({
        source: $access,
        key: "state",
        cases: {
            allowed: ()=>fn(),
            restricted: ()=>null
        }
    });
};




const $455b7f8724d924ef$export$d41d9ab3de2def3d = (s)=>{
    let h = 0;
    for(let i = 0; i < s.length; i++)h = Math.imul(31, h) + s.charCodeAt(i) | 0;
    return h.toString();
};





const $6df367bb5a5c3419$export$cb5260c832aab30a = ({ schema_name: schema_name, text: text, query: query, kind: kind, level: level, from: from, to: to, page: page })=>{
    return (0, $b60cd828ae3cfea9$export$299ba2dee77727e9)({
        url: `/api/logs/search?from=${from ?? ""}&to=${to ?? ""}&tz=${(0, $5cd65399be29f718$export$6f5c75afcb5ad5cc)}&page=${page ?? 1}`,
        body: JSON.stringify({
            schema_name: schema_name,
            text: text,
            query: query,
            kind: kind,
            level: level
        })
    });
};
const $6df367bb5a5c3419$export$171f02120609777f = ({ schema_name: schema_name, hash: hash })=>{
    return (0, $b60cd828ae3cfea9$export$3988ae62b71be9a3)({
        url: `/api/logs/group/${schema_name}/${hash}`
    });
};




const $f54641c7b3157777$export$5201ff832105f45f = ()=>{
    return (0, $b60cd828ae3cfea9$export$3988ae62b71be9a3)({
        url: "/api/api_tokens"
    });
};
const $f54641c7b3157777$export$3f3434baf5a5c9c = (id)=>{
    return (0, $b60cd828ae3cfea9$export$3988ae62b71be9a3)({
        url: `/api/api_tokens/${id}`
    });
};
const $f54641c7b3157777$export$7703b0c6d42d7aa3 = (apiToken)=>{
    return (0, $b60cd828ae3cfea9$export$299ba2dee77727e9)({
        url: "/api/api_tokens",
        body: JSON.stringify(apiToken)
    });
};
const $f54641c7b3157777$export$31fac03968f1e535 = (apiToken)=>{
    return (0, $b60cd828ae3cfea9$export$327f7b26ebf455db)({
        url: `/api/api_tokens/${apiToken.id}`,
        body: JSON.stringify(apiToken)
    });
};
const $f54641c7b3157777$export$9a463dbd0de9693b = (id)=>{
    return (0, $b60cd828ae3cfea9$export$1d2f21e549771e67)({
        url: `/api/api_tokens/${id}`
    });
};



const $676173f0fcc8f3dc$export$862778ea698fdf39 = (admin)=>{
    return (0, $b60cd828ae3cfea9$export$299ba2dee77727e9)({
        url: "/api/setup/register_admin",
        body: JSON.stringify(admin)
    });
};



const $dde8f8cdf92b8dc1$export$1dd984b792643a90 = (email, password)=>{
    return (0, $b60cd828ae3cfea9$export$299ba2dee77727e9)({
        url: "/api/session",
        body: JSON.stringify({
            email: email,
            password: password
        })
    });
};
const $dde8f8cdf92b8dc1$export$12151e9ef3722552 = ()=>{
    return (0, $b60cd828ae3cfea9$export$3988ae62b71be9a3)({
        url: "/api/session"
    });
};







var $agnkb = parcelRequire("agnkb");
const $b047cb928fb2fbfa$var$reset = (0, $agnkb.createEffect)();
const $b047cb928fb2fbfa$var$resetSearch = (0, $agnkb.createEvent)();
const $b047cb928fb2fbfa$export$ff606c0379270787 = (0, $agnkb.createStore)("").reset($b047cb928fb2fbfa$var$resetSearch);
const $b047cb928fb2fbfa$var$queryChanged = (0, $agnkb.createEvent)();
$b047cb928fb2fbfa$export$ff606c0379270787.on($b047cb928fb2fbfa$var$queryChanged, (_, query)=>query);
const $b047cb928fb2fbfa$var$resetFilter = (0, $agnkb.createEvent)();
const $b047cb928fb2fbfa$var$filterChanged = (0, $agnkb.createEvent)();
const $b047cb928fb2fbfa$export$f39a1cdbeb983f5c = (0, $agnkb.createStore)("{}").reset($b047cb928fb2fbfa$var$resetFilter);
$b047cb928fb2fbfa$export$f39a1cdbeb983f5c.on($b047cb928fb2fbfa$var$filterChanged, (formattedFilter, changedFilter)=>{
    const filter = JSON.parse(formattedFilter);
    const newFilter = {
        ...filter,
        ...changedFilter
    };
    return JSON.stringify(newFilter);
});
const $b047cb928fb2fbfa$var$kindChanged = (0, $agnkb.createEvent)();
const $b047cb928fb2fbfa$export$315396cc69206b29 = (0, $agnkb.createStore)("").reset($b047cb928fb2fbfa$var$resetFilter);
$b047cb928fb2fbfa$export$315396cc69206b29.on($b047cb928fb2fbfa$var$kindChanged, (_, kind)=>kind);
const $b047cb928fb2fbfa$var$resetLevelFilter = (0, $agnkb.createEvent)();
const $b047cb928fb2fbfa$var$levelChanged = (0, $agnkb.createEvent)();
const $b047cb928fb2fbfa$export$e843a4bdf9f6b7a8 = (0, $agnkb.createStore)("").reset($b047cb928fb2fbfa$var$resetLevelFilter);
$b047cb928fb2fbfa$export$e843a4bdf9f6b7a8.on($b047cb928fb2fbfa$var$levelChanged, (_, level)=>level);
const $b047cb928fb2fbfa$var$resetTimeFilter = (0, $agnkb.createEvent)();
const $b047cb928fb2fbfa$var$fromTimeChanged = (0, $agnkb.createEvent)();
const $b047cb928fb2fbfa$export$e04137b70cc2e046 = (0, $agnkb.createStore)("").reset($b047cb928fb2fbfa$var$resetTimeFilter);
$b047cb928fb2fbfa$export$e04137b70cc2e046.on($b047cb928fb2fbfa$var$fromTimeChanged, (_, from)=>from);
const $b047cb928fb2fbfa$var$toTimeChanged = (0, $agnkb.createEvent)();
const $b047cb928fb2fbfa$export$c30aa56130429a96 = (0, $agnkb.createStore)("").reset($b047cb928fb2fbfa$var$resetTimeFilter);
$b047cb928fb2fbfa$export$c30aa56130429a96.on($b047cb928fb2fbfa$var$toTimeChanged, (_, to)=>to);
const $b047cb928fb2fbfa$var$resetPage = (0, $agnkb.createEvent)();
const $b047cb928fb2fbfa$var$pageChanged = (0, $agnkb.createEvent)();
const $b047cb928fb2fbfa$export$befb8e48537eb878 = (0, $agnkb.createStore)("1").on($b047cb928fb2fbfa$var$pageChanged, (_, newPage)=>newPage).reset([
    $b047cb928fb2fbfa$var$queryChanged,
    $b047cb928fb2fbfa$var$filterChanged,
    $b047cb928fb2fbfa$var$kindChanged,
    $b047cb928fb2fbfa$var$fromTimeChanged,
    $b047cb928fb2fbfa$var$toTimeChanged,
    $b047cb928fb2fbfa$var$resetPage
]);
const $b047cb928fb2fbfa$var$getLogsFx = (0, $agnkb.createEffect)((schema_name)=>{
    return (0, $6df367bb5a5c3419$export$cb5260c832aab30a)({
        schema_name: schema_name
    });
});
const $b047cb928fb2fbfa$var$queryLogsFx = (0, $agnkb.createEffect)(({ schema_name: schema_name, text: text, query: query, kind: kind, level: level, from: from, to: to, page: page })=>{
    const objectQuery = JSON.parse(query || "{}");
    const formattedQuery = Object.entries(objectQuery).reduce((acc, [k, v])=>{
        if (v.trim().length > 0) return {
            ...acc,
            [k]: v
        };
        return acc;
    }, {});
    return (0, $6df367bb5a5c3419$export$cb5260c832aab30a)({
        schema_name: schema_name,
        text: text,
        query: formattedQuery,
        kind: kind,
        level: level,
        from: from,
        to: to,
        page: page
    });
});
const $b047cb928fb2fbfa$var$getLogGroupFx = (0, $agnkb.createEffect)(({ schema_name: schema_name, hash: hash })=>{
    return (0, $6df367bb5a5c3419$export$171f02120609777f)({
        schema_name: schema_name,
        hash: hash
    });
});
const $b047cb928fb2fbfa$export$b16c828f71c53019 = (0, $agnkb.createStore)([]).on($b047cb928fb2fbfa$var$getLogsFx.doneData, (_, logsResponse)=>logsResponse.data).on($b047cb928fb2fbfa$var$queryLogsFx.doneData, (_, logsResponse)=>logsResponse.data).reset($b047cb928fb2fbfa$var$reset);
const $b047cb928fb2fbfa$export$ebfeba3788e0f172 = (0, $agnkb.createStore)(0).on($b047cb928fb2fbfa$var$getLogsFx.doneData, (_, logsResponse)=>logsResponse.meta.pages).on($b047cb928fb2fbfa$var$queryLogsFx.doneData, (_, logsResponse)=>logsResponse.meta.pages);
const $b047cb928fb2fbfa$export$fc711c680434a993 = (0, $agnkb.createStore)({
    tags: [],
    kind: null,
    schema_name: "",
    group_hash: "",
    logs: []
});
(0, $agnkb.sample)({
    source: $b047cb928fb2fbfa$var$getLogGroupFx.doneData,
    fn: (logsResponse)=>{
        // Extract to separate reducer
        const logs = logsResponse.data;
        const intl = Intl.DateTimeFormat((0, $d2a241c4f7a9141f$export$180605366c04f0cd)(), (0, $5cd65399be29f718$export$65702e18b569a15d));
        const logsGroup = {
            kind: logs[0].kind,
            tags: Object.entries(logs[0]?.query),
            schema_name: logs[0]?.schema_name,
            group_hash: logs[0]?.group_hash,
            logs: []
        };
        logsGroup.logs = logs.map((log)=>{
            return {
                ...log,
                created_at: intl.format(new Date(log.created_at))
            };
        });
        return logsGroup;
    },
    target: $b047cb928fb2fbfa$export$fc711c680434a993
});
const $b047cb928fb2fbfa$export$6a8055382887310a = $b047cb928fb2fbfa$export$b16c828f71c53019.map((logs)=>{
    const intl = Intl.DateTimeFormat((0, $d2a241c4f7a9141f$export$180605366c04f0cd)(), (0, $5cd65399be29f718$export$65702e18b569a15d));
    const groupedLogs = logs.reduce((acc, log)=>{
        const key = JSON.stringify(log.query);
        if (acc[key]?.logs?.length === 5) return acc;
        const logsGroup = {
            tags: Object.entries(log.query),
            kind: log.kind,
            schema_name: log.schema_name,
            group_hash: log.group_hash,
            logs: []
        };
        const formattedLog = {
            ...log,
            created_at: intl.format(new Date(log.created_at))
        };
        acc[key] = acc[key] || logsGroup;
        acc[key].logs.push(formattedLog);
        return acc;
    }, {});
    return Object.values(groupedLogs);
});
(0, $agnkb.sample)({
    clock: $b047cb928fb2fbfa$var$reset,
    target: [
        $b047cb928fb2fbfa$var$resetFilter,
        $b047cb928fb2fbfa$var$resetSearch,
        $b047cb928fb2fbfa$var$resetPage
    ]
});
const $b047cb928fb2fbfa$export$fb4689499fb20c56 = {
    getLogsFx: $b047cb928fb2fbfa$var$getLogsFx,
    queryLogsFx: $b047cb928fb2fbfa$var$queryLogsFx,
    getLogGroupFx: $b047cb928fb2fbfa$var$getLogGroupFx,
    reset: $b047cb928fb2fbfa$var$reset
};
const $b047cb928fb2fbfa$export$4bf9923669ad6c63 = {
    queryChanged: $b047cb928fb2fbfa$var$queryChanged,
    filterChanged: $b047cb928fb2fbfa$var$filterChanged,
    kindChanged: $b047cb928fb2fbfa$var$kindChanged,
    levelChanged: $b047cb928fb2fbfa$var$levelChanged,
    resetLevelFilter: $b047cb928fb2fbfa$var$resetLevelFilter,
    resetFilter: $b047cb928fb2fbfa$var$resetFilter,
    fromTimeChanged: $b047cb928fb2fbfa$var$fromTimeChanged,
    toTimeChanged: $b047cb928fb2fbfa$var$toTimeChanged,
    resetTimeFilter: $b047cb928fb2fbfa$var$resetTimeFilter,
    resetSearch: $b047cb928fb2fbfa$var$resetSearch,
    pageChanged: $b047cb928fb2fbfa$var$pageChanged
};







var $agnkb = parcelRequire("agnkb");

const $8767297ef2df0995$var$BASE_CLASSES = [
    "text-sm",
    "font-medium",
    "mr-2",
    "px-2.5",
    "py-0.5",
    "rounded"
];
const $8767297ef2df0995$var$LEVEL_CLASSES = {
    trace: [
        "bg-green-100",
        "text-green-800",
        "dark:bg-green-900",
        "dark:text-green-300"
    ],
    debug: [
        "bg-blue-100",
        "text-blue-800",
        "dark:bg-blue-900",
        "dark:text-blue-300"
    ],
    info: [
        "bg-gray-100",
        "text-gray-800",
        "dark:bg-gray-700",
        "dark:text-gray-300"
    ],
    warn: [
        "bg-yellow-100",
        "text-yellow-800",
        "dark:bg-yellow-900",
        "dark:text-yellow-300"
    ],
    error: [
        "bg-red-100",
        "text-red-800",
        "dark:bg-red-900",
        "dark:text-red-300"
    ],
    fatal: [
        "bg-pink-100",
        "text-pink-800",
        "dark:bg-pink-900",
        "dark:text-pink-300"
    ]
};
const $8767297ef2df0995$var$levelCLasses = (text)=>{
    const classes = text.map((text)=>$8767297ef2df0995$var$LEVEL_CLASSES[text.toLowerCase()]);
    return classes.map((classes)=>$8767297ef2df0995$var$BASE_CLASSES.concat(classes).join(" "));
};
const $8767297ef2df0995$export$f8ab115d87e210a = (text)=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("span", ()=>{
        const touchClasses = (0, $agnkb.createEvent)();
        const $classes = (0, $agnkb.restore)(touchClasses, "");
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                $classes
            ],
            text: text
        });
        const touch = (0, $agnkb.createEvent)();
        (0, $agnkb.sample)({
            clock: [
                touch,
                text
            ],
            source: $8767297ef2df0995$var$levelCLasses(text),
            target: touchClasses
        });
        // Hack to apply classes from store
        // https://github.com/effector/effector/issues/964
        (0, $133989e677847899$export$35059013cd4a06db)(()=>{
            touch();
        });
    });
};



var $agnkb = parcelRequire("agnkb");

const $44a797417a66b5ab$var$forwardIcon = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("svg", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "w-5",
                "h-5"
            ],
            attr: {
                "aria-hidden": true,
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 14 10"
            }
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("path", {
            attr: {
                stroke: "currentColor",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M1 5h12m0 0L9 1m4 4L9 9"
            }
        });
    });
};
const $44a797417a66b5ab$var$backIcon = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("svg", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "w-5",
                "h-5"
            ],
            attr: {
                "aria-hidden": true,
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 14 10"
            }
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("path", {
            attr: {
                stroke: "currentColor",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M13 5H1m0 0 4 4M1 5l4-4"
            }
        });
    });
};
const $44a797417a66b5ab$export$e2d1bd910e689283 = (variant, event)=>{
    const buttonClicked = (0, $agnkb.createEvent)();
    (0, $agnkb.sample)({
        clock: buttonClicked,
        target: event
    });
    (0, $133989e677847899$export$dda1d9f60106f0e9)("button", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            handler: {
                click: buttonClicked
            },
            classList: [
                "text-white",
                "bg-blue-700",
                "hover:bg-blue-800",
                "focus:ring-4",
                "focus:outline-none",
                "focus:ring-blue-300",
                "font-medium",
                "rounded-lg",
                "text-sm",
                "p-2.5",
                "text-center",
                "inline-flex",
                "items-center",
                "mr-2",
                "dark:bg-blue-600",
                "dark:hover:bg-blue-700",
                "dark:focus:ring-blue-800"
            ],
            attr: {
                type: "button"
            }
        });
        variant === "back" ? $44a797417a66b5ab$var$backIcon() : $44a797417a66b5ab$var$forwardIcon();
    });
};



var $agnkb = parcelRequire("agnkb");

const $68cf3827aab84f08$var$BASE_CLASSES = [
    "inline-flex",
    "items-center"
];
const $68cf3827aab84f08$var$VARIANTS = {
    default: [
        "block",
        "text-white",
        "bg-blue-700",
        "border",
        "dark:border-blue-600",
        "hover:bg-blue-800",
        "font-medium",
        "dark:bg-blue-600",
        "dark:hover:bg-blue-700",
        "focus:outline-none"
    ],
    alternative: [
        "block",
        "font-medium",
        "text-gray-900",
        "bg-white",
        "border",
        "border-gray-200",
        "hover:bg-gray-100",
        "hover:text-blue-700",
        "dark:bg-gray-800",
        "dark:text-gray-400",
        "dark:border-gray-600",
        "dark:hover:text-white",
        "dark:hover:bg-gray-700"
    ],
    delete: [
        "block",
        "text-white",
        "bg-red-600",
        "border",
        "dark:border-red-600",
        "hover:bg-red-800",
        "font-medium",
        "dark:bg-red-600",
        "dark:hover:bg-red-700",
        "focus:outline-none"
    ],
    delete_icon: [
        "block",
        "text-red-600",
        "font-medium",
        "focus:outline-none"
    ],
    light: [
        "block",
        "font-medium",
        "text-gray-900",
        "hover:text-blue-700",
        "dark:text-gray-400",
        "dark:hover:text-white"
    ]
};
const $68cf3827aab84f08$var$SIZES = {
    base: {
        default: [
            "px-5",
            "py-2.5",
            "text-sm",
            "rounded-lg"
        ],
        round: [
            "p-2.5",
            "text-sm"
        ]
    },
    small: {
        default: [
            "px-3",
            "py-2",
            "text-sm",
            "rounded-lg"
        ],
        round: [
            "p-2",
            "text-sm"
        ]
    },
    extra_small: {
        default: [
            "px-3",
            "py-2",
            "text-xs",
            "rounded-lg"
        ],
        round: [
            "p-1.5",
            "text-xs"
        ]
    },
    plain: {
        default: [
            "text-xs",
            "rounded-lg"
        ],
        round: [
            "text-xs"
        ]
    }
};
const $68cf3827aab84f08$var$STYLES = {
    round: [
        "rounded-full"
    ],
    default: [
        ""
    ]
};
const $68cf3827aab84f08$var$buttonClass = (variant, size, style)=>{
    const $currentVariant = variant.map((variant)=>$68cf3827aab84f08$var$VARIANTS[variant]);
    const $sumClasses = $currentVariant.map((variant)=>$68cf3827aab84f08$var$STYLES[style].concat($68cf3827aab84f08$var$BASE_CLASSES).concat(variant).concat($68cf3827aab84f08$var$SIZES[size][style]));
    return $sumClasses.map((classes)=>classes.join(" "));
};
const $68cf3827aab84f08$export$353f5b6fc5456de1 = ({ text: text, event: event, variant: variant, size: size, style: style, visible: visible, prevent: prevent, preIcon: preIcon, postIcon: postIcon })=>{
    const localPreIcon = preIcon || function() {
        return;
    };
    const localPostIcon = postIcon || function() {
        return;
    };
    (0, $133989e677847899$export$dda1d9f60106f0e9)("button", ()=>{
        localPreIcon();
        const touchClasses = (0, $agnkb.createEvent)();
        const $classes = (0, $agnkb.restore)(touchClasses, "");
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            handler: {
                on: {
                    click: event ?? (0, $agnkb.createEvent)()
                },
                config: {
                    prevent: prevent
                }
            },
            classList: [
                $classes
            ],
            text: text,
            visible: visible
        });
        localPostIcon();
        const touch = (0, $agnkb.createEvent)();
        const $localVariant = (0, $agnkb.is).unit(variant) ? variant : (0, $agnkb.createStore)(variant);
        const localStyle = style ?? "default";
        (0, $agnkb.sample)({
            clock: [
                touch,
                $localVariant
            ],
            source: $68cf3827aab84f08$var$buttonClass($localVariant, size, localStyle),
            target: touchClasses
        });
        // Hack to apply classes from store
        // https://github.com/effector/effector/issues/964
        (0, $133989e677847899$export$35059013cd4a06db)(()=>{
            touch();
        });
    });
};






const $580628c81deb6a79$export$94b4c87f5c7de894 = ({ title: title, description: description, route: route, params: params })=>{
    (0, $99a5bbd2d001ca47$export$a6c7ac8248d6e38a)(route, {
        params: params,
        classList: [
            "block",
            "max-w-xs",
            "p-6",
            "bg-white",
            "border",
            "border-gray-200",
            "rounded-lg",
            "shadow",
            "hover:bg-gray-100",
            "dark:bg-gray-800",
            "dark:border-gray-700",
            "dark:hover:bg-gray-700"
        ],
        fn () {
            (0, $133989e677847899$export$dda1d9f60106f0e9)("h5", {
                classList: [
                    "mb-2",
                    "truncate",
                    "text-lg",
                    "font-bold",
                    "tracking-tight",
                    "text-gray-900",
                    "dark:text-white"
                ],
                text: title
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("p", {
                classList: [
                    "font-normal",
                    "line-clamp-3",
                    "text-gray-700",
                    "dark:text-gray-400"
                ],
                text: description
            });
        }
    });
};



var $agnkb = parcelRequire("agnkb");


const $67c46e6f0d26bccc$export$e4e28536a33d07a3 = ({ tags: tags, kind: kind, schema: schema, content: content, href: href })=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "w-full",
                "bg-white",
                "border",
                "border-gray-200",
                "rounded-lg",
                "shadow",
                "dark:bg-gray-800",
                "dark:border-gray-700"
            ]
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "flex",
                    "flex-row",
                    "items-center",
                    "bg-gray-50",
                    "dark:bg-gray-800",
                    "border-b",
                    "border-gray-200",
                    "rounded-t-lg",
                    "dark:border-gray-700",
                    "dark:text-gray-400"
                ]
            });
            const localSchema = schema || (0, $agnkb.createStore)({});
            const localKind = kind || (0, $agnkb.createStore)(null);
            (0, $133989e677847899$export$dda1d9f60106f0e9)("ul", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "flex",
                        "flex-wrap",
                        "gap-3",
                        "basis-11/12",
                        "flex-nowrap",
                        "overflow-scroll",
                        "text-sm",
                        "p-4",
                        "justify-start",
                        "font-medium",
                        "text-center",
                        "text-gray-500"
                    ],
                    attr: {
                        role: "tablist",
                        id: "defaultTab"
                    }
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("li", ()=>{
                    const $kindTitle = (0, $agnkb.combine)(localKind, localSchema, (kind, schema)=>{
                        const schemaKind = schema?.kinds?.find((k)=>k.name === kind);
                        if (!schemaKind) return null;
                        return schemaKind.title;
                    });
                    (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                        visible: $kindTitle.map(Boolean)
                    });
                    (0, $133989e677847899$export$dda1d9f60106f0e9)("kbd", {
                        classList: [
                            "block",
                            "px-2",
                            "py-1.5",
                            "text-xs",
                            "font-semibold",
                            "text-gray-800",
                            "bg-gray-100",
                            "border",
                            "border-gray-200",
                            "rounded-lg",
                            "dark:bg-gray-600",
                            "dark:text-gray-100",
                            "dark:border-gray-500"
                        ],
                        text: $kindTitle
                    });
                });
                (0, $133989e677847899$export$8837f4fc672e936d)(tags, ({ store: tag })=>{
                    (0, $133989e677847899$export$dda1d9f60106f0e9)("li", ()=>{
                        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                            classList: [
                                "min-w-fit"
                            ]
                        });
                        (0, $133989e677847899$export$dda1d9f60106f0e9)("kbd", {
                            classList: [
                                "block",
                                "px-2",
                                "py-1.5",
                                "text-xs",
                                "font-semibold",
                                "text-gray-800",
                                "bg-gray-100",
                                "border",
                                "border-gray-200",
                                "rounded-lg",
                                "dark:bg-gray-600",
                                "dark:text-gray-100",
                                "dark:border-gray-500"
                            ],
                            text: (0, $agnkb.combine)(tag, localSchema, (tag, schema)=>{
                                const [tagKey, tagValue] = tag;
                                const field = schema?.fields.find((f)=>f.name === tagKey);
                                if (!field) return `${tagKey}: ${tagValue}`;
                                return `${field.title}: ${tagValue}`;
                            })
                        });
                    });
                });
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    visible: (0, $agnkb.createStore)(Boolean(href)),
                    classList: [
                        "basis-1/12",
                        "p-4",
                        "min-w-fit",
                        "border-l",
                        "border-gray-200",
                        "dark:border-gray-700",
                        "flex",
                        "justify-center"
                    ]
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("a", ()=>{
                    (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                        attr: {
                            href: href || "",
                            target: "_blank"
                        }
                    });
                    (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                        text: "Open",
                        variant: "default",
                        size: "extra_small"
                    });
                });
            });
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                attr: {
                    id: "defaultTabContent"
                }
            });
            content();
        });
    });
};





var $agnkb = parcelRequire("agnkb");


const $d94fff289995878f$export$931cbfb6bfb85fc = ({ items: items, itemChanged: itemChanged, currentKind: currentKind, kinds: kinds, kindChanged: kindChanged })=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "w-max",
                "top-0",
                "left-0",
                "w-5/6",
                "absolute",
                "left-0",
                "top-9",
                "border",
                "border-gray-200",
                "dark:bg-gray-800",
                "dark:border-gray-700",
                "z-50",
                "bg-white",
                "divide-y",
                "divide-gray-100",
                "rounded-lg",
                "shadow",
                "dark:bg-gray-700",
                "dark:divide-gray-600",
                "shadow-2xl"
            ]
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("ul", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "flex",
                    "flex-col",
                    "flex-wrap",
                    "py-2",
                    "text-sm",
                    "text-gray-700",
                    "dark:text-gray-200"
                ]
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("li", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    visible: kinds.map((kinds)=>kinds?.length > 0),
                    classList: [
                        "block",
                        "px-4",
                        "py-2",
                        "flex-auto",
                        "shrink-0"
                    ]
                });
                (0, $36b3d4afe650f8db$export$ef9b1a59e592288f)({
                    value: currentKind,
                    text: "Kind",
                    options: kinds,
                    optionSelected: kindChanged
                });
            });
            (0, $133989e677847899$export$8837f4fc672e936d)(items, ({ store: item })=>{
                (0, $133989e677847899$export$dda1d9f60106f0e9)("li", ()=>{
                    (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                        classList: [
                            "block",
                            "px-4",
                            "py-2",
                            "flex-auto",
                            "shrink-0"
                        ]
                    });
                    const inputChanged = (0, $agnkb.createEvent)();
                    (0, $agnkb.sample)({
                        source: item,
                        clock: inputChanged,
                        fn: (item, event)=>{
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            return {
                                [item.key]: event.target.value
                            };
                        },
                        target: itemChanged
                    });
                    (0, $8fd8e1c76dc7465f$export$c9107cef9e6ae1b7)(item, inputChanged);
                });
            });
        });
    });
};



const $8fd8e1c76dc7465f$export$c9107cef9e6ae1b7 = (item, inputChanged)=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "relative",
                "z-0"
            ]
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("input", {
            attr: {
                type: "text",
                id: "floating_standard",
                placeholder: "_",
                value: item.map((i)=>i.value)
            },
            handler: {
                on: {
                    input: inputChanged
                }
            },
            classList: [
                "block",
                "py-2.5",
                "px-0",
                "w-full",
                "text-sm",
                "text-gray-900",
                "bg-transparent",
                "border-0",
                "border-b-2",
                "border-gray-300",
                "appearance-none",
                "dark:text-white",
                "dark:border-gray-600",
                "dark:focus:border-blue-500",
                "focus:outline-none",
                "focus:ring-0",
                "focus:border-blue-600",
                "placeholder:opacity-0",
                "focus:outline",
                "outline-1",
                "peer"
            ]
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("label", {
            attr: {
                for: "floating_standard"
            },
            classList: [
                "absolute",
                "text-sm",
                "text-gray-500",
                "dark:text-gray-400",
                "duration-300",
                "transform",
                "-translate-y-6",
                "scale-75",
                "top-3",
                "-z-10",
                "origin-[0]",
                "peer-focus:left-0",
                "peer-focus:text-blue-600",
                "peer-focus:dark:text-blue-500",
                "peer-placeholder-shown:scale-100",
                "peer-placeholder-shown:translate-y-0",
                "peer-focus:scale-75",
                "peer-focus:-translate-y-6"
            ],
            text: item.map((i)=>i.name)
        });
    });
};



const $ccd9bd4f73abf9cf$export$8b251419efc915eb = (text)=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("h1", {
        classList: [
            "inline-block",
            "text-2xl",
            "sm:text-3xl",
            "font-extrabold",
            "text-slate-900",
            "tracking-tight",
            "dark:text-slate-200"
        ],
        text: text
    });
};



const $a5453ffc4cd3b2d6$export$82431628d8b8c126 = (text)=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("h5", {
        classList: [
            "text-xl",
            "text-slate-800",
            "font-bold",
            "dark:text-slate-200"
        ],
        text: text
    });
};



const $cfe9a25a978b21b0$export$4d7ad962dfb0e81e = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("svg", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "w-2.5",
                "h-2.5",
                "ml-2.5"
            ],
            attr: {
                "aria-hidden": "true",
                xmlhs: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 10 6"
            }
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("path", {
            attr: {
                stroke: "currentColor",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "m1 1 4 4 4-4"
            }
        });
    });
};



const $1f8051c24980d921$export$28f6150e232898de = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("svg", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "h-4",
                "w-4",
                "mr-2"
            ],
            attr: {
                "aria-hidden": "true",
                xmlhs: "http://www.w3.org/2000/svg",
                fill: "currentColor",
                viewBox: "0 0 20 20"
            }
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("path", {
            attr: {
                "fill-rule": "evenodd",
                stroke: "currentColor",
                "clip-rule": "evenodd",
                d: "M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z"
            }
        });
    });
};



const $c09823cb9eec778a$export$d05925e1c7f3f136 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("svg", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "w-2.5",
                "h-2.5"
            ],
            attr: {
                "aria-hidden": true,
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 6 10"
            }
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("path", {
            attr: {
                stroke: "currentColor",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M5 1 1 5l4 4"
            }
        });
    });
};



const $dcfe48720d3593b3$export$3da0e0ec94bd4ce1 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("svg", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "w-2.5",
                "h-2.5"
            ],
            attr: {
                "aria-hidden": true,
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 6 10"
            }
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("path", {
            attr: {
                stroke: "currentColor",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "m1 9 4-4-4-4"
            }
        });
    });
};



const $e7283f6ef3d54df0$export$3b621d86b1566b2 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("svg", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "w-5",
                "h-5",
                "ml-2.5"
            ],
            attr: {
                xmlhs: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 20 20"
            }
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("path", {
            attr: {
                stroke: "currentColor",
                fill: "none",
                "fill-rule": "evenodd",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                d: "M10 10l5.09-5.09L10 10l5.09 5.09L10 10zm0 0L4.91 4.91 10 10l-5.09 5.09L10 10z"
            }
        });
    });
};



const $573a5341bb6530de$export$70208e77f6c45b17 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("svg", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "w-5",
                "h-5"
            ],
            attr: {
                "aria-hidden": true,
                xmlns: "http://www.w3.org/2000/svg",
                fill: "currentColor",
                viewBox: "0 0 24 24"
            }
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("path", {
            attr: {
                stroke: "currentColor",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "1",
                d: "M24 13.616v-3.232l-2.869-1.02c-.198-.687-.472-1.342-.811-1.955l1.308-2.751-2.285-2.285-2.751 1.307c-.613-.339-1.269-.613-1.955-.811l-1.021-2.869h-3.232l-1.021 2.869c-.686.198-1.342.471-1.955.811l-2.751-1.308-2.285 2.285 1.308 2.752c-.339.613-.614 1.268-.811 1.955l-2.869 1.02v3.232l2.869 1.02c.197.687.472 1.342.811 1.955l-1.308 2.751 2.285 2.286 2.751-1.308c.613.339 1.269.613 1.955.811l1.021 2.869h3.232l1.021-2.869c.687-.198 1.342-.472 1.955-.811l2.751 1.308 2.285-2.286-1.308-2.751c.339-.613.613-1.268.811-1.955l2.869-1.02zm-12 2.384c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z"
            }
        });
    });
};



const $8295e9913b74aadf$export$f21ab0717a89c77f = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("svg", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "w-3",
                "h-3"
            ],
            attr: {
                "aria-hidden": true,
                xmlns: "http://www.w3.org/2000/svg",
                fill: "currentColor",
                viewBox: "0 0 25 24"
            }
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("path", {
            attr: {
                stroke: "currentColor",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "1",
                d: "M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z"
            }
        });
    });
};



const $c38f17198d3679fb$export$d23329de703dffc4 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("svg", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "w-5",
                "h-5"
            ],
            attr: {
                "aria-hidden": true,
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 18 20"
            }
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("path", {
            attr: {
                stroke: "currentColor",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M1 5h16M7 8v8m4-8v8M7 1h4a1 1 0 0 1 1 1v3H6V2a1 1 0 0 1 1-1ZM3 5h12v13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5Z"
            }
        });
    });
};



const $9d70cf9dc154c107$export$f314ed182f5da2a0 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("svg", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "w-4",
                "h-4",
                "text-gray-800",
                "dark:text-white"
            ],
            attr: {
                "aria-hidden": true,
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 20 20"
            }
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("path", {
            attr: {
                stroke: "currentColor",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M7.529 7.988a2.502 2.502 0 0 1 5 .191A2.441 2.441 0 0 1 10 10.582V12m-.01 3.008H10M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            }
        });
    });
};



const $90601e5b8da2fcb8$export$8099ab97743c966c = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("svg", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "h-4",
                "w-4",
                "mr-2"
            ],
            attr: {
                "aria-hidden": "true",
                xmlhs: "http://www.w3.org/2000/svg",
                fill: "currentColor",
                viewBox: "0 0 24 24"
            }
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("path", {
            attr: {
                "fill-rule": "evenodd",
                stroke: "currentColor",
                "clip-rule": "evenodd",
                d: "M2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0Zm11-4a1 1 0 1 0-2 0v4c0 .3.1.5.3.7l3 3a1 1 0 0 0 1.4-1.4L13 11.6V8Z"
            }
        });
    });
};



const $b4a930a779b8fa8d$export$98afb0d17ceac256 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("svg", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "h-4",
                "w-4",
                "mr-2"
            ],
            attr: {
                "aria-hidden": "true",
                xmlhs: "http://www.w3.org/2000/svg",
                fill: "currentColor",
                viewBox: "0 0 24 24"
            }
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("path", {
            attr: {
                d: "M8.6 3.2a1 1 0 0 0-1.6 1 3.5 3.5 0 0 1-.8 3.6c-.6.8-4 5.6-1 10.7A7.7 7.7 0 0 0 12 22a8 8 0 0 0 7-3.8 7.8 7.8 0 0 0 .6-6.5 8.7 8.7 0 0 0-2.6-4 1 1 0 0 0-1.6.7 10 10 0 0 1-.8 3.4 9.9 9.9 0 0 0-2.2-5.5A14.4 14.4 0 0 0 9 3.5l-.4-.3Z"
            }
        });
    });
};





var $agnkb = parcelRequire("agnkb");


const $378e0a91f74a58dc$export$f5b8910cec6cf069 = ({ value: value, type: type, label: label, required: required, inputChanged: inputChanged, visible: visible, autofocus: autofocus, disabled: disabled, errorText: errorText, hint: hint })=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: {
                relative: true,
                "mb-6": type !== "datetime-local",
                flex: type === "checkbox",
                "items-center": type === "checkbox"
            },
            visible: visible
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: {
                    flex: true,
                    "items-center": true,
                    "mb-2": type !== "checkbox"
                }
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("label", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: {
                        block: true,
                        "mr-2": type === "checkbox",
                        "text-sm": true,
                        "font-medium": true,
                        "text-gray-900": true,
                        "dark:text-white": true
                    },
                    text: label,
                    attr: {
                        for: label
                    }
                });
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "pl-1"
                    ],
                    visible: (0, $agnkb.createStore)(hint ?? "").map(Boolean)
                });
                (0, $1135dd29bd0deb8d$export$5b6b19405a83ff9d)({
                    text: hint
                });
            });
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("input", ()=>{
            const localInputChanged = (0, $agnkb.createEvent)();
            (0, $agnkb.sample)({
                source: localInputChanged,
                fn: (event)=>{
                    if (type === "number") try {
                        return parseInt(event.target.value, 10);
                    } catch  {
                        return 0;
                    }
                    if (type === "checkbox") return Boolean(event.target.checked);
                    return event.target.value;
                },
                target: [
                    inputChanged
                ]
            });
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: {
                    "bg-gray-50": true,
                    border: true,
                    "border-gray-300": true,
                    "text-gray-900": true,
                    "text-sm": true,
                    "rounded-lg": true,
                    "focus:ring-blue-500": true,
                    "focus:border-blue-500": true,
                    "focus:outline": type !== "checkbox",
                    "outline-1": type !== "checkbox",
                    block: true,
                    "w-full": type !== "checkbox",
                    "w-4": type === "checkbox",
                    "h-4": type === "checkbox",
                    "p-2.5": true,
                    "dark:bg-gray-700": true,
                    "dark:border-gray-600": true,
                    "dark:placeholder-gray-400": true,
                    "dark:text-white": true,
                    "dark:focus:ring-blue-500": true,
                    "dark:focus:border-blue-500": true
                },
                attr: {
                    disabled: disabled ?? (0, $agnkb.createStore)(false),
                    id: label,
                    type: type,
                    required: Boolean(required),
                    autofocus: (0, $agnkb.createStore)(autofocus ?? false),
                    value: value ?? (0, $agnkb.createStore)(null),
                    checked: value ?? (0, $agnkb.createStore)(null)
                },
                handler: {
                    on: {
                        input: localInputChanged
                    }
                }
            });
        });
        (0, $50bc7b2791a6cb44$export$852d7888b34e2b72)(errorText, errorText?.map(Boolean));
    });
};





var $agnkb = parcelRequire("agnkb");
const $7b04e6c47838d986$export$9e02366ea7b554d = (0, $agnkb.createEvent)();
const $7b04e6c47838d986$export$c84671f46d6a1ca = ({ content: content, layoutVisible: layoutVisible })=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "w-full",
                "min-h-screen",
                "bg-white",
                "text-slate-700",
                "dark:bg-slate-900",
                "dark:text-slate-300"
            ],
            handler: {
                on: {
                    click: $7b04e6c47838d986$export$9e02366ea7b554d
                }
            }
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                visible: layoutVisible
            });
            (0, $9bc96fedc1402115$export$1ba59dacbcbf90fe)();
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: {
                    "py-2": layoutVisible.map((visible)=>visible),
                    "px-4": layoutVisible.map((visible)=>visible),
                    "sm:p-7": layoutVisible.map((visible)=>visible),
                    "sm:ml-64": layoutVisible
                }
            });
            content();
        });
    });
};



const $8a0a4c7088cd4755$export$a6c7ac8248d6e38a = (route, text)=>{
    $99a5bbd2d001ca47$export$a6c7ac8248d6e38a(route, {
        classList: [
            "font-medium",
            "text-blue-600",
            "dark:text-blue-500",
            "hover:underline"
        ],
        text: text
    });
};



const $a98816a4129b2dff$export$e6ff31bff12b7ff4 = (size)=>{
    const localSize = size ?? "xl";
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$dda1d9f60106f0e9)("span", {
            classList: [
                "mr-3",
                "leading-7",
                `text-${localSize}`
            ],
            attr: {
                alt: "Moonlogs logo"
            },
            text: "\uD83C\uDF18"
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("span", {
            classList: [
                "self-center",
                `text-${localSize}`,
                "font-semibold",
                "whitespace-nowrap",
                "dark:text-white"
            ],
            text: "Moonlogs"
        });
    });
};





var $agnkb = parcelRequire("agnkb");
const $9b5a966ddaaf2373$var$BASE_CLASSES = [
    "flex",
    "items-center",
    "justify-center",
    "px-3",
    "h-8",
    "leading-tight",
    "text-gray-500",
    "bg-white",
    "border",
    "border-gray-300",
    "hover:bg-gray-100",
    "hover:text-gray-700",
    "dark:bg-gray-800",
    "dark:border-gray-700",
    "dark:text-gray-400",
    "dark:hover:bg-gray-700",
    "dark:hover:text-white"
];
const $9b5a966ddaaf2373$var$ACTIVE_CLASSES = [
    "z-10",
    "flex",
    "items-center",
    "justify-center",
    "px-3",
    "h-8",
    "leading-tight",
    "text-blue-600",
    "border",
    "border-blue-300",
    "bg-blue-50",
    "hover:bg-blue-100",
    "hover:text-blue-700",
    "dark:border-gray-700",
    "dark:bg-gray-700",
    "dark:text-white"
];
// hack to avoid multiple page selection bug
// https://github.com/effector/effector/issues/964
const $9b5a966ddaaf2373$var$$localCurrentPage = (0, $agnkb.createStore)("1");
const $9b5a966ddaaf2373$export$68f5e1453c188a82 = (pages, currentPage, pageChanged)=>{
    (0, $agnkb.sample)({
        source: currentPage,
        target: $9b5a966ddaaf2373$var$$localCurrentPage
    });
    (0, $133989e677847899$export$dda1d9f60106f0e9)("nav", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            visible: pages.map((pages)=>pages > 0),
            classList: [
                "flex",
                "pb-2"
            ],
            attr: {
                "aria-label": "Page navigation"
            }
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("ul", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "grid",
                    "grid-cols-9",
                    "items-center",
                    "-space-x-px",
                    "h-8",
                    "text-sm"
                ]
            });
            const $pagesList = pages.map((count)=>new Array(count).fill(null).map((_, i)=>i + 1));
            const $truncatedPages = $9b5a966ddaaf2373$var$truncatedPages($pagesList, currentPage);
            $9b5a966ddaaf2373$var$PreviousPages(pages, pageChanged);
            $9b5a966ddaaf2373$var$FirstPage(pages, pageChanged);
            $9b5a966ddaaf2373$var$PagesList($truncatedPages, pageChanged);
            $9b5a966ddaaf2373$var$LastPage($truncatedPages, $pagesList, pageChanged);
            $9b5a966ddaaf2373$var$NextPage(pages, pageChanged);
        });
    });
};
const $9b5a966ddaaf2373$var$PagesList = (truncatedPages, pageChanged)=>{
    (0, $133989e677847899$export$8837f4fc672e936d)(truncatedPages, ({ store: page })=>{
        (0, $133989e677847899$export$dda1d9f60106f0e9)("li", ()=>{
            const $isActive = (0, $agnkb.combine)([
                $9b5a966ddaaf2373$var$$localCurrentPage,
                page
            ], ([currentPage, page])=>{
                return currentPage === `${page}`;
            });
            const localPageClicked = (0, $agnkb.createEvent)();
            (0, $agnkb.sample)({
                source: page,
                clock: localPageClicked,
                fn: (page)=>`${page}`,
                target: pageChanged
            });
            const $state = $isActive.map((isActive)=>({
                    state: isActive ? "active" : "not_active"
                }));
            (0, $133989e677847899$export$8fdf71db98f19724)({
                source: $state,
                key: "state",
                cases: {
                    active: ()=>{
                        (0, $133989e677847899$export$dda1d9f60106f0e9)("a", {
                            attr: {
                                href: ""
                            },
                            handler: {
                                on: {
                                    click: localPageClicked
                                },
                                config: {
                                    prevent: true
                                }
                            },
                            classList: $9b5a966ddaaf2373$var$ACTIVE_CLASSES,
                            text: page
                        });
                    },
                    not_active: ()=>{
                        (0, $133989e677847899$export$dda1d9f60106f0e9)("a", {
                            attr: {
                                href: ""
                            },
                            handler: {
                                on: {
                                    click: localPageClicked
                                },
                                config: {
                                    prevent: true
                                }
                            },
                            classList: $9b5a966ddaaf2373$var$BASE_CLASSES,
                            text: page
                        });
                    }
                }
            });
        });
    });
};
const $9b5a966ddaaf2373$var$FirstPage = (pages, pageChanged)=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("li", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            visible: pages.map((pages)=>pages >= 7)
        });
        const $isActive = (0, $agnkb.combine)([
            $9b5a966ddaaf2373$var$$localCurrentPage,
            (0, $agnkb.createStore)("1")
        ], ([currentPage, pastPage])=>{
            return currentPage === pastPage;
        });
        const localPageClicked = (0, $agnkb.createEvent)();
        (0, $agnkb.sample)({
            source: (0, $agnkb.createStore)("1"),
            clock: localPageClicked,
            target: pageChanged
        });
        const $state = $isActive.map((isActive)=>({
                state: isActive ? "active" : "not_active"
            }));
        (0, $133989e677847899$export$8fdf71db98f19724)({
            source: $state,
            key: "state",
            cases: {
                active: ()=>{
                    (0, $133989e677847899$export$dda1d9f60106f0e9)("a", {
                        attr: {
                            href: ""
                        },
                        handler: {
                            on: {
                                click: localPageClicked
                            },
                            config: {
                                prevent: true
                            }
                        },
                        classList: $9b5a966ddaaf2373$var$ACTIVE_CLASSES,
                        text: "1"
                    });
                },
                not_active: ()=>{
                    (0, $133989e677847899$export$dda1d9f60106f0e9)("a", {
                        attr: {
                            href: ""
                        },
                        handler: {
                            on: {
                                click: localPageClicked
                            },
                            config: {
                                prevent: true
                            }
                        },
                        classList: $9b5a966ddaaf2373$var$BASE_CLASSES,
                        text: "1"
                    });
                }
            }
        });
    });
};
const $9b5a966ddaaf2373$var$LastPage = (truncatedPages, pagesList, pageChanged)=>{
    const $showLastPage = (0, $agnkb.combine)([
        truncatedPages,
        pagesList
    ], ([truncatedPages, pagesList])=>pagesList.length > truncatedPages.length);
    (0, $133989e677847899$export$dda1d9f60106f0e9)("li", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            visible: $showLastPage
        });
        const $lastPageNumber = pagesList.map((pagesList)=>pagesList[pagesList.length - 1]);
        const $isActive = (0, $agnkb.combine)([
            $9b5a966ddaaf2373$var$$localCurrentPage,
            $lastPageNumber
        ], ([currentPage, pastPage])=>{
            return parseInt(currentPage) === pastPage;
        });
        const localPageClicked = (0, $agnkb.createEvent)();
        (0, $agnkb.sample)({
            source: $lastPageNumber,
            clock: localPageClicked,
            fn: (page)=>`${page}`,
            target: pageChanged
        });
        const $state = $isActive.map((isActive)=>({
                state: isActive ? "active" : "not_active"
            }));
        (0, $133989e677847899$export$8fdf71db98f19724)({
            source: $state,
            key: "state",
            cases: {
                active: ()=>{
                    (0, $133989e677847899$export$dda1d9f60106f0e9)("a", {
                        attr: {
                            href: ""
                        },
                        handler: {
                            on: {
                                click: localPageClicked
                            },
                            config: {
                                prevent: true
                            }
                        },
                        classList: $9b5a966ddaaf2373$var$ACTIVE_CLASSES,
                        text: $lastPageNumber
                    });
                },
                not_active: ()=>{
                    (0, $133989e677847899$export$dda1d9f60106f0e9)("a", {
                        attr: {
                            href: ""
                        },
                        handler: {
                            on: {
                                click: localPageClicked
                            },
                            config: {
                                prevent: true
                            }
                        },
                        classList: $9b5a966ddaaf2373$var$BASE_CLASSES,
                        text: $lastPageNumber
                    });
                }
            }
        });
    });
};
const $9b5a966ddaaf2373$var$PreviousPages = (pages, pageChanged)=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("li", ()=>{
        const previousClicked = (0, $agnkb.createEvent)();
        (0, $agnkb.sample)({
            source: [
                $9b5a966ddaaf2373$var$$localCurrentPage,
                pages
            ],
            clock: previousClicked,
            filter: ([cur])=>parseInt(cur) > 1,
            fn: ([cur])=>{
                const previousPage = parseInt(cur) - 1;
                return `${previousPage}`;
            },
            target: pageChanged
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("a", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                attr: {
                    href: ""
                },
                handler: {
                    on: {
                        click: previousClicked
                    },
                    config: {
                        prevent: true
                    }
                },
                classList: [
                    "flex",
                    "items-center",
                    "justify-center",
                    "px-3",
                    "h-8",
                    "ml-0",
                    "leading-tight",
                    "text-gray-500",
                    "bg-white",
                    "border",
                    "border-gray-300",
                    "rounded-l-lg",
                    "hover:bg-gray-100",
                    "hover:text-gray-700",
                    "dark:bg-gray-800",
                    "dark:border-gray-700",
                    "dark:text-gray-400",
                    "dark:hover:bg-gray-700",
                    "dark:hover:text-white"
                ]
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("span", {
                classList: [
                    "sr-only"
                ],
                text: "Previous"
            });
            (0, $c09823cb9eec778a$export$d05925e1c7f3f136)();
        });
    });
};
const $9b5a966ddaaf2373$var$NextPage = (pages, pageChanged)=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("li", ()=>{
        const nextClicked = (0, $agnkb.createEvent)();
        (0, $agnkb.sample)({
            source: [
                $9b5a966ddaaf2373$var$$localCurrentPage,
                pages
            ],
            clock: nextClicked,
            filter: ([cur, pages])=>parseInt(cur) !== pages,
            fn: ([cur])=>{
                const previousPage = parseInt(cur) + 1;
                return `${previousPage}`;
            },
            target: pageChanged
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("a", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                attr: {
                    href: ""
                },
                handler: {
                    on: {
                        click: nextClicked
                    },
                    config: {
                        prevent: true
                    }
                },
                classList: [
                    "flex",
                    "items-center",
                    "justify-center",
                    "px-3",
                    "h-8",
                    "leading-tight",
                    "text-gray-500",
                    "bg-white",
                    "border",
                    "border-gray-300",
                    "rounded-r-lg",
                    "hover:bg-gray-100",
                    "hover:text-gray-700",
                    "dark:bg-gray-800",
                    "dark:border-gray-700",
                    "dark:text-gray-400",
                    "dark:hover:bg-gray-700",
                    "dark:hover:text-white"
                ]
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("span", {
                classList: [
                    "sr-only"
                ],
                text: "Next"
            });
            (0, $dcfe48720d3593b3$export$3da0e0ec94bd4ce1)();
        });
    });
};
const $9b5a966ddaaf2373$var$truncatedPages = (pagesList, currentPage)=>{
    return (0, $agnkb.combine)([
        pagesList,
        currentPage
    ], ([pagesList, currentPage])=>{
        if (pagesList.length <= 5) return pagesList;
        const cur = parseInt(currentPage);
        const minPage = Math.max(Math.min(cur - 3, pagesList.length - 6), 1);
        const maxPage = Math.max(cur + 5, minPage);
        const pages = pagesList.slice(minPage, maxPage);
        const sliced = pages.slice(1, 5);
        const nextPageIsLast = sliced[sliced.length - 1] === pagesList.length;
        const lastIndex = nextPageIsLast ? 6 : 5;
        return pages.filter((p)=>p !== pagesList.length).slice(0, lastIndex);
    });
};



var $agnkb = parcelRequire("agnkb");


const $84354d291f24209c$export$4b85d3515bd863a5 = (inputChanged, searchQuery)=>{
    const searchCleared = (0, $agnkb.createEvent)();
    (0, $agnkb.sample)({
        clock: searchCleared,
        fn: ()=>"",
        target: inputChanged
    });
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "bg-white",
                "dark:bg-gray-900",
                "max-w-xl",
                "py-3"
            ]
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("label", {
            attr: {
                for: "table-search"
            },
            classList: [
                "sr-only"
            ],
            text: "Search"
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "relative",
                    "flex"
                ]
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "absolute",
                        "inset-y-0",
                        "left-0",
                        "flex",
                        "items-center",
                        "pl-3",
                        "pointer-events-none"
                    ]
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("svg", ()=>{
                    (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                        classList: [
                            "w-4",
                            "h-4",
                            "text-gray-500",
                            "dark:text-gray-400"
                        ],
                        attr: {
                            "aria-hidden": true,
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 20 20"
                        }
                    });
                    (0, $133989e677847899$export$dda1d9f60106f0e9)("path", {
                        attr: {
                            stroke: "currentColor",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                        }
                    });
                });
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("input", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    attr: {
                        type: "text",
                        id: "table-search",
                        placeholder: "Search",
                        value: searchQuery
                    },
                    handler: {
                        input: inputChanged.prepend((e)=>e.target.value)
                    },
                    classList: [
                        "block",
                        "w-full",
                        "p-2.5",
                        "pl-10",
                        "text-sm",
                        "focus:outline",
                        "outline-1",
                        "text-gray-900",
                        "border",
                        "border-gray-300",
                        "rounded-lg",
                        "bg-gray-50",
                        "focus:ring-blue-500",
                        "focus:border-blue-500",
                        "dark:bg-gray-700",
                        "dark:border-gray-600",
                        "dark:placeholder-gray-400",
                        "dark:text-white",
                        "dark:focus:ring-blue-500",
                        "dark:focus:border-blue-500",
                        "focus:outline",
                        "outline-1"
                    ]
                });
            });
            (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                text: "Clear",
                variant: "light",
                size: "small",
                event: searchCleared,
                visible: searchQuery.map((query)=>query.length > 0)
            });
        });
    });
};





var $agnkb = parcelRequire("agnkb");


const $9bc96fedc1402115$export$c4306c1cb71b8196 = (0, $agnkb.createEvent)();
const $9bc96fedc1402115$var$sidebarTriggered = (0, $agnkb.createEvent)();
const $9bc96fedc1402115$var$$sidebarVisible = (0, $agnkb.createStore)(false);
const $9bc96fedc1402115$var$outsideClicked = (0, $agnkb.createEvent)();
(0, $agnkb.sample)({
    clock: $9bc96fedc1402115$export$c4306c1cb71b8196,
    fn: ()=>false,
    target: $9bc96fedc1402115$var$$sidebarVisible
});
(0, $agnkb.sample)({
    source: $9bc96fedc1402115$var$$sidebarVisible,
    clock: $9bc96fedc1402115$var$sidebarTriggered,
    fn: (v)=>!v,
    target: $9bc96fedc1402115$var$$sidebarVisible
});
(0, $agnkb.sample)({
    source: $9bc96fedc1402115$var$$sidebarVisible,
    clock: $9bc96fedc1402115$var$outsideClicked,
    filter: (visible, { node: node, event: event })=>!node.contains(event.target),
    fn: ()=>false,
    target: $9bc96fedc1402115$var$$sidebarVisible
});
const $9bc96fedc1402115$var$SidebarButton = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("button", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            handler: {
                on: {
                    click: $9bc96fedc1402115$var$sidebarTriggered
                }
            },
            attr: {
                "data-drawer-target": "default-sidebar",
                "data-drawer-toggle": "default-sidebar",
                "aria-controls": "default-sidebar",
                type: "button"
            },
            classList: [
                "inline-flex",
                "items-center",
                "pt-3.5",
                "pl-3.5",
                "text-sm",
                "text-gray-500",
                "rounded-lg",
                "sm:hidden",
                "hover:bg-gray-100",
                "focus:outline-none",
                "focus:ring-2",
                "focus:ring-gray-200",
                "dark:text-gray-400",
                "dark:hover:bg-gray-200",
                "dark:focus:ring-gray-600"
            ]
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("span", {
            classList: [
                "sr-only"
            ],
            text: "Open sidebar"
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("svg", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "w-6 h-6"
                ],
                attr: {
                    aria_hidden: true,
                    fill: "currentColor",
                    viewBox: "0 0 20 20",
                    xmlns: "http://www.w3.org/2000/svg"
                }
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("path", {
                attr: {
                    "clip-rule": "evenodd",
                    "fill-rule": "evenodd",
                    d: "M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
                }
            });
        });
    });
};
const $9bc96fedc1402115$export$1ba59dacbcbf90fe = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        $9bc96fedc1402115$var$SidebarButton();
        (0, $133989e677847899$export$dda1d9f60106f0e9)("aside", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                attr: {
                    id: "default-sidebar",
                    "aria-label": "Sidebar"
                },
                classList: {
                    fixed: true,
                    "top-0": true,
                    "left-0": true,
                    "z-40": true,
                    "w-64": true,
                    "h-screen": true,
                    "transition-transform": true,
                    "-translate-x-full": $9bc96fedc1402115$var$$sidebarVisible.map((v)=>!v),
                    "sm:translate-x-0": $9bc96fedc1402115$var$$sidebarVisible.map((v)=>!v)
                }
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "h-full",
                        "px-3",
                        "py-4",
                        "overflow-y-auto",
                        "bg-gray-50",
                        "dark:bg-gray-800"
                    ]
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("a", ()=>{
                    const homeClicked = (0, $agnkb.createEvent)();
                    (0, $e13fe69fd88e859a$export$89e12c5b50f7529d)({
                        clock: homeClicked,
                        route: (0, $99a5bbd2d001ca47$export$c344a3deb8f83e2f)
                    });
                    (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                        classList: [
                            "flex",
                            "items-center",
                            "pl-2.5",
                            "mb-5"
                        ],
                        attr: {
                            href: ""
                        },
                        handler: {
                            on: {
                                click: homeClicked
                            },
                            config: {
                                prevent: true
                            }
                        }
                    });
                    (0, $133989e677847899$export$dda1d9f60106f0e9)("span", {
                        classList: [
                            "mr-3",
                            "leading-7",
                            "text-2xl"
                        ],
                        attr: {
                            alt: "Moonlogs logo"
                        },
                        text: "\uD83C\uDF18"
                    });
                    (0, $133989e677847899$export$dda1d9f60106f0e9)("span", {
                        classList: [
                            "self-center",
                            "text-xl",
                            "font-semibold",
                            "whitespace-nowrap",
                            "dark:text-white"
                        ],
                        text: "Moonlogs"
                    });
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("ul", ()=>{
                    (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                        classList: [
                            "space-y-2",
                            "font-medium"
                        ]
                    });
                    $9bc96fedc1402115$export$b09fc4897b18f7d8("Profile", (0, $99a5bbd2d001ca47$export$80d23b9cca383549));
                    $9bc96fedc1402115$export$b09fc4897b18f7d8("Log groups", (0, $99a5bbd2d001ca47$export$c344a3deb8f83e2f));
                    (0, $13a4b22c312e9558$export$292f834bcb6eb1a1)("Admin", ()=>{
                        $9bc96fedc1402115$export$b09fc4897b18f7d8("Members", (0, $99a5bbd2d001ca47$export$74bc9c86497b4ac6));
                    });
                    (0, $13a4b22c312e9558$export$292f834bcb6eb1a1)("Admin", ()=>{
                        $9bc96fedc1402115$export$b09fc4897b18f7d8("Tags", (0, $99a5bbd2d001ca47$export$773ade5e3261acbd));
                    });
                    (0, $13a4b22c312e9558$export$292f834bcb6eb1a1)("Admin", ()=>{
                        $9bc96fedc1402115$export$b09fc4897b18f7d8("API tokens", (0, $99a5bbd2d001ca47$export$14fdbf877e70314a));
                    });
                });
            });
        });
        (0, $133989e677847899$export$35059013cd4a06db)((node)=>{
            document.addEventListener("click", (event)=>{
                $9bc96fedc1402115$var$outsideClicked({
                    node: node,
                    event: event
                });
            });
        });
    });
};
const $9bc96fedc1402115$export$b09fc4897b18f7d8 = (text, route)=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("li", ()=>{
        (0, $99a5bbd2d001ca47$export$a6c7ac8248d6e38a)(route, {
            text: text,
            classList: {
                flex: true,
                "items-center": true,
                "p-2": true,
                "text-gray-900": true,
                "rounded-lg": true,
                "dark:text-white": true,
                "hover:bg-gray-200": true,
                "bg-gray-200": route.$isOpened,
                "dark:bg-gray-700": route.$isOpened,
                "dark:hover:bg-gray-700": true,
                group: true
            }
        });
    });
};




const $c9f21913a9eee54d$export$58be81f5c6860851 = (logs)=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "antialiased"
            ]
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "relative",
                    "overflow-x-auto",
                    "sm:rounded-b-lg"
                ]
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("table", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "min-w-full",
                        "w-max",
                        "text-sm",
                        "text-left",
                        "table-fixed"
                    ]
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("thead", ()=>{
                    (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                        classList: [
                            "text-xs",
                            "text-gray-700",
                            "uppercase",
                            "bg-gray-50",
                            "w-full",
                            "dark:bg-gray-700",
                            "dark:text-gray-200"
                        ]
                    });
                    (0, $133989e677847899$export$dda1d9f60106f0e9)("tr", ()=>{
                        (0, $133989e677847899$export$dda1d9f60106f0e9)("th", {
                            attr: {
                                scope: "col"
                            },
                            classList: [
                                "px-4",
                                "py-3",
                                "w-24",
                                "lg:w-48"
                            ],
                            text: "Time"
                        });
                        (0, $133989e677847899$export$dda1d9f60106f0e9)("th", {
                            attr: {
                                scope: "col"
                            },
                            classList: [
                                "px-4",
                                "py-3",
                                "w-16"
                            ],
                            text: "Level"
                        });
                        (0, $133989e677847899$export$dda1d9f60106f0e9)("th", {
                            attr: {
                                scope: "col"
                            },
                            classList: [
                                "px-4",
                                "py-3"
                            ],
                            text: "Text"
                        });
                    });
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("tbody", ()=>{
                    (0, $133989e677847899$export$8837f4fc672e936d)(logs, ({ store: log })=>{
                        (0, $133989e677847899$export$dda1d9f60106f0e9)("tr", ()=>{
                            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                                classList: [
                                    "border-t",
                                    "w-full",
                                    "dark:border-gray-700",
                                    "hover:bg-gray-50",
                                    "dark:hover:bg-gray-600",
                                    "text-gray-900",
                                    "dark:text-gray-100"
                                ]
                            });
                            (0, $133989e677847899$export$dda1d9f60106f0e9)("td", ()=>{
                                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                                    classList: [
                                        "px-4",
                                        "py-4"
                                    ]
                                });
                                (0, $133989e677847899$export$dda1d9f60106f0e9)("div", {
                                    text: (0, $133989e677847899$export$aee1dbae5de2db9d)(log, "created_at")
                                });
                            });
                            (0, $133989e677847899$export$dda1d9f60106f0e9)("td", ()=>{
                                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                                    classList: [
                                        "px-4",
                                        "py-4"
                                    ]
                                });
                                (0, $8767297ef2df0995$export$f8ab115d87e210a)((0, $133989e677847899$export$aee1dbae5de2db9d)(log, "level"));
                            });
                            (0, $133989e677847899$export$dda1d9f60106f0e9)("td", ()=>{
                                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                                    classList: [
                                        "px-4",
                                        "py-4"
                                    ]
                                });
                                (0, $133989e677847899$export$dda1d9f60106f0e9)("div", {
                                    text: (0, $133989e677847899$export$aee1dbae5de2db9d)(log, "text")
                                });
                            });
                        });
                    });
                });
            });
        });
    });
};




var $agnkb = parcelRequire("agnkb");


const $36b3d4afe650f8db$export$ef9b1a59e592288f = ({ value: value, text: text, options: options, optionSelected: optionSelected, withBlank: withBlank })=>{
    const $optionsHash = options.map((o)=>(0, $455b7f8724d924ef$export$d41d9ab3de2def3d)(o.join("")));
    const dropdownTriggered = (0, $agnkb.createEvent)();
    const $localVisible = (0, $agnkb.createStore)(false);
    const outsideClicked = (0, $agnkb.createEvent)();
    (0, $agnkb.sample)({
        source: $localVisible,
        clock: dropdownTriggered,
        fn: (v)=>!v,
        target: $localVisible
    });
    (0, $agnkb.sample)({
        clock: optionSelected,
        fn: ()=>false,
        target: $localVisible
    });
    (0, $agnkb.sample)({
        source: {
            visible: $localVisible,
            hash: $optionsHash
        },
        clock: outsideClicked,
        filter: ({ visible: visible, hash: hash }, event)=>{
            return hash !== event.target.id && visible;
        },
        fn: ()=>false,
        target: $localVisible
    });
    const $selected = (0, $agnkb.combine)([
        options,
        value
    ], ([options, value])=>{
        return options.find((o)=>o === value || o.id === value || o.name === value) || "";
    });
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "relative"
            ]
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("label", {
            classList: [
                "block",
                "mb-2",
                "text-sm",
                "font-medium",
                "text-gray-900",
                "dark:text-white"
            ],
            text: text
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "relative"
                ]
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("input", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "cursor-default",
                        "bg-gray-50",
                        "focus:outline",
                        "outline-1",
                        "border",
                        "border-gray-300",
                        "text-gray-900",
                        "text-sm",
                        "rounded-lg",
                        "focus:ring-blue-500",
                        "focus:border-blue-500",
                        "block",
                        "w-full",
                        "p-2.5",
                        "dark:bg-gray-700",
                        "dark:border-gray-600",
                        "dark:placeholder-gray-400",
                        "dark:text-white",
                        "dark:focus:ring-blue-500",
                        "dark:focus:border-blue-500",
                        "cursor-pointer"
                    ],
                    attr: {
                        readonly: true,
                        type: "select",
                        value: $selected.map((s)=>s?.title || s?.name || s),
                        id: $optionsHash
                    },
                    handler: {
                        on: {
                            click: dropdownTriggered
                        }
                    }
                });
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "absolute",
                        "top-4",
                        "right-2"
                    ]
                });
                (0, $cfe9a25a978b21b0$export$4d7ad962dfb0e81e)();
            });
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                visible: $localVisible,
                classList: [
                    "max-h-56",
                    "overflow-scroll",
                    "left-0",
                    "absolute",
                    "left-0",
                    "top-18",
                    "w-fit",
                    "border",
                    "border-gray-200",
                    "dark:bg-gray-800",
                    "dark:border-gray-700",
                    "z-50",
                    "bg-white",
                    "divide-y",
                    "divide-gray-100",
                    "rounded-lg",
                    "shadow",
                    "dark:bg-gray-700",
                    "dark:divide-gray-600",
                    "shadow-2xl"
                ]
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("ul", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "flex",
                        "flex-col",
                        "flex-wrap",
                        "text-gray-700",
                        "dark:text-gray-200"
                    ]
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("li", {
                    classList: [
                        "hover:bg-gray-100",
                        "dark:hover:bg-gray-600",
                        "flex",
                        "border-gray-300",
                        "dark:border-gray-700",
                        "items-center",
                        "px-6",
                        "py-2.5",
                        "flex-auto",
                        "w-full",
                        "text-sm",
                        "font-medium",
                        "text-gray-900",
                        "dark:text-white",
                        "shrink-0",
                        "block",
                        "cursor-pointer"
                    ],
                    text: "—",
                    visible: withBlank,
                    handler: {
                        on: {
                            click: optionSelected.prepend(()=>null)
                        }
                    }
                });
                (0, $133989e677847899$export$8837f4fc672e936d)(options, ({ store: option })=>{
                    (0, $133989e677847899$export$dda1d9f60106f0e9)("li", ()=>{
                        const localOptionSelected = (0, $agnkb.createEvent)();
                        (0, $agnkb.sample)({
                            source: option,
                            clock: localOptionSelected,
                            fn: (option)=>option.name || option,
                            target: optionSelected
                        });
                        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                            classList: [
                                "hover:bg-gray-100",
                                "dark:hover:bg-gray-600",
                                "flex",
                                "border-gray-300",
                                "dark:border-gray-700",
                                "items-center",
                                "px-6",
                                "py-2.5",
                                "flex-auto",
                                "w-full",
                                "text-sm",
                                "font-medium",
                                "text-gray-900",
                                "dark:text-white",
                                "shrink-0",
                                "block",
                                "cursor-pointer"
                            ],
                            text: option.map((o)=>o.title || o.name || o),
                            handler: {
                                on: {
                                    click: localOptionSelected
                                }
                            }
                        });
                    });
                });
            });
        });
        (0, $133989e677847899$export$35059013cd4a06db)(()=>{
            document.addEventListener("click", (event)=>{
                outsideClicked(event);
            });
        });
    });
};



var $agnkb = parcelRequire("agnkb");

const $50bc7b2791a6cb44$export$852d7888b34e2b72 = (text, visible)=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("p", {
        classList: [
            "mt-2",
            "text-sm",
            "text-red-600",
            "dark:text-red-400"
        ],
        visible: visible || (0, $agnkb.createStore)(false),
        text: text || (0, $agnkb.createStore)("")
    });
};




var $agnkb = parcelRequire("agnkb");

const $58a7352922021345$export$23b8bf72cfd1bee4 = (users, editClicked)=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "antialiased"
            ]
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "relative",
                    "overflow-x-auto",
                    "sm:rounded-b-lg"
                ]
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("table", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "min-w-full",
                        "w-max",
                        "text-sm",
                        "text-left",
                        "table-fixed"
                    ]
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("thead", ()=>{
                    (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                        classList: [
                            "text-xs",
                            "text-gray-700",
                            "uppercase",
                            "bg-gray-50",
                            "w-full",
                            "dark:bg-gray-700",
                            "dark:text-gray-200"
                        ]
                    });
                    (0, $133989e677847899$export$dda1d9f60106f0e9)("tr", ()=>{
                        (0, $133989e677847899$export$dda1d9f60106f0e9)("th", {
                            attr: {
                                scope: "col"
                            },
                            classList: [
                                "px-6",
                                "py-3",
                                "w-48",
                                "lg:w-72"
                            ],
                            text: "Email"
                        });
                        (0, $133989e677847899$export$dda1d9f60106f0e9)("th", {
                            attr: {
                                scope: "col"
                            },
                            classList: [
                                "px-6",
                                "py-3",
                                "w-48",
                                "lg:w-72"
                            ],
                            text: "Name"
                        });
                        (0, $133989e677847899$export$dda1d9f60106f0e9)("th", {
                            attr: {
                                scope: "col"
                            },
                            classList: [
                                "px-6",
                                "py-3"
                            ],
                            text: "Role"
                        });
                        (0, $133989e677847899$export$dda1d9f60106f0e9)("th", {
                            attr: {
                                scope: "col"
                            },
                            classList: [
                                "px-6",
                                "py-3"
                            ],
                            text: "Revoked"
                        });
                        (0, $133989e677847899$export$dda1d9f60106f0e9)("th", {
                            attr: {
                                scope: "col"
                            },
                            classList: [
                                "px-6",
                                "py-3"
                            ],
                            text: "Actions"
                        });
                    });
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("tbody", ()=>{
                    (0, $133989e677847899$export$8837f4fc672e936d)(users, ({ store: user })=>{
                        (0, $133989e677847899$export$dda1d9f60106f0e9)("tr", ()=>{
                            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                                classList: {
                                    "border-t": true,
                                    "w-full": true,
                                    "dark:border-gray-700": true,
                                    "hover:bg-gray-50": true,
                                    "dark:hover:bg-gray-600": true,
                                    "text-gray-900": true,
                                    "dark:text-gray-200": true,
                                    "opacity-50": user.map((u)=>u.is_revoked)
                                }
                            });
                            (0, $133989e677847899$export$dda1d9f60106f0e9)("td", ()=>{
                                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                                    classList: [
                                        "px-6",
                                        "py-4"
                                    ]
                                });
                                (0, $133989e677847899$export$dda1d9f60106f0e9)("div", {
                                    text: (0, $133989e677847899$export$aee1dbae5de2db9d)(user, "email")
                                });
                            });
                            (0, $133989e677847899$export$dda1d9f60106f0e9)("td", ()=>{
                                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                                    classList: [
                                        "px-6",
                                        "py-4"
                                    ]
                                });
                                (0, $133989e677847899$export$dda1d9f60106f0e9)("div", {
                                    text: (0, $133989e677847899$export$aee1dbae5de2db9d)(user, "name")
                                });
                            });
                            (0, $133989e677847899$export$dda1d9f60106f0e9)("td", ()=>{
                                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                                    classList: [
                                        "px-6",
                                        "py-4"
                                    ]
                                });
                                (0, $133989e677847899$export$dda1d9f60106f0e9)("div", {
                                    text: (0, $133989e677847899$export$aee1dbae5de2db9d)(user, "role")
                                });
                            });
                            (0, $133989e677847899$export$dda1d9f60106f0e9)("td", ()=>{
                                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                                    classList: [
                                        "px-6",
                                        "py-4"
                                    ]
                                });
                                (0, $133989e677847899$export$dda1d9f60106f0e9)("div", {
                                    text: user.map((u)=>u.is_revoked ? "Revoked" : "Active")
                                });
                            });
                            (0, $133989e677847899$export$dda1d9f60106f0e9)("td", ()=>{
                                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                                    classList: [
                                        "px-6",
                                        "py-4"
                                    ]
                                });
                                const localEditClicked = (0, $agnkb.createEvent)();
                                (0, $agnkb.sample)({
                                    source: (0, $133989e677847899$export$aee1dbae5de2db9d)(user, "id"),
                                    clock: localEditClicked,
                                    target: editClicked
                                });
                                (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                                    text: "Edit",
                                    event: localEditClicked,
                                    variant: "default",
                                    size: "extra_small"
                                });
                            });
                        });
                    });
                });
            });
        });
    });
};




var $agnkb = parcelRequire("agnkb");

const $452d31565306cecd$export$d9a60fd79fbcc877 = (apiTokens, editClicked)=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "antialiased"
            ]
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "relative",
                    "overflow-x-auto",
                    "sm:rounded-b-lg"
                ]
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("table", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "min-w-full",
                        "w-max",
                        "text-sm",
                        "text-left",
                        "table-fixed"
                    ]
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("thead", ()=>{
                    (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                        classList: [
                            "text-xs",
                            "text-gray-700",
                            "uppercase",
                            "bg-gray-50",
                            "w-full",
                            "dark:bg-gray-700",
                            "dark:text-gray-200"
                        ]
                    });
                    (0, $133989e677847899$export$dda1d9f60106f0e9)("tr", ()=>{
                        (0, $133989e677847899$export$dda1d9f60106f0e9)("th", {
                            attr: {
                                scope: "col"
                            },
                            classList: [
                                "px-6",
                                "py-3"
                            ],
                            text: "Name"
                        });
                        (0, $133989e677847899$export$dda1d9f60106f0e9)("th", {
                            attr: {
                                scope: "col"
                            },
                            classList: [
                                "px-6",
                                "py-3",
                                "w-48",
                                "lg:w-72"
                            ],
                            text: "Token"
                        });
                        (0, $133989e677847899$export$dda1d9f60106f0e9)("th", {
                            attr: {
                                scope: "col"
                            },
                            classList: [
                                "px-6",
                                "py-3"
                            ],
                            text: "Revoked"
                        });
                        (0, $133989e677847899$export$dda1d9f60106f0e9)("th", {
                            attr: {
                                scope: "col"
                            },
                            classList: [
                                "px-6",
                                "py-3"
                            ],
                            text: "Actions"
                        });
                    });
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("tbody", ()=>{
                    (0, $133989e677847899$export$8837f4fc672e936d)(apiTokens, ({ store: apiToken })=>{
                        (0, $133989e677847899$export$dda1d9f60106f0e9)("tr", ()=>{
                            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                                classList: {
                                    "border-t": true,
                                    "w-full": true,
                                    "dark:border-gray-700": true,
                                    "hover:bg-gray-50": true,
                                    "dark:hover:bg-gray-600": true,
                                    "text-gray-900": true,
                                    "dark:text-gray-200": true,
                                    "opacity-50": apiToken.map((at)=>at.is_revoked)
                                }
                            });
                            (0, $133989e677847899$export$dda1d9f60106f0e9)("td", ()=>{
                                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                                    classList: [
                                        "px-6",
                                        "py-4"
                                    ]
                                });
                                (0, $133989e677847899$export$dda1d9f60106f0e9)("div", {
                                    text: (0, $133989e677847899$export$aee1dbae5de2db9d)(apiToken, "name")
                                });
                            });
                            (0, $133989e677847899$export$dda1d9f60106f0e9)("td", ()=>{
                                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                                    classList: [
                                        "px-6",
                                        "py-4"
                                    ]
                                });
                                (0, $133989e677847899$export$dda1d9f60106f0e9)("div", {
                                    text: apiToken.map((t)=>t.token || new Array(32).fill("*").join(""))
                                });
                            });
                            (0, $133989e677847899$export$dda1d9f60106f0e9)("td", ()=>{
                                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                                    classList: [
                                        "px-6",
                                        "py-4"
                                    ]
                                });
                                (0, $133989e677847899$export$dda1d9f60106f0e9)("div", {
                                    text: apiToken.map((token)=>token.is_revoked ? "Revoked" : "Active")
                                });
                            });
                            (0, $133989e677847899$export$dda1d9f60106f0e9)("td", ()=>{
                                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                                    classList: [
                                        "px-6",
                                        "py-4"
                                    ]
                                });
                                const localEditClicked = (0, $agnkb.createEvent)();
                                (0, $agnkb.sample)({
                                    source: (0, $133989e677847899$export$aee1dbae5de2db9d)(apiToken, "id"),
                                    clock: localEditClicked,
                                    target: editClicked
                                });
                                (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                                    text: "Edit",
                                    event: localEditClicked,
                                    variant: "default",
                                    size: "extra_small"
                                });
                            });
                        });
                    });
                });
            });
        });
    });
};




var $agnkb = parcelRequire("agnkb");

const $53c993165942ee63$export$8cea405697bd6ef = (tags, editClicked)=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "antialiased"
            ]
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "relative",
                    "overflow-x-auto",
                    "sm:rounded-b-lg"
                ]
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("table", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "min-w-full",
                        "w-max",
                        "text-sm",
                        "text-left",
                        "table-fixed"
                    ]
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("thead", ()=>{
                    (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                        classList: [
                            "text-xs",
                            "text-gray-700",
                            "uppercase",
                            "bg-gray-50",
                            "w-full",
                            "dark:bg-gray-700",
                            "dark:text-gray-200"
                        ]
                    });
                    (0, $133989e677847899$export$dda1d9f60106f0e9)("tr", ()=>{
                        (0, $133989e677847899$export$dda1d9f60106f0e9)("th", {
                            attr: {
                                scope: "col"
                            },
                            classList: [
                                "px-6",
                                "py-3"
                            ],
                            text: "Name"
                        });
                        (0, $133989e677847899$export$dda1d9f60106f0e9)("th", {
                            attr: {
                                scope: "col"
                            },
                            classList: [
                                "px-6",
                                "py-3",
                                "max-w-28",
                                "w-28"
                            ],
                            text: "Actions"
                        });
                    });
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("tbody", ()=>{
                    (0, $133989e677847899$export$8837f4fc672e936d)(tags, ({ store: tag })=>{
                        (0, $133989e677847899$export$dda1d9f60106f0e9)("tr", ()=>{
                            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                                classList: [
                                    "border-t",
                                    "w-full",
                                    "dark:border-gray-700",
                                    "hover:bg-gray-50",
                                    "dark:hover:bg-gray-600",
                                    "text-gray-900",
                                    "dark:text-gray-200"
                                ]
                            });
                            (0, $133989e677847899$export$dda1d9f60106f0e9)("td", ()=>{
                                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                                    classList: [
                                        "px-6",
                                        "py-4"
                                    ]
                                });
                                (0, $133989e677847899$export$dda1d9f60106f0e9)("div", {
                                    text: (0, $133989e677847899$export$aee1dbae5de2db9d)(tag, "name")
                                });
                            });
                            (0, $133989e677847899$export$dda1d9f60106f0e9)("td", ()=>{
                                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                                    classList: [
                                        "px-6",
                                        "py-4"
                                    ]
                                });
                                const localEditClicked = (0, $agnkb.createEvent)();
                                (0, $agnkb.sample)({
                                    source: (0, $133989e677847899$export$aee1dbae5de2db9d)(tag, "id"),
                                    clock: localEditClicked,
                                    target: editClicked
                                });
                                (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                                    text: "Edit",
                                    event: localEditClicked,
                                    variant: "default",
                                    size: "extra_small"
                                });
                            });
                        });
                    });
                });
            });
        });
    });
};




const $1135dd29bd0deb8d$export$5b6b19405a83ff9d = ({ text: text })=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "group",
                "w-max"
            ]
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "group-hover:underline",
                    "cursor-pointer"
                ]
            });
            (0, $9d70cf9dc154c107$export$f314ed182f5da2a0)();
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "absolute",
                    "pointer-events-none",
                    "bottom-1/3",
                    "transform",
                    "-translate-y-1/2",
                    "ml-6",
                    "bg-gray-800",
                    "text-white",
                    "text-center",
                    "px-2",
                    "py-1",
                    "rounded",
                    "opacity-0",
                    "group-hover:opacity-100",
                    "transition-opacity",
                    "duration-300"
                ]
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "text-left",
                        "text-sm",
                        "px-1",
                        "py-0.5"
                    ]
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("p", {
                    text: text
                });
            });
        });
    });
};




const $80777629d33d636a$export$b04be29aa201d4f5 = ({ text: text, hint: hint })=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "flex",
                "items-center"
            ]
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("p", {
            classList: [
                "block",
                "text-sm",
                "font-medium",
                "text-gray-900",
                "dark:text-white"
            ],
            text: text
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "pl-1"
                ]
            });
            (0, $1135dd29bd0deb8d$export$5b6b19405a83ff9d)({
                text: hint
            });
        });
    });
};



var $agnkb = parcelRequire("agnkb");

var $8cde029bb678322e$exports = {};

!function(e, t) {
    t($8cde029bb678322e$exports, (parcelRequire("agnkb")));
}($8cde029bb678322e$exports, function(e, t) {
    "use strict";
    function n(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var r = n(t);
    function o(e, t, n) {
        return e(n = {
            path: t,
            exports: {},
            require: function(e, t) {
                return function() {
                    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
                }(null == t && n.path);
            }
        }, n.exports), n.exports;
    }
    var a = o(function(e, t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.and = function(...e) {
            return (0, r.default.combine)({
                and: [
                    e,
                    (e)=>{
                        for (const t of e)if (!t) return !1;
                        return !0;
                    }
                ],
                or: {
                    sid: "-rbm5ks"
                }
            });
        };
    }), i = o(function(e, t) {
        function n(e) {
            throw new Error(e);
        }
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.combineEvents = function({ events: e, reset: t, target: o = (0, r.default.createEvent)({
            name: "target",
            sid: "aip3nf"
        }) }) {
            r.default.is.unit(o) || n("target should be a unit");
            t && !r.default.is.unit(t) && n("reset should be a unit");
            return (0, r.default.withRegion)(o, ()=>{
                const n = Object.keys(e), a = Array.isArray(e) ? [
                    ...n
                ].fill("") : {}, i = (0, r.default.createStore)(n.length, {
                    and: {
                        serialize: "ignore"
                    },
                    name: "$counter",
                    sid: "-dby0v3"
                }), u = (0, r.default.createStore)(a, {
                    and: {
                        serialize: "ignore"
                    },
                    name: "$results",
                    sid: "c60qbe"
                });
                i.reset((0, r.default.sample)({
                    and: [
                        {
                            source: o
                        }
                    ],
                    or: {
                        sid: "-8hxq8z"
                    }
                })), u.reset(o), t && (i.reset((0, r.default.sample)({
                    and: [
                        {
                            source: t
                        }
                    ],
                    or: {
                        sid: "3c6u5p"
                    }
                })), u.reset(t));
                for (const a of n){
                    const n = (0, r.default.createStore)(!1, {
                        and: {
                            serialize: "ignore"
                        },
                        name: "$isDone",
                        sid: "uttu1j"
                    }).on(e[a], ()=>!0).reset(o);
                    t && n.reset(t), i.on(n, (e)=>e - 1), u.on(e[a], (e, t)=>{
                        const n = Array.isArray(e) ? [
                            ...e
                        ] : {
                            ...e
                        };
                        return n[a] = t, n;
                    });
                }
                (0, r.default.guard)({
                    and: [
                        {
                            source: (0, r.default.sample)({
                                and: [
                                    {
                                        source: u,
                                        clock: (0, r.default.merge)(Object.values(e), {
                                            name: "clock",
                                            sid: "-531esq"
                                        })
                                    }
                                ],
                                or: {
                                    name: "source",
                                    sid: "uwap9g"
                                }
                            }),
                            filter: i.map((e)=>0 === e),
                            target: o
                        }
                    ],
                    or: {
                        sid: "ciyd7d"
                    }
                });
            }), o;
        };
    }), u = o(function(e, t) {
        function n(e) {
            return r.default.is.unit(e) ? e.map((e)=>!e) : (t)=>!e(t);
        }
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.condition = function({ if: e, then: t, else: o, source: a = (0, r.default.createEvent)({
            name: "source",
            sid: "epke23"
        }) }) {
            const i = r.default.is.unit(e) || (u = e, "function" == typeof u) ? e : (t)=>t === e;
            var u;
            t && o ? (0, r.default.split)({
                and: [
                    {
                        source: a,
                        match: {
                            then: i,
                            else: n(i)
                        },
                        cases: {
                            then: t,
                            else: o
                        }
                    }
                ],
                or: {
                    sid: "9tug3k"
                }
            }) : t ? (0, r.default.guard)({
                and: [
                    {
                        source: a,
                        filter: i,
                        target: t
                    }
                ],
                or: {
                    sid: "abznoh"
                }
            }) : o && (0, r.default.guard)({
                and: [
                    {
                        source: a,
                        filter: n(i),
                        target: o
                    }
                ],
                or: {
                    sid: "-eb29qp"
                }
            });
            return a;
        };
    }), s = o(function(e, t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.debounce = function({ source: e, timeout: t, target: n }) {
            if (!r.default.is.unit(e)) throw new TypeError("source must be unit from effector");
            if (r.default.is.domain(e, {
                sid: "k76nst"
            })) throw new TypeError("source cannot be domain");
            const o = function(e) {
                if (r.default.is.store(e, {
                    sid: "-mlqvq"
                })) return e;
                if ("number" == typeof e) {
                    if (e < 0 || !Number.isFinite(e)) throw new Error(`timeout must be positive number or zero. Received: "${e}"`);
                    return (0, r.default.createStore)(e, {
                        and: {
                            name: "$timeout"
                        },
                        sid: "-6oihcx"
                    });
                }
                throw new TypeError(`timeout parameter in interval method should be number or Store. "${typeof e}" was passed`);
            }(t), a = (0, r.default.createEvent)({
                name: "saveTimeoutId",
                sid: "vsg63k"
            }), i = (0, r.default.createStore)(null, {
                and: {
                    serialize: "ignore"
                },
                name: "$timeoutId",
                sid: "lhz3ie"
            }).on(a, (e, t)=>t), u = (0, r.default.createEvent)({
                name: "saveReject",
                sid: "qddkx3"
            }), s = (0, r.default.createStore)(null, {
                and: {
                    serialize: "ignore"
                },
                name: "$rejecter",
                sid: "-o8m8p2"
            }).on(u, (e, t)=>t), d = null != n ? n : (0, r.default.createEvent)({
                name: "tick",
                sid: "a51tok"
            }), c = (0, r.default.createEffect)(({ timeout: e, timeoutId: t, rejectPromise: n })=>(t && clearTimeout(t), n && n(), new Promise((t, n)=>{
                    u(n), a(setTimeout(t, e));
                })), {
                name: "timerBaseFx",
                sid: "-6dos97"
            }), l = (0, r.default.attach)({
                and: {
                    source: {
                        timeoutId: i,
                        rejectPromise: s
                    },
                    mapParams: (e, { timeoutId: t, rejectPromise: n })=>({
                            timeout: e,
                            timeoutId: t,
                            rejectPromise: n
                        }),
                    effect: c
                },
                or: {
                    name: "timerFx",
                    sid: "ca9mop"
                }
            });
            s.reset(l.done), i.reset(l.done);
            const f = (0, r.default.createStore)([], {
                and: {
                    serialize: "ignore"
                },
                name: "$payload",
                sid: "jthvlw"
            }).on(e, (e, t)=>[
                    t
                ]), m = (0, r.default.createStore)(!0, {
                and: {
                    serialize: "ignore"
                },
                name: "$canTick",
                sid: "-rehy9s"
            }), p = (0, r.default.createEvent)({
                name: "triggerTick",
                sid: "31ed0l"
            });
            m.on(p, ()=>!1).on([
                d,
                o,
                l
            ], ()=>!0);
            const g = (0, r.default.merge)([
                e,
                o
            ], {
                name: "requestTick",
                sid: "7xoh8q"
            });
            return (0, r.default.guard)({
                and: [
                    {
                        clock: g,
                        filter: m,
                        target: p
                    }
                ],
                or: {
                    sid: "-1mcdjn"
                }
            }), (0, r.default.sample)({
                and: [
                    {
                        source: o,
                        clock: p,
                        target: l
                    }
                ],
                or: {
                    sid: "-1j1lzh"
                }
            }), (0, r.default.sample)({
                and: [
                    {
                        source: f,
                        clock: l.done,
                        fn: ([e])=>e,
                        target: d
                    }
                ],
                or: {
                    sid: "-1475yq"
                }
            }), d;
        };
    }), d = o(function(e, t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.debug = o;
        const n = {
            trace: !1,
            handler: (e)=>{
                if (h(e.node) && "finally" === e.node.meta.named) return;
                const { scope: t, scopeName: n, name: r, kind: o, value: a, loc: i, trace: u, node: s, logType: d } = e, c = t ? ` (scope: ${n})` : "", l = null != r ? r : i ? `${i.file}:${i.line}:${i.column}` : "", f = "initial" === d ? " [getState]" : "";
                console.info(`[${o}]${c} ${l}${f}`, a), u && u.length > 0 && !h(s) && (console.groupCollapsed(`[${o}]${c} ${l} trace`), u.forEach((e)=>{
                    const { name: t, kind: n, value: r, loc: o } = e, a = null != t ? t : o ? `${o.file}:${o.line}:${o.column}` : "";
                    console.info(`<- [${n}] ${a}`, r);
                }), console.groupEnd());
            }
        };
        function o(...e) {
            const { config: t, units: o1 } = function(...e) {
                let t = n;
                const [o, ...a] = e, i = [];
                if (function(e) {
                    if (!r.default.is.unit(e)) return !Object.values(e).every(r.default.is.unit);
                    return !1;
                }(o)) t = {
                    ...n,
                    ...o
                };
                else if (r.default.is.unit(o)) i.push(o);
                else for (const [e, t] of Object.entries(o))b.set(v(t).id, e), i.push(t);
                for (const e of a)if (r.default.is.unit(e)) i.push(e);
                else for (const [t, n] of Object.entries(e))b.set(v(n).id, t), i.push(n);
                return {
                    config: t,
                    units: i
                };
            }(...e);
            o1.forEach((e)=>{
                r.default.is.store(e, {
                    sid: "-foynff"
                }) || r.default.is.event(e, {
                    sid: "apy28p"
                }) || r.default.is.effect(e, {
                    sid: "apy3od"
                }) ? i(e, t) : r.default.is.domain(e, {
                    sid: "-rsqe9t"
                }) && a(e, t);
            });
        }
        function a(e, t) {
            e.onCreateStore((e)=>i(e, t)), e.onCreateEvent((e)=>i(e, t)), e.onCreateEffect((e)=>i(e, t)), e.onCreateDomain((e)=>a(e, t));
        }
        function i(e, t) {
            r.default.is.store(e, {
                sid: "w7ds2s"
            }) ? (!function(e, t) {
                if (!t.handler) throw Error("patronum/debug must have the handler");
                const n = {
                    logType: "initial",
                    scope: null,
                    scopeName: null,
                    node: $(e),
                    kind: y(e),
                    value: e.getState(),
                    name: w(e),
                    loc: j(e),
                    trace: [],
                    stackMeta: {}
                };
                t.handler(n), p.forEach((n)=>d(e, t, n)), l((n)=>d(e, t, n));
            }(e, t), u(e, t)) : r.default.is.event(e, {
                sid: "fretyd"
            }) ? u(e, t) : r.default.is.effect(e, {
                sid: "gpi2qr"
            }) && (u(e, t), u(e.finally, t), u(e.done, t), u(e.fail, t));
        }
        function u(e, t) {
            const n = (0, r.default.createNode)({
                parent: [
                    e
                ],
                meta: {
                    op: "watch"
                },
                family: {
                    owners: e
                },
                regional: !0,
                node: [
                    r.default.step.run({
                        fn (n, r, o) {
                            var a;
                            const i = null !== (a = o?.scope) && void 0 !== a ? a : null, u = {
                                logType: "update",
                                scope: i,
                                scopeName: g(i),
                                node: $(e),
                                kind: y(e),
                                value: n,
                                name: w(e),
                                loc: j(e),
                                stackMeta: _(o.parent),
                                trace: t.trace ? s(o) : []
                            };
                            if (!t.handler) throw Error("patronum/debug must have the handler");
                            t.handler(u);
                        }
                    })
                ]
            });
            return ()=>(0, r.default.clearNode)(n);
        }
        function s(e) {
            const t = [];
            let n = e?.parent;
            for(; n;){
                const { node: e, value: r } = n, o = {
                    node: e,
                    value: r,
                    name: w(e),
                    loc: j(e),
                    kind: y(e),
                    stackMeta: _(n)
                };
                t.push(o), n = n.parent;
            }
            return t;
        }
        function d(e, t, n) {
            if (!t.handler) throw Error("patronum/debug must have the handler");
            const r = $(e), o = {
                logType: "initial",
                scope: n,
                scopeName: g(n),
                node: r,
                kind: y(e),
                value: n.getState(e),
                name: w(e),
                loc: j(e),
                trace: [],
                stackMeta: {}
            };
            t.handler(o);
        }
        const c = new Set, l = (e)=>(c.add(e), ()=>{
                c.delete(e);
            });
        let f = 0;
        const m = new Map, p = {
            save (e, t) {
                p.get(e) || m.set(e, t);
            },
            get (e) {
                var t;
                return e && null !== (t = m.get(e)) && void 0 !== t ? t : null;
            },
            delete (e) {
                m.delete(e);
            },
            forEach (e) {
                m.forEach((t, n)=>e(n, t));
            },
            clear () {
                m.clear();
            }
        };
        function g(e) {
            if (!e) return null;
            const t = p.get(e);
            if (!t) return e._debugId || (e._debugId = (f += 1, `unknown_${f}`));
            return t.name;
        }
        function h(e) {
            const t = $(e), { sid: n, named: r } = t.meta;
            return Boolean(!n && ("finally" === r || "done" === r || "doneData" === r || "fail" === r || "failData" === r || "inFlight" === r || "pending" === r));
        }
        function y(e) {
            if (r.default.is.store(e, {
                sid: "4o7s04"
            })) return "store";
            if (r.default.is.effect(e, {
                sid: "4pv5s7"
            }) || h(e)) return "effect";
            if (r.default.is.event(e, {
                sid: "4rijka"
            })) return "event";
            if (r.default.is.domain(e, {
                sid: "54plsy"
            })) return "domain";
            if (r.default.is.unit(e)) return "unit";
            const t = $(e);
            return t.meta.op ? t.meta.op : "unknown";
        }
        o.registerScope = function(e, t) {
            return p.save(e, {
                name: t.name
            }), c.forEach((t)=>t(e)), ()=>{
                p.delete(e);
            };
        }, o.unregisterAllScopes = function() {
            p.clear();
        };
        const v = (e)=>e.graphite || e, b = new Map;
        function w(e) {
            const t = b.get(v(e).id);
            if (t) return t;
            if (h(e)) {
                const t = $(e), n = t.family.owners.find((e)=>"effect" === e.meta.op);
                if (n) {
                    const e = k(n);
                    return `${e ? `${e}/` : ""}${w(n)}.${t.meta.named}`;
                }
                return t.meta.named;
            }
            if (function(e) {
                const t = $(e), { op: n } = t.meta;
                return "on" === n;
            }(e)) {
                const t = $(e);
                return `${w(t.next[0])}.on(${w(t.family.owners[0])})`;
            }
            if (r.default.is.unit(e)) {
                if (e?.compositeName?.fullName) return e.compositeName.fullName;
                const t = k(e), n = t ? `${t}/` : "";
                if (e?.shortName) return `${n}${e.shortName}`;
                if (e?.name) return `${n}${e.name}`;
            }
            return $(e)?.meta?.name ? $(e).meta.name : null;
        }
        function k(e) {
            const t = $(e).family.owners.find((e)=>"domain" === e.meta.op);
            return t ? w(t) : null;
        }
        function j(e) {
            const t = function({ meta: e }) {
                return "config" in e ? e.config.loc : e.loc;
            }($(e));
            if (t) return t;
        }
        function $(e) {
            return "graphite" in e ? e.graphite : e;
        }
        function _(e) {
            if (!e) return {};
            return e.meta || {};
        }
    }), c = o(function(e, t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.delay = function({ source: e, timeout: t, target: n = (0, r.default.createEvent)({
            name: "target",
            sid: "-z2vw3w"
        }) }) {
            if (!r.default.is.unit(e)) throw new TypeError("source must be a unit from effector");
            if (!r.default.is.unit(n)) throw new TypeError("target must be a unit from effector");
            const o = function(e) {
                if (r.default.is.store(e, {
                    sid: "-v8hs87"
                }) || "function" == typeof e || "number" == typeof e) return e;
                throw new TypeError(`'timeout' argument must be a function, Store, or a number. Passed "${typeof e}"`);
            }(t), a = (0, r.default.createEffect)(({ payload: e, milliseconds: t })=>new Promise((n)=>{
                    setTimeout(n, t, e);
                }), {
                name: "timerFx",
                sid: "-2uwk8k"
            });
            return (0, r.default.sample)({
                and: [
                    {
                        source: (0, r.default.combine)({
                            and: [
                                {
                                    milliseconds: o
                                }
                            ],
                            or: {
                                name: "source",
                                sid: "c4jhin"
                            }
                        }),
                        clock: e,
                        fn: ({ milliseconds: e }, t)=>({
                                payload: t,
                                milliseconds: "function" == typeof e ? e(t) : e
                            }),
                        target: a
                    }
                ],
                or: {
                    sid: "-w88eue"
                }
            }), (0, r.default.forward)({
                and: {
                    from: a.doneData,
                    to: n
                },
                or: {
                    sid: "-vozm2r"
                }
            }), a.doneData;
        };
    }), l = o(function(e, t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.either = function e(t, n, o) {
            if (r.default.is.store(t, {
                sid: "ozzvoc"
            })) return (0, r.default.combine)({
                and: [
                    t,
                    n,
                    o,
                    (e, t, n)=>e ? t : n
                ],
                or: {
                    sid: "-5vau2h"
                }
            });
            const a = t;
            return e(a.filter, a.then, a.other);
        };
    }), f = o(function(e, t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.empty = function(e) {
            return e.map((e)=>null === e);
        };
    }), m = o(function(e, t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.equals = function(e, t) {
            return (0, r.default.combine)({
                and: [
                    e,
                    t,
                    (e, t)=>e === t
                ],
                or: {
                    sid: "-pqjlti"
                }
            });
        };
    }), p = o(function(e, t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.every = function(e, t) {
            let n, o = [], a = ()=>!1;
            Array.isArray(e) ? (o = e, a = t) : Array.isArray(e.stores) && (o = e.stores, a = e.predicate);
            i = a, n = "function" == typeof i ? a : r.default.is.store(a, {
                sid: "sid3ut"
            }) ? a.map((e)=>(t)=>e === t) : (e)=>e === a;
            var i;
            const u = (0, r.default.combine)({
                and: [
                    o
                ],
                or: {
                    name: "$values",
                    sid: "h09uhg"
                }
            }), s = n;
            return (0, r.default.combine)({
                and: [
                    s,
                    u,
                    (e, t)=>t.every(e)
                ],
                or: {
                    sid: "hfkdw9"
                }
            });
        };
    }), g = o(function(e, t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.format = function(e, ...t) {
            return (0, r.default.combine)({
                and: [
                    t,
                    (t)=>e.reduce((n, r, o)=>n.concat(function(e, t) {
                                return t === e.length - 1;
                            }(e, o) ? r : `${r}${function(e) {
                                if (Array.isArray(e)) return e.map((e)=>String(e)).join(", ");
                                return String(e);
                            }(t[o])}`), "")
                ],
                or: {
                    sid: "-yrbthp"
                }
            });
        };
    }), h = o(function(e, t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.inFlight = function({ effects: e, domain: t }) {
            if (t) {
                const e = t.createStore(0, {
                    name: "$inFlight",
                    sid: "-y7vg7t"
                });
                return t.onCreateEffect((t)=>{
                    e.on(t, (e)=>e + 1).on(t.finally, (e)=>e - 1);
                }), e;
            }
            return (0, r.default.combine)({
                and: [
                    e.map((e)=>e.inFlight),
                    (e)=>e.reduce((e, t)=>e + t, 0)
                ],
                or: {
                    sid: "ubqxa7"
                }
            });
        };
    }), y = o(function(e, t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.interval = function({ timeout: e, start: t, stop: n, leading: o = !1, trailing: a = !1 }) {
            const i = null != t ? t : (0, r.default.createEvent)({
                name: "setup",
                sid: "-ajedhm"
            }), u = null != n ? n : (0, r.default.createEvent)({
                name: "teardown",
                sid: "-ryi8gr"
            }), s = (0, r.default.createEvent)({
                name: "tick",
                sid: "-cw8a02"
            }), d = (0, r.default.createStore)(!1, {
                name: "$isRunning",
                sid: "-5gspmy"
            }), c = function(e) {
                if (r.default.is.store(e, {
                    sid: "8i2x6t"
                })) return e;
                if ("number" == typeof e) return (0, r.default.createStore)(e, {
                    and: {
                        name: "$timeout"
                    },
                    sid: "-jluixv"
                });
                throw new TypeError(`timeout parameter in interval method should be number or Store. "${typeof e}" was passed`);
            }(e), l = d.map((e)=>!e), f = (0, r.default.createEvent)({
                name: "saveTimeout",
                sid: "satd6r"
            }), m = (0, r.default.createStore)(null, {
                name: "$timeoutId",
                sid: "hehxq7"
            }).on(f, (e, { timeoutId: t })=>t), p = (0, r.default.createStore)(()=>{}, {
                name: "$rejecter",
                sid: "-sc3eh9"
            }).on(f, (e, { reject: t })=>t), g = (0, r.default.attach)({
                and: {
                    source: {
                        timeout: c,
                        running: d
                    },
                    effect: ({ timeout: e, running: t })=>t ? new Promise((t, n)=>{
                            const r = setTimeout(t, e);
                            f({
                                timeoutId: r,
                                reject: n
                            });
                        }) : Promise.reject()
                },
                or: {
                    name: "timeoutFx",
                    sid: "-xlxric"
                }
            }), h = (0, r.default.attach)({
                and: {
                    source: {
                        timeoutId: m,
                        rejecter: p
                    },
                    effect: ({ timeoutId: e, rejecter: t })=>{
                        t(), e && clearTimeout(e);
                    }
                },
                or: {
                    name: "cleanupFx",
                    sid: "-32ewxw"
                }
            });
            if ((0, r.default.guard)({
                and: [
                    {
                        clock: i,
                        source: c,
                        filter: l,
                        target: g
                    }
                ],
                or: {
                    sid: "-us95i7"
                }
            }), o) {
                const e = (0, r.default.guard)({
                    and: [
                        {
                            clock: i,
                            filter: l
                        }
                    ],
                    or: {
                        name: "onReady",
                        sid: "farho0"
                    }
                });
                (0, r.default.sample)({
                    and: [
                        {
                            clock: e,
                            target: s
                        }
                    ],
                    or: {
                        sid: "-ubrbnn"
                    }
                });
            }
            (0, r.default.sample)({
                and: [
                    {
                        clock: i,
                        fn: ()=>!0,
                        target: d
                    }
                ],
                or: {
                    sid: "-ua3xxa"
                }
            }), (0, r.default.guard)({
                and: [
                    {
                        clock: g.done,
                        source: c,
                        filter: d,
                        target: g
                    }
                ],
                or: {
                    sid: "6lcmx8"
                }
            }), (0, r.default.guard)({
                and: [
                    {
                        clock: g.done,
                        filter: d,
                        target: s.prepend(()=>{})
                    }
                ],
                or: {
                    sid: "6p772r"
                }
            }), a && (0, r.default.sample)({
                and: [
                    {
                        clock: u,
                        target: s
                    }
                ],
                or: {
                    sid: "75p0xb"
                }
            });
            return d.on(u, ()=>!1), (0, r.default.sample)({
                and: [
                    {
                        clock: u,
                        target: h
                    }
                ],
                or: {
                    sid: "7ln232"
                }
            }), {
                tick: s,
                isRunning: d,
                "@@trigger": ()=>({
                        setup: i,
                        teardown: u,
                        fired: s
                    })
            };
        };
    }), v = o(function(e, t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.not = function(e) {
            return e.map((e)=>!e);
        };
    }), b = o(function(e, t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.once = function(e) {
            const t = (0, r.default.createStore)(!0, {
                name: "$canTrigger",
                sid: "hqg5e0"
            }), n = (0, r.default.sample)({
                and: [
                    {
                        clock: e,
                        filter: t
                    }
                ],
                or: {
                    name: "trigger",
                    sid: "-cvmmt0"
                }
            });
            return t.on(n, ()=>!1), (0, r.default.sample)({
                and: [
                    {
                        clock: n
                    }
                ],
                or: {
                    sid: "-pw95tp"
                }
            });
        };
    }), w = o(function(e, t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.or = function(...e) {
            return (0, r.default.combine)({
                and: [
                    e,
                    (e)=>{
                        for (const t of e)if (t) return !0;
                        return !1;
                    }
                ],
                or: {
                    sid: "-44722k"
                }
            });
        };
    }), k = o(function(e, t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.pending = function({ effects: e, domain: t, of: o = "some" }) {
            if (!r.default.is.domain(t, {
                sid: "97b92c"
            }) && !e) throw new TypeError("domain or effects should be passed");
            if ("some" !== o && "every" !== o) throw new TypeError(`strategy parameter "of" can be "every" or "some". Passed: "${o}"`);
            let a = null != e ? e : [];
            const i = n[o];
            t && (a = [], t.onCreateEffect((e)=>a.push(e)));
            return (0, r.default.combine)({
                and: [
                    a.map((e)=>e.pending),
                    i
                ],
                or: {
                    sid: "a37bj0"
                }
            });
        };
        const n = {
            some: (e)=>e.some(Boolean),
            every: (e)=>e.every(Boolean)
        };
    }), j = o(function(e, t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.reset = function({ clock: e, target: t }) {
            const n = Array.isArray(t) ? t : [
                t
            ], o = Array.isArray(e) ? e : [
                null != e ? e : (0, r.default.createEvent)({
                    name: "clocks",
                    sid: "bqmea5"
                })
            ];
            return n.forEach((e)=>{
                e.reset(o);
            }), void 0 === e ? o[0] : void 0;
        };
    }), $ = o(function(e, t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.reshape = function({ source: e, shape: t }) {
            const n = {};
            for(const r in t)if (r in t) {
                const o = t[r];
                n[r] = e.map((e)=>{
                    const t = o(e);
                    return void 0 === t ? null : t;
                });
            }
            return n;
        };
    }), _ = o(function(e, t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.snapshot = function({ source: e, clock: t, fn: n = (e)=>e }) {
            const o = n(e.defaultState), a = t ? (0, r.default.sample)({
                and: [
                    {
                        source: e,
                        clock: t,
                        fn: n
                    }
                ],
                or: {
                    name: "onSnapshot",
                    sid: "-imuiws"
                }
            }) : (0, r.default.sample)({
                and: [
                    {
                        source: e,
                        fn: n
                    }
                ],
                or: {
                    name: "onSnapshot",
                    sid: "-imaqbf"
                }
            }), i = (0, r.default.createStore)(o, {
                name: "$snapshot",
                sid: "-63s6pn"
            });
            return i.on(a, (e, t)=>t), i;
        };
    }), E = o(function(e, t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.some = function(e, t) {
            let n, o = [], a = ()=>!1;
            Array.isArray(e) ? (o = e, a = t) : Array.isArray(e.stores) && (o = e.stores, a = e.predicate);
            i = a, n = "function" == typeof i ? a : r.default.is.store(a, {
                sid: "zbwu0l"
            }) ? a.map((e)=>(t)=>e === t) : (e)=>e === a;
            var i;
            const u = (0, r.default.combine)({
                and: [
                    o
                ],
                or: {
                    name: "$values",
                    sid: "-lv5do0"
                }
            }), s = n;
            return (0, r.default.combine)({
                and: [
                    s,
                    u,
                    (e, t)=>t.some(e)
                ],
                or: {
                    sid: "-efc5w7"
                }
            });
        };
    }), P = o(function(e, t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.splitMap = function({ source: e, cases: t }) {
            const n = {};
            let o = r.default.is.store(e, {
                name: "current",
                sid: "-htjkz7"
            }) ? e.updates : e;
            for(const e in t)if (e in t) {
                const r = t[e];
                n[e] = o.filterMap(r), o = o.filter({
                    fn: (e)=>!r(e)
                });
            }
            return n.__ = o, n;
        };
    }), M = o(function(e, t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.spread = function({ targets: e, source: t = (0, r.default.createEvent)({
            name: "source",
            sid: "-fkbi3c"
        }) }) {
            for(const i in e)if (o = e, a = i, n.call(o, a)) {
                const n = e[i], o = (0, r.default.guard)({
                    and: [
                        {
                            source: t,
                            greedy: !0,
                            filter: (e)=>"object" == typeof e && null !== e && i in e
                        }
                    ],
                    or: {
                        name: "hasTargetKey",
                        sid: "-cov4g4"
                    }
                });
                (0, r.default.sample)({
                    and: [
                        {
                            greedy: !0,
                            clock: o,
                            fn: (e)=>e[i],
                            target: n
                        }
                    ],
                    or: {
                        sid: "lpn34j"
                    }
                });
            }
            var o, a;
            return t;
        };
        const n = {}.hasOwnProperty;
    }), S = o(function(e, t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.status = function({ effect: e, defaultValue: t = "initial" }) {
            const n = (0, r.default.createStore)(t, {
                name: "$status",
                sid: "abrgim"
            });
            return n.on(e, ()=>"pending").on(e.done, ()=>"done").on(e.fail, ()=>"fail"), n;
        };
    }), O = o(function(e, t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.throttle = function({ source: e, timeout: t, target: n = (0, r.default.createEvent)({
            name: "target",
            sid: "r328r6"
        }) }) {
            if (!r.default.is.unit(e)) throw new TypeError("source must be unit from effector");
            const o = function(e) {
                if (r.default.is.store(e, {
                    sid: "-h0ap6r"
                })) return e;
                if ("number" == typeof e) {
                    if (e < 0 || !Number.isFinite(e)) throw new Error(`timeout must be positive number or zero. Received: "${e}"`);
                    return (0, r.default.createStore)(e, {
                        and: {
                            name: "$timeout"
                        },
                        sid: "-h97n10"
                    });
                }
                throw new TypeError(`timeout parameter should be number or Store. "${typeof e}" was passed`);
            }(t), a = (0, r.default.createEffect)((e)=>new Promise((t)=>setTimeout(t, e)), {
                name: "timerFx",
                sid: "-pyjx8k"
            }), i = (0, r.default.createStore)(null, {
                and: {
                    serialize: "ignore"
                },
                name: "$payload",
                sid: "hinjft"
            }).on(e, (e, t)=>t), u = (0, r.default.createEvent)({
                name: "triggerTick",
                sid: "-sf8sou"
            }), s = (0, r.default.createStore)(!0, {
                and: {
                    serialize: "ignore"
                },
                name: "$canTick",
                sid: "-m0cqc"
            }).on(u, ()=>!1).on(n, ()=>!0);
            return (0, r.default.guard)({
                and: [
                    {
                        clock: e,
                        filter: s,
                        target: u
                    }
                ],
                or: {
                    sid: "-hzhj9b"
                }
            }), (0, r.default.sample)({
                and: [
                    {
                        source: o,
                        clock: u,
                        target: a
                    }
                ],
                or: {
                    sid: "-hkn38k"
                }
            }), (0, r.default.sample)({
                and: [
                    {
                        source: i,
                        clock: a.done,
                        target: n
                    }
                ],
                or: {
                    sid: "-hhcboe"
                }
            }), n;
        };
    }), T = o(function(e, t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.time = function({ clock: e, getNow: t, initial: o }) {
            const a = null != t ? t : n, i = (0, r.default.createEffect)(a, {
                name: "readNowFx",
                sid: "53d7kp"
            }), u = (0, r.default.restore)(i, null != o ? o : a(), {
                name: "$time",
                sid: "-xu6mk0"
            });
            return (0, r.default.forward)({
                and: {
                    from: e,
                    to: i
                },
                or: {
                    sid: "remzgl"
                }
            }), u;
        };
        const n = ()=>Date.now();
    }), x = a.and, q = i.combineEvents, z = u.condition, A = s.debounce, F = d.debug, N = c.delay, I = l.either, D = f.empty, C = m.equals, R = p.every, B = g.format, K = h.inFlight, V = y.interval, G = v.not, H = b.once, J = w.or, L = k.pending, Q = j.reset, U = $.reshape, W = _.snapshot, X = E.some, Y = P.splitMap, Z = M.spread, ee = S.status, te = O.throttle, ne = T.time, re = {
        and: x,
        combineEvents: q,
        condition: z,
        debounce: A,
        debug: F,
        delay: N,
        either: I,
        empty: D,
        equals: C,
        every: R,
        format: B,
        inFlight: K,
        interval: V,
        not: G,
        once: H,
        or: J,
        pending: L,
        reset: Q,
        reshape: U,
        snapshot: W,
        some: X,
        splitMap: Y,
        spread: Z,
        status: ee,
        throttle: te,
        time: ne
    };
    e.and = x, e.combineEvents = q, e.condition = z, e.debounce = A, e.debug = F, e.default = re, e.delay = N, e.either = I, e.empty = D, e.equals = C, e.every = R, e.format = B, e.inFlight = K, e.interval = V, e.not = G, e.once = H, e.or = J, e.pending = L, e.reset = Q, e.reshape = U, e.snapshot = W, e.some = X, e.splitMap = Y, e.spread = Z, e.status = ee, e.throttle = te, e.time = ne, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});


const $56844779f94b1f26$export$eae70af4b4e3f197 = ({ text: text, options: options, selectedOptions: selectedOptions, optionChecked: optionChecked, optionUnchecked: optionUnchecked })=>{
    const dropdownTriggered = (0, $agnkb.createEvent)();
    const $localVisible = (0, $agnkb.createStore)(false);
    const outsideClicked = (0, $agnkb.createEvent)();
    (0, $agnkb.sample)({
        source: $localVisible,
        clock: dropdownTriggered,
        fn: (v)=>!v,
        target: $localVisible
    });
    (0, $agnkb.sample)({
        source: $localVisible,
        clock: outsideClicked,
        filter: (visible, { node: node, event: event })=>!node.contains(event.target) && visible,
        fn: ()=>false,
        target: $localVisible
    });
    const localSelectedOptions = selectedOptions || (0, $agnkb.createStore)([]);
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "relative",
                "mb-6"
            ]
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("label", {
            classList: [
                "block",
                "mb-2",
                "text-sm",
                "font-medium",
                "text-gray-900",
                "dark:text-white"
            ],
            text: text
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("input", ()=>{
            const selectedText = (0, $agnkb.combine)(options, localSelectedOptions, (opts, selectedOpts)=>{
                if (!selectedOpts || selectedOpts.length === 0) return "Click to select tags";
                return opts.filter((o)=>selectedOpts?.includes(o.id)).map((o)=>o.name).join(", ");
            });
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "cursor-default",
                    "bg-gray-50",
                    "border",
                    "border-gray-300",
                    "text-gray-900",
                    "text-sm",
                    "rounded-lg",
                    "focus:outline",
                    "outline-1",
                    "focus:ring-blue-500",
                    "focus:border-blue-500",
                    "block",
                    "w-full",
                    "p-2.5",
                    "dark:bg-gray-700",
                    "dark:border-gray-600",
                    "dark:placeholder-gray-400",
                    "dark:text-white",
                    "dark:focus:ring-blue-500",
                    "dark:focus:border-blue-500",
                    "cursor-pointer"
                ],
                attr: {
                    readonly: true,
                    type: "select",
                    value: selectedText
                },
                handler: {
                    on: {
                        click: dropdownTriggered
                    }
                }
            });
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                visible: $localVisible,
                classList: [
                    "max-h-56",
                    "overflow-scroll",
                    "left-0",
                    "absolute",
                    "left-0",
                    "top-18",
                    "w-fit",
                    "border",
                    "border-gray-200",
                    "dark:bg-gray-800",
                    "dark:border-gray-700",
                    "z-50",
                    "bg-white",
                    "divide-y",
                    "divide-gray-100",
                    "rounded-lg",
                    "shadow",
                    "dark:bg-gray-700",
                    "dark:divide-gray-600",
                    "shadow-2xl"
                ]
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("ul", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "flex",
                        "flex-col",
                        "flex-wrap",
                        "text-gray-700",
                        "dark:text-gray-200"
                    ]
                });
                (0, $133989e677847899$export$8837f4fc672e936d)(options, ({ store: option })=>{
                    (0, $133989e677847899$export$dda1d9f60106f0e9)("li", ()=>{
                        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                            classList: [
                                "hover:bg-gray-100",
                                "dark:hover:bg-gray-600",
                                "flex",
                                "border-gray-300",
                                "dark:border-gray-700",
                                "items-center",
                                "px-5",
                                "flex-auto",
                                "shrink-0"
                            ]
                        });
                        const localOptionSelected = (0, $agnkb.createEvent)();
                        const localChecked = (0, $agnkb.createEvent)();
                        (0, $agnkb.sample)({
                            source: option,
                            clock: localChecked,
                            fn: (option)=>option.id,
                            target: optionChecked
                        });
                        const localUnchecked = (0, $agnkb.createEvent)();
                        (0, $agnkb.sample)({
                            source: option,
                            clock: localUnchecked,
                            fn: (option)=>option.id,
                            target: optionUnchecked
                        });
                        (0, $8cde029bb678322e$exports.condition)({
                            source: localOptionSelected,
                            if: (event)=>event.target.checked,
                            then: localChecked,
                            else: localUnchecked
                        });
                        (0, $133989e677847899$export$dda1d9f60106f0e9)("input", ()=>{
                            const selected = (0, $agnkb.combine)(option, localSelectedOptions, (opt, selectedOpts)=>{
                                if (!selectedOpts) return false;
                                return selectedOpts.includes(opt.id);
                            });
                            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                                classList: [
                                    "bg-gray-50",
                                    "border-gray-300",
                                    "text-gray-900",
                                    "rounded-lg",
                                    "focus:ring-blue-500",
                                    "focus:border-blue-500",
                                    "block",
                                    "w-4",
                                    "h-4",
                                    "p-2.5",
                                    "dark:bg-gray-700",
                                    "dark:border-gray-600",
                                    "dark:placeholder-gray-400",
                                    "dark:text-white",
                                    "dark:focus:ring-blue-500",
                                    "dark:focus:border-blue-500",
                                    "cursor-pointer"
                                ],
                                attr: {
                                    type: "checkbox",
                                    id: (0, $133989e677847899$export$aee1dbae5de2db9d)(option, "id"),
                                    checked: selected
                                },
                                handler: {
                                    on: {
                                        change: localOptionSelected
                                    }
                                }
                            });
                        });
                        (0, $133989e677847899$export$dda1d9f60106f0e9)("label", {
                            classList: [
                                "block",
                                "ml-3",
                                "w-full",
                                "text-sm",
                                "font-medium",
                                "py-2.5",
                                "text-gray-900",
                                "dark:text-white",
                                "cursor-pointer"
                            ],
                            text: (0, $133989e677847899$export$aee1dbae5de2db9d)(option, "name"),
                            attr: {
                                for: (0, $133989e677847899$export$aee1dbae5de2db9d)(option, "id")
                            }
                        });
                    });
                });
            });
        });
        (0, $133989e677847899$export$35059013cd4a06db)((node)=>{
            document.addEventListener("click", (event)=>{
                outsideClicked({
                    node: node,
                    event: event
                });
            });
        });
    });
};







var $agnkb = parcelRequire("agnkb");
function $5bf12b132222dee5$export$2e2bcd8739ae039() {
    $5bf12b132222dee5$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5bf12b132222dee5$export$2e2bcd8739ae039.apply(this, arguments);
}


/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */ var $4fde2844f3d388bb$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($4fde2844f3d388bb$export$e19cd5f9376f8cee || ($4fde2844f3d388bb$export$e19cd5f9376f8cee = {}));
var $4fde2844f3d388bb$var$readOnly = function(obj) {
    return obj;
};
function $4fde2844f3d388bb$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
var $4fde2844f3d388bb$var$BeforeUnloadEventType = "beforeunload";
var $4fde2844f3d388bb$var$HashChangeEventType = "hashchange";
var $4fde2844f3d388bb$var$PopStateEventType = "popstate";
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $4fde2844f3d388bb$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    var _options = options, _options$window = _options.window, window = _options$window === void 0 ? document.defaultView : _options$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $4fde2844f3d388bb$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || "default"
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $4fde2844f3d388bb$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation = getIndexAndLocation(), nextIndex = _getIndexAndLocation[0], nextLocation = _getIndexAndLocation[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($4fde2844f3d388bb$var$PopStateEventType, handlePop);
    var action = $4fde2844f3d388bb$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation2 = getIndexAndLocation(), index = _getIndexAndLocation2[0], location = _getIndexAndLocation2[1];
    var listeners = $4fde2844f3d388bb$var$createEvents();
    var blockers = $4fde2844f3d388bb$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $5bf12b132222dee5$export$2e2bcd8739ae039)({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function createHref(to) {
        return typeof to === "string" ? to : $4fde2844f3d388bb$export$fe53371bee54353d(to);
    } // state defaults to `null` because `window.history.state` does
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $4fde2844f3d388bb$var$readOnly((0, $5bf12b132222dee5$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            hash: "",
            search: ""
        }, typeof to === "string" ? $4fde2844f3d388bb$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $4fde2844f3d388bb$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation3 = getIndexAndLocation();
        index = _getIndexAndLocation3[0];
        location = _getIndexAndLocation3[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $4fde2844f3d388bb$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr[0], url = _getHistoryStateAndUr[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, "", url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $4fde2844f3d388bb$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr2[0], url = _getHistoryStateAndUr2[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, "", url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($4fde2844f3d388bb$var$BeforeUnloadEventType, $4fde2844f3d388bb$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($4fde2844f3d388bb$var$BeforeUnloadEventType, $4fde2844f3d388bb$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $4fde2844f3d388bb$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    var _options2 = options, _options2$window = _options2.window, window = _options2$window === void 0 ? document.defaultView : _options2$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _parsePath = $4fde2844f3d388bb$export$8ccf933b0513f8d0(window.location.hash.substr(1)), _parsePath$pathname = _parsePath.pathname, pathname = _parsePath$pathname === void 0 ? "/" : _parsePath$pathname, _parsePath$search = _parsePath.search, search = _parsePath$search === void 0 ? "" : _parsePath$search, _parsePath$hash = _parsePath.hash, hash = _parsePath$hash === void 0 ? "" : _parsePath$hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $4fde2844f3d388bb$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || "default"
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $4fde2844f3d388bb$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation4 = getIndexAndLocation(), nextIndex = _getIndexAndLocation4[0], nextLocation = _getIndexAndLocation4[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($4fde2844f3d388bb$var$PopStateEventType, handlePop); // popstate does not fire on hashchange in IE 11 and old (trident) Edge
    // https://developer.mozilla.org/de/docs/Web/API/Window/popstate_event
    window.addEventListener($4fde2844f3d388bb$var$HashChangeEventType, function() {
        var _getIndexAndLocation5 = getIndexAndLocation(), nextLocation = _getIndexAndLocation5[1]; // Ignore extraneous hashchange events.
        if ($4fde2844f3d388bb$export$fe53371bee54353d(nextLocation) !== $4fde2844f3d388bb$export$fe53371bee54353d(location)) handlePop();
    });
    var action = $4fde2844f3d388bb$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation6 = getIndexAndLocation(), index = _getIndexAndLocation6[0], location = _getIndexAndLocation6[1];
    var listeners = $4fde2844f3d388bb$var$createEvents();
    var blockers = $4fde2844f3d388bb$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $5bf12b132222dee5$export$2e2bcd8739ae039)({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getBaseHref() {
        var base = document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href;
    }
    function createHref(to) {
        return getBaseHref() + "#" + (typeof to === "string" ? to : $4fde2844f3d388bb$export$fe53371bee54353d(to));
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $4fde2844f3d388bb$var$readOnly((0, $5bf12b132222dee5$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            hash: "",
            search: ""
        }, typeof to === "string" ? $4fde2844f3d388bb$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $4fde2844f3d388bb$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation7 = getIndexAndLocation();
        index = _getIndexAndLocation7[0];
        location = _getIndexAndLocation7[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $4fde2844f3d388bb$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr3 = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr3[0], url = _getHistoryStateAndUr3[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, "", url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $4fde2844f3d388bb$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr4 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr4[0], url = _getHistoryStateAndUr4[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, "", url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($4fde2844f3d388bb$var$BeforeUnloadEventType, $4fde2844f3d388bb$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($4fde2844f3d388bb$var$BeforeUnloadEventType, $4fde2844f3d388bb$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#creatememoryhistory
 */ function $4fde2844f3d388bb$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options3 = options, _options3$initialEntr = _options3.initialEntries, initialEntries = _options3$initialEntr === void 0 ? [
        "/"
    ] : _options3$initialEntr, initialIndex = _options3.initialIndex;
    var entries = initialEntries.map(function(entry) {
        var location = $4fde2844f3d388bb$var$readOnly((0, $5bf12b132222dee5$export$2e2bcd8739ae039)({
            pathname: "/",
            search: "",
            hash: "",
            state: null,
            key: $4fde2844f3d388bb$var$createKey()
        }, typeof entry === "string" ? $4fde2844f3d388bb$export$8ccf933b0513f8d0(entry) : entry));
        return location;
    });
    var index = $4fde2844f3d388bb$var$clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
    var action = $4fde2844f3d388bb$export$e19cd5f9376f8cee.Pop;
    var location = entries[index];
    var listeners = $4fde2844f3d388bb$var$createEvents();
    var blockers = $4fde2844f3d388bb$var$createEvents();
    function createHref(to) {
        return typeof to === "string" ? to : $4fde2844f3d388bb$export$fe53371bee54353d(to);
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $4fde2844f3d388bb$var$readOnly((0, $5bf12b132222dee5$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            search: "",
            hash: ""
        }, typeof to === "string" ? $4fde2844f3d388bb$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $4fde2844f3d388bb$var$createKey()
        }));
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction, nextLocation) {
        action = nextAction;
        location = nextLocation;
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $4fde2844f3d388bb$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            applyTx(nextAction, nextLocation);
        }
    }
    function replace(to, state) {
        var nextAction = $4fde2844f3d388bb$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            entries[index] = nextLocation;
            applyTx(nextAction, nextLocation);
        }
    }
    function go(delta) {
        var nextIndex = $4fde2844f3d388bb$var$clamp(index + delta, 0, entries.length - 1);
        var nextAction = $4fde2844f3d388bb$export$e19cd5f9376f8cee.Pop;
        var nextLocation = entries[nextIndex];
        function retry() {
            go(delta);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index = nextIndex;
            applyTx(nextAction, nextLocation);
        }
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            return blockers.push(blocker);
        }
    };
    return history;
} ////////////////////////////////////////////////////////////////////////////////
// UTILS
////////////////////////////////////////////////////////////////////////////////
function $4fde2844f3d388bb$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
function $4fde2844f3d388bb$var$promptBeforeUnload(event) {
    // Cancel the event.
    event.preventDefault(); // Chrome (and legacy IE) requires returnValue to be set.
    event.returnValue = "";
}
function $4fde2844f3d388bb$var$createEvents() {
    var handlers = [];
    return {
        get length () {
            return handlers.length;
        },
        push: function push(fn) {
            handlers.push(fn);
            return function() {
                handlers = handlers.filter(function(handler) {
                    return handler !== fn;
                });
            };
        },
        call: function call(arg) {
            handlers.forEach(function(fn) {
                return fn && fn(arg);
            });
        }
    };
}
function $4fde2844f3d388bb$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createpath
 */ function $4fde2844f3d388bb$export$fe53371bee54353d(_ref) {
    var _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? "/" : _ref$pathname, _ref$search = _ref.search, search = _ref$search === void 0 ? "" : _ref$search, _ref$hash = _ref.hash, hash = _ref$hash === void 0 ? "" : _ref$hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#parsepath
 */ function $4fde2844f3d388bb$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}



const $99a5bbd2d001ca47$export$a6c7ac8248d6e38a = (0, $ad1d53f18b004f8e$export$cdda5b1be25f9499)();
const $99a5bbd2d001ca47$export$798bfdbebc5ea68e = (0, $e13fe69fd88e859a$export$544c268deaca2597)();
const $99a5bbd2d001ca47$export$7adfc20e44871f54 = (0, $e13fe69fd88e859a$export$544c268deaca2597)();
const $99a5bbd2d001ca47$export$8e0dc54c469007d0 = (0, $e13fe69fd88e859a$export$544c268deaca2597)();
const $99a5bbd2d001ca47$export$4dc84672b833126 = (0, $e13fe69fd88e859a$export$544c268deaca2597)();
const $99a5bbd2d001ca47$export$c344a3deb8f83e2f = (0, $e13fe69fd88e859a$export$544c268deaca2597)();
const $99a5bbd2d001ca47$export$80d23b9cca383549 = (0, $e13fe69fd88e859a$export$544c268deaca2597)();
const $99a5bbd2d001ca47$export$7b0e65fd5f03ad04 = (0, $e13fe69fd88e859a$export$544c268deaca2597)();
const $99a5bbd2d001ca47$export$b19c7415af7c6beb = (0, $e13fe69fd88e859a$export$544c268deaca2597)();
const $99a5bbd2d001ca47$export$74bc9c86497b4ac6 = (0, $e13fe69fd88e859a$export$544c268deaca2597)();
const $99a5bbd2d001ca47$export$89b5ccf9a225519 = (0, $e13fe69fd88e859a$export$544c268deaca2597)();
const $99a5bbd2d001ca47$export$9ceadcfb9eb7b7f2 = (0, $e13fe69fd88e859a$export$544c268deaca2597)();
const $99a5bbd2d001ca47$export$7219f3a18e5a89f7 = (0, $e13fe69fd88e859a$export$544c268deaca2597)();
const $99a5bbd2d001ca47$export$102e5ceef0d527c1 = (0, $e13fe69fd88e859a$export$544c268deaca2597)();
const $99a5bbd2d001ca47$export$14fdbf877e70314a = (0, $e13fe69fd88e859a$export$544c268deaca2597)();
const $99a5bbd2d001ca47$export$a945d1f11027dc7d = (0, $e13fe69fd88e859a$export$544c268deaca2597)();
const $99a5bbd2d001ca47$export$dabbba65ed76796e = (0, $e13fe69fd88e859a$export$544c268deaca2597)();
const $99a5bbd2d001ca47$export$773ade5e3261acbd = (0, $e13fe69fd88e859a$export$544c268deaca2597)();
const $99a5bbd2d001ca47$export$600fa41b9ffe82c7 = (0, $e13fe69fd88e859a$export$544c268deaca2597)();
const $99a5bbd2d001ca47$export$21c91e254ab993b9 = (0, $e13fe69fd88e859a$export$544c268deaca2597)();
const $99a5bbd2d001ca47$export$cd891b82501bb412 = [
    {
        path: "/login",
        route: $99a5bbd2d001ca47$export$798bfdbebc5ea68e
    },
    {
        path: "/register",
        route: $99a5bbd2d001ca47$export$7adfc20e44871f54
    },
    {
        path: "/forbidden",
        route: $99a5bbd2d001ca47$export$8e0dc54c469007d0
    },
    {
        path: "/not_found",
        route: $99a5bbd2d001ca47$export$4dc84672b833126
    },
    {
        path: "/profile",
        route: $99a5bbd2d001ca47$export$80d23b9cca383549
    },
    {
        path: "/",
        route: $99a5bbd2d001ca47$export$c344a3deb8f83e2f
    },
    {
        path: "/schemas/create",
        route: $99a5bbd2d001ca47$export$7219f3a18e5a89f7
    },
    {
        path: "/schemas/:id/edit",
        route: $99a5bbd2d001ca47$export$102e5ceef0d527c1
    },
    {
        path: "/logs/:schemaName",
        route: $99a5bbd2d001ca47$export$7b0e65fd5f03ad04
    },
    {
        path: "/logs/:schemaName/:hash",
        route: $99a5bbd2d001ca47$export$b19c7415af7c6beb
    },
    {
        path: "/members",
        route: $99a5bbd2d001ca47$export$74bc9c86497b4ac6
    },
    {
        path: "/members/create",
        route: $99a5bbd2d001ca47$export$89b5ccf9a225519
    },
    {
        path: "/members/:id/edit",
        route: $99a5bbd2d001ca47$export$9ceadcfb9eb7b7f2
    },
    {
        path: "/api_tokens",
        route: $99a5bbd2d001ca47$export$14fdbf877e70314a
    },
    {
        path: "/api_tokens/create",
        route: $99a5bbd2d001ca47$export$a945d1f11027dc7d
    },
    {
        path: "/api_tokens/:id/edit",
        route: $99a5bbd2d001ca47$export$dabbba65ed76796e
    },
    {
        path: "/tags",
        route: $99a5bbd2d001ca47$export$773ade5e3261acbd
    },
    {
        path: "/tags/create",
        route: $99a5bbd2d001ca47$export$600fa41b9ffe82c7
    },
    {
        path: "/tags/:id/edit",
        route: $99a5bbd2d001ca47$export$21c91e254ab993b9
    }
];
const $99a5bbd2d001ca47$var$history = (0, $4fde2844f3d388bb$export$719fc203c4e16dee)();
const $99a5bbd2d001ca47$export$cc1adf6fb659c762 = (0, $e13fe69fd88e859a$export$5f30bfe6ad37bbb0)();
const $99a5bbd2d001ca47$export$5375cda95f0b0eb4 = (0, $e13fe69fd88e859a$export$dbd150cc4bdc656b)({
    routes: $99a5bbd2d001ca47$export$cd891b82501bb412,
    controls: $99a5bbd2d001ca47$export$cc1adf6fb659c762
});
const $99a5bbd2d001ca47$export$f4259f350ec92f0b = (0, $agnkb.createEvent)();
(0, $agnkb.sample)({
    clock: $99a5bbd2d001ca47$export$5375cda95f0b0eb4.routeNotFound,
    target: (0, $282d3c07b97d7068$export$18d0aa8b957caef4)
});
// Attach history for the router on the app start
(0, $agnkb.sample)({
    clock: $99a5bbd2d001ca47$export$f4259f350ec92f0b,
    fn: ()=>$99a5bbd2d001ca47$var$history,
    target: $99a5bbd2d001ca47$export$5375cda95f0b0eb4.setHistory
});
// Add router into the Link instance to easily resolve routes paths
(0, $ad1d53f18b004f8e$export$a92cb4e662b6b4b2)({
    clock: $99a5bbd2d001ca47$export$f4259f350ec92f0b,
    router: $99a5bbd2d001ca47$export$5375cda95f0b0eb4,
    Link: $99a5bbd2d001ca47$export$a6c7ac8248d6e38a
});
(0, $agnkb.sample)({
    clock: $99a5bbd2d001ca47$export$f4259f350ec92f0b,
    target: (0, $282d3c07b97d7068$export$e42464f64b0bde8c)
});
(0, $agnkb.sample)({
    clock: $99a5bbd2d001ca47$export$f4259f350ec92f0b,
    target: (0, $d461744a27a10557$exports).effects.loadThemeFromStorageFx
});
const $99a5bbd2d001ca47$export$43ca6af8ac2c217e = (route)=>{
    const sessionCheckStarted = (0, $agnkb.createEvent)();
    const alreadyAuthorized = (0, $agnkb.sample)({
        clock: sessionCheckStarted,
        filter: (0, $282d3c07b97d7068$export$456a1449be803865)
    });
    (0, $agnkb.sample)({
        source: (0, $282d3c07b97d7068$export$456a1449be803865),
        clock: sessionCheckStarted,
        filter: (isAuthorized)=>!isAuthorized,
        target: (0, $282d3c07b97d7068$export$e42464f64b0bde8c)
    });
    (0, $agnkb.sample)({
        source: (0, $282d3c07b97d7068$export$b6537f11d186f6b6).doneData,
        filter: (sessionResponse)=>(!sessionResponse?.data?.token || !sessionResponse.success) && !sessionResponse.data.should_create_initial_admin,
        target: (0, $282d3c07b97d7068$export$d8ff71519acdd706)
    });
    return (0, $e13fe69fd88e859a$export$cdba908a7d0612af)({
        route: route,
        beforeOpen: sessionCheckStarted,
        openOn: [
            alreadyAuthorized,
            (0, $282d3c07b97d7068$export$c20bb6a46350d592)
        ]
    });
};
const $99a5bbd2d001ca47$export$274a9e080274304d = (role, route, fallback)=>{
    const checkRoleStarted = (0, $agnkb.createEvent)();
    const succeed = (0, $agnkb.createEvent)();
    const failed = (0, $agnkb.createEvent)();
    (0, $8cde029bb678322e$exports.condition)({
        source: (0, $agnkb.sample)({
            clock: checkRoleStarted,
            source: (0, $d461744a27a10557$exports).$currentAccount,
            fn: (user)=>user.role === role
        }),
        if: Boolean,
        then: succeed,
        else: failed
    });
    (0, $e13fe69fd88e859a$export$89e12c5b50f7529d)({
        clock: failed,
        route: fallback || $99a5bbd2d001ca47$export$c344a3deb8f83e2f
    });
    return (0, $e13fe69fd88e859a$export$cdba908a7d0612af)({
        route: route,
        beforeOpen: checkRoleStarted,
        openOn: succeed,
        cancelOn: failed
    });
};
(0, $agnkb.sample)({
    clock: $99a5bbd2d001ca47$export$5375cda95f0b0eb4.$path,
    target: (0, $9bc96fedc1402115$export$c4306c1cb71b8196)
});



const $68473ef2ef43bd57$export$eebd315af76f7497 = ({ title: title, description: description, name: name })=>{
    (0, $580628c81deb6a79$export$94b4c87f5c7de894)({
        title: title,
        description: description,
        route: (0, $99a5bbd2d001ca47$export$7b0e65fd5f03ad04),
        params: {
            schemaName: name
        }
    });
};


var $8aa4cde03a0e26f5$exports = {};

$parcel$export($8aa4cde03a0e26f5$exports, "$schemas", function () { return $8aa4cde03a0e26f5$export$41e5fd7206ebdf5a; });
$parcel$export($8aa4cde03a0e26f5$exports, "$currentSchema", function () { return $8aa4cde03a0e26f5$export$df48da447676e586; });
$parcel$export($8aa4cde03a0e26f5$exports, "effects", function () { return $8aa4cde03a0e26f5$export$fb4689499fb20c56; });


var $agnkb = parcelRequire("agnkb");
const $8aa4cde03a0e26f5$var$getSchemasFx = (0, $agnkb.createEffect)(()=>{
    return (0, $e0105e1f51ddac9f$export$2ea2899b54bd4140)();
});
const $8aa4cde03a0e26f5$var$getSchemaFx = (0, $agnkb.createEffect)((id)=>{
    return (0, $e0105e1f51ddac9f$export$19a621270f26273c)(id);
});
const $8aa4cde03a0e26f5$var$querySchemasFx = (0, $agnkb.createEffect)((query)=>{
    return (0, $e0105e1f51ddac9f$export$1671f9161fc49fec)(query);
});
const $8aa4cde03a0e26f5$export$41e5fd7206ebdf5a = (0, $agnkb.createStore)([]).on($8aa4cde03a0e26f5$var$getSchemasFx.doneData, (_, schemasResponse)=>schemasResponse.data).on($8aa4cde03a0e26f5$var$querySchemasFx.doneData, (_, schemasResponse)=>schemasResponse.data);
const $8aa4cde03a0e26f5$export$df48da447676e586 = (0, $agnkb.createStore)({
    id: 0,
    title: "",
    description: "",
    name: "",
    fields: [],
    kinds: [],
    tag_id: null
}).on($8aa4cde03a0e26f5$var$getSchemaFx.doneData, (_, schemaResponse)=>schemaResponse.data);
const $8aa4cde03a0e26f5$export$fb4689499fb20c56 = {
    getSchemasFx: $8aa4cde03a0e26f5$var$getSchemasFx,
    getSchemaFx: $8aa4cde03a0e26f5$var$getSchemaFx,
    querySchemasFx: $8aa4cde03a0e26f5$var$querySchemasFx
};







var $agnkb = parcelRequire("agnkb");

(0, $agnkb.sample)({
    clock: (0, $99a5bbd2d001ca47$export$7b0e65fd5f03ad04).closed,
    target: (0, $b047cb928fb2fbfa$exports).effects.reset
});
(0, $e13fe69fd88e859a$export$cdba908a7d0612af)({
    route: (0, $99a5bbd2d001ca47$export$43ca6af8ac2c217e)((0, $99a5bbd2d001ca47$export$7b0e65fd5f03ad04)),
    beforeOpen: {
        effect: (0, $b047cb928fb2fbfa$exports).effects.queryLogsFx,
        mapParams: (route)=>({
                schema_name: route.params.schemaName,
                text: route.query.q,
                query: route.query.f,
                kind: route.query.k,
                level: route.query.l,
                from: route.query.from,
                to: route.query.to,
                page: route.query.p
            })
    }
});
(0, $e13fe69fd88e859a$export$cdba908a7d0612af)({
    route: (0, $99a5bbd2d001ca47$export$43ca6af8ac2c217e)((0, $99a5bbd2d001ca47$export$7b0e65fd5f03ad04)),
    beforeOpen: {
        effect: (0, $8aa4cde03a0e26f5$exports).effects.getSchemasFx,
        mapParams: ()=>({})
    }
});
(0, $e13fe69fd88e859a$export$cdba908a7d0612af)({
    route: (0, $99a5bbd2d001ca47$export$43ca6af8ac2c217e)((0, $99a5bbd2d001ca47$export$b19c7415af7c6beb)),
    beforeOpen: {
        effect: (0, $8aa4cde03a0e26f5$exports).effects.getSchemasFx,
        mapParams: ()=>({})
    }
});
(0, $e13fe69fd88e859a$export$cdba908a7d0612af)({
    route: (0, $99a5bbd2d001ca47$export$43ca6af8ac2c217e)((0, $99a5bbd2d001ca47$export$b19c7415af7c6beb)),
    beforeOpen: {
        effect: (0, $b047cb928fb2fbfa$exports).effects.getLogGroupFx,
        mapParams: (route)=>({
                schema_name: route.params.schemaName,
                hash: route.params.hash
            })
    }
});
(0, $e13fe69fd88e859a$export$664131e403871764)({
    source: {
        q: (0, $b047cb928fb2fbfa$exports).$searchQuery,
        f: (0, $b047cb928fb2fbfa$exports).$formattedSearchFilter,
        k: (0, $b047cb928fb2fbfa$exports).$currentKind,
        l: (0, $b047cb928fb2fbfa$exports).$currentLevel,
        from: (0, $b047cb928fb2fbfa$exports).$currentFromTime,
        to: (0, $b047cb928fb2fbfa$exports).$currentToTime,
        p: (0, $b047cb928fb2fbfa$exports).$currentPage
    },
    clock: (0, $8cde029bb678322e$exports.debounce)({
        source: (0, $agnkb.combine)((0, $b047cb928fb2fbfa$exports).$searchQuery, (0, $b047cb928fb2fbfa$exports).$formattedSearchFilter, (0, $b047cb928fb2fbfa$exports).$currentKind, (0, $b047cb928fb2fbfa$exports).$currentLevel, (0, $b047cb928fb2fbfa$exports).$currentFromTime, (0, $b047cb928fb2fbfa$exports).$currentToTime, (0, $b047cb928fb2fbfa$exports).$currentPage),
        timeout: 200
    }),
    route: (0, $99a5bbd2d001ca47$export$7b0e65fd5f03ad04),
    controls: (0, $99a5bbd2d001ca47$export$cc1adf6fb659c762)
});





var $d38a3a161a7d1109$exports = {};

$parcel$export($d38a3a161a7d1109$exports, "$tags", function () { return $d38a3a161a7d1109$export$e4133d5f33a10862; });
$parcel$export($d38a3a161a7d1109$exports, "$currentTag", function () { return $d38a3a161a7d1109$export$e27fbee6dbd3d2f4; });
$parcel$export($d38a3a161a7d1109$exports, "effects", function () { return $d38a3a161a7d1109$export$fb4689499fb20c56; });
$parcel$export($d38a3a161a7d1109$exports, "events", function () { return $d38a3a161a7d1109$export$4bf9923669ad6c63; });


var $agnkb = parcelRequire("agnkb");
const $d38a3a161a7d1109$var$getTagsFx = (0, $agnkb.createEffect)(()=>{
    return (0, $52b80dee660e935b$export$af63d7414243dad3)();
});
const $d38a3a161a7d1109$var$getTagFx = (0, $agnkb.createEffect)((id)=>{
    return (0, $52b80dee660e935b$export$dad497fe1f6e27c0)(id);
});
const $d38a3a161a7d1109$export$e4133d5f33a10862 = (0, $agnkb.createStore)([]).on($d38a3a161a7d1109$var$getTagsFx.doneData, (_, tagsResponse)=>tagsResponse.data);
const $d38a3a161a7d1109$export$e27fbee6dbd3d2f4 = (0, $agnkb.createStore)({
    id: 0,
    name: ""
}).on($d38a3a161a7d1109$var$getTagFx.doneData, (_, tagResponse)=>tagResponse.data);
const $d38a3a161a7d1109$export$fb4689499fb20c56 = {
    getTagsFx: $d38a3a161a7d1109$var$getTagsFx,
    getTagFx: $d38a3a161a7d1109$var$getTagFx
};
const $d38a3a161a7d1109$export$4bf9923669ad6c63 = {};




(0, $e13fe69fd88e859a$export$cdba908a7d0612af)({
    route: (0, $99a5bbd2d001ca47$export$43ca6af8ac2c217e)((0, $99a5bbd2d001ca47$export$c344a3deb8f83e2f)),
    beforeOpen: {
        effect: (0, $8aa4cde03a0e26f5$exports).effects.getSchemasFx,
        mapParams: ()=>({})
    }
});
(0, $e13fe69fd88e859a$export$cdba908a7d0612af)({
    route: (0, $99a5bbd2d001ca47$export$274a9e080274304d)("Admin", (0, $99a5bbd2d001ca47$export$43ca6af8ac2c217e)((0, $99a5bbd2d001ca47$export$7219f3a18e5a89f7))),
    beforeOpen: {
        effect: (0, $d38a3a161a7d1109$exports).effects.getTagsFx,
        mapParams: ()=>({})
    }
});
(0, $e13fe69fd88e859a$export$cdba908a7d0612af)({
    route: (0, $99a5bbd2d001ca47$export$274a9e080274304d)("Admin", (0, $99a5bbd2d001ca47$export$43ca6af8ac2c217e)((0, $99a5bbd2d001ca47$export$102e5ceef0d527c1))),
    beforeOpen: {
        effect: (0, $8aa4cde03a0e26f5$exports).effects.getSchemaFx,
        mapParams: ({ params: params })=>params.id
    }
});
(0, $e13fe69fd88e859a$export$cdba908a7d0612af)({
    route: (0, $99a5bbd2d001ca47$export$274a9e080274304d)("Admin", (0, $99a5bbd2d001ca47$export$43ca6af8ac2c217e)((0, $99a5bbd2d001ca47$export$102e5ceef0d527c1))),
    beforeOpen: {
        effect: (0, $d38a3a161a7d1109$exports).effects.getTagsFx,
        mapParams: ({ params: params })=>params.id
    }
});






(0, $e13fe69fd88e859a$export$cdba908a7d0612af)({
    route: (0, $99a5bbd2d001ca47$export$274a9e080274304d)("Admin", (0, $99a5bbd2d001ca47$export$43ca6af8ac2c217e)((0, $99a5bbd2d001ca47$export$74bc9c86497b4ac6))),
    beforeOpen: {
        effect: (0, $d461744a27a10557$exports).effects.getUsersFx,
        mapParams: ({ params: params })=>params
    }
});
(0, $e13fe69fd88e859a$export$cdba908a7d0612af)({
    route: (0, $99a5bbd2d001ca47$export$274a9e080274304d)("Admin", (0, $99a5bbd2d001ca47$export$43ca6af8ac2c217e)((0, $99a5bbd2d001ca47$export$89b5ccf9a225519))),
    beforeOpen: {
        effect: (0, $d38a3a161a7d1109$exports).effects.getTagsFx,
        mapParams: ()=>({})
    }
});
(0, $e13fe69fd88e859a$export$cdba908a7d0612af)({
    route: (0, $99a5bbd2d001ca47$export$274a9e080274304d)("Admin", (0, $99a5bbd2d001ca47$export$43ca6af8ac2c217e)((0, $99a5bbd2d001ca47$export$9ceadcfb9eb7b7f2))),
    beforeOpen: {
        effect: (0, $d461744a27a10557$exports).effects.getUserFx,
        mapParams: ({ params: params })=>params.id
    }
});
(0, $e13fe69fd88e859a$export$cdba908a7d0612af)({
    route: (0, $99a5bbd2d001ca47$export$274a9e080274304d)("Admin", (0, $99a5bbd2d001ca47$export$43ca6af8ac2c217e)((0, $99a5bbd2d001ca47$export$9ceadcfb9eb7b7f2))),
    beforeOpen: {
        effect: (0, $d38a3a161a7d1109$exports).effects.getTagsFx,
        mapParams: ()=>({})
    }
});





var $agnkb = parcelRequire("agnkb");
var $342d003583f843b3$exports = {};

$parcel$export($342d003583f843b3$exports, "$apiTokens", function () { return $342d003583f843b3$export$774d270f2e02bd88; });
$parcel$export($342d003583f843b3$exports, "$currentApiToken", function () { return $342d003583f843b3$export$ce2db1d05370e778; });
$parcel$export($342d003583f843b3$exports, "effects", function () { return $342d003583f843b3$export$fb4689499fb20c56; });
$parcel$export($342d003583f843b3$exports, "events", function () { return $342d003583f843b3$export$4bf9923669ad6c63; });


var $agnkb = parcelRequire("agnkb");
const $342d003583f843b3$var$getApiTokensFx = (0, $agnkb.createEffect)(()=>{
    return (0, $f54641c7b3157777$export$5201ff832105f45f)();
});
const $342d003583f843b3$var$getApiTokenFx = (0, $agnkb.createEffect)((id)=>{
    return (0, $f54641c7b3157777$export$3f3434baf5a5c9c)(id);
});
const $342d003583f843b3$export$774d270f2e02bd88 = (0, $agnkb.createStore)([]).on($342d003583f843b3$var$getApiTokensFx.doneData, (_, apiTokensResponse)=>apiTokensResponse.data);
const $342d003583f843b3$export$ce2db1d05370e778 = (0, $agnkb.createStore)({
    id: 0,
    name: "",
    token: "",
    is_revoked: false
}).on($342d003583f843b3$var$getApiTokenFx.doneData, (_, apiTokenResponse)=>apiTokenResponse.data);
const $342d003583f843b3$export$fb4689499fb20c56 = {
    getApiTokensFx: $342d003583f843b3$var$getApiTokensFx,
    getApiTokenFx: $342d003583f843b3$var$getApiTokenFx
};
const $342d003583f843b3$export$4bf9923669ad6c63 = {};




(0, $e13fe69fd88e859a$export$cdba908a7d0612af)({
    route: (0, $99a5bbd2d001ca47$export$274a9e080274304d)("Admin", (0, $99a5bbd2d001ca47$export$43ca6af8ac2c217e)((0, $99a5bbd2d001ca47$export$14fdbf877e70314a))),
    beforeOpen: {
        effect: (0, $342d003583f843b3$exports).effects.getApiTokensFx,
        mapParams: ({ params: params })=>params
    }
});
(0, $e13fe69fd88e859a$export$cdba908a7d0612af)({
    route: (0, $99a5bbd2d001ca47$export$274a9e080274304d)("Admin", (0, $99a5bbd2d001ca47$export$43ca6af8ac2c217e)((0, $99a5bbd2d001ca47$export$a945d1f11027dc7d))),
    beforeOpen: {
        effect: (0, $agnkb.createEffect)(),
        mapParams: ()=>({})
    }
});
(0, $e13fe69fd88e859a$export$cdba908a7d0612af)({
    route: (0, $99a5bbd2d001ca47$export$274a9e080274304d)("Admin", (0, $99a5bbd2d001ca47$export$43ca6af8ac2c217e)((0, $99a5bbd2d001ca47$export$dabbba65ed76796e))),
    beforeOpen: {
        effect: (0, $342d003583f843b3$exports).effects.getApiTokenFx,
        mapParams: ({ params: params })=>params.id
    }
});






var $agnkb = parcelRequire("agnkb");
(0, $e13fe69fd88e859a$export$89e12c5b50f7529d)({
    clock: (0, $282d3c07b97d7068$export$d8ff71519acdd706),
    route: (0, $99a5bbd2d001ca47$export$798bfdbebc5ea68e)
});
(0, $e13fe69fd88e859a$export$89e12c5b50f7529d)({
    clock: (0, $282d3c07b97d7068$export$f6206badeeec0319),
    route: (0, $99a5bbd2d001ca47$export$8e0dc54c469007d0)
});
(0, $e13fe69fd88e859a$export$89e12c5b50f7529d)({
    clock: (0, $282d3c07b97d7068$export$18d0aa8b957caef4),
    route: (0, $99a5bbd2d001ca47$export$4dc84672b833126)
});
(0, $e13fe69fd88e859a$export$89e12c5b50f7529d)({
    clock: (0, $282d3c07b97d7068$export$d2059582cfe4247c),
    route: (0, $99a5bbd2d001ca47$export$7adfc20e44871f54)
});
(0, $agnkb.sample)({
    source: [
        (0, $99a5bbd2d001ca47$export$798bfdbebc5ea68e).$isOpened,
        (0, $282d3c07b97d7068$export$456a1449be803865)
    ],
    filter: ([loginRouteOpened, isAuthorized])=>loginRouteOpened && isAuthorized,
    target: (0, $99a5bbd2d001ca47$export$c344a3deb8f83e2f).open
});





var $agnkb = parcelRequire("agnkb");

(0, $e13fe69fd88e859a$export$cdba908a7d0612af)({
    route: (0, $99a5bbd2d001ca47$export$43ca6af8ac2c217e)((0, $99a5bbd2d001ca47$export$c344a3deb8f83e2f)),
    beforeOpen: {
        effect: (0, $d38a3a161a7d1109$exports).effects.getTagsFx,
        mapParams: ()=>({})
    }
});
(0, $e13fe69fd88e859a$export$cdba908a7d0612af)({
    route: (0, $99a5bbd2d001ca47$export$43ca6af8ac2c217e)((0, $99a5bbd2d001ca47$export$773ade5e3261acbd)),
    beforeOpen: {
        effect: (0, $d38a3a161a7d1109$exports).effects.getTagsFx,
        mapParams: ({ params: params })=>params
    }
});
(0, $e13fe69fd88e859a$export$cdba908a7d0612af)({
    route: (0, $99a5bbd2d001ca47$export$274a9e080274304d)("Admin", (0, $99a5bbd2d001ca47$export$43ca6af8ac2c217e)((0, $99a5bbd2d001ca47$export$600fa41b9ffe82c7))),
    beforeOpen: {
        effect: (0, $agnkb.createEffect)(),
        mapParams: ()=>({})
    }
});
(0, $e13fe69fd88e859a$export$cdba908a7d0612af)({
    route: (0, $99a5bbd2d001ca47$export$274a9e080274304d)("Admin", (0, $99a5bbd2d001ca47$export$43ca6af8ac2c217e)((0, $99a5bbd2d001ca47$export$21c91e254ab993b9))),
    beforeOpen: {
        effect: (0, $d38a3a161a7d1109$exports).effects.getTagFx,
        mapParams: ({ params: params })=>params.id
    }
});






(0, $e13fe69fd88e859a$export$cdba908a7d0612af)({
    route: (0, $99a5bbd2d001ca47$export$43ca6af8ac2c217e)((0, $99a5bbd2d001ca47$export$80d23b9cca383549)),
    beforeOpen: {
        effect: (0, $d38a3a161a7d1109$exports).effects.getTagsFx,
        mapParams: ()=>({})
    }
});
(0, $e13fe69fd88e859a$export$cdba908a7d0612af)({
    route: (0, $99a5bbd2d001ca47$export$43ca6af8ac2c217e)((0, $99a5bbd2d001ca47$export$80d23b9cca383549)),
    beforeOpen: {
        effect: (0, $d461744a27a10557$exports).effects.loadThemeFromStorageFx,
        mapParams: ()=>({})
    }
});








var $agnkb = parcelRequire("agnkb");








var $agnkb = parcelRequire("agnkb");

const $0fe4bfda9278ce93$export$ec91da630f36d5ea = ({ filterItems: filterItems, filterChanged: filterChanged, currentKind: currentKind, kindItems: kindItems, kindChanged: kindChanged, applied: applied })=>{
    const dropdownTriggered = (0, $agnkb.createEvent)();
    const $localVisible = (0, $agnkb.createStore)(false);
    const outsideClicked = (0, $agnkb.createEvent)();
    (0, $agnkb.sample)({
        source: $localVisible,
        clock: dropdownTriggered,
        fn: (v)=>!v,
        target: $localVisible
    });
    (0, $agnkb.sample)({
        source: $localVisible,
        clock: outsideClicked,
        filter: (visible, { node: node, event: event })=>!node.contains(event.target) && visible,
        fn: ()=>false,
        target: $localVisible
    });
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "relative"
            ]
        });
        (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
            text: "Filter",
            variant: applied.map((state)=>state ? "default" : "alternative"),
            size: "small",
            event: dropdownTriggered,
            preIcon: (0, $1f8051c24980d921$export$28f6150e232898de),
            postIcon: (0, $cfe9a25a978b21b0$export$4d7ad962dfb0e81e)
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                visible: $localVisible
            });
            (0, $d94fff289995878f$export$931cbfb6bfb85fc)({
                items: filterItems,
                itemChanged: filterChanged,
                currentKind: currentKind,
                kinds: kindItems,
                kindChanged: kindChanged
            });
        });
        (0, $133989e677847899$export$35059013cd4a06db)((node)=>{
            document.addEventListener("click", (event)=>{
                outsideClicked({
                    node: node,
                    event: event
                });
            });
        });
    });
};






var $agnkb = parcelRequire("agnkb");

const $4e0656ad48906f69$export$a6671a32ac390a0c = ({ applied: applied, fromTime: fromTime, fromTimeChanged: fromTimeChanged, toTime: toTime, toTimeChanged: toTimeChanged })=>{
    const dropdownTriggered = (0, $agnkb.createEvent)();
    const $localVisible = (0, $agnkb.createStore)(false);
    const outsideClicked = (0, $agnkb.createEvent)();
    (0, $agnkb.sample)({
        source: $localVisible,
        clock: dropdownTriggered,
        fn: (v)=>!v,
        target: $localVisible
    });
    (0, $agnkb.sample)({
        source: $localVisible,
        clock: outsideClicked,
        filter: (visible, { node: node, event: event })=>!node.contains(event.target) && visible,
        fn: ()=>false,
        target: $localVisible
    });
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "relative"
            ]
        });
        (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
            text: "Time",
            variant: applied.map((state)=>state ? "default" : "alternative"),
            size: "small",
            event: dropdownTriggered,
            preIcon: (0, $90601e5b8da2fcb8$export$8099ab97743c966c),
            postIcon: (0, $cfe9a25a978b21b0$export$4d7ad962dfb0e81e)
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                visible: $localVisible
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "w-fit",
                        "top-0",
                        "left-0",
                        "w-5/6",
                        "absolute",
                        "left-0",
                        "top-9",
                        "border",
                        "border-gray-200",
                        "dark:bg-gray-800",
                        "dark:border-gray-700",
                        "z-50",
                        "bg-white",
                        "divide-y",
                        "divide-gray-100",
                        "rounded-lg",
                        "shadow",
                        "dark:bg-gray-700",
                        "dark:divide-gray-600",
                        "shadow-2xl"
                    ]
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("ul", ()=>{
                    (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                        classList: [
                            "flex",
                            "flex-col",
                            "flex-wrap",
                            "py-2",
                            "text-sm",
                            "text-gray-700",
                            "dark:text-gray-200"
                        ]
                    });
                    (0, $133989e677847899$export$dda1d9f60106f0e9)("li", ()=>{
                        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                            classList: [
                                "block",
                                "px-4",
                                "py-2",
                                "flex-auto",
                                "shrink-0"
                            ]
                        });
                        (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
                            type: "datetime-local",
                            value: fromTime,
                            label: "From",
                            inputChanged: fromTimeChanged
                        });
                    });
                    (0, $133989e677847899$export$dda1d9f60106f0e9)("li", ()=>{
                        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                            classList: [
                                "block",
                                "px-4",
                                "py-2",
                                "flex-auto",
                                "shrink-0"
                            ]
                        });
                        (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
                            type: "datetime-local",
                            value: toTime,
                            label: "To",
                            inputChanged: toTimeChanged
                        });
                    });
                });
            });
        });
        (0, $133989e677847899$export$35059013cd4a06db)((node)=>{
            document.addEventListener("click", (event)=>{
                outsideClicked({
                    node: node,
                    event: event
                });
            });
        });
    });
};











var $agnkb = parcelRequire("agnkb");

var $agnkb = parcelRequire("agnkb");

var $bFIWD = parcelRequire("bFIWD");

var $agnkb = parcelRequire("agnkb");
var $4b00999441b3ecb9$exports = {};
"use strict";

$4b00999441b3ecb9$exports = (parcelRequire("fxh8I"));



var $kVQJL = parcelRequire("kVQJL");
function $84b1f439e5473ece$var$e(e, t, n, r) {
    let o = [
        (0, $agnkb.step).run({
            fn: (e)=>t(e)
        })
    ];
    if (r && o.unshift(r), n) {
        let t = (0, $agnkb.createNode)({
            node: o
        }), r = e.graphite.id, u = n.additionalLinks, s = u[r] || [];
        return u[r] = s, s.push(t), ()=>{
            let e = s.indexOf(t);
            -1 !== e && s.splice(e, 1), (0, $agnkb.clearNode)(t);
        };
    }
    {
        let t = (0, $agnkb.createNode)({
            node: o,
            parent: [
                e
            ],
            family: {
                owners: e
            }
        });
        return ()=>{
            (0, $agnkb.clearNode)(t);
        };
    }
}
function $84b1f439e5473ece$var$t(e, t) {
    return t.displayName = e, t;
}
function $84b1f439e5473ece$var$n(t, n) {
    (0, $agnkb.is).store(t) || $84b1f439e5473ece$var$R("expect useStore argument to be a store");
    let r = (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).useCallback((r)=>$84b1f439e5473ece$var$e(t, r, n), [
        t,
        n
    ]), o = (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).useCallback(()=>$84b1f439e5473ece$var$V(t, n), [
        t,
        n
    ]);
    return $84b1f439e5473ece$var$O(r, o, o);
}
function $84b1f439e5473ece$var$r(t, n) {
    let r = (0, $agnkb.is).unit(t), o = {};
    r ? o = {
        unit: t
    } : "@@unitShape" in t ? "function" == typeof t["@@unitShape"] ? o = t["@@unitShape"]() : $84b1f439e5473ece$var$R("expect @@unitShape to be a function") : o = t;
    let u = Array.isArray(o), s = (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).useRef({
        stale: 1,
        justSubscribed: 0,
        scope: n
    }), [l, a, i, c, f] = (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).useMemo(()=>{
        s.current.stale = 1;
        let e = Array.isArray(o) ? [] : {}, t = [], r = [], u = [], l = [];
        for(let s in o){
            let a = o[s];
            (0, $agnkb.is).unit(a) || $84b1f439e5473ece$var$R("expect useUnit argument to be a unit"), (0, $agnkb.is).event(a) || (0, $agnkb.is).effect(a) ? (e[s] = n ? (0, $agnkb.scopeBind)(a, {
                scope: n
            }) : a, u.push(s), l.push(a)) : (e[s] = null, t.push(s), r.push(a));
        }
        return [
            e,
            t,
            r,
            u,
            l
        ];
    }, [
        s,
        n,
        ...Object.keys(o),
        ...Object.values(o)
    ]), p = (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).useRef({
        value: l,
        storeKeys: a,
        eventKeys: c,
        eventValues: f
    }), d = (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).useCallback((t)=>{
        let r = s.current;
        r.justSubscribed = 1;
        let o = ()=>{
            r.stale || (r.stale = 1, t());
        }, u = (0, $agnkb.step).compute({
            priority: "sampler",
            batch: 1
        }), l = i.map((t)=>$84b1f439e5473ece$var$e(t, o, n, u));
        return ()=>{
            l.forEach((e)=>e());
        };
    }, [
        i,
        n,
        p,
        s
    ]), m = (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).useCallback(()=>{
        let e, t = p.current, o = s.current, d = 0, m = t.value, y = t.storeKeys, h = t.eventKeys, v = t.eventValues, b = n !== o.scope;
        if (o.stale || o.justSubscribed || b) {
            d = !o.justSubscribed || b, e = u ? [
                ...l
            ] : {
                ...l
            }, y.length === a.length && h.length === c.length || (d = 1);
            for(let t = 0; t < a.length; t++){
                let r = $84b1f439e5473ece$var$V(i[t], n), o = a[t];
                d || (d = y.includes(o) ? m[o] !== r : 1), e[o] = r;
            }
            for(let e = 0; e < c.length; e++){
                let t = f[e], n = c[e];
                d || (d = h.includes(n) ? v[h.indexOf(n)] !== t : 1);
            }
        }
        return d && (t.value = e), t.storeKeys = a, t.eventKeys = c, t.eventValues = f, o.stale = 0, o.justSubscribed = !d, o.scope = n, r ? t.value.unit : t.value;
    }, [
        d,
        i,
        f,
        n,
        p,
        s
    ]);
    return $84b1f439e5473ece$var$O(d, m, m);
}
function $84b1f439e5473ece$var$o([t, n], r) {
    let o, u, s, l, a = $84b1f439e5473ece$var$L;
    n ? (o = n, s = t, l = []) : { fn: o, store: s, keys: l, defaultValue: u, updateFilter: a = $84b1f439e5473ece$var$L } = t, (0, $agnkb.is).store(s) || $84b1f439e5473ece$var$R("useStoreMap expects a store"), Array.isArray(l) || $84b1f439e5473ece$var$R("useStoreMap expects an array as keys"), "function" != typeof o && $84b1f439e5473ece$var$R("useStoreMap expects a function");
    let i = (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).useCallback((t)=>$84b1f439e5473ece$var$e(s, t, r), [
        s,
        r
    ]), c = (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).useCallback(()=>$84b1f439e5473ece$var$V(s, r), [
        s,
        r
    ]), f = (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).useRef(), p = (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).useRef(), d = (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).useRef(l);
    return $84b1f439e5473ece$var$K(i, c, c, (e)=>{
        if (f.current !== e || !((e, t)=>{
            if (!e || !t || e.length !== t.length) return 0;
            let n = 1;
            for(let r = 0; r < e.length; r++)if (e[r] !== t[r]) {
                n = 0;
                break;
            }
            return n;
        })(d.current, l)) {
            let t = o(e, l);
            void 0 === t && void 0 !== u && (t = u), f.current = e, d.current = l, void 0 !== t && (p.current = t);
        }
        return p.current;
    }, (e, t)=>!a(t, e));
}
function $84b1f439e5473ece$var$u(e, t = {}, n) {
    let { open: o, close: u, set: s } = $84b1f439e5473ece$var$r({
        open: e.open,
        close: e.close,
        set: e.set
    }, n), l = (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).useMemo(()=>({
            open: o,
            close: u,
            set: s
        }), [
        e,
        o
    ]), a = (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).useRef({
        value: null,
        count: 0
    });
    $84b1f439e5473ece$var$M(()=>(l.open(a.current.value), ()=>l.close(a.current.value)), [
        l
    ]), ((e, t)=>{
        if (e === t) return 1;
        if ("object" == typeof e && null !== e && "object" == typeof t && null !== t) {
            let n = Object.keys(e), r = Object.keys(t);
            if (n.length !== r.length) return 0;
            for(let r = 0; r < n.length; r++){
                let o = n[r];
                if (e[o] !== t[o]) return 0;
            }
            return 1;
        }
        return 0;
    })(a.current.value, t) || (a.current.value = t, a.current.count += 1), $84b1f439e5473ece$var$M(()=>{
        l.set(a.current.value);
    }, [
        a.current.count
    ]);
}
function $84b1f439e5473ece$var$s(e) {
    let t = (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).useContext($84b1f439e5473ece$var$U);
    return e && !t && $84b1f439e5473ece$var$R("No scope found, consider adding <Provider> to app root"), t;
}
function $84b1f439e5473ece$export$90fc3a17d93f704c(e, t) {
    return ((e, t)=>{
        if (!t) return e;
        let n = (0, $agnkb.is).unit(e) || "object" != typeof e ? {
            event: e
        } : e;
        return (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).useMemo(()=>{
            if ((0, $agnkb.is).unit(e)) return (0, $agnkb.scopeBind)(e, {
                scope: t
            });
            let n = Array.isArray(e) ? [] : {};
            for(let r in e)n[r] = (0, $agnkb.scopeBind)(e[r], {
                scope: t
            });
            return n;
        }, [
            t,
            ...Object.keys(n),
            ...Object.values(n)
        ]);
    })(e, $84b1f439e5473ece$var$s(null == t ? void 0 : t.forceScope));
}
function $84b1f439e5473ece$export$6ccbb43953eebf8(e, t) {
    return $84b1f439e5473ece$var$n(e, $84b1f439e5473ece$var$s(null == t ? void 0 : t.forceScope));
}
function $84b1f439e5473ece$export$d048e1275d50b112(e, t) {
    return $84b1f439e5473ece$var$r(e, $84b1f439e5473ece$var$s(null == t ? void 0 : t.forceScope));
}
function $84b1f439e5473ece$export$8b87f165e6cd655(e, t) {
    return $84b1f439e5473ece$var$o([
        e,
        t
    ], $84b1f439e5473ece$var$s(null == e ? void 0 : e.forceScope));
}
function $84b1f439e5473ece$export$f9763ecd339e95eb(e, r, u) {
    return ((e, r, u)=>{
        let s, l, a, i = [];
        "object" == typeof r && null !== r ? (r.keys && (i = r.keys), { fn: s, getKey: l, placeholder: a } = r) : s = r, (0, $agnkb.is).store(e) || $84b1f439e5473ece$var$R("expect useList first argument to be a store"), "function" != typeof s && $84b1f439e5473ece$var$R("expect useList's renderItem to be a function"), Array.isArray(i) || $84b1f439e5473ece$var$R("expect useList's keys to be an array");
        let c = (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).useMemo(()=>{
            let n = $84b1f439e5473ece$var$t(`${e.shortName || "Unknown"}.Item`, (t)=>{
                let { index: n, keys: r, keyVal: s, value: l } = t;
                if (f.current[1]) return f.current[0](l, s);
                let a = $84b1f439e5473ece$var$o([
                    {
                        store: e,
                        keys: [
                            n,
                            ...r
                        ],
                        fn: (e, t)=>e[t[0]]
                    }
                ], u);
                return f.current[0](a, n);
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).memo(n);
        }, [
            e,
            u,
            !!l
        ]), f = (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).useRef([
            s,
            l
        ]);
        f.current = [
            s,
            l
        ];
        let p = (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).useMemo(()=>i, i);
        if (l) {
            let t = $84b1f439e5473ece$var$n(e, u);
            return 0 === t.length && a ? a : t.map((e)=>{
                let t = f.current[1](e);
                return (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).createElement(c, {
                    keyVal: t,
                    key: t,
                    keys: p,
                    value: e
                });
            });
        }
        {
            let t = $84b1f439e5473ece$var$o([
                {
                    store: e,
                    keys: [
                        e
                    ],
                    fn: (e)=>e.length
                }
            ], u);
            return 0 === t && a ? a : Array.from({
                length: t
            }, (e, t)=>(0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).createElement(c, {
                    index: t,
                    key: t,
                    keys: p
                }));
        }
    })(e, r, $84b1f439e5473ece$var$s(null == u ? void 0 : u.forceScope));
}
function $84b1f439e5473ece$export$41d95a587fecc5a0(e, t = {}, n) {
    return $84b1f439e5473ece$var$u(e, t, $84b1f439e5473ece$var$s(null == n ? void 0 : n.forceScope));
}
function $84b1f439e5473ece$export$60e54eaca7e7fb38(e, n) {
    function r(e) {
        let t = (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).useRef(e), r = $84b1f439e5473ece$export$6ccbb43953eebf8(o);
        $84b1f439e5473ece$var$M(()=>(s({
                props: t.current,
                state: o.getState()
            }), ()=>{
                l({
                    props: t.current,
                    state: o.getState()
                });
            }), []);
        let u = n(e, r);
        return t.current = e, u;
    }
    let o;
    (0, $agnkb.is).store(e) ? o = e : "object" == typeof e && null !== e ? o = (0, $agnkb.combine)(e) : $84b1f439e5473ece$var$R("shape should be a store or object with stores");
    let u = "Unknown";
    o && o.shortName && (u = o.shortName);
    let s = (0, $agnkb.createEvent)(), l = (0, $agnkb.createEvent)();
    return r.mounted = s, r.unmounted = l, $84b1f439e5473ece$var$t(`${u}.View`, r);
}
function $84b1f439e5473ece$export$401a2ee3d210505c(e) {
    return $84b1f439e5473ece$export$60e54eaca7e7fb38(e, ({ children: e }, t)=>e(t));
}
function $84b1f439e5473ece$var$y(e, t) {
    let n = t ? e : e[0];
    var r;
    ((e)=>{
        if (!e) throw Error("expect first argument be an object");
    })($84b1f439e5473ece$var$G(r = n) || ((e)=>"function" == typeof e)(r));
    let o = n.or, u = n.and;
    if (u) {
        let n = t ? u : u[0];
        if ($84b1f439e5473ece$var$G(n) && "and" in n) {
            let n = $84b1f439e5473ece$var$y(u, t);
            e = n[0], o = {
                ...o,
                ...n[1]
            };
        } else e = u;
    }
    return [
        e,
        o
    ];
}
function $84b1f439e5473ece$var$h(e, t) {
    let n = t && $84b1f439e5473ece$var$G(r = t[0]) && (r.and || r.or) ? t : [
        {
            and: t
        }
    ];
    var r;
    let o, [[u, s], l] = $84b1f439e5473ece$var$y(n), a = {}, i = {}, c = l;
    var f;
    return "string" == typeof u ? (i = {
        name: u
    }, $84b1f439e5473ece$var$G(f = s) && "sid" in f || (a = s || {})) : ((e)=>$84b1f439e5473ece$var$G(e) && ("domain" in e || "defaultState" in e || "name" in e))(u) && (i = u, a = u.defaultState || {}, o = u.domain), {
        hook: e,
        domain: o,
        defaultState: a,
        mainConfig: i,
        maybeConfig: c
    };
}
function $84b1f439e5473ece$export$b7eb246e5f4e5a66(...e) {
    return (({ domain: e, defaultState: n, hook: r, mainConfig: o, maybeConfig: u })=>{
        function l(e) {
            return r(l, e, $84b1f439e5473ece$var$s()), null;
        }
        let a = $84b1f439e5473ece$var$W({
            or: u,
            and: o
        }), i = `${e ? `${e.compositeName.fullName}/` : ""}${a.name || "gate"}`, c = (0, $agnkb.createEvent)({
            name: `${i}.set`,
            sid: a.sid ? `${a.sid}|set` : void 0
        }), f = (0, $agnkb.createEvent)({
            name: `${i}.open`,
            sid: a.sid ? `${a.sid}|open` : void 0
        }), p = (0, $agnkb.createEvent)({
            name: `${i}.close`,
            sid: a.sid ? `${a.sid}|close` : void 0
        }), d = (0, $agnkb.createStore)(Boolean(0), {
            name: `${i}.status`,
            serialize: "ignore"
        }).on(f, ()=>Boolean(1)).on(p, ()=>Boolean(0)), m = (0, $agnkb.createStore)(n, {
            name: `${i}.state`,
            sid: a.sid
        }).on(c, (e, t)=>t).on(f, (e, t)=>t).reset(p);
        if (e) {
            let { hooks: t } = e;
            (0, $agnkb.launch)({
                target: [
                    t.store,
                    t.store,
                    t.event,
                    t.event,
                    t.event
                ],
                params: [
                    d,
                    m,
                    f,
                    p,
                    c
                ]
            });
        }
        return l.open = f, l.close = p, l.status = d, l.state = m, l.set = c, $84b1f439e5473ece$var$t(`Gate:${i}`, l);
    })($84b1f439e5473ece$var$h($84b1f439e5473ece$var$u, e));
}
let $84b1f439e5473ece$var$R = (e)=>{
    throw Error(e);
}, $84b1f439e5473ece$var$M = "undefined" != typeof window ? (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).useEffect;
const { useSyncExternalStore: $84b1f439e5473ece$var$O } = (0, (/*@__PURE__*/$parcel$interopDefault($kVQJL))), { useSyncExternalStoreWithSelector: $84b1f439e5473ece$var$K } = (0, (/*@__PURE__*/$parcel$interopDefault($4b00999441b3ecb9$exports))), $84b1f439e5473ece$var$V = (e, t)=>t ? t.getState(e) : e.getState(), $84b1f439e5473ece$var$L = (e, t)=>e !== t, $84b1f439e5473ece$var$U = (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).createContext(null);
let { Provider: $84b1f439e5473ece$export$2881499e37b75b9a } = $84b1f439e5473ece$var$U, $84b1f439e5473ece$var$I = (e)=>console.error(`${e} is deprecated`), $84b1f439e5473ece$export$fd50cb2633c11e6e = (e, n, r)=>($84b1f439e5473ece$var$I("createContextComponent"), $84b1f439e5473ece$var$t(`${e.shortName || "Unknown"}.ContextComponent`, (t)=>{
        let o = (0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).useContext(n), u = $84b1f439e5473ece$export$6ccbb43953eebf8(e);
        return r(t, u, o);
    })), $84b1f439e5473ece$export$64605811ab45167f = (e)=>(n)=>{
        let r = e;
        return "function" != typeof e && (r = n, n = e), $84b1f439e5473ece$var$t(`Connect(${r.displayName || r.name || "Unknown"})`, (e)=>(0, (/*@__PURE__*/$parcel$interopDefault($bFIWD))).createElement(r, {
                ...e,
                ...$84b1f439e5473ece$export$6ccbb43953eebf8(n)
            }));
    }, $84b1f439e5473ece$export$e4f2caaf2e4db677 = (e, t)=>($84b1f439e5473ece$var$I("createReactState"), $84b1f439e5473ece$export$64605811ab45167f(t)(e)), $84b1f439e5473ece$var$G = (e)=>"object" == typeof e && null !== e, $84b1f439e5473ece$var$W = (e, t = {})=>($84b1f439e5473ece$var$G(e) && ($84b1f439e5473ece$var$W(e.or, t), ((e)=>{
        for(let o in e)r = o, ((e)=>void 0 === e)(n = e[o]) || "or" === r || "and" === r || (t[r] = n);
        var n, r;
    })(e), $84b1f439e5473ece$var$W(e.and, t)), t);


const $995c23da6372e497$var$a = {
    store: function({ init: e, domain: i, existing: s }, o) {
        return s || (i ? i.store(e, {
            and: o,
            sid: "-efg263"
        }) : (0, $agnkb.createStore)(e, {
            and: o,
            sid: "-dyefrw"
        }));
    },
    event: function({ domain: e, existing: r }) {
        return r || (e ? e.event({
            sid: "-y6riru"
        }) : (0, $agnkb.createEvent)({
            sid: "-y6rhv4"
        }));
    }
};
function $995c23da6372e497$var$d(r, i, s) {
    var o, n, t, d, l, u, c, m, v, f, h, $;
    const g = "function" == typeof i.init ? i.init() : i.init, V = $995c23da6372e497$var$a.store({
        domain: s,
        existing: null === (o = i.units) || void 0 === o ? void 0 : o.$value,
        init: g
    }, {
        and: {
            sid: `${r}-$value`
        },
        name: "$value",
        sid: "-qmuyz8"
    }), x = $995c23da6372e497$var$a.store({
        domain: s,
        existing: null === (n = i.units) || void 0 === n ? void 0 : n.$errors,
        init: []
    }, {
        and: {
            sid: `${r}-$errors`
        },
        name: "$errors",
        sid: "-vpp9qr"
    }), E = x.map((e)=>e[0] ? e[0] : null), p = $995c23da6372e497$var$a.store({
        domain: s,
        existing: null === (t = i.units) || void 0 === t ? void 0 : t.$initValue,
        init: g
    }, {
        and: {
            sid: `${r}-$initValue`
        },
        name: "$initValue",
        sid: "yr2fi7"
    }), y = $995c23da6372e497$var$a.store({
        domain: s,
        existing: null === (d = i.units) || void 0 === d ? void 0 : d.$isTouched,
        init: !1
    }, {
        and: {
            sid: `${r}-$touched`
        },
        name: "$touched",
        sid: "-q2zc60"
    }), T = (0, $agnkb.combine)({
        and: [
            V,
            p,
            (e, r)=>e !== r
        ],
        or: {
            name: "$isDirty",
            sid: "cgx1r6"
        }
    }), k = $995c23da6372e497$var$a.event({
        domain: s,
        existing: null === (l = i.units) || void 0 === l ? void 0 : l.onChange
    }, {
        name: "onChange",
        sid: "fko8ie"
    }), F = $995c23da6372e497$var$a.event({
        domain: s,
        existing: null === (u = i.units) || void 0 === u ? void 0 : u.onBlur
    }, {
        name: "onBlur",
        sid: "-kwhocu"
    }), b = $995c23da6372e497$var$a.event({
        domain: s,
        existing: null === (c = i.units) || void 0 === c ? void 0 : c.changed
    }, {
        name: "changed",
        sid: "svcdu2"
    }), w = $995c23da6372e497$var$a.event({
        domain: s,
        existing: null === (m = i.units) || void 0 === m ? void 0 : m.addError
    }, {
        name: "addError",
        sid: "utax3x"
    }), D = $995c23da6372e497$var$a.event({
        domain: s,
        existing: null === (v = i.units) || void 0 === v ? void 0 : v.validate
    }, {
        name: "validate",
        sid: "-al4q5y"
    }), j = $995c23da6372e497$var$a.event({
        domain: s,
        existing: null === (f = i.units) || void 0 === f ? void 0 : f.resetErrors
    }, {
        name: "resetErrors",
        sid: "-8bnwk6"
    }), q = $995c23da6372e497$var$a.event({
        domain: s,
        existing: null === (h = i.units) || void 0 === h ? void 0 : h.resetValue
    }, {
        name: "resetValue",
        sid: "-5k4ef5"
    }), S = $995c23da6372e497$var$a.event({
        domain: s,
        existing: null === ($ = i.units) || void 0 === $ ? void 0 : $.reset
    }, {
        name: "reset",
        sid: "-t5gx88"
    }), O = E.map((e)=>null === e), B = E.map((e)=>(null == e ? void 0 : e.errorText) || ""), C = (0, $agnkb.combine)({
        and: [
            {
                value: V,
                errors: x,
                firstError: E,
                isValid: O,
                isDirty: T,
                isTouched: y
            }
        ],
        or: {
            name: "$field",
            sid: "-3lcsvv"
        }
    }), I = {
        value: V,
        initValue: p,
        isValid: O,
        isDirty: T,
        touched: y,
        errors: x,
        firstError: E,
        errorText: B,
        onChange: k,
        onBlur: F,
        addError: w,
        validate: D,
        reset: S,
        resetErrors: j,
        resetValue: q
    };
    return {
        changed: b,
        name: r,
        $initValue: p,
        $value: V,
        $errors: x,
        $firstError: E,
        $errorText: B,
        $isValid: O,
        $isDirty: T,
        $isTouched: y,
        $touched: y,
        $field: C,
        onChange: k,
        onBlur: F,
        addError: w,
        validate: D,
        set: k,
        reset: S,
        resetErrors: j,
        resetValue: q,
        filter: i.filter,
        "@@unitShape": ()=>I
    };
}
function $995c23da6372e497$var$l(i, n) {
    const { form: t, field: a, fieldConfig: d } = i, l = d.rules || [], u = t.validateOn || [
        "submit"
    ], c = d.validateOn || [], { $value: m, $errors: v, onBlur: f, changed: h, addError: $, validate: g, resetErrors: V, resetValue: x, reset: E } = a, p = "function" == typeof l ? (0, $agnkb.createStore)([], {
        and: {
            sid: `${a.name}-$rulesSources`
        },
        name: "rulesSources",
        sid: "8mhplv"
    }) : (0, $agnkb.combine)({
        and: [
            l.map(({ source: e }, i)=>{
                const s = `${a.name}-$rulesSources-${i}`;
                return e || (0, $agnkb.createStore)(null, {
                    and: {
                        sid: s
                    },
                    sid: "kjwg5z"
                });
            })
        ],
        or: {
            name: "rulesSources",
            sid: "93jc02"
        }
    }), y = (T = l, (e, r, i)=>{
        const s = [], o = "function" == typeof T ? T(e, r) : T;
        for(let n = 0; n < o.length; n++){
            const t = o[n], a = i ? i[n] : null, d = t.validator(e, r, a);
            "boolean" != typeof d || d || s.push({
                rule: t.name,
                errorText: t.errorText,
                value: e
            }), "object" != typeof d || d.isValid || s.push({
                rule: t.name,
                errorText: d.errorText,
                value: e
            });
        }
        return s;
    });
    var T;
    const k = [
        ...u,
        ...c
    ], F = [];
    if (k.includes("submit")) {
        const r = (0, $agnkb.sample)({
            and: [
                {
                    source: (0, $agnkb.combine)({
                        and: [
                            {
                                fieldValue: m,
                                form: t.$values,
                                rulesSources: p
                            }
                        ],
                        or: {
                            name: "source",
                            sid: "a7in27"
                        }
                    }),
                    clock: t.submit
                }
            ],
            or: {
                name: "validationTrigger",
                sid: "ag2jep"
            }
        });
        F.push(r);
    }
    k.includes("blur") && F.push((0, $agnkb.sample)({
        and: [
            {
                source: (0, $agnkb.combine)({
                    and: [
                        {
                            fieldValue: m,
                            form: t.$values,
                            rulesSources: p
                        }
                    ],
                    or: {
                        name: "source",
                        sid: "pcyjof"
                    }
                }),
                clock: f
            }
        ],
        or: {
            sid: "-mjjw0q"
        }
    })), k.includes("change") && F.push((0, $agnkb.sample)({
        and: [
            {
                source: (0, $agnkb.combine)({
                    and: [
                        {
                            fieldValue: m,
                            form: t.$values,
                            rulesSources: p
                        }
                    ],
                    or: {
                        name: "source",
                        sid: "-uzr82o"
                    }
                }),
                clock: (0, $agnkb.merge)([
                    h,
                    x,
                    t.resetValues
                ], {
                    name: "clock",
                    sid: "mklqro"
                })
            }
        ],
        or: {
            sid: "-7v5lsp"
        }
    })), F.push((0, $agnkb.sample)({
        and: [
            {
                source: (0, $agnkb.combine)({
                    and: [
                        {
                            fieldValue: m,
                            form: t.$values,
                            rulesSources: p
                        }
                    ],
                    or: {
                        name: "source",
                        sid: "-gsekud"
                    }
                }),
                clock: g
            }
        ],
        or: {
            sid: "6c71fm"
        }
    })), F.push((0, $agnkb.sample)({
        and: [
            {
                source: (0, $agnkb.combine)({
                    and: [
                        {
                            fieldValue: m,
                            form: t.$values,
                            rulesSources: p
                        }
                    ],
                    or: {
                        name: "source",
                        sid: "-323jeq"
                    }
                }),
                clock: t.validate
            }
        ],
        or: {
            sid: "a4k0l6"
        }
    }));
    const b = (0, $agnkb.sample)({
        and: [
            {
                source: m,
                clock: $,
                fn: (e, { rule: r, errorText: i })=>({
                        rule: r,
                        value: e,
                        errorText: i
                    })
            }
        ],
        or: {
            name: "addErrorWithValue",
            sid: "symbs8"
        }
    }), w = (0, $agnkb.sample)({
        and: [
            {
                source: m,
                clock: t.addErrors,
                fn: (e, r)=>({
                        value: e,
                        newErrors: r
                    })
            }
        ],
        or: {
            name: "addErrorsWithValue",
            sid: "-6mh24c"
        }
    });
    v.on(F, (e, { form: r, fieldValue: i, rulesSources: s })=>y(i, r, s)).on(b, (e, r)=>[
            r,
            ...e
        ]).on(w, (e, { value: r, newErrors: i })=>{
        const s = [];
        for (const e of i)e.field === a.name && s.push({
            value: r,
            rule: e.rule,
            errorText: e.errorText
        });
        return [
            ...s,
            ...e
        ];
    }).reset(V, t.reset, E, t.resetErrors), k.includes("change") || v.reset(h);
}
function $995c23da6372e497$var$u({ field: e, form: r }) {
    const { $value: i, $initValue: t, $touched: a, onChange: d, changed: l, name: u, reset: c, resetValue: m, filter: v } = e, { setForm: f, setInitialForm: h, resetForm: $, resetTouched: g, resetValues: V } = r, x = (0, $agnkb.sample)({
        and: [
            {
                source: t,
                clock: (0, $agnkb.merge)([
                    c,
                    m,
                    V,
                    $
                ], {
                    name: "clock",
                    sid: "3kodws"
                })
            }
        ],
        or: {
            name: "resetValueWithInit",
            sid: "oge6qb"
        }
    });
    a.on(l, ()=>!0).reset(c, $, g), (0, $agnkb.guard)({
        and: [
            {
                source: d,
                filter: v || (()=>!0),
                target: l
            }
        ],
        or: {
            sid: "-kx8mil"
        }
    }), t.on(h, (e, r)=>r.hasOwnProperty(u) ? r[u] : e), i.on(l, (e, r)=>r).on([
        f,
        h
    ], (e, r)=>r.hasOwnProperty(u) ? r[u] : e).on(x, (e, r)=>r);
}
function $995c23da6372e497$export$f681a8129d2e9d28(r) {
    const { filter: i, domain: o, fields: t, validateOn: c, units: m } = r, v = {}, f = [], h = [];
    for(const e in t){
        if (!t.hasOwnProperty(e)) continue;
        const r = $995c23da6372e497$var$d(e, t[e], o);
        v[e] = r, f.push(r.$isDirty), h.push(r.$touched);
    }
    const $ = function(r) {
        const i = {};
        for(const e in r)r.hasOwnProperty(e) && (i[e] = r[e].$value);
        return (0, $agnkb.combine)({
            and: [
                i
            ],
            or: {
                sid: "39yu4w"
            }
        });
    }(v), g = function(r) {
        const i = [];
        for(const e in r){
            if (!r.hasOwnProperty(e)) continue;
            const { $firstError: s } = r[e];
            i.push(s);
        }
        return (0, $agnkb.combine)({
            and: [
                i
            ],
            or: {
                name: "$firstErrors",
                sid: "-1vosn1"
            }
        }).map((e)=>e.every((e)=>null === e));
    }(v), V = i ? (0, $agnkb.combine)({
        and: [
            g,
            i,
            (e, r)=>e && r
        ],
        or: {
            name: "$isFormValid",
            sid: "j5pxai"
        }
    }) : g, x = (0, $agnkb.combine)({
        and: [
            f
        ],
        or: {
            name: "$isDirty",
            sid: "il8stq"
        }
    }).map((e)=>e.some(Boolean)), E = (0, $agnkb.combine)({
        and: [
            h
        ],
        or: {
            name: "$touched",
            sid: "2no1yv"
        }
    }).map((e)=>e.some(Boolean)), p = (0, $agnkb.combine)({
        and: [
            {
                isValid: g,
                isDirty: x,
                touched: E
            }
        ],
        or: {
            name: "$meta",
            sid: "yii6e7"
        }
    }), y = $995c23da6372e497$var$a.event({
        domain: o,
        existing: null == m ? void 0 : m.validate
    }, {
        name: "validate",
        sid: "5z7ulc"
    }), T = $995c23da6372e497$var$a.event({
        domain: o,
        existing: null == m ? void 0 : m.submit
    }, {
        name: "submitForm",
        sid: "-xys7v0"
    }), k = $995c23da6372e497$var$a.event({
        domain: o,
        existing: null == m ? void 0 : m.formValidated
    }, {
        name: "formValidated",
        sid: "-2r221i"
    }), F = $995c23da6372e497$var$a.event({
        domain: o,
        existing: null == m ? void 0 : m.setInitialForm
    }, {
        name: "setInitialForm",
        sid: "-q10ho7"
    }), b = $995c23da6372e497$var$a.event({
        domain: o,
        existing: null == m ? void 0 : m.setForm
    }, {
        name: "setForm",
        sid: "l2bjv0"
    }), w = $995c23da6372e497$var$a.event({
        domain: o,
        existing: null == m ? void 0 : m.addErrors
    }, {
        name: "addErrors",
        sid: "n5fjqj"
    }), D = $995c23da6372e497$var$a.event({
        domain: o,
        existing: null == m ? void 0 : m.reset
    }, {
        name: "resetForm",
        sid: "pfltj4"
    }), j = $995c23da6372e497$var$a.event({
        domain: o,
        existing: null == m ? void 0 : m.resetValues
    }, {
        name: "resetValues",
        sid: "-s67s76"
    }), q = $995c23da6372e497$var$a.event({
        domain: o,
        existing: null == m ? void 0 : m.resetErrors
    }, {
        name: "resetErrors",
        sid: "hulqf7"
    }), S = $995c23da6372e497$var$a.event({
        domain: o,
        existing: null == m ? void 0 : m.resetTouched
    }, {
        name: "resetTouched",
        sid: "2gwck3"
    }), O = (0, $agnkb.sample)({
        and: [
            {
                source: $,
                clock: T
            }
        ],
        or: {
            name: "submitWithFormData",
            sid: "foyubg"
        }
    }), B = (0, $agnkb.sample)({
        and: [
            {
                source: $,
                clock: y
            }
        ],
        or: {
            name: "validateWithFormData",
            sid: "-mn7k5o"
        }
    });
    for(const e in v){
        if (!v.hasOwnProperty(e)) continue;
        const r = t[e], i = v[e];
        $995c23da6372e497$var$u({
            form: {
                setForm: b,
                setInitialForm: F,
                resetForm: D,
                resetTouched: S,
                resetValues: j
            },
            field: i
        }), $995c23da6372e497$var$l({
            form: {
                $values: $,
                submit: T,
                reset: D,
                addErrors: w,
                resetValues: j,
                resetErrors: q,
                validate: y,
                validateOn: c
            },
            fieldConfig: r,
            field: i
        });
    }
    (0, $agnkb.guard)({
        and: [
            {
                source: O,
                filter: V,
                target: k
            }
        ],
        or: {
            sid: "4sls6r"
        }
    }), (0, $agnkb.guard)({
        and: [
            {
                source: B,
                filter: V,
                target: k
            }
        ],
        or: {
            sid: "4vwjqx"
        }
    });
    const C = {
        isValid: g,
        isDirty: x,
        touched: E,
        submit: T,
        reset: D,
        addErrors: w,
        validate: y,
        setForm: b,
        setInitialForm: F,
        resetTouched: S,
        resetValues: j,
        resetErrors: q,
        formValidated: k
    };
    return {
        fields: v,
        $values: $,
        $eachValid: g,
        $isValid: g,
        $isDirty: x,
        $touched: E,
        $meta: p,
        submit: T,
        validate: y,
        resetTouched: S,
        addErrors: w,
        reset: D,
        resetValues: j,
        resetErrors: q,
        setForm: b,
        setInitialForm: F,
        set: b,
        formValidated: k,
        "@@unitShape": ()=>C
    };
}
function $995c23da6372e497$export$294aa081a6c6f55d(e) {
    const { value: r, errors: i, firstError: s, isValid: o, isDirty: n, isTouched: a } = (0, $84b1f439e5473ece$export$d048e1275d50b112)(e.$field);
    return {
        name: e.name,
        value: r,
        errors: i,
        firstError: s,
        isValid: o,
        isDirty: n,
        touched: a,
        isTouched: a,
        onChange: (0, $84b1f439e5473ece$export$d048e1275d50b112)(e.onChange),
        onBlur: (0, $84b1f439e5473ece$export$d048e1275d50b112)(e.onBlur),
        addError: (0, $84b1f439e5473ece$export$d048e1275d50b112)(e.addError),
        validate: (0, $84b1f439e5473ece$export$d048e1275d50b112)(e.validate),
        reset: (0, $84b1f439e5473ece$export$d048e1275d50b112)(e.reset),
        set: (0, $84b1f439e5473ece$export$d048e1275d50b112)(e.onChange),
        resetErrors: (0, $84b1f439e5473ece$export$d048e1275d50b112)(e.resetErrors),
        hasError: ()=>null !== s,
        errorText: (e)=>s ? e && e[s.rule] ? e[s.rule] : s.errorText || "" : ""
    };
}
function $995c23da6372e497$export$87c0cf8eb5a167e0(e) {
    const r = {}, i = {};
    for(const s in e.fields){
        if (!e.fields.hasOwnProperty(s)) continue;
        const o = $995c23da6372e497$export$294aa081a6c6f55d(e.fields[s]);
        r[s] = o, i[s] = o.value;
    }
    const { isValid: s, isDirty: o, touched: n } = (0, $84b1f439e5473ece$export$d048e1275d50b112)(e.$meta);
    return {
        fields: r,
        values: i,
        hasError: (e)=>e ? !!r[e] && Boolean(r[e].firstError) : !s,
        eachValid: s,
        isValid: s,
        isDirty: o,
        isTouched: n,
        touched: n,
        errors: (e)=>r[e] ? r[e].errors : [],
        error: (e)=>r[e] ? r[e].firstError : null,
        errorText: (e, i)=>{
            const s = r[e];
            return s && s.firstError ? i && i[s.firstError.rule] ? i[s.firstError.rule] : s.firstError.errorText || "" : "";
        },
        reset: (0, $84b1f439e5473ece$export$d048e1275d50b112)(e.reset),
        submit: (0, $84b1f439e5473ece$export$d048e1275d50b112)(e.submit),
        setForm: (0, $84b1f439e5473ece$export$d048e1275d50b112)(e.setForm),
        set: (0, $84b1f439e5473ece$export$d048e1275d50b112)(e.setForm),
        formValidated: (0, $84b1f439e5473ece$export$d048e1275d50b112)(e.formValidated)
    };
}


const $d4513bc0cb578700$export$714e9b412011a758 = (0, $995c23da6372e497$export$f681a8129d2e9d28)({
    fields: {
        email: {
            init: "",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).required(),
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).email()
            ]
        },
        password: {
            init: "",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).required()
            ]
        }
    },
    validateOn: [
        "submit"
    ]
});
const $d4513bc0cb578700$export$a2d4db23f6dc3678 = (0, $agnkb.createStore)("");
const $d4513bc0cb578700$export$76cf5b969e0a5b5 = (0, $agnkb.createEffect)(({ email: email, password: password })=>{
    return (0, $dde8f8cdf92b8dc1$export$1dd984b792643a90)(email, password);
});
(0, $agnkb.sample)({
    source: $d4513bc0cb578700$export$714e9b412011a758.formValidated,
    target: $d4513bc0cb578700$export$76cf5b969e0a5b5
});
const $d4513bc0cb578700$export$30f984e72e154994 = (0, $agnkb.createEvent)();
(0, $agnkb.sample)({
    source: $d4513bc0cb578700$export$76cf5b969e0a5b5.doneData,
    fn: (logInResponse)=>logInResponse.data.token,
    target: [
        (0, $282d3c07b97d7068$export$c20bb6a46350d592),
        (0, $99a5bbd2d001ca47$export$c344a3deb8f83e2f).open,
        $d4513bc0cb578700$export$714e9b412011a758.reset
    ]
});
(0, $agnkb.sample)({
    source: $d4513bc0cb578700$export$76cf5b969e0a5b5.doneData,
    filter: (logInResponse)=>!logInResponse.success,
    fn: (logInResponse)=>{
        if (logInResponse.code === 401) return "Wrong email or password";
        return logInResponse.error;
    },
    target: $d4513bc0cb578700$export$a2d4db23f6dc3678
});
(0, $agnkb.sample)({
    source: (0, $282d3c07b97d7068$export$b6537f11d186f6b6).doneData,
    filter: (sessionResponse)=>sessionResponse.success && !!sessionResponse.data.token,
    fn: (sessionResponse)=>{
        const { id: id, email: email, name: name, role: role, tag_ids: tag_ids, token: token, is_revoked: is_revoked } = sessionResponse.data;
        return {
            id: id,
            email: email,
            name: name,
            role: role,
            tag_ids: tag_ids,
            token: token,
            is_revoked: is_revoked
        };
    },
    target: (0, $d461744a27a10557$exports).$currentAccount
});
(0, $agnkb.sample)({
    source: $d4513bc0cb578700$export$76cf5b969e0a5b5.doneData,
    filter: (loginResponse)=>loginResponse.success,
    fn: (loginResponse)=>{
        const { id: id, email: email, name: name, role: role, tag_ids: tag_ids, token: token, is_revoked: is_revoked } = loginResponse.data;
        return {
            id: id,
            email: email,
            name: name,
            role: role,
            tag_ids: tag_ids,
            token: token,
            is_revoked: is_revoked
        };
    },
    target: (0, $d461744a27a10557$exports).$currentAccount
});



const $ffb7d3ea5d42063a$export$334c29725a78c21d = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "mt-10",
                "max-w-sm",
                "w-full"
            ]
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("form", ()=>{
            (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
                type: "email",
                label: "Email",
                autofocus: true,
                inputChanged: (0, $d4513bc0cb578700$export$714e9b412011a758).fields.email.changed,
                errorText: (0, $d4513bc0cb578700$export$714e9b412011a758).fields.email.$errorText
            });
            (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
                type: "password",
                label: "Password",
                inputChanged: (0, $d4513bc0cb578700$export$714e9b412011a758).fields.password.changed,
                errorText: (0, $d4513bc0cb578700$export$714e9b412011a758).fields.password.$errorText
            });
            (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                text: "Log in",
                event: (0, $d4513bc0cb578700$export$714e9b412011a758).submit,
                size: "base",
                prevent: true,
                variant: "default"
            });
            (0, $50bc7b2791a6cb44$export$852d7888b34e2b72)((0, $d4513bc0cb578700$export$a2d4db23f6dc3678), (0, $d4513bc0cb578700$export$a2d4db23f6dc3678).map(Boolean));
        });
    });
};










var $agnkb = parcelRequire("agnkb");

const $f621ac0a0cde3a2d$export$23e324a212d3f03d = (0, $995c23da6372e497$export$f681a8129d2e9d28)({
    fields: {
        name: {
            init: "",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).required()
            ]
        },
        email: {
            init: "",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).required(),
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).email()
            ]
        },
        password: {
            init: "",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).required(),
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).password()
            ]
        },
        passwordConfirmation: {
            init: "",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).required(),
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).password()
            ]
        }
    },
    validateOn: [
        "submit"
    ]
});
const $f621ac0a0cde3a2d$export$6d69234222d2c2e3 = (0, $agnkb.createStore)("");
const $f621ac0a0cde3a2d$export$184f37973937390 = (0, $agnkb.createEffect)((adminInfo)=>{
    return (0, $676173f0fcc8f3dc$export$862778ea698fdf39)(adminInfo);
});
(0, $agnkb.sample)({
    source: $f621ac0a0cde3a2d$export$23e324a212d3f03d.formValidated,
    target: $f621ac0a0cde3a2d$export$184f37973937390
});
const $f621ac0a0cde3a2d$export$f812e939960ea834 = (0, $agnkb.createEvent)();
(0, $agnkb.sample)({
    source: $f621ac0a0cde3a2d$export$184f37973937390.doneData,
    fn: (registrationResponse)=>registrationResponse.data.token,
    target: [
        (0, $99a5bbd2d001ca47$export$798bfdbebc5ea68e).open,
        $f621ac0a0cde3a2d$export$23e324a212d3f03d.reset
    ]
});
(0, $agnkb.sample)({
    source: $f621ac0a0cde3a2d$export$184f37973937390.doneData,
    filter: (registrationResponse)=>!registrationResponse.success,
    fn: (registrationResponse)=>registrationResponse.error,
    target: $f621ac0a0cde3a2d$export$6d69234222d2c2e3
});



const $ea116515a0a36702$export$36efa24ef475d1f4 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "mt-10",
                "max-w-sm",
                "w-full"
            ]
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("form", ()=>{
            (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
                type: "text",
                label: "Name",
                autofocus: true,
                inputChanged: (0, $f621ac0a0cde3a2d$export$23e324a212d3f03d).fields.name.changed,
                errorText: (0, $f621ac0a0cde3a2d$export$23e324a212d3f03d).fields.name.$errorText
            });
            (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
                type: "email",
                label: "Email",
                inputChanged: (0, $f621ac0a0cde3a2d$export$23e324a212d3f03d).fields.email.changed,
                errorText: (0, $f621ac0a0cde3a2d$export$23e324a212d3f03d).fields.email.$errorText
            });
            (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
                type: "password",
                label: "Password",
                inputChanged: (0, $f621ac0a0cde3a2d$export$23e324a212d3f03d).fields.password.changed,
                errorText: (0, $f621ac0a0cde3a2d$export$23e324a212d3f03d).fields.password.$errorText
            });
            (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
                type: "password",
                label: "Confirm password",
                required: true,
                inputChanged: (0, $f621ac0a0cde3a2d$export$23e324a212d3f03d).fields.passwordConfirmation.changed,
                errorText: (0, $f621ac0a0cde3a2d$export$23e324a212d3f03d).fields.passwordConfirmation.$errorText
            });
            (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                text: "Register",
                event: (0, $f621ac0a0cde3a2d$export$23e324a212d3f03d).submit,
                size: "base",
                prevent: true,
                variant: "default"
            });
            (0, $50bc7b2791a6cb44$export$852d7888b34e2b72)((0, $f621ac0a0cde3a2d$export$6d69234222d2c2e3), (0, $f621ac0a0cde3a2d$export$6d69234222d2c2e3).map(Boolean));
        });
    });
};










var $agnkb = parcelRequire("agnkb");

const $0aa83f71ec916746$var$tagChecked = (0, $agnkb.createEvent)();
const $0aa83f71ec916746$var$tagUnchecked = (0, $agnkb.createEvent)();
const $0aa83f71ec916746$export$c131bf539d195aab = (0, $995c23da6372e497$export$f681a8129d2e9d28)({
    fields: {
        name: {
            init: "",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).required()
            ]
        },
        email: {
            init: "",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).required(),
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).email()
            ]
        },
        role: {
            init: "Member",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).required()
            ]
        },
        tag_ids: {
            init: [],
            rules: []
        },
        password: {
            init: "",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).required(),
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).password()
            ]
        },
        passwordConfirmation: {
            init: "",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).required(),
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).password()
            ]
        }
    },
    validateOn: [
        "submit"
    ]
});
const $0aa83f71ec916746$export$80ae25fb0441ca08 = (0, $agnkb.createStore)("");
const $0aa83f71ec916746$export$115fdab95928426d = (0, $agnkb.createEffect)((user)=>{
    return (0, $35791464ed1de21e$export$3493b8991d49f558)(user);
});
(0, $agnkb.sample)({
    source: $0aa83f71ec916746$export$c131bf539d195aab.formValidated,
    target: $0aa83f71ec916746$export$115fdab95928426d
});
(0, $agnkb.sample)({
    source: $0aa83f71ec916746$export$115fdab95928426d.doneData,
    filter: (userResponse)=>userResponse.success && Boolean(userResponse.data.id),
    target: [
        (0, $99a5bbd2d001ca47$export$74bc9c86497b4ac6).open,
        $0aa83f71ec916746$export$c131bf539d195aab.reset
    ]
});
(0, $agnkb.sample)({
    source: $0aa83f71ec916746$export$115fdab95928426d.doneData,
    filter: (userResponse)=>!userResponse.success,
    fn: (userResponse)=>userResponse.error,
    target: $0aa83f71ec916746$export$80ae25fb0441ca08
});
(0, $agnkb.sample)({
    source: $0aa83f71ec916746$export$c131bf539d195aab.fields.tag_ids.$value,
    clock: $0aa83f71ec916746$var$tagChecked,
    fn: (tags, newTagID)=>[
            ...tags,
            newTagID
        ],
    target: $0aa83f71ec916746$export$c131bf539d195aab.fields.tag_ids.onChange
});
(0, $agnkb.sample)({
    source: $0aa83f71ec916746$export$c131bf539d195aab.fields.tag_ids.$value,
    clock: $0aa83f71ec916746$var$tagUnchecked,
    fn: (tags, newTagID)=>tags.filter((t)=>t !== newTagID),
    target: $0aa83f71ec916746$export$c131bf539d195aab.fields.tag_ids.onChange
});
const $0aa83f71ec916746$export$4bf9923669ad6c63 = {
    tagChecked: $0aa83f71ec916746$var$tagChecked,
    tagUnchecked: $0aa83f71ec916746$var$tagUnchecked
};



var $agnkb = parcelRequire("agnkb");

const $977859033bdd8463$export$52bc5eaf00b02549 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("form", ()=>{
        (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
            type: "text",
            label: "Name",
            value: (0, $0aa83f71ec916746$export$c131bf539d195aab).fields.name.$value,
            inputChanged: (0, $0aa83f71ec916746$export$c131bf539d195aab).fields.name.changed,
            errorText: (0, $0aa83f71ec916746$export$c131bf539d195aab).fields.name.$errorText
        });
        (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
            type: "email",
            label: "Email",
            value: (0, $0aa83f71ec916746$export$c131bf539d195aab).fields.email.$value,
            inputChanged: (0, $0aa83f71ec916746$export$c131bf539d195aab).fields.email.changed,
            errorText: (0, $0aa83f71ec916746$export$c131bf539d195aab).fields.email.$errorText
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "mb-6"
                ]
            });
            (0, $36b3d4afe650f8db$export$ef9b1a59e592288f)({
                text: "Select a role",
                value: (0, $0aa83f71ec916746$export$c131bf539d195aab).fields.role.$value,
                options: (0, $agnkb.createStore)([
                    "Member",
                    "Admin"
                ]),
                optionSelected: (0, $0aa83f71ec916746$export$c131bf539d195aab).fields.role.changed
            });
        });
        const $tagSelectionVisible = (0, $0aa83f71ec916746$export$c131bf539d195aab).fields.role.$value.map((role)=>role !== "Admin");
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                visible: $tagSelectionVisible
            });
            (0, $56844779f94b1f26$export$eae70af4b4e3f197)({
                text: "Select tags",
                options: (0, $d38a3a161a7d1109$exports).$tags,
                selectedOptions: (0, $0aa83f71ec916746$export$c131bf539d195aab).fields.tag_ids.$value,
                optionChecked: (0, $0aa83f71ec916746$export$4bf9923669ad6c63).tagChecked,
                optionUnchecked: (0, $0aa83f71ec916746$export$4bf9923669ad6c63).tagUnchecked
            });
        });
        (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
            type: "password",
            label: "Password",
            required: true,
            value: (0, $0aa83f71ec916746$export$c131bf539d195aab).fields.password.$value,
            inputChanged: (0, $0aa83f71ec916746$export$c131bf539d195aab).fields.password.changed,
            errorText: (0, $0aa83f71ec916746$export$c131bf539d195aab).fields.password.$errorText
        });
        (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
            type: "password",
            label: "Confirm password",
            required: true,
            value: (0, $0aa83f71ec916746$export$c131bf539d195aab).fields.passwordConfirmation.$value,
            inputChanged: (0, $0aa83f71ec916746$export$c131bf539d195aab).fields.passwordConfirmation.changed,
            errorText: (0, $0aa83f71ec916746$export$c131bf539d195aab).fields.passwordConfirmation.$errorText
        });
        (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
            text: "Create",
            event: (0, $0aa83f71ec916746$export$c131bf539d195aab).submit,
            size: "base",
            prevent: true,
            variant: "default"
        });
        (0, $50bc7b2791a6cb44$export$852d7888b34e2b72)((0, $0aa83f71ec916746$export$80ae25fb0441ca08), (0, $0aa83f71ec916746$export$80ae25fb0441ca08).map(Boolean));
    });
};













var $agnkb = parcelRequire("agnkb");

const $c36b2fb4b37902b9$var$tagChecked = (0, $agnkb.createEvent)();
const $c36b2fb4b37902b9$var$tagUnchecked = (0, $agnkb.createEvent)();
const $c36b2fb4b37902b9$export$c131bf539d195aab = (0, $995c23da6372e497$export$f681a8129d2e9d28)({
    fields: {
        name: {
            init: "",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).required()
            ]
        },
        email: {
            init: "",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).required(),
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).email()
            ]
        },
        is_revoked: {
            init: false,
            rules: []
        },
        role: {
            init: "Member",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).required()
            ]
        },
        tag_ids: {
            init: [],
            rules: []
        },
        password: {
            init: "",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).password()
            ]
        },
        passwordConfirmation: {
            init: "",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).password()
            ]
        }
    },
    validateOn: [
        "submit"
    ]
});
const $c36b2fb4b37902b9$export$fc7ab2dba121b08d = (0, $agnkb.createStore)("");
const $c36b2fb4b37902b9$export$df6ab3ee37df290e = (0, $agnkb.createEffect)((user)=>{
    return (0, $35791464ed1de21e$export$2729cf999c745c98)(user);
});
(0, $agnkb.sample)({
    source: (0, $d461744a27a10557$exports).$currentUser,
    target: $c36b2fb4b37902b9$export$c131bf539d195aab.setInitialForm
});
(0, $agnkb.sample)({
    source: (0, $d461744a27a10557$exports).$currentUser,
    clock: $c36b2fb4b37902b9$export$c131bf539d195aab.formValidated,
    fn: (currentUser, userToEdit)=>{
        return {
            ...userToEdit,
            id: currentUser.id
        };
    },
    target: $c36b2fb4b37902b9$export$df6ab3ee37df290e
});
(0, $agnkb.sample)({
    source: $c36b2fb4b37902b9$export$df6ab3ee37df290e.doneData,
    filter: (userResponse)=>userResponse.success && Boolean(userResponse.data.id),
    target: [
        $c36b2fb4b37902b9$export$c131bf539d195aab.reset,
        (0, $99a5bbd2d001ca47$export$74bc9c86497b4ac6).open
    ]
});
(0, $agnkb.sample)({
    source: $c36b2fb4b37902b9$export$df6ab3ee37df290e.doneData,
    filter: (userResponse)=>!userResponse.success,
    fn: (userResponse)=>userResponse.error,
    target: $c36b2fb4b37902b9$export$fc7ab2dba121b08d
});
const $c36b2fb4b37902b9$export$b648f854811ba86e = (0, $agnkb.createEffect)((id)=>{
    (0, $35791464ed1de21e$export$7d0f10f273c0438a)(id);
});
const $c36b2fb4b37902b9$export$512f3066ec3171e4 = (0, $agnkb.createEvent)();
const $c36b2fb4b37902b9$var$alertDeleteFx = (0, $agnkb.createEffect)((id)=>{
    const confirmed = confirm("Are you sure you want to delete this user?");
    return confirmed ? {
        confirmed: true,
        id: id
    } : {
        confirmed: false,
        id: id
    };
});
(0, $agnkb.sample)({
    clock: $c36b2fb4b37902b9$export$512f3066ec3171e4,
    target: $c36b2fb4b37902b9$var$alertDeleteFx
});
(0, $agnkb.sample)({
    source: (0, $d461744a27a10557$exports).$currentUser,
    clock: $c36b2fb4b37902b9$var$alertDeleteFx.doneData,
    filter: (_, { confirmed: confirmed })=>confirmed,
    fn: ({ id: id })=>id,
    target: $c36b2fb4b37902b9$export$b648f854811ba86e
});
(0, $e13fe69fd88e859a$export$89e12c5b50f7529d)({
    clock: $c36b2fb4b37902b9$export$b648f854811ba86e.done,
    route: (0, $99a5bbd2d001ca47$export$74bc9c86497b4ac6)
});
(0, $agnkb.sample)({
    source: $c36b2fb4b37902b9$export$c131bf539d195aab.fields.tag_ids.$value,
    clock: $c36b2fb4b37902b9$var$tagChecked,
    fn: (tags, newTagID)=>[
            ...tags,
            newTagID
        ],
    target: $c36b2fb4b37902b9$export$c131bf539d195aab.fields.tag_ids.onChange
});
(0, $agnkb.sample)({
    source: $c36b2fb4b37902b9$export$c131bf539d195aab.fields.tag_ids.$value,
    clock: $c36b2fb4b37902b9$var$tagUnchecked,
    fn: (tags, newTagID)=>tags.filter((t)=>t !== newTagID),
    target: $c36b2fb4b37902b9$export$c131bf539d195aab.fields.tag_ids.onChange
});
const $c36b2fb4b37902b9$export$4bf9923669ad6c63 = {
    tagChecked: $c36b2fb4b37902b9$var$tagChecked,
    tagUnchecked: $c36b2fb4b37902b9$var$tagUnchecked
};



var $agnkb = parcelRequire("agnkb");

const $29db75923d80c4fe$export$84403d1f0ee954bb = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("form", ()=>{
        (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
            type: "text",
            label: "Name",
            value: (0, $c36b2fb4b37902b9$export$c131bf539d195aab).fields.name.$value,
            inputChanged: (0, $c36b2fb4b37902b9$export$c131bf539d195aab).fields.name.changed,
            errorText: (0, $c36b2fb4b37902b9$export$c131bf539d195aab).fields.name.$errorText
        });
        (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
            type: "email",
            label: "Email",
            value: (0, $c36b2fb4b37902b9$export$c131bf539d195aab).fields.email.$value,
            inputChanged: (0, $c36b2fb4b37902b9$export$c131bf539d195aab).fields.email.changed,
            errorText: (0, $c36b2fb4b37902b9$export$c131bf539d195aab).fields.email.$errorText
        });
        (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
            type: "checkbox",
            label: "Revoked",
            value: (0, $c36b2fb4b37902b9$export$c131bf539d195aab).fields.is_revoked.$value,
            inputChanged: (0, $c36b2fb4b37902b9$export$c131bf539d195aab).fields.is_revoked.changed,
            errorText: (0, $c36b2fb4b37902b9$export$c131bf539d195aab).fields.is_revoked.$errorText
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "mb-6"
                ]
            });
            (0, $36b3d4afe650f8db$export$ef9b1a59e592288f)({
                text: "Select a role",
                value: (0, $c36b2fb4b37902b9$export$c131bf539d195aab).fields.role.$value,
                options: (0, $agnkb.createStore)([
                    "Member",
                    "Admin"
                ]),
                optionSelected: (0, $c36b2fb4b37902b9$export$c131bf539d195aab).fields.role.changed
            });
        });
        const $tagSelectionVisible = (0, $c36b2fb4b37902b9$export$c131bf539d195aab).fields.role.$value.map((role)=>role !== "Admin");
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                visible: $tagSelectionVisible
            });
            (0, $56844779f94b1f26$export$eae70af4b4e3f197)({
                text: "Select tags",
                options: (0, $d38a3a161a7d1109$exports).$tags,
                selectedOptions: (0, $c36b2fb4b37902b9$export$c131bf539d195aab).fields.tag_ids.$value,
                optionChecked: (0, $c36b2fb4b37902b9$export$4bf9923669ad6c63).tagChecked,
                optionUnchecked: (0, $c36b2fb4b37902b9$export$4bf9923669ad6c63).tagUnchecked
            });
        });
        (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
            type: "password",
            label: "Password",
            required: true,
            value: (0, $c36b2fb4b37902b9$export$c131bf539d195aab).fields.password.$value,
            inputChanged: (0, $c36b2fb4b37902b9$export$c131bf539d195aab).fields.password.changed,
            errorText: (0, $c36b2fb4b37902b9$export$c131bf539d195aab).fields.password.$errorText
        });
        (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
            value: (0, $c36b2fb4b37902b9$export$c131bf539d195aab).fields.passwordConfirmation.$value,
            type: "password",
            label: "Confirm password",
            required: true,
            inputChanged: (0, $c36b2fb4b37902b9$export$c131bf539d195aab).fields.passwordConfirmation.changed,
            errorText: (0, $c36b2fb4b37902b9$export$c131bf539d195aab).fields.passwordConfirmation.$errorText
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "flex",
                    "justify-start",
                    "space-x-2"
                ]
            });
            (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                text: "Save",
                event: (0, $c36b2fb4b37902b9$export$c131bf539d195aab).submit,
                size: "base",
                prevent: true,
                variant: "default"
            });
            (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                text: "Delete",
                event: (0, $c36b2fb4b37902b9$export$512f3066ec3171e4),
                size: "base",
                prevent: true,
                variant: "delete"
            });
        });
        (0, $50bc7b2791a6cb44$export$852d7888b34e2b72)((0, $c36b2fb4b37902b9$export$fc7ab2dba121b08d), (0, $c36b2fb4b37902b9$export$fc7ab2dba121b08d).map(Boolean));
    });
};










var $agnkb = parcelRequire("agnkb");

const $e4d530802f548216$export$3f33f0eacbfa003d = (0, $995c23da6372e497$export$f681a8129d2e9d28)({
    fields: {
        name: {
            init: "",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).required()
            ]
        }
    },
    validateOn: [
        "submit"
    ]
});
const $e4d530802f548216$export$80ae25fb0441ca08 = (0, $agnkb.createStore)("");
const $e4d530802f548216$export$d7248b891acae91a = (0, $agnkb.createEffect)((apiToken)=>{
    return (0, $f54641c7b3157777$export$7703b0c6d42d7aa3)(apiToken);
});
(0, $agnkb.sample)({
    source: $e4d530802f548216$export$3f33f0eacbfa003d.formValidated,
    target: $e4d530802f548216$export$d7248b891acae91a
});
const $e4d530802f548216$var$resetToken = (0, $agnkb.createEvent)();
const $e4d530802f548216$export$177d12b6b7ffef8d = (0, $agnkb.createStore)("").reset($e4d530802f548216$var$resetToken);
(0, $agnkb.sample)({
    source: $e4d530802f548216$export$d7248b891acae91a.doneData,
    filter: (apiTokenResponse)=>apiTokenResponse.success && Boolean(apiTokenResponse.data.id),
    fn: (apiTokenResponse)=>apiTokenResponse.data.token,
    target: [
        $e4d530802f548216$export$177d12b6b7ffef8d,
        $e4d530802f548216$export$3f33f0eacbfa003d.reset
    ]
});
(0, $agnkb.sample)({
    clock: (0, $99a5bbd2d001ca47$export$5375cda95f0b0eb4).$path,
    target: $e4d530802f548216$var$resetToken
});
(0, $agnkb.sample)({
    source: $e4d530802f548216$export$d7248b891acae91a.doneData,
    filter: (apiTokenResponse)=>!apiTokenResponse.success,
    fn: (apiTokenResponse)=>apiTokenResponse.error,
    target: $e4d530802f548216$export$80ae25fb0441ca08
});



var $agnkb = parcelRequire("agnkb");
const $17f806cd5c2df842$export$da721989ce272e44 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("form", ()=>{
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                visible: (0, $e4d530802f548216$export$177d12b6b7ffef8d).map((t)=>!t)
            });
            (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
                type: "text",
                label: "Name",
                value: (0, $e4d530802f548216$export$3f33f0eacbfa003d).fields.name.$value,
                inputChanged: (0, $e4d530802f548216$export$3f33f0eacbfa003d).fields.name.changed,
                errorText: (0, $e4d530802f548216$export$3f33f0eacbfa003d).fields.name.$errorText,
                hint: "Name - is used to indicate which service will use this API token. It does not affect the token functionally"
            });
            (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                text: "Create",
                event: (0, $e4d530802f548216$export$3f33f0eacbfa003d).submit,
                size: "base",
                prevent: true,
                variant: "default"
            });
            (0, $50bc7b2791a6cb44$export$852d7888b34e2b72)((0, $e4d530802f548216$export$80ae25fb0441ca08), (0, $e4d530802f548216$export$80ae25fb0441ca08).map(Boolean));
        });
        (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
            type: "text",
            label: "Your integration API token has been successfully created. Make sure to save it securely now, as it won't be displayed again for security reasons",
            value: (0, $e4d530802f548216$export$177d12b6b7ffef8d),
            visible: (0, $e4d530802f548216$export$177d12b6b7ffef8d).map(Boolean),
            inputChanged: (0, $agnkb.createEvent)()
        });
    });
};












var $agnkb = parcelRequire("agnkb");

const $606827bb7bd57343$export$3f33f0eacbfa003d = (0, $995c23da6372e497$export$f681a8129d2e9d28)({
    fields: {
        name: {
            init: "",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).required()
            ]
        },
        is_revoked: {
            init: false,
            rules: []
        }
    },
    validateOn: [
        "submit"
    ]
});
const $606827bb7bd57343$export$fc7ab2dba121b08d = (0, $agnkb.createStore)("");
const $606827bb7bd57343$export$12c7396c1c52ec49 = (0, $agnkb.createEffect)((apiToken)=>{
    return (0, $f54641c7b3157777$export$31fac03968f1e535)(apiToken);
});
(0, $agnkb.sample)({
    source: (0, $342d003583f843b3$exports).$currentApiToken,
    target: $606827bb7bd57343$export$3f33f0eacbfa003d.setInitialForm
});
(0, $agnkb.sample)({
    source: (0, $342d003583f843b3$exports).$currentApiToken,
    clock: $606827bb7bd57343$export$3f33f0eacbfa003d.formValidated,
    fn: (currentApiToken, apiTokenToEdit)=>{
        return {
            ...apiTokenToEdit,
            id: currentApiToken.id
        };
    },
    target: $606827bb7bd57343$export$12c7396c1c52ec49
});
(0, $agnkb.sample)({
    source: $606827bb7bd57343$export$12c7396c1c52ec49.doneData,
    filter: (apiTokenResponse)=>apiTokenResponse.success && Boolean(apiTokenResponse.data.id),
    target: [
        $606827bb7bd57343$export$3f33f0eacbfa003d.reset,
        (0, $99a5bbd2d001ca47$export$14fdbf877e70314a).open
    ]
});
(0, $agnkb.sample)({
    source: $606827bb7bd57343$export$12c7396c1c52ec49.doneData,
    filter: (apiTokenResponse)=>!apiTokenResponse.success,
    fn: (apiTokenResponse)=>apiTokenResponse.error,
    target: $606827bb7bd57343$export$fc7ab2dba121b08d
});
const $606827bb7bd57343$var$deleteApiTokenFx = (0, $agnkb.createEffect)((id)=>{
    (0, $f54641c7b3157777$export$9a463dbd0de9693b)(id);
});
const $606827bb7bd57343$export$788c63e97b8e259c = (0, $agnkb.createEvent)();
const $606827bb7bd57343$var$alertDeleteFx = (0, $agnkb.createEffect)((id)=>{
    const confirmed = confirm("Are you sure you want to delete this API token?");
    return confirmed ? {
        confirmed: true,
        id: id
    } : {
        confirmed: false,
        id: id
    };
});
(0, $agnkb.sample)({
    clock: $606827bb7bd57343$export$788c63e97b8e259c,
    target: $606827bb7bd57343$var$alertDeleteFx
});
(0, $agnkb.sample)({
    source: (0, $342d003583f843b3$exports).$currentApiToken,
    clock: $606827bb7bd57343$var$alertDeleteFx.doneData,
    filter: (_, { confirmed: confirmed })=>confirmed,
    fn: ({ id: id })=>id,
    target: $606827bb7bd57343$var$deleteApiTokenFx
});
(0, $e13fe69fd88e859a$export$89e12c5b50f7529d)({
    clock: $606827bb7bd57343$var$deleteApiTokenFx.done,
    route: (0, $99a5bbd2d001ca47$export$14fdbf877e70314a)
});


const $90e03fc11c96bd1f$export$f86fac28d312f23a = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("form", ()=>{
        (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
            type: "text",
            label: "Name",
            value: (0, $606827bb7bd57343$export$3f33f0eacbfa003d).fields.name.$value,
            inputChanged: (0, $606827bb7bd57343$export$3f33f0eacbfa003d).fields.name.changed,
            errorText: (0, $606827bb7bd57343$export$3f33f0eacbfa003d).fields.name.$errorText,
            hint: "Name - is used to indicate which service will use this API token. It does not affect the token functionally"
        });
        (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
            type: "checkbox",
            label: "Revoked",
            value: (0, $606827bb7bd57343$export$3f33f0eacbfa003d).fields.is_revoked.$value,
            inputChanged: (0, $606827bb7bd57343$export$3f33f0eacbfa003d).fields.is_revoked.changed,
            errorText: (0, $606827bb7bd57343$export$3f33f0eacbfa003d).fields.is_revoked.$errorText
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "flex",
                    "justify-start",
                    "space-x-2"
                ]
            });
            (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                text: "Save",
                event: (0, $606827bb7bd57343$export$3f33f0eacbfa003d).submit,
                size: "base",
                prevent: true,
                variant: "default"
            });
            (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                text: "Delete",
                event: (0, $606827bb7bd57343$export$788c63e97b8e259c),
                size: "base",
                prevent: true,
                variant: "delete"
            });
        });
        (0, $50bc7b2791a6cb44$export$852d7888b34e2b72)((0, $606827bb7bd57343$export$fc7ab2dba121b08d), (0, $606827bb7bd57343$export$fc7ab2dba121b08d).map(Boolean));
    });
};










var $agnkb = parcelRequire("agnkb");

const $012f197d96c393a5$export$95f51435d026f585 = (0, $995c23da6372e497$export$f681a8129d2e9d28)({
    fields: {
        name: {
            init: "",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).required()
            ]
        }
    },
    validateOn: [
        "submit"
    ]
});
const $012f197d96c393a5$export$80ae25fb0441ca08 = (0, $agnkb.createStore)("");
const $012f197d96c393a5$export$8be071a101db945e = (0, $agnkb.createEffect)((tag)=>{
    return (0, $52b80dee660e935b$export$ee84a198a55b65e5)(tag);
});
(0, $agnkb.sample)({
    source: $012f197d96c393a5$export$95f51435d026f585.formValidated,
    target: $012f197d96c393a5$export$8be071a101db945e
});
(0, $agnkb.sample)({
    source: $012f197d96c393a5$export$8be071a101db945e.doneData,
    filter: (tagResponse)=>tagResponse.success && Boolean(tagResponse.data.id),
    target: [
        $012f197d96c393a5$export$95f51435d026f585.reset,
        (0, $99a5bbd2d001ca47$export$773ade5e3261acbd).open
    ]
});
(0, $agnkb.sample)({
    source: $012f197d96c393a5$export$8be071a101db945e.doneData,
    filter: (tagResponse)=>!tagResponse.success,
    fn: (tagResponse)=>tagResponse.error,
    target: $012f197d96c393a5$export$80ae25fb0441ca08
});


const $57bcdcdb1e37881f$export$d18a51de73af28cf = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("form", ()=>{
        (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
            type: "text",
            label: "Name",
            value: (0, $012f197d96c393a5$export$95f51435d026f585).fields.name.$value,
            inputChanged: (0, $012f197d96c393a5$export$95f51435d026f585).fields.name.changed,
            errorText: (0, $012f197d96c393a5$export$95f51435d026f585).fields.name.$errorText,
            hint: "Name - used for the human-readable name of the tag in the web interface"
        });
        (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
            text: "Create",
            event: (0, $012f197d96c393a5$export$95f51435d026f585).submit,
            size: "base",
            prevent: true,
            variant: "default"
        });
        (0, $50bc7b2791a6cb44$export$852d7888b34e2b72)((0, $012f197d96c393a5$export$80ae25fb0441ca08), (0, $012f197d96c393a5$export$80ae25fb0441ca08).map(Boolean));
    });
};












var $agnkb = parcelRequire("agnkb");

const $308feb680b99ce97$export$95f51435d026f585 = (0, $995c23da6372e497$export$f681a8129d2e9d28)({
    fields: {
        name: {
            init: "",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).required()
            ]
        }
    },
    validateOn: [
        "submit"
    ]
});
const $308feb680b99ce97$export$fc7ab2dba121b08d = (0, $agnkb.createStore)("");
const $308feb680b99ce97$export$d363da60efdc3b1 = (0, $agnkb.createEffect)((tag)=>{
    return (0, $52b80dee660e935b$export$aaf61dfaebff7546)(tag);
});
(0, $agnkb.sample)({
    source: (0, $d38a3a161a7d1109$exports).$currentTag,
    target: $308feb680b99ce97$export$95f51435d026f585.setInitialForm
});
(0, $agnkb.sample)({
    source: (0, $d38a3a161a7d1109$exports).$currentTag,
    clock: $308feb680b99ce97$export$95f51435d026f585.formValidated,
    fn: (currentTag, tagToEdit)=>{
        return {
            ...tagToEdit,
            id: currentTag.id
        };
    },
    target: $308feb680b99ce97$export$d363da60efdc3b1
});
(0, $agnkb.sample)({
    source: $308feb680b99ce97$export$d363da60efdc3b1.doneData,
    filter: (tagResponse)=>tagResponse.success && Boolean(tagResponse.data.id),
    target: [
        $308feb680b99ce97$export$95f51435d026f585.reset,
        (0, $99a5bbd2d001ca47$export$773ade5e3261acbd).open
    ]
});
(0, $agnkb.sample)({
    source: $308feb680b99ce97$export$d363da60efdc3b1.doneData,
    filter: (tagResponse)=>!tagResponse.success,
    fn: (tagResponse)=>tagResponse.error,
    target: $308feb680b99ce97$export$fc7ab2dba121b08d
});
const $308feb680b99ce97$var$deleteTagFx = (0, $agnkb.createEffect)((id)=>{
    (0, $52b80dee660e935b$export$2895d72886bc0b68)(id);
});
const $308feb680b99ce97$export$58aa8b8ed9576027 = (0, $agnkb.createEvent)();
const $308feb680b99ce97$var$alertDeleteFx = (0, $agnkb.createEffect)((id)=>{
    const confirmed = confirm("Are you sure you want to delete this tag?");
    return confirmed ? {
        confirmed: true,
        id: id
    } : {
        confirmed: false,
        id: id
    };
});
(0, $agnkb.sample)({
    clock: $308feb680b99ce97$export$58aa8b8ed9576027,
    target: $308feb680b99ce97$var$alertDeleteFx
});
(0, $agnkb.sample)({
    source: (0, $d38a3a161a7d1109$exports).$currentTag,
    clock: $308feb680b99ce97$var$alertDeleteFx.doneData,
    filter: (_, { confirmed: confirmed })=>confirmed,
    fn: ({ id: id })=>id,
    target: $308feb680b99ce97$var$deleteTagFx
});
(0, $e13fe69fd88e859a$export$89e12c5b50f7529d)({
    clock: $308feb680b99ce97$var$deleteTagFx.done,
    route: (0, $99a5bbd2d001ca47$export$773ade5e3261acbd)
});


const $bb9a43c618f90a0a$export$9463da1fa69280fc = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("form", ()=>{
        (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
            type: "text",
            label: "Name",
            value: (0, $308feb680b99ce97$export$95f51435d026f585).fields.name.$value,
            inputChanged: (0, $308feb680b99ce97$export$95f51435d026f585).fields.name.changed,
            errorText: (0, $308feb680b99ce97$export$95f51435d026f585).fields.name.$errorText,
            hint: "Name - used for the human-readable name of the tag in the web interface"
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "flex",
                    "justify-start",
                    "space-x-2"
                ]
            });
            (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                text: "Save",
                event: (0, $308feb680b99ce97$export$95f51435d026f585).submit,
                size: "base",
                prevent: true,
                variant: "default"
            });
            (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                text: "Delete",
                event: (0, $308feb680b99ce97$export$58aa8b8ed9576027),
                size: "base",
                prevent: true,
                variant: "delete"
            });
        });
        (0, $50bc7b2791a6cb44$export$852d7888b34e2b72)((0, $308feb680b99ce97$export$fc7ab2dba121b08d), (0, $308feb680b99ce97$export$fc7ab2dba121b08d).map(Boolean));
    });
};







var $agnkb = parcelRequire("agnkb");

const $8103980a7e39bede$export$238bd84311fcbf75 = ({ applied: applied, levelChanged: levelChanged, level: level, resetLevelFilter: resetLevelFilter })=>{
    const dropdownTriggered = (0, $agnkb.createEvent)();
    const $localVisible = (0, $agnkb.createStore)(false);
    const outsideClicked = (0, $agnkb.createEvent)();
    (0, $agnkb.sample)({
        source: $localVisible,
        clock: [
            dropdownTriggered,
            levelChanged
        ],
        fn: (v)=>!v,
        target: $localVisible
    });
    (0, $agnkb.sample)({
        source: $localVisible,
        clock: outsideClicked,
        filter: (visible, { node: node, event: event })=>!node.contains(event.target) && visible,
        fn: ()=>false,
        target: $localVisible
    });
    const $levels = (0, $agnkb.createStore)([
        "Info",
        "Error",
        "Warn",
        "Debug",
        "Trace",
        "Fatal"
    ]);
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "relative"
            ]
        });
        (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
            text: (0, $agnkb.combine)([
                (0, $agnkb.createStore)("Level"),
                level
            ], ([defaultLabel, level])=>level || defaultLabel),
            variant: applied.map((state)=>state ? "default" : "alternative"),
            size: "small",
            event: dropdownTriggered,
            preIcon: (0, $b4a930a779b8fa8d$export$98afb0d17ceac256),
            postIcon: (0, $cfe9a25a978b21b0$export$4d7ad962dfb0e81e)
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                visible: $localVisible
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "max-h-56",
                        "overflow-scroll",
                        "left-0",
                        "absolute",
                        "left-0",
                        "top-18",
                        "w-fit",
                        "border",
                        "border-gray-200",
                        "dark:bg-gray-800",
                        "dark:border-gray-700",
                        "z-50",
                        "bg-white",
                        "divide-y",
                        "divide-gray-100",
                        "rounded-lg",
                        "shadow",
                        "dark:bg-gray-700",
                        "dark:divide-gray-600",
                        "shadow-2xl"
                    ]
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("ul", ()=>{
                    (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                        classList: [
                            "flex",
                            "flex-col",
                            "flex-wrap",
                            "text-gray-700",
                            "dark:text-gray-200"
                        ]
                    });
                    (0, $133989e677847899$export$dda1d9f60106f0e9)("li", {
                        classList: [
                            "hover:bg-gray-100",
                            "dark:hover:bg-gray-600",
                            "flex",
                            "border-gray-300",
                            "dark:border-gray-700",
                            "items-center",
                            "px-6",
                            "py-2.5",
                            "flex-auto",
                            "w-full",
                            "text-sm",
                            "font-medium",
                            "text-gray-900",
                            "dark:text-white",
                            "shrink-0",
                            "block",
                            "cursor-pointer"
                        ],
                        text: "—",
                        handler: {
                            on: {
                                click: resetLevelFilter
                            }
                        }
                    });
                    (0, $133989e677847899$export$8837f4fc672e936d)($levels, ({ store: level })=>{
                        (0, $133989e677847899$export$dda1d9f60106f0e9)("li", ()=>{
                            const localLevelSelected = (0, $agnkb.createEvent)();
                            (0, $agnkb.sample)({
                                source: level,
                                clock: localLevelSelected,
                                fn: (level)=>level,
                                target: levelChanged
                            });
                            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                                classList: [
                                    "hover:bg-gray-100",
                                    "dark:hover:bg-gray-600",
                                    "flex",
                                    "border-gray-300",
                                    "dark:border-gray-700",
                                    "items-center",
                                    "px-6",
                                    "py-2.5",
                                    "flex-auto",
                                    "w-full",
                                    "text-sm",
                                    "font-medium",
                                    "text-gray-900",
                                    "dark:text-white",
                                    "shrink-0",
                                    "block",
                                    "cursor-pointer"
                                ],
                                text: level.map((l)=>l),
                                handler: {
                                    on: {
                                        click: localLevelSelected
                                    }
                                }
                            });
                        });
                    });
                });
            });
        });
        (0, $133989e677847899$export$35059013cd4a06db)((node)=>{
            document.addEventListener("click", (event)=>{
                outsideClicked({
                    node: node,
                    event: event
                });
            });
        });
    });
};









var $agnkb = parcelRequire("agnkb");

const $26f69fcd82c2fb22$var$$currentSchema = (0, $agnkb.combine)([
    (0, $99a5bbd2d001ca47$export$7b0e65fd5f03ad04).$params,
    (0, $8aa4cde03a0e26f5$exports).$schemas
], ([params, schemas])=>{
    const currentSchema = schemas.find((s)=>s.name === params.schemaName);
    if (currentSchema) return currentSchema;
    return {
        id: 0,
        title: "",
        description: "",
        name: "",
        fields: [],
        kinds: []
    };
});
const $26f69fcd82c2fb22$var$$currentFilter = (0, $agnkb.combine)([
    $26f69fcd82c2fb22$var$$currentSchema,
    (0, $b047cb928fb2fbfa$exports).$formattedSearchFilter
], ([schema, searchFilter])=>{
    const filter = JSON.parse(searchFilter);
    const fields = schema?.fields || [];
    return fields.map((f)=>{
        const value = filter[f.name] || "";
        return {
            name: f.title,
            key: f.name,
            value: value
        };
    });
});
const $26f69fcd82c2fb22$export$79d13b60110f33be = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "pb-4"
            ]
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "flex",
                    "max-w-2xl",
                    "w-full",
                    "flex-row"
                ]
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "w-full"
                    ]
                });
                (0, $84354d291f24209c$export$4b85d3515bd863a5)((0, $b047cb928fb2fbfa$exports).events.queryChanged, (0, $b047cb928fb2fbfa$exports).$searchQuery);
            });
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "relative",
                    "flex",
                    "space-x-2"
                ]
            });
            // Filter by query and kind
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "flex",
                        "items-center"
                    ]
                });
                const $filtersApplied = (0, $agnkb.combine)($26f69fcd82c2fb22$var$$currentFilter, (0, $b047cb928fb2fbfa$exports).$currentKind, (items, kind)=>{
                    const itemsApplied = items.filter((item)=>item.value.trim().length > 0).length > 0;
                    const kindApplied = kind?.length > 0;
                    return itemsApplied || kindApplied;
                });
                (0, $0fe4bfda9278ce93$export$ec91da630f36d5ea)({
                    filterItems: $26f69fcd82c2fb22$var$$currentFilter,
                    filterChanged: (0, $b047cb928fb2fbfa$exports).events.filterChanged,
                    currentKind: (0, $b047cb928fb2fbfa$exports).$currentKind,
                    kindItems: $26f69fcd82c2fb22$var$$currentSchema.map((s)=>s.kinds || []),
                    kindChanged: (0, $b047cb928fb2fbfa$exports).events.kindChanged,
                    applied: $filtersApplied
                });
                const filterCleared = (0, $agnkb.createEvent)();
                (0, $agnkb.sample)({
                    clock: filterCleared,
                    fn: ()=>({}),
                    target: (0, $b047cb928fb2fbfa$exports).events.resetFilter
                });
                (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                    text: "Clear",
                    variant: "light",
                    size: "small",
                    event: filterCleared,
                    visible: $filtersApplied
                });
            });
            // Filter by datetime range
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "flex",
                        "items-center"
                    ]
                });
                const $timeFiltersApplied = (0, $agnkb.combine)([
                    (0, $b047cb928fb2fbfa$exports).$currentFromTime,
                    (0, $b047cb928fb2fbfa$exports).$currentToTime
                ], ([from, to])=>{
                    return Boolean(from) || Boolean(to);
                });
                (0, $4e0656ad48906f69$export$a6671a32ac390a0c)({
                    applied: $timeFiltersApplied,
                    fromTime: (0, $b047cb928fb2fbfa$exports).$currentFromTime,
                    fromTimeChanged: (0, $b047cb928fb2fbfa$exports).events.fromTimeChanged,
                    toTime: (0, $b047cb928fb2fbfa$exports).$currentToTime,
                    toTimeChanged: (0, $b047cb928fb2fbfa$exports).events.toTimeChanged
                });
                const timeFilterCleared = (0, $agnkb.createEvent)();
                (0, $agnkb.sample)({
                    clock: timeFilterCleared,
                    fn: ()=>({}),
                    target: (0, $b047cb928fb2fbfa$exports).events.resetTimeFilter
                });
                (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                    text: "Clear",
                    variant: "light",
                    size: "small",
                    event: timeFilterCleared,
                    visible: $timeFiltersApplied
                });
            });
            // Filter by level
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "flex",
                        "items-center"
                    ]
                });
                const $levelFiltersApplied = (0, $b047cb928fb2fbfa$exports).$currentLevel.map(Boolean);
                (0, $8103980a7e39bede$export$238bd84311fcbf75)({
                    applied: $levelFiltersApplied,
                    level: (0, $b047cb928fb2fbfa$exports).$currentLevel,
                    levelChanged: (0, $b047cb928fb2fbfa$exports).events.levelChanged,
                    resetLevelFilter: (0, $b047cb928fb2fbfa$exports).events.resetLevelFilter
                });
                const levelFilterCleared = (0, $agnkb.createEvent)();
                (0, $agnkb.sample)({
                    clock: levelFilterCleared,
                    fn: ()=>({}),
                    target: (0, $b047cb928fb2fbfa$exports).events.resetLevelFilter
                });
                (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                    text: "Clear",
                    variant: "light",
                    size: "small",
                    event: levelFilterCleared,
                    visible: $levelFiltersApplied
                });
            });
        });
    });
};








var $agnkb = parcelRequire("agnkb");

const $b28c0d0baf4d3d77$var$$schema = (0, $agnkb.combine)([
    (0, $99a5bbd2d001ca47$export$5375cda95f0b0eb4).$activeRoutes,
    (0, $8aa4cde03a0e26f5$exports).$schemas
], ([activeRoutes, schemas])=>{
    const schemaName = activeRoutes[0]?.$params.getState().schemaName;
    return schemas.find((s)=>s.name === schemaName) || null;
});
const $b28c0d0baf4d3d77$var$$schemaTitle = $b28c0d0baf4d3d77$var$$schema.map((s)=>s?.title || "");
const $b28c0d0baf4d3d77$export$2fd85863a4729089 = ()=>{
    const routeOpened = (0, $agnkb.createEvent)();
    (0, $agnkb.sample)({
        source: [
            (0, $99a5bbd2d001ca47$export$7b0e65fd5f03ad04).$params,
            (0, $8aa4cde03a0e26f5$exports).$schemas
        ],
        clock: routeOpened,
        fn: ([params, schemas])=>{
            const schemaId = schemas.find((s)=>s.name === params.schemaName)?.id;
            return {
                id: schemaId || 0
            };
        },
        target: (0, $99a5bbd2d001ca47$export$102e5ceef0d527c1).open
    });
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "flex",
                "items-center",
                "justify-between"
            ]
        });
        (0, $ccd9bd4f73abf9cf$export$8b251419efc915eb)($b28c0d0baf4d3d77$var$$schemaTitle);
        (0, $13a4b22c312e9558$export$292f834bcb6eb1a1)("Admin", ()=>{
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "ml-2.5"
                    ]
                });
                (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                    text: "Settings",
                    variant: "default",
                    size: "extra_small",
                    event: routeOpened
                });
            });
        });
    });
};







var $agnkb = parcelRequire("agnkb");

const $e7296d402af7e8a9$export$e29e7e18e02e605e = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "flex",
                "flex-col",
                "space-y-6",
                "mt-2"
            ]
        });
        const $activeSchema = (0, $agnkb.combine)([
            (0, $99a5bbd2d001ca47$export$5375cda95f0b0eb4).$activeRoutes,
            (0, $8aa4cde03a0e26f5$exports).$schemas
        ], ([activeRoutes, schemas])=>{
            const schemaName = activeRoutes[0]?.$params.getState().schemaName;
            return schemas.find((s)=>s.name === schemaName) || null;
        });
        (0, $133989e677847899$export$8837f4fc672e936d)((0, $b047cb928fb2fbfa$exports).$logsGroups, ({ store: group })=>{
            (0, $67c46e6f0d26bccc$export$e4e28536a33d07a3)({
                tags: group.map((g)=>g.tags),
                kind: group.map((g)=>g.kind),
                schema: $activeSchema,
                href: group.map((g)=>`${g.schema_name}/${g.group_hash}`),
                content: ()=>{
                    (0, $c9f21913a9eee54d$export$58be81f5c6860851)(group.map((g)=>g.logs));
                }
            });
        });
    });
};






var $agnkb = parcelRequire("agnkb");

const $f3fe18bde3766b9c$export$48f6b48a42d49a36 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "flex",
                "flex-col",
                "space-y-6",
                "mt-3"
            ]
        });
        const editTagClicked = (0, $agnkb.createEvent)();
        (0, $agnkb.sample)({
            source: editTagClicked,
            fn: (id)=>({
                    id: id
                }),
            target: (0, $99a5bbd2d001ca47$export$21c91e254ab993b9).open
        });
        (0, $53c993165942ee63$export$8cea405697bd6ef)((0, $d38a3a161a7d1109$exports).$tags, editTagClicked);
    });
};






var $agnkb = parcelRequire("agnkb");

const $c3011c55eb821fab$export$86a2ad2cbd078da9 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "flex",
                "flex-col",
                "space-y-6",
                "mt-3"
            ]
        });
        const editApiTokenClicked = (0, $agnkb.createEvent)();
        (0, $agnkb.sample)({
            source: editApiTokenClicked,
            fn: (id)=>({
                    id: id
                }),
            target: (0, $99a5bbd2d001ca47$export$dabbba65ed76796e).open
        });
        (0, $452d31565306cecd$export$d9a60fd79fbcc877)((0, $342d003583f843b3$exports).$apiTokens, editApiTokenClicked);
    });
};




const $891f142abfdf8517$export$c17ac1167fee36b4 = ()=>{
    (0, $a98816a4129b2dff$export$e6ff31bff12b7ff4)("2xl");
    (0, $ffb7d3ea5d42063a$export$334c29725a78c21d)();
};




const $441c5755e98a2888$export$1f41dfafa8aa46d7 = ()=>{
    (0, $ccd9bd4f73abf9cf$export$8b251419efc915eb)("Create initial moonlogs admin");
    (0, $ea116515a0a36702$export$36efa24ef475d1f4)();
};






var $agnkb = parcelRequire("agnkb");

const $43b60f79e6520491$export$ac7bdc137eeafdfd = (text, route)=>{
    const routeOpened = (0, $agnkb.createEvent)();
    (0, $e13fe69fd88e859a$export$89e12c5b50f7529d)({
        clock: routeOpened,
        route: route
    });
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "flex",
                "items-center"
            ]
        });
        (0, $ccd9bd4f73abf9cf$export$8b251419efc915eb)(text);
        (0, $13a4b22c312e9558$export$292f834bcb6eb1a1)("Admin", ()=>{
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "ml-2.5"
                    ]
                });
                (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                    text: "",
                    variant: "default",
                    style: "round",
                    size: "extra_small",
                    event: routeOpened,
                    preIcon: (0, $8295e9913b74aadf$export$f21ab0717a89c77f)
                });
            });
        });
    });
};






var $agnkb = parcelRequire("agnkb");

const $0f78e9a16afe7d09$export$b7b58f2e100445f7 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "container",
                "mx-auto",
                "mt-3"
            ]
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "mt-5"
                ]
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "pb-3"
                    ]
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("p", {
                    text: "Name"
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("p", {
                    classList: [
                        "truncate",
                        "tracking-tight",
                        "font-semibold",
                        "text-gray-900",
                        "dark:text-white"
                    ],
                    text: (0, $133989e677847899$export$aee1dbae5de2db9d)((0, $d461744a27a10557$exports).$currentAccount, "name")
                });
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "py-3"
                    ]
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("p", {
                    text: "Email"
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("p", {
                    classList: [
                        "truncate",
                        "tracking-tight",
                        "font-semibold",
                        "text-gray-900",
                        "dark:text-white"
                    ],
                    text: (0, $133989e677847899$export$aee1dbae5de2db9d)((0, $d461744a27a10557$exports).$currentAccount, "email")
                });
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "py-3"
                    ]
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("p", {
                    text: "Role"
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("p", {
                    classList: [
                        "truncate",
                        "tracking-tight",
                        "font-semibold",
                        "text-gray-900",
                        "dark:text-white"
                    ],
                    text: (0, $133989e677847899$export$aee1dbae5de2db9d)((0, $d461744a27a10557$exports).$currentAccount, "role")
                });
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "py-3"
                    ]
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("p", {
                    text: "Tags"
                });
                const $userTagNames = (0, $agnkb.combine)([
                    (0, $d38a3a161a7d1109$exports).$tags,
                    (0, $133989e677847899$export$aee1dbae5de2db9d)((0, $d461744a27a10557$exports).$currentAccount, "tag_ids")
                ], ([tags, tagIds])=>{
                    const appliedTags = tags.filter((t)=>tagIds?.includes(t.id)).map((t)=>t.name).join(", ");
                    return appliedTags || "—";
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("p", {
                    classList: [
                        "truncate",
                        "tracking-tight",
                        "font-semibold",
                        "text-gray-900",
                        "dark:text-white"
                    ],
                    text: $userTagNames
                });
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "py-3",
                        "max-w-5"
                    ]
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("p", {
                    text: "Theme"
                });
                (0, $36b3d4afe650f8db$export$ef9b1a59e592288f)({
                    value: (0, $d461744a27a10557$exports).$currentTheme,
                    text: "",
                    options: (0, $agnkb.createStore)([
                        "dark",
                        "light"
                    ]),
                    optionSelected: (0, $d461744a27a10557$exports).themeChanged,
                    withBlank: (0, $agnkb.createStore)(false)
                });
            });
        });
    });
};







var $agnkb = parcelRequire("agnkb");
const $8c35f94bf03154ee$export$ff606c0379270787 = (0, $agnkb.createStore)("");
const $8c35f94bf03154ee$export$4e32eb31a8087e = (0, $agnkb.createEvent)();
$8c35f94bf03154ee$export$ff606c0379270787.on($8c35f94bf03154ee$export$4e32eb31a8087e, (_, query)=>query);
const $8c35f94bf03154ee$var$$filteredSchemas = (0, $agnkb.combine)([
    (0, $8aa4cde03a0e26f5$exports).$schemas,
    (0, $d38a3a161a7d1109$exports).$tags,
    $8c35f94bf03154ee$export$ff606c0379270787
], ([schemas, tags, searchQuery])=>{
    return schemas.filter((s)=>{
        const titleMatched = s.title.toLowerCase().includes(searchQuery.toLocaleLowerCase());
        const descriptionMatched = s.description.toLocaleLowerCase().includes(searchQuery.toLowerCase());
        const tagMatched = tags.filter((t)=>t.name.toLowerCase().includes(searchQuery.toLocaleLowerCase())).map((t)=>t.id).includes(s.tag_id ?? 0);
        return titleMatched || descriptionMatched || tagMatched;
    });
});
const $8c35f94bf03154ee$export$c488a48563a0ae84 = $8c35f94bf03154ee$var$$filteredSchemas.map((schemas)=>{
    return schemas.reduce((acc, schema)=>{
        const tag = schema.tag_id || "General";
        acc[tag] = acc[tag] || [];
        acc[tag].push(schema);
        return acc;
    }, {});
});



var $agnkb = parcelRequire("agnkb");


const $16d833d077915038$export$1b3b8923c9b136b4 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "pt-3"
            ]
        });
        (0, $84354d291f24209c$export$4b85d3515bd863a5)((0, $8c35f94bf03154ee$export$4e32eb31a8087e), (0, $8c35f94bf03154ee$export$ff606c0379270787));
        (0, $133989e677847899$export$8837f4fc672e936d)((0, $8c35f94bf03154ee$export$c488a48563a0ae84).map((groups)=>Object.entries(groups)), ({ store: schemaGroups })=>{
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "mt-2",
                        "mb-9"
                    ]
                });
                const tagId = schemaGroups.map((g)=>g[0]);
                const tagName = (0, $agnkb.combine)((0, $d38a3a161a7d1109$exports).$tags, tagId, (tags, tagId)=>{
                    return tags.find((t)=>String(t.id) === tagId)?.name || "General";
                });
                (0, $a5453ffc4cd3b2d6$export$82431628d8b8c126)(tagName);
                (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                    (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                        classList: [
                            "mt-3",
                            "max-w-7xl",
                            "grid",
                            "gap-4",
                            "grid-cols-2",
                            "md:grid-cols-3",
                            "lg:grid-cols-4",
                            "xl:grid-cols-5"
                        ]
                    });
                    (0, $133989e677847899$export$8837f4fc672e936d)({
                        source: schemaGroups.map((g)=>g[1]),
                        key: "id",
                        fields: [
                            "title",
                            "description",
                            "name"
                        ],
                        fn ({ fields: [title, description, name] }) {
                            (0, $68473ef2ef43bd57$export$eebd315af76f7497)({
                                title: title,
                                description: description,
                                name: name
                            });
                        }
                    });
                });
            });
        });
    });
};




const $c197dbdcf0fd54a1$export$36d69433c4f81145 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", {
        fn () {
            // This allows to show/hide route if page is matched
            // It is required to call `withRoute` inside `h` call
            (0, $ad1d53f18b004f8e$export$1261263aa227ed77)((0, $99a5bbd2d001ca47$export$c344a3deb8f83e2f));
            (0, $43b60f79e6520491$export$ac7bdc137eeafdfd)("Log groups", (0, $99a5bbd2d001ca47$export$7219f3a18e5a89f7));
            (0, $16d833d077915038$export$1b3b8923c9b136b4)();
        }
    });
};










var $agnkb = parcelRequire("agnkb");
const $409a5561118831f7$export$92a1dc06e0dfd3c8 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        // This allows to show/hide route if page is matched
        // It is required to call `withRoute` inside `h` call
        (0, $ad1d53f18b004f8e$export$1261263aa227ed77)((0, $99a5bbd2d001ca47$export$b19c7415af7c6beb));
        (0, $b28c0d0baf4d3d77$export$2fd85863a4729089)();
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "mt-3"
                ]
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "flex",
                        "flex-col",
                        "space-y-6"
                    ]
                });
                const $activeSchema = (0, $agnkb.combine)([
                    (0, $99a5bbd2d001ca47$export$5375cda95f0b0eb4).$activeRoutes,
                    (0, $8aa4cde03a0e26f5$exports).$schemas
                ], ([activeRoutes, schemas])=>{
                    const schemaName = activeRoutes[0]?.$params.getState().schemaName;
                    return schemas.find((s)=>s.name === schemaName) || null;
                });
                (0, $67c46e6f0d26bccc$export$e4e28536a33d07a3)({
                    tags: (0, $b047cb928fb2fbfa$exports).$groupedLogs.map((g)=>g.tags),
                    schema: $activeSchema,
                    kind: (0, $b047cb928fb2fbfa$exports).$groupedLogs.map((g)=>g.kind),
                    content: ()=>{
                        (0, $c9f21913a9eee54d$export$58be81f5c6860851)((0, $b047cb928fb2fbfa$exports).$groupedLogs.map((g)=>g.logs));
                    }
                });
            });
        });
    });
};








const $6f11c84b38516848$export$d9d9548ecfa1cf81 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        // This allows to show/hide route if page is matched
        // It is required to call `withRoute` inside `h` call
        (0, $ad1d53f18b004f8e$export$1261263aa227ed77)((0, $99a5bbd2d001ca47$export$7b0e65fd5f03ad04));
        (0, $b28c0d0baf4d3d77$export$2fd85863a4729089)();
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "pt-3"
                ]
            });
            (0, $26f69fcd82c2fb22$export$79d13b60110f33be)();
            (0, $9b5a966ddaaf2373$export$68f5e1453c188a82)((0, $b047cb928fb2fbfa$exports).$pages, (0, $b047cb928fb2fbfa$exports).$currentPage, (0, $b047cb928fb2fbfa$exports).events.pageChanged);
            (0, $e7296d402af7e8a9$export$e29e7e18e02e605e)();
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "pt-4"
                    ]
                });
                (0, $9b5a966ddaaf2373$export$68f5e1453c188a82)((0, $b047cb928fb2fbfa$exports).$pages, (0, $b047cb928fb2fbfa$exports).$currentPage, (0, $b047cb928fb2fbfa$exports).events.pageChanged);
            });
        });
    });
};










var $agnkb = parcelRequire("agnkb");

const $1ca54464f5783c66$export$f1fe4f4cedfdcc31 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: [
                "flex",
                "flex-col",
                "space-y-6",
                "mt-3"
            ]
        });
        const editUserClicked = (0, $agnkb.createEvent)();
        (0, $e13fe69fd88e859a$export$89e12c5b50f7529d)({
            clock: editUserClicked,
            params: (id)=>({
                    id: id
                }),
            route: (0, $99a5bbd2d001ca47$export$9ceadcfb9eb7b7f2)
        });
        (0, $58a7352922021345$export$23b8bf72cfd1bee4)((0, $d461744a27a10557$exports).$users, editUserClicked);
    });
};



const $bccf8b40087c885f$export$d8b21067e493157a = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        // This allows to show/hide route if page is matched
        // It is required to call `withRoute` inside `h` call
        (0, $ad1d53f18b004f8e$export$1261263aa227ed77)((0, $99a5bbd2d001ca47$export$74bc9c86497b4ac6));
        (0, $43b60f79e6520491$export$ac7bdc137eeafdfd)("Members", (0, $99a5bbd2d001ca47$export$89b5ccf9a225519));
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "pt-3"
                ]
            });
            (0, $1ca54464f5783c66$export$f1fe4f4cedfdcc31)();
        });
    });
};






const $dd6f6b8a7e61c579$export$f14c0e3f98d164c0 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", {
        fn () {
            // This allows to show/hide route if page is matched
            // It is required to call `withRoute` inside `h` call
            (0, $ad1d53f18b004f8e$export$1261263aa227ed77)((0, $99a5bbd2d001ca47$export$798bfdbebc5ea68e));
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "h-screen",
                        "flex",
                        "flex-col",
                        "items-center",
                        "justify-center",
                        "px-7"
                    ]
                });
                (0, $891f142abfdf8517$export$c17ac1167fee36b4)();
            });
        }
    });
};








const $a357c080b91b61a7$export$e070584b0f32cce0 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        // This allows to show/hide route if page is matched
        // It is required to call `withRoute` inside `h` call
        (0, $ad1d53f18b004f8e$export$1261263aa227ed77)((0, $99a5bbd2d001ca47$export$89b5ccf9a225519));
        (0, $ccd9bd4f73abf9cf$export$8b251419efc915eb)("Create member");
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "pt-5",
                    "max-w-2xl"
                ]
            });
            (0, $977859033bdd8463$export$52bc5eaf00b02549)();
        });
    });
};







const $257d980be76b472a$export$ae109b118e3436c5 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        // This allows to show/hide route if page is matched
        // It is required to call `withRoute` inside `h` call
        (0, $ad1d53f18b004f8e$export$1261263aa227ed77)((0, $99a5bbd2d001ca47$export$9ceadcfb9eb7b7f2));
        (0, $ccd9bd4f73abf9cf$export$8b251419efc915eb)("Edit member");
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "pt-5",
                    "max-w-2xl"
                ]
            });
            (0, $29db75923d80c4fe$export$84403d1f0ee954bb)();
        });
    });
};













var $agnkb = parcelRequire("agnkb");

const $679c012d6e261382$var$addField = (0, $agnkb.createEvent)();
const $679c012d6e261382$var$removeField = (0, $agnkb.createEvent)();
const $679c012d6e261382$var$fieldTitleChanged = (0, $agnkb.createEvent)();
const $679c012d6e261382$var$fieldNameChanged = (0, $agnkb.createEvent)();
const $679c012d6e261382$var$addKind = (0, $agnkb.createEvent)();
const $679c012d6e261382$var$removeKind = (0, $agnkb.createEvent)();
const $679c012d6e261382$var$kindTitleChanged = (0, $agnkb.createEvent)();
const $679c012d6e261382$var$kindNameChanged = (0, $agnkb.createEvent)();
const $679c012d6e261382$var$tagSelected = (0, $agnkb.createEvent)();
const $679c012d6e261382$export$2cf1be879d3cd26f = (0, $995c23da6372e497$export$f681a8129d2e9d28)({
    fields: {
        title: {
            init: "",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).required()
            ]
        },
        description: {
            init: "",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).required()
            ]
        },
        name: {
            init: "",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).required()
            ]
        },
        retention_days: {
            init: "",
            rules: []
        },
        fields: {
            init: [],
            rules: []
        },
        kinds: {
            init: [],
            rules: []
        },
        tag_id: {
            init: null,
            rules: []
        }
    },
    validateOn: [
        "submit"
    ]
});
(0, $agnkb.sample)({
    source: (0, $d38a3a161a7d1109$exports).$tags,
    clock: $679c012d6e261382$var$tagSelected,
    fn: (tags, selectedTag)=>{
        return tags.find((t)=>t.name === selectedTag)?.id || null;
    },
    target: $679c012d6e261382$export$2cf1be879d3cd26f.fields.tag_id.onChange
});
(0, $agnkb.sample)({
    source: $679c012d6e261382$export$2cf1be879d3cd26f.fields.fields.$value,
    clock: $679c012d6e261382$var$addField,
    fn: (fields)=>[
            ...fields,
            {
                title: "",
                name: ""
            }
        ],
    target: $679c012d6e261382$export$2cf1be879d3cd26f.fields.fields.onChange
});
(0, $agnkb.sample)({
    source: $679c012d6e261382$export$2cf1be879d3cd26f.fields.fields.$value,
    clock: $679c012d6e261382$var$removeField,
    fn: (fields, idx)=>[
            ...fields.slice(0, idx),
            ...fields.slice(idx + 1)
        ],
    target: $679c012d6e261382$export$2cf1be879d3cd26f.fields.fields.onChange
});
(0, $agnkb.sample)({
    source: $679c012d6e261382$export$2cf1be879d3cd26f.fields.fields.$value,
    clock: $679c012d6e261382$var$fieldTitleChanged,
    fn: (fields, { title: title, idx: idx })=>{
        return fields.map((field, index)=>index === idx ? {
                ...field,
                title: title
            } : field);
    },
    target: $679c012d6e261382$export$2cf1be879d3cd26f.fields.fields.onChange
});
(0, $agnkb.sample)({
    source: $679c012d6e261382$export$2cf1be879d3cd26f.fields.fields.$value,
    clock: $679c012d6e261382$var$fieldNameChanged,
    fn: (fields, { name: name, idx: idx })=>{
        return fields.map((field, index)=>index === idx ? {
                ...field,
                name: name
            } : field);
    },
    target: $679c012d6e261382$export$2cf1be879d3cd26f.fields.fields.onChange
});
(0, $agnkb.sample)({
    source: $679c012d6e261382$export$2cf1be879d3cd26f.fields.kinds.$value,
    clock: $679c012d6e261382$var$addKind,
    fn: (kinds)=>[
            ...kinds || [],
            {
                title: "",
                name: ""
            }
        ],
    target: $679c012d6e261382$export$2cf1be879d3cd26f.fields.kinds.onChange
});
(0, $agnkb.sample)({
    source: $679c012d6e261382$export$2cf1be879d3cd26f.fields.kinds.$value,
    clock: $679c012d6e261382$var$removeKind,
    fn: (kinds, idx)=>[
            ...kinds.slice(0, idx),
            ...kinds.slice(idx + 1)
        ],
    target: $679c012d6e261382$export$2cf1be879d3cd26f.fields.kinds.onChange
});
(0, $agnkb.sample)({
    source: $679c012d6e261382$export$2cf1be879d3cd26f.fields.kinds.$value,
    clock: $679c012d6e261382$var$kindTitleChanged,
    fn: (kinds, { title: title, idx: idx })=>{
        return kinds.map((kind, index)=>index === idx ? {
                ...kind,
                title: title
            } : kind);
    },
    target: $679c012d6e261382$export$2cf1be879d3cd26f.fields.kinds.onChange
});
(0, $agnkb.sample)({
    source: $679c012d6e261382$export$2cf1be879d3cd26f.fields.kinds.$value,
    clock: $679c012d6e261382$var$kindNameChanged,
    fn: (kinds, { name: name, idx: idx })=>{
        return kinds.map((kind, index)=>index === idx ? {
                ...kind,
                name: name
            } : kind);
    },
    target: $679c012d6e261382$export$2cf1be879d3cd26f.fields.kinds.onChange
});
const $679c012d6e261382$export$4bf9923669ad6c63 = {
    addField: $679c012d6e261382$var$addField,
    removeField: $679c012d6e261382$var$removeField,
    fieldTitleChanged: $679c012d6e261382$var$fieldTitleChanged,
    fieldNameChanged: $679c012d6e261382$var$fieldNameChanged,
    addKind: $679c012d6e261382$var$addKind,
    removeKind: $679c012d6e261382$var$removeKind,
    kindTitleChanged: $679c012d6e261382$var$kindTitleChanged,
    kindNameChanged: $679c012d6e261382$var$kindNameChanged,
    tagSelected: $679c012d6e261382$var$tagSelected
};
const $679c012d6e261382$export$80ae25fb0441ca08 = (0, $agnkb.createStore)("");
const $679c012d6e261382$export$3333de421a597687 = (0, $agnkb.createEffect)((schema)=>{
    return (0, $e0105e1f51ddac9f$export$5f4ce795563f4211)(schema);
});
(0, $agnkb.sample)({
    source: $679c012d6e261382$export$2cf1be879d3cd26f.formValidated,
    target: $679c012d6e261382$export$3333de421a597687
});
(0, $agnkb.sample)({
    source: $679c012d6e261382$export$3333de421a597687.doneData,
    filter: (schemaResponse)=>schemaResponse.success && Boolean(schemaResponse.data.id),
    target: [
        $679c012d6e261382$export$2cf1be879d3cd26f.reset,
        $679c012d6e261382$export$80ae25fb0441ca08.reinit,
        (0, $99a5bbd2d001ca47$export$c344a3deb8f83e2f).open
    ]
});
(0, $agnkb.sample)({
    source: $679c012d6e261382$export$3333de421a597687.doneData,
    filter: (schemaResponse)=>!schemaResponse.success,
    fn: (schemaResponse)=>schemaResponse.error,
    target: $679c012d6e261382$export$80ae25fb0441ca08
});



var $agnkb = parcelRequire("agnkb");


const $9d2219f32507ee78$export$baa43a1f1486f545 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("form", ()=>{
        (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
            type: "text",
            label: "Name",
            required: true,
            value: (0, $679c012d6e261382$export$2cf1be879d3cd26f).fields.name.$value,
            inputChanged: (0, $679c012d6e261382$export$2cf1be879d3cd26f).fields.name.changed,
            errorText: (0, $679c012d6e261382$export$2cf1be879d3cd26f).fields.name.$errorText,
            hint: "Name - used as a textual identifier for the group. Must be specified in Latin, in lowercase, and with underscores as separators"
        });
        (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
            type: "text",
            label: "Title",
            value: (0, $679c012d6e261382$export$2cf1be879d3cd26f).fields.title.$value,
            inputChanged: (0, $679c012d6e261382$export$2cf1be879d3cd26f).fields.title.changed,
            errorText: (0, $679c012d6e261382$export$2cf1be879d3cd26f).fields.title.$errorText,
            hint: "Title - used for the human-readable name of the group in the web interface. Group search will also search for groups based on this characteristic"
        });
        (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
            type: "text",
            label: "Description",
            value: (0, $679c012d6e261382$export$2cf1be879d3cd26f).fields.description.$value,
            inputChanged: (0, $679c012d6e261382$export$2cf1be879d3cd26f).fields.description.changed,
            errorText: (0, $679c012d6e261382$export$2cf1be879d3cd26f).fields.description.$errorText,
            hint: "Description - used for the human-readable description of group details in the web interface. Group search will also search for groups based on this characteristic"
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "mb-6"
                ]
            });
            (0, $36b3d4afe650f8db$export$ef9b1a59e592288f)({
                text: "Select a tag",
                value: (0, $679c012d6e261382$export$2cf1be879d3cd26f).fields.tag_id.$value,
                options: (0, $d38a3a161a7d1109$exports).$tags,
                optionSelected: (0, $679c012d6e261382$export$4bf9923669ad6c63).tagSelected
            });
        });
        (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
            type: "number",
            label: "Retention days",
            value: (0, $679c012d6e261382$export$2cf1be879d3cd26f).fields.retention_days.$value,
            inputChanged: (0, $679c012d6e261382$export$2cf1be879d3cd26f).fields.retention_days.changed,
            errorText: (0, $679c012d6e261382$export$2cf1be879d3cd26f).fields.retention_days.$errorText,
            hint: "Retention days - the number of days during which logs will be available after their creation. After the specified number of days elapses, the logs will be deleted. To set an infinite lifespan, specify 0 or leave the field empty"
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "relative",
                    "flex",
                    "items-center",
                    "mb-4",
                    "pt-2"
                ]
            });
            (0, $80777629d33d636a$export$b04be29aa201d4f5)({
                text: "Group query fields",
                hint: "Group query fields - a set of fields by which log grouping will occur"
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "ml-1"
                    ]
                });
                (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                    text: "",
                    variant: "default",
                    prevent: true,
                    style: "round",
                    size: "extra_small",
                    event: (0, $679c012d6e261382$export$4bf9923669ad6c63).addField,
                    preIcon: (0, $8295e9913b74aadf$export$f21ab0717a89c77f)
                });
            });
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$8837f4fc672e936d)((0, $679c012d6e261382$export$2cf1be879d3cd26f).fields.fields.$value, ({ store: queryField, key: idx })=>{
                const titleChanged = (0, $agnkb.createEvent)();
                const nameChanged = (0, $agnkb.createEvent)();
                (0, $agnkb.sample)({
                    source: idx,
                    clock: titleChanged,
                    fn: (idx, title)=>({
                            title: title,
                            idx: idx
                        }),
                    target: (0, $679c012d6e261382$export$4bf9923669ad6c63).fieldTitleChanged
                });
                (0, $agnkb.sample)({
                    source: idx,
                    clock: nameChanged,
                    fn: (idx, name)=>({
                            name: name,
                            idx: idx
                        }),
                    target: (0, $679c012d6e261382$export$4bf9923669ad6c63).fieldNameChanged
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                    (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                        classList: [
                            "grid",
                            "gap-3",
                            "place-items-stretch"
                        ],
                        style: {
                            gridTemplateColumns: "14fr 14fr 1fr"
                        }
                    });
                    (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
                        type: "text",
                        label: "Title",
                        required: true,
                        value: queryField.map((f)=>f.title),
                        inputChanged: titleChanged,
                        errorText: (0, $679c012d6e261382$export$2cf1be879d3cd26f).fields.fields.$errorText,
                        hint: "Title - used for the human-readable name of the field in the web interface for log filtering"
                    });
                    (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
                        type: "text",
                        label: "Name",
                        required: true,
                        value: queryField.map((f)=>f.name),
                        inputChanged: nameChanged,
                        errorText: (0, $679c012d6e261382$export$2cf1be879d3cd26f).fields.fields.$errorText,
                        hint: "Name - used as a textual identifier for the group. Must be specified in Latin, in lowercase, and with underscores as separators"
                    });
                    (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                        text: "",
                        event: (0, $69cfdfca25b18a98$export$e614dc9140f7ae71)({
                            source: idx,
                            target: (0, $679c012d6e261382$export$4bf9923669ad6c63).removeField
                        }),
                        size: "plain",
                        prevent: true,
                        variant: "delete_icon",
                        preIcon: (0, $c38f17198d3679fb$export$d23329de703dffc4)
                    });
                });
            });
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "relative",
                    "flex",
                    "items-center",
                    "mb-4",
                    "pt-4"
                ]
            });
            (0, $80777629d33d636a$export$b04be29aa201d4f5)({
                text: "Kinds",
                hint: "Kinds - a set of select options by which log grouping will occur"
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "ml-1"
                    ]
                });
                (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                    text: "",
                    variant: "default",
                    prevent: true,
                    style: "round",
                    size: "extra_small",
                    event: (0, $679c012d6e261382$export$4bf9923669ad6c63).addKind,
                    preIcon: (0, $8295e9913b74aadf$export$f21ab0717a89c77f)
                });
            });
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$8837f4fc672e936d)((0, $679c012d6e261382$export$2cf1be879d3cd26f).fields.kinds.$value, ({ store: kind, key: idx })=>{
                const titleChanged = (0, $agnkb.createEvent)();
                const nameChanged = (0, $agnkb.createEvent)();
                (0, $agnkb.sample)({
                    source: idx,
                    clock: titleChanged,
                    fn: (idx, title)=>({
                            title: title,
                            idx: idx
                        }),
                    target: (0, $679c012d6e261382$export$4bf9923669ad6c63).kindTitleChanged
                });
                (0, $agnkb.sample)({
                    source: idx,
                    clock: nameChanged,
                    fn: (idx, name)=>({
                            name: name,
                            idx: idx
                        }),
                    target: (0, $679c012d6e261382$export$4bf9923669ad6c63).kindNameChanged
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                    (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                        classList: [
                            "grid",
                            "gap-3",
                            "place-items-stretch"
                        ],
                        style: {
                            gridTemplateColumns: "14fr 14fr 1fr"
                        }
                    });
                    (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
                        type: "text",
                        label: "Title",
                        required: true,
                        value: kind.map((k)=>k.title),
                        inputChanged: titleChanged,
                        errorText: (0, $679c012d6e261382$export$2cf1be879d3cd26f).fields.kinds.$errorText,
                        hint: "Title - used for the human-readable name of the kind in the web interface for log filtering"
                    });
                    (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
                        type: "text",
                        label: "Name",
                        required: true,
                        value: kind.map((k)=>k.name),
                        inputChanged: nameChanged,
                        errorText: (0, $679c012d6e261382$export$2cf1be879d3cd26f).fields.fields.$errorText,
                        hint: "Name - used as a textual identifier for the kind. Must be specified in Latin, in lowercase, and with underscores as separators"
                    });
                    (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                        text: "",
                        event: (0, $69cfdfca25b18a98$export$e614dc9140f7ae71)({
                            source: idx,
                            target: (0, $679c012d6e261382$export$4bf9923669ad6c63).removeKind
                        }),
                        size: "plain",
                        prevent: true,
                        variant: "delete_icon",
                        preIcon: (0, $c38f17198d3679fb$export$d23329de703dffc4)
                    });
                });
            });
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "pt-4"
                ]
            });
            (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                text: "Create",
                event: (0, $679c012d6e261382$export$2cf1be879d3cd26f).submit,
                size: "base",
                prevent: true,
                variant: "default"
            });
        });
        (0, $50bc7b2791a6cb44$export$852d7888b34e2b72)((0, $679c012d6e261382$export$80ae25fb0441ca08), (0, $679c012d6e261382$export$80ae25fb0441ca08).map(Boolean));
    });
};




const $083b88661efb834f$export$acca6a3dc3ec5938 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        // This allows to show/hide route if page is matched
        // It is required to call `withRoute` inside `h` call
        (0, $ad1d53f18b004f8e$export$1261263aa227ed77)((0, $99a5bbd2d001ca47$export$7219f3a18e5a89f7));
        (0, $ccd9bd4f73abf9cf$export$8b251419efc915eb)("Create log group");
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "pt-5",
                    "max-w-3xl"
                ]
            });
            (0, $9d2219f32507ee78$export$baa43a1f1486f545)();
        });
    });
};















var $agnkb = parcelRequire("agnkb");

const $da6ebdfc374681bb$var$addField = (0, $agnkb.createEvent)();
const $da6ebdfc374681bb$var$removeField = (0, $agnkb.createEvent)();
const $da6ebdfc374681bb$var$fieldTitleChanged = (0, $agnkb.createEvent)();
const $da6ebdfc374681bb$var$fieldNameChanged = (0, $agnkb.createEvent)();
const $da6ebdfc374681bb$var$addKind = (0, $agnkb.createEvent)();
const $da6ebdfc374681bb$var$removeKind = (0, $agnkb.createEvent)();
const $da6ebdfc374681bb$var$kindTitleChanged = (0, $agnkb.createEvent)();
const $da6ebdfc374681bb$var$kindNameChanged = (0, $agnkb.createEvent)();
const $da6ebdfc374681bb$var$tagSelected = (0, $agnkb.createEvent)();
const $da6ebdfc374681bb$export$2cf1be879d3cd26f = (0, $995c23da6372e497$export$f681a8129d2e9d28)({
    fields: {
        title: {
            init: "",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).required()
            ]
        },
        description: {
            init: "",
            rules: [
                (0, $ebb40c4f76ecbb36$export$354076178bdef094).required()
            ]
        },
        retention_days: {
            init: "",
            rules: []
        },
        fields: {
            init: [],
            rules: []
        },
        kinds: {
            init: [],
            rules: []
        },
        tag_id: {
            init: null,
            rules: []
        }
    },
    validateOn: [
        "submit"
    ]
});
(0, $agnkb.sample)({
    source: (0, $d38a3a161a7d1109$exports).$tags,
    clock: $da6ebdfc374681bb$var$tagSelected,
    fn: (tags, selectedTag)=>{
        return tags.find((t)=>t.name === selectedTag)?.id || null;
    },
    target: $da6ebdfc374681bb$export$2cf1be879d3cd26f.fields.tag_id.onChange
});
(0, $agnkb.sample)({
    source: $da6ebdfc374681bb$export$2cf1be879d3cd26f.fields.fields.$value,
    clock: $da6ebdfc374681bb$var$addField,
    fn: (fields)=>[
            ...fields,
            {
                title: "",
                name: ""
            }
        ],
    target: $da6ebdfc374681bb$export$2cf1be879d3cd26f.fields.fields.onChange
});
(0, $agnkb.sample)({
    source: $da6ebdfc374681bb$export$2cf1be879d3cd26f.fields.fields.$value,
    clock: $da6ebdfc374681bb$var$removeField,
    fn: (fields, idx)=>[
            ...fields.slice(0, idx),
            ...fields.slice(idx + 1)
        ],
    target: $da6ebdfc374681bb$export$2cf1be879d3cd26f.fields.fields.onChange
});
(0, $agnkb.sample)({
    source: $da6ebdfc374681bb$export$2cf1be879d3cd26f.fields.fields.$value,
    clock: $da6ebdfc374681bb$var$fieldTitleChanged,
    fn: (fields, { title: title, idx: idx })=>{
        return fields.map((field, index)=>index === idx ? {
                ...field,
                title: title
            } : field);
    },
    target: $da6ebdfc374681bb$export$2cf1be879d3cd26f.fields.fields.onChange
});
(0, $agnkb.sample)({
    source: $da6ebdfc374681bb$export$2cf1be879d3cd26f.fields.fields.$value,
    clock: $da6ebdfc374681bb$var$fieldNameChanged,
    fn: (fields, { name: name, idx: idx })=>{
        return fields.map((field, index)=>index === idx ? {
                ...field,
                name: name
            } : field);
    },
    target: $da6ebdfc374681bb$export$2cf1be879d3cd26f.fields.fields.onChange
});
(0, $agnkb.sample)({
    source: $da6ebdfc374681bb$export$2cf1be879d3cd26f.fields.kinds.$value,
    clock: $da6ebdfc374681bb$var$addKind,
    fn: (kinds)=>[
            ...kinds || [],
            {
                title: "",
                name: ""
            }
        ],
    target: $da6ebdfc374681bb$export$2cf1be879d3cd26f.fields.kinds.onChange
});
(0, $agnkb.sample)({
    source: $da6ebdfc374681bb$export$2cf1be879d3cd26f.fields.kinds.$value,
    clock: $da6ebdfc374681bb$var$removeKind,
    fn: (kinds, idx)=>[
            ...kinds.slice(0, idx),
            ...kinds.slice(idx + 1)
        ],
    target: $da6ebdfc374681bb$export$2cf1be879d3cd26f.fields.kinds.onChange
});
(0, $agnkb.sample)({
    source: $da6ebdfc374681bb$export$2cf1be879d3cd26f.fields.kinds.$value,
    clock: $da6ebdfc374681bb$var$kindTitleChanged,
    fn: (kinds, { title: title, idx: idx })=>{
        return kinds.map((kind, index)=>index === idx ? {
                ...kind,
                title: title
            } : kind);
    },
    target: $da6ebdfc374681bb$export$2cf1be879d3cd26f.fields.kinds.onChange
});
(0, $agnkb.sample)({
    source: $da6ebdfc374681bb$export$2cf1be879d3cd26f.fields.kinds.$value,
    clock: $da6ebdfc374681bb$var$kindNameChanged,
    fn: (kinds, { name: name, idx: idx })=>{
        return kinds.map((kind, index)=>index === idx ? {
                ...kind,
                name: name
            } : kind);
    },
    target: $da6ebdfc374681bb$export$2cf1be879d3cd26f.fields.kinds.onChange
});
const $da6ebdfc374681bb$export$4bf9923669ad6c63 = {
    addField: $da6ebdfc374681bb$var$addField,
    removeField: $da6ebdfc374681bb$var$removeField,
    fieldTitleChanged: $da6ebdfc374681bb$var$fieldTitleChanged,
    fieldNameChanged: $da6ebdfc374681bb$var$fieldNameChanged,
    addKind: $da6ebdfc374681bb$var$addKind,
    removeKind: $da6ebdfc374681bb$var$removeKind,
    kindTitleChanged: $da6ebdfc374681bb$var$kindTitleChanged,
    kindNameChanged: $da6ebdfc374681bb$var$kindNameChanged,
    tagSelected: $da6ebdfc374681bb$var$tagSelected
};
const $da6ebdfc374681bb$export$fc7ab2dba121b08d = (0, $agnkb.createStore)("");
const $da6ebdfc374681bb$export$2c8f1bd136c8c3e3 = (0, $agnkb.createEffect)((schema)=>{
    return (0, $e0105e1f51ddac9f$export$e1b290f9620da5ab)(schema);
});
(0, $agnkb.sample)({
    source: (0, $8aa4cde03a0e26f5$exports).$currentSchema,
    target: $da6ebdfc374681bb$export$2cf1be879d3cd26f.setInitialForm
});
(0, $agnkb.sample)({
    source: (0, $8aa4cde03a0e26f5$exports).$currentSchema,
    clock: $da6ebdfc374681bb$export$2cf1be879d3cd26f.formValidated,
    fn: (currentSchema, schemaToEdit)=>{
        return {
            ...schemaToEdit,
            id: currentSchema.id
        };
    },
    target: $da6ebdfc374681bb$export$2c8f1bd136c8c3e3
});
(0, $agnkb.sample)({
    source: $da6ebdfc374681bb$export$2c8f1bd136c8c3e3.doneData,
    filter: (schemaResponse)=>schemaResponse.success && Boolean(schemaResponse.data.id),
    target: [
        $da6ebdfc374681bb$export$2cf1be879d3cd26f.reset,
        (0, $99a5bbd2d001ca47$export$c344a3deb8f83e2f).open
    ]
});
(0, $agnkb.sample)({
    source: $da6ebdfc374681bb$export$2c8f1bd136c8c3e3.doneData,
    filter: (schemaResponse)=>!schemaResponse.success,
    fn: (schemaResponse)=>schemaResponse.error,
    target: $da6ebdfc374681bb$export$fc7ab2dba121b08d
});
const $da6ebdfc374681bb$export$7b1f8ac08c9e3e89 = (0, $agnkb.createEffect)((id)=>{
    (0, $e0105e1f51ddac9f$export$afb15112eaa2ae8e)(id);
});
const $da6ebdfc374681bb$export$68cd3485797ebb97 = (0, $agnkb.createEvent)();
const $da6ebdfc374681bb$var$alertDeleteFx = (0, $agnkb.createEffect)((id)=>{
    const confirmed = confirm("Are you sure you want to delete this log group?");
    return confirmed ? {
        confirmed: true,
        id: id
    } : {
        confirmed: false,
        id: id
    };
});
(0, $agnkb.sample)({
    clock: $da6ebdfc374681bb$export$68cd3485797ebb97,
    target: $da6ebdfc374681bb$var$alertDeleteFx
});
(0, $agnkb.sample)({
    source: (0, $8aa4cde03a0e26f5$exports).$currentSchema,
    clock: $da6ebdfc374681bb$var$alertDeleteFx.doneData,
    filter: (_, { confirmed: confirmed })=>confirmed,
    fn: ({ id: id })=>id,
    target: $da6ebdfc374681bb$export$7b1f8ac08c9e3e89
});
(0, $e13fe69fd88e859a$export$89e12c5b50f7529d)({
    clock: $da6ebdfc374681bb$export$7b1f8ac08c9e3e89.done,
    route: (0, $99a5bbd2d001ca47$export$c344a3deb8f83e2f)
});




var $agnkb = parcelRequire("agnkb");

const $8ae11b12dfa6813f$export$cfd5281471cba4be = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("form", ()=>{
        (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
            type: "text",
            label: "Title",
            value: (0, $da6ebdfc374681bb$export$2cf1be879d3cd26f).fields.title.$value,
            inputChanged: (0, $da6ebdfc374681bb$export$2cf1be879d3cd26f).fields.title.changed,
            errorText: (0, $da6ebdfc374681bb$export$2cf1be879d3cd26f).fields.title.$errorText,
            hint: "Title - used for the human-readable name of the group in the web interface. Group search will also search for groups based on this characteristic"
        });
        (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
            type: "text",
            label: "Description",
            value: (0, $da6ebdfc374681bb$export$2cf1be879d3cd26f).fields.description.$value,
            inputChanged: (0, $da6ebdfc374681bb$export$2cf1be879d3cd26f).fields.description.changed,
            errorText: (0, $da6ebdfc374681bb$export$2cf1be879d3cd26f).fields.description.$errorText,
            hint: "Description - used for the human-readable description of group details in the web interface. Group search will also search for groups based on this characteristic"
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "mb-6"
                ]
            });
            (0, $36b3d4afe650f8db$export$ef9b1a59e592288f)({
                text: "Select a tag",
                value: (0, $da6ebdfc374681bb$export$2cf1be879d3cd26f).fields.tag_id.$value,
                options: (0, $d38a3a161a7d1109$exports).$tags,
                optionSelected: (0, $da6ebdfc374681bb$export$4bf9923669ad6c63).tagSelected
            });
        });
        (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
            type: "number",
            label: "Retention days",
            value: (0, $da6ebdfc374681bb$export$2cf1be879d3cd26f).fields.retention_days.$value,
            inputChanged: (0, $da6ebdfc374681bb$export$2cf1be879d3cd26f).fields.retention_days.changed,
            errorText: (0, $da6ebdfc374681bb$export$2cf1be879d3cd26f).fields.retention_days.$errorText,
            hint: "Retention days - the number of days during which logs will be available after their creation. After the specified number of days elapses, the logs will be deleted. To set an infinite lifespan, specify 0 or leave the field empty"
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "relative",
                    "flex",
                    "items-center",
                    "mb-4",
                    "pt-4"
                ]
            });
            (0, $80777629d33d636a$export$b04be29aa201d4f5)({
                text: "Group query fields",
                hint: "Group query fields - a set of fields by which log grouping will occur"
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "ml-1"
                    ]
                });
                (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                    text: "",
                    variant: "default",
                    prevent: true,
                    style: "round",
                    size: "extra_small",
                    event: (0, $da6ebdfc374681bb$export$4bf9923669ad6c63).addField,
                    preIcon: (0, $8295e9913b74aadf$export$f21ab0717a89c77f)
                });
            });
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$8837f4fc672e936d)((0, $da6ebdfc374681bb$export$2cf1be879d3cd26f).fields.fields.$value, ({ store: queryField, key: idx })=>{
                const titleChanged = (0, $agnkb.createEvent)();
                const nameChanged = (0, $agnkb.createEvent)();
                (0, $agnkb.sample)({
                    source: idx,
                    clock: titleChanged,
                    fn: (idx, title)=>({
                            title: title,
                            idx: idx
                        }),
                    target: (0, $da6ebdfc374681bb$export$4bf9923669ad6c63).fieldTitleChanged
                });
                (0, $agnkb.sample)({
                    source: idx,
                    clock: nameChanged,
                    fn: (idx, name)=>({
                            name: name,
                            idx: idx
                        }),
                    target: (0, $da6ebdfc374681bb$export$4bf9923669ad6c63).fieldNameChanged
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                    (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                        classList: [
                            "grid",
                            "gap-3",
                            "place-items-stretch"
                        ],
                        style: {
                            gridTemplateColumns: "14fr 14fr 1fr"
                        }
                    });
                    (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
                        type: "text",
                        label: "Title",
                        required: true,
                        value: queryField.map((f)=>f.title),
                        inputChanged: titleChanged,
                        errorText: (0, $da6ebdfc374681bb$export$2cf1be879d3cd26f).fields.fields.$errorText,
                        hint: "Title - used for the human-readable name of the field in the web interface for log filtering"
                    });
                    (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
                        type: "text",
                        label: "Name",
                        required: true,
                        value: queryField.map((f)=>f.name),
                        inputChanged: nameChanged,
                        errorText: (0, $da6ebdfc374681bb$export$2cf1be879d3cd26f).fields.fields.$errorText,
                        hint: "Name - used as a textual identifier for the group. Must be specified in Latin, in lowercase, and with underscores as separators"
                    });
                    (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                        text: "",
                        event: (0, $69cfdfca25b18a98$export$e614dc9140f7ae71)({
                            source: idx,
                            target: (0, $da6ebdfc374681bb$export$4bf9923669ad6c63).removeField
                        }),
                        size: "plain",
                        prevent: true,
                        variant: "delete_icon",
                        preIcon: (0, $c38f17198d3679fb$export$d23329de703dffc4)
                    });
                });
            });
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "relative",
                    "flex",
                    "items-center",
                    "mb-4",
                    "pt-4"
                ]
            });
            (0, $80777629d33d636a$export$b04be29aa201d4f5)({
                text: "Kinds",
                hint: "Kinds - a set of select options by which log grouping will occur"
            });
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "ml-1"
                    ]
                });
                (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                    text: "",
                    variant: "default",
                    prevent: true,
                    style: "round",
                    size: "extra_small",
                    event: (0, $da6ebdfc374681bb$export$4bf9923669ad6c63).addKind,
                    preIcon: (0, $8295e9913b74aadf$export$f21ab0717a89c77f)
                });
            });
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$8837f4fc672e936d)((0, $da6ebdfc374681bb$export$2cf1be879d3cd26f).fields.kinds.$value, ({ store: kind, key: idx })=>{
                const titleChanged = (0, $agnkb.createEvent)();
                const nameChanged = (0, $agnkb.createEvent)();
                (0, $agnkb.sample)({
                    source: idx,
                    clock: titleChanged,
                    fn: (idx, title)=>({
                            title: title,
                            idx: idx
                        }),
                    target: (0, $da6ebdfc374681bb$export$4bf9923669ad6c63).kindTitleChanged
                });
                (0, $agnkb.sample)({
                    source: idx,
                    clock: nameChanged,
                    fn: (idx, name)=>({
                            name: name,
                            idx: idx
                        }),
                    target: (0, $da6ebdfc374681bb$export$4bf9923669ad6c63).kindNameChanged
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                    (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                        classList: [
                            "grid",
                            "gap-3",
                            "place-items-stretch"
                        ],
                        style: {
                            gridTemplateColumns: "14fr 14fr 1fr"
                        }
                    });
                    (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
                        type: "text",
                        label: "Title",
                        required: true,
                        value: kind.map((k)=>k.title),
                        inputChanged: titleChanged,
                        errorText: (0, $da6ebdfc374681bb$export$2cf1be879d3cd26f).fields.kinds.$errorText,
                        hint: "Title - used for the human-readable name of the kind in the web interface for log filtering"
                    });
                    (0, $378e0a91f74a58dc$export$f5b8910cec6cf069)({
                        type: "text",
                        label: "Name",
                        required: true,
                        value: kind.map((k)=>k.name),
                        inputChanged: nameChanged,
                        errorText: (0, $da6ebdfc374681bb$export$2cf1be879d3cd26f).fields.fields.$errorText,
                        hint: "Name - used as a textual identifier for the kind. Must be specified in Latin, in lowercase, and with underscores as separators"
                    });
                    (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                        text: "",
                        event: (0, $69cfdfca25b18a98$export$e614dc9140f7ae71)({
                            source: idx,
                            target: (0, $da6ebdfc374681bb$export$4bf9923669ad6c63).removeKind
                        }),
                        size: "plain",
                        prevent: true,
                        variant: "delete_icon",
                        preIcon: (0, $c38f17198d3679fb$export$d23329de703dffc4)
                    });
                });
            });
        });
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "flex",
                    "justify-start",
                    "space-x-2",
                    "pt-4"
                ]
            });
            (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                text: "Save",
                event: (0, $da6ebdfc374681bb$export$2cf1be879d3cd26f).submit,
                size: "base",
                prevent: true,
                variant: "default"
            });
            (0, $68cf3827aab84f08$export$353f5b6fc5456de1)({
                text: "Delete",
                event: (0, $da6ebdfc374681bb$export$68cd3485797ebb97),
                size: "base",
                prevent: true,
                variant: "delete"
            });
        });
        (0, $50bc7b2791a6cb44$export$852d7888b34e2b72)((0, $da6ebdfc374681bb$export$fc7ab2dba121b08d), (0, $da6ebdfc374681bb$export$fc7ab2dba121b08d).map(Boolean));
    });
};




const $bb8121cc0e753e20$export$a1b205be0ea4484 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        // This allows to show/hide route if page is matched
        // It is required to call `withRoute` inside `h` call
        (0, $ad1d53f18b004f8e$export$1261263aa227ed77)((0, $99a5bbd2d001ca47$export$102e5ceef0d527c1));
        (0, $ccd9bd4f73abf9cf$export$8b251419efc915eb)("Edit log group");
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "pt-5",
                    "max-w-2xl"
                ]
            });
            (0, $8ae11b12dfa6813f$export$cfd5281471cba4be)();
        });
    });
};






const $e52b600f766c37eb$export$751b3ee8b1c5c13f = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        // This allows to show/hide route if page is matched
        // It is required to call `withRoute` inside `h` call
        (0, $ad1d53f18b004f8e$export$1261263aa227ed77)((0, $99a5bbd2d001ca47$export$14fdbf877e70314a));
        (0, $43b60f79e6520491$export$ac7bdc137eeafdfd)("API tokens", (0, $99a5bbd2d001ca47$export$a945d1f11027dc7d));
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "pt-3"
                ]
            });
            (0, $c3011c55eb821fab$export$86a2ad2cbd078da9)();
        });
    });
};







const $b029291dbc139016$export$8fa819150bfbf401 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        // This allows to show/hide route if page is matched
        // It is required to call `withRoute` inside `h` call
        (0, $ad1d53f18b004f8e$export$1261263aa227ed77)((0, $99a5bbd2d001ca47$export$a945d1f11027dc7d));
        (0, $ccd9bd4f73abf9cf$export$8b251419efc915eb)("Create API token");
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "pt-5",
                    "max-w-2xl"
                ]
            });
            (0, $17f806cd5c2df842$export$da721989ce272e44)();
        });
    });
};







const $e3acb6c43bcf0759$export$8bac369750810305 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        // This allows to show/hide route if page is matched
        // It is required to call `withRoute` inside `h` call
        (0, $ad1d53f18b004f8e$export$1261263aa227ed77)((0, $99a5bbd2d001ca47$export$dabbba65ed76796e));
        (0, $ccd9bd4f73abf9cf$export$8b251419efc915eb)("Edit API token");
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "pt-5",
                    "max-w-2xl"
                ]
            });
            (0, $90e03fc11c96bd1f$export$f86fac28d312f23a)();
        });
    });
};






const $e3c7cbf728cd2677$export$6d49d144b9c71de7 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", {
        fn () {
            // This allows to show/hide route if page is matched
            // It is required to call `withRoute` inside `h` call
            (0, $ad1d53f18b004f8e$export$1261263aa227ed77)((0, $99a5bbd2d001ca47$export$7adfc20e44871f54));
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "h-screen",
                        "flex",
                        "flex-col",
                        "items-center",
                        "justify-center"
                    ]
                });
                (0, $441c5755e98a2888$export$1f41dfafa8aa46d7)();
            });
        }
    });
};






const $04ab43a6a8ac06c7$export$1ca757ec50c8f5ac = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        // This allows to show/hide route if page is matched
        // It is required to call `withRoute` inside `h` call
        (0, $ad1d53f18b004f8e$export$1261263aa227ed77)((0, $99a5bbd2d001ca47$export$773ade5e3261acbd));
        (0, $43b60f79e6520491$export$ac7bdc137eeafdfd)("Tags", (0, $99a5bbd2d001ca47$export$600fa41b9ffe82c7));
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "pt-3",
                    "max-w-3xl"
                ]
            });
            (0, $f3fe18bde3766b9c$export$48f6b48a42d49a36)();
        });
    });
};







const $e88f537906b8e4bf$export$b8a3ac91944abbc4 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        // This allows to show/hide route if page is matched
        // It is required to call `withRoute` inside `h` call
        (0, $ad1d53f18b004f8e$export$1261263aa227ed77)((0, $99a5bbd2d001ca47$export$600fa41b9ffe82c7));
        (0, $ccd9bd4f73abf9cf$export$8b251419efc915eb)("Create tag");
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "pt-5",
                    "max-w-2xl"
                ]
            });
            (0, $57bcdcdb1e37881f$export$d18a51de73af28cf)();
        });
    });
};







const $5deec8e5fdf16b8e$export$a272e0dc93e4c8c0 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
        // This allows to show/hide route if page is matched
        // It is required to call `withRoute` inside `h` call
        (0, $ad1d53f18b004f8e$export$1261263aa227ed77)((0, $99a5bbd2d001ca47$export$21c91e254ab993b9));
        (0, $ccd9bd4f73abf9cf$export$8b251419efc915eb)("Edit tag");
        (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
            (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                classList: [
                    "pt-5",
                    "max-w-2xl"
                ]
            });
            (0, $bb9a43c618f90a0a$export$9463da1fa69280fc)();
        });
    });
};






const $032a699e0eca9878$export$9edca6c54b1627c8 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", {
        fn () {
            // This allows to show/hide route if page is matched
            // It is required to call `withRoute` inside `h` call
            (0, $ad1d53f18b004f8e$export$1261263aa227ed77)((0, $99a5bbd2d001ca47$export$8e0dc54c469007d0));
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "h-screen",
                        "flex",
                        "flex-col",
                        "items-center",
                        "justify-center",
                        "px-7",
                        "text-center"
                    ]
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                    (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                        classList: [
                            "mb-4"
                        ]
                    });
                    (0, $ccd9bd4f73abf9cf$export$8b251419efc915eb)("You do not have permission to access this resource");
                });
                (0, $8a0a4c7088cd4755$export$a6c7ac8248d6e38a)((0, $99a5bbd2d001ca47$export$c344a3deb8f83e2f), "Go to home page");
            });
        }
    });
};






const $7678b46a96c8f4d5$export$31641b61980e511f = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", {
        fn () {
            // This allows to show/hide route if page is matched
            // It is required to call `withRoute` inside `h` call
            (0, $ad1d53f18b004f8e$export$1261263aa227ed77)((0, $99a5bbd2d001ca47$export$4dc84672b833126));
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "h-screen",
                        "flex",
                        "flex-col",
                        "items-center",
                        "justify-center",
                        "px-7",
                        "text-center"
                    ]
                });
                (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                    (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                        classList: [
                            "mb-4"
                        ]
                    });
                    (0, $ccd9bd4f73abf9cf$export$8b251419efc915eb)("The requested resource could not be found");
                });
                (0, $8a0a4c7088cd4755$export$a6c7ac8248d6e38a)((0, $99a5bbd2d001ca47$export$c344a3deb8f83e2f), "Go to home page");
            });
        }
    });
};







const $8b3c33b8ad5db7ff$export$120c0e7b1bef3ec7 = ()=>{
    (0, $133989e677847899$export$dda1d9f60106f0e9)("div", {
        fn () {
            // This allows to show/hide route if page is matched
            // It is required to call `withRoute` inside `h` call
            (0, $ad1d53f18b004f8e$export$1261263aa227ed77)((0, $99a5bbd2d001ca47$export$80d23b9cca383549));
            (0, $133989e677847899$export$dda1d9f60106f0e9)("div", ()=>{
                (0, $133989e677847899$export$a40e83dd9f9a97c8)({
                    classList: [
                        "max-w-3xl"
                    ]
                });
                (0, $ccd9bd4f73abf9cf$export$8b251419efc915eb)("Profile");
                (0, $0f78e9a16afe7d09$export$b7b58f2e100445f7)();
            });
        }
    });
};


function $63ba5f428a00943d$export$c717c2ee03fc6c49() {
    const $layoutVisible = (0, $agnkb.combine)([
        (0, $99a5bbd2d001ca47$export$798bfdbebc5ea68e).$isOpened,
        (0, $99a5bbd2d001ca47$export$7adfc20e44871f54).$isOpened,
        (0, $99a5bbd2d001ca47$export$8e0dc54c469007d0).$isOpened,
        (0, $99a5bbd2d001ca47$export$4dc84672b833126).$isOpened
    ], ([loginOpened, registerOpened, forbiddenOpened, notFoundOpened])=>{
        return !loginOpened && !registerOpened && !forbiddenOpened && !notFoundOpened;
    });
    (0, $7b04e6c47838d986$export$c84671f46d6a1ca)({
        content: ()=>{
            (0, $dd6f6b8a7e61c579$export$f14c0e3f98d164c0)();
            (0, $e3c7cbf728cd2677$export$6d49d144b9c71de7)();
            (0, $032a699e0eca9878$export$9edca6c54b1627c8)();
            (0, $7678b46a96c8f4d5$export$31641b61980e511f)();
            (0, $8b3c33b8ad5db7ff$export$120c0e7b1bef3ec7)();
            (0, $c197dbdcf0fd54a1$export$36d69433c4f81145)();
            (0, $6f11c84b38516848$export$d9d9548ecfa1cf81)();
            (0, $409a5561118831f7$export$92a1dc06e0dfd3c8)();
            (0, $bccf8b40087c885f$export$d8b21067e493157a)();
            (0, $a357c080b91b61a7$export$e070584b0f32cce0)();
            (0, $257d980be76b472a$export$ae109b118e3436c5)();
            (0, $083b88661efb834f$export$acca6a3dc3ec5938)();
            (0, $bb8121cc0e753e20$export$a1b205be0ea4484)();
            (0, $e52b600f766c37eb$export$751b3ee8b1c5c13f)();
            (0, $b029291dbc139016$export$8fa819150bfbf401)();
            (0, $e3acb6c43bcf0759$export$8bac369750810305)();
            (0, $04ab43a6a8ac06c7$export$1ca757ec50c8f5ac)();
            (0, $e88f537906b8e4bf$export$b8a3ac91944abbc4)();
            (0, $5deec8e5fdf16b8e$export$a272e0dc93e4c8c0)();
        },
        layoutVisible: $layoutVisible
    });
}



function $9c9511130919aebc$var$Application() {
    (0, $133989e677847899$export$dda1d9f60106f0e9)("body", ()=>{
        (0, $133989e677847899$export$a40e83dd9f9a97c8)({
            classList: {
                "w-full": true,
                "min-h-screen": true,
                "bg-white": true,
                "text-slate-700": true,
                "dark:bg-slate-900": true,
                "dark:text-slate-300": true,
                dark: (0, $d461744a27a10557$exports).$currentTheme.map((theme)=>theme === "dark")
            }
        });
        (0, $63ba5f428a00943d$export$c717c2ee03fc6c49)();
        (0, $ad1d53f18b004f8e$export$5e89343b21832879)((0, $99a5bbd2d001ca47$export$f4259f350ec92f0b));
    });
}
(0, $133989e677847899$export$fb1889ddede82380)(document.querySelector("html"), $9c9511130919aebc$var$Application);

})();
//# sourceMappingURL=index.330f4c6a.js.map
